(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree41b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree41b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kOgzt", function(module, exports) {
$parcel$export(module.exports, "b64_decode", () => (parcelRequire("77crt")).b64_decode);
$parcel$export(module.exports, "getColorHexValue", () => (parcelRequire("3IaSv")).getColorHexValue);
$parcel$export(module.exports, "getAllCookies", () => (parcelRequire("ceOOn")).getAllCookies);
$parcel$export(module.exports, "elementReady", () => (parcelRequire("a3TA1")).elementReady);
$parcel$export(module.exports, "addWindowResizeEvent", () => (parcelRequire("6oLIz")).addWindowResizeEvent);
$parcel$export(module.exports, "addWindowScrollEvent", () => (parcelRequire("6oLIz")).addWindowScrollEvent);
$parcel$export(module.exports, "getReCAPTCHAResponse", () => (parcelRequire("isKkJ")).getReCAPTCHAResponse);
$parcel$export(module.exports, "slideDown", () => (parcelRequire("h30hJ")).slideDown);
$parcel$export(module.exports, "slideUp", () => (parcelRequire("h30hJ")).slideUp);
$parcel$export(module.exports, "scrollToElement", () => (parcelRequire("jWfAU")).scrollToElement);
$parcel$export(module.exports, "getThemeData", () => (parcelRequire("6sEQA")).getThemeData);
$parcel$export(module.exports, "waitForElement", () => (parcelRequire("hxRak")).waitForElement);
parcelRequire("77crt");
parcelRequire("3IaSv");
parcelRequire("ceOOn");
parcelRequire("a3TA1");
parcelRequire("6oLIz");
parcelRequire("isKkJ");
parcelRequire("h30hJ");
parcelRequire("jWfAU");
parcelRequire("6sEQA");
parcelRequire("hxRak");

});
parcelRegister("77crt", function(module, exports) {

$parcel$export(module.exports, "b64_decode", () => $52e2d69231a1aae4$export$bf9d481ba07b53f9);
const $52e2d69231a1aae4$export$3c2a198a9c1ae5f3 = (string)=>{
    return window.btoa(unescape(encodeURIComponent(string)));
};
const $52e2d69231a1aae4$export$bf9d481ba07b53f9 = (string)=>{
    return decodeURIComponent(escape(window.atob(string)));
};

});

parcelRegister("3IaSv", function(module, exports) {

$parcel$export(module.exports, "getColorHexValue", () => $2b3deb4eff4b3150$export$be9603b40fb67b4a);

var $b8TNY = parcelRequire("b8TNY");
const $2b3deb4eff4b3150$export$be9603b40fb67b4a = (id, opacity = 1, useTransparency = false)=>{
    const bodyColorValue = getComputedStyle(document.body).getPropertyValue(`--color-body`);
    const baseColorValue = getComputedStyle(document.body).getPropertyValue(`--color-${id}`);
    if (useTransparency) return (0, $b8TNY.default)(baseColorValue).alpha(opacity).hex();
    else return (0, $b8TNY.default)(baseColorValue).mix(bodyColorValue, 1 - opacity).hex();
};

});
parcelRegister("b8TNY", function(module, exports) {

$parcel$export(module.exports, "default", () => $81cbbacd84e74401$export$2e2bcd8739ae039);
// feel free to comment out anything to rollup
// a smaller chroma.js bundle

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("cF22K");
parcelRequire("iygXn");
parcelRequire("QEjK4");
parcelRequire("kytU9");
parcelRequire("kn0Pa");
parcelRequire("hDPZe");
parcelRequire("eDzBg");
parcelRequire("7pAyc");
parcelRequire("kXega");
parcelRequire("8P76D");
parcelRequire("bEZjX");
parcelRequire("jywIV");
parcelRequire("4Zhp6");
parcelRequire("kMTGA");
parcelRequire("dkzY3");
parcelRequire("gac9F");
parcelRequire("fWmFX");
parcelRequire("3s82t");
parcelRequire("75dqB");
parcelRequire("2ISBM");
parcelRequire("52gBS");
parcelRequire("3wKag");

var $8UmTp = parcelRequire("8UmTp");

var $9u72g = parcelRequire("9u72g");

var $hKhjA = parcelRequire("hKhjA");

var $jpCQy = parcelRequire("jpCQy");

var $dvq8W = parcelRequire("dvq8W");

var $eIGWI = parcelRequire("eIGWI");

var $4ZQS0 = parcelRequire("4ZQS0");

var $cgHIr = parcelRequire("cgHIr");

var $5BDZu = parcelRequire("5BDZu");

var $iM4ga = parcelRequire("iM4ga");

var $xkLDw = parcelRequire("xkLDw");

var $iB6ta = parcelRequire("iB6ta");

var $dID0y = parcelRequire("dID0y");

var $lT4NS = parcelRequire("lT4NS");

var $1vtEw = parcelRequire("1vtEw");

var $2LSBy = parcelRequire("2LSBy");

var $6Sny4 = parcelRequire("6Sny4");

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("7hd9c");
parcelRequire("cIiSk");
parcelRequire("kBR14");
parcelRequire("hskHC");
parcelRequire("bmZFS");
parcelRequire("2yZD4");
parcelRequire("fbI2I");
parcelRequire("7Z9E2");
parcelRequire("996dd");
parcelRequire("getAx");
parcelRequire("eSrDz");
parcelRequire("ayOPU");
parcelRequire("i89Hq");
parcelRequire("j6weT");
parcelRequire("35MHU");
Object.assign((0, $gaK1V.default), {
    analyze: $cgHIr.analyze,
    average: $8UmTp.default,
    bezier: $9u72g.default,
    blend: $hKhjA.default,
    brewer: $6Sny4.default,
    Color: $e7KSJ.default,
    colors: $2LSBy.default,
    contrast: $5BDZu.default,
    contrastAPCA: $iM4ga.default,
    cubehelix: $jpCQy.default,
    deltaE: $xkLDw.default,
    distance: $iB6ta.default,
    input: $lT4NS.default,
    interpolate: (0, $dvq8W.default),
    limits: $cgHIr.limits,
    mix: $dvq8W.default,
    random: $eIGWI.default,
    scale: $4ZQS0.default,
    scales: $1vtEw.default,
    valid: $dID0y.default
});
var $81cbbacd84e74401$export$2e2bcd8739ae039 = (0, $gaK1V.default);

});
parcelRegister("gaK1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc61491d55326ff6$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");

var $6QlZc = parcelRequire("6QlZc");
const $bc61491d55326ff6$var$chroma = (...args)=>{
    return new (0, $e7KSJ.default)(...args);
};
$bc61491d55326ff6$var$chroma.version = (0, $6QlZc.version);
var $bc61491d55326ff6$export$2e2bcd8739ae039 = $bc61491d55326ff6$var$chroma;

});
parcelRegister("e7KSJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a48615e4fc00386b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
var $7ElX1 = parcelRequire("7ElX1");
var $hMEmV = parcelRequire("hMEmV");

var $lT4NS = parcelRequire("lT4NS");
class $a48615e4fc00386b$var$Color {
    constructor(...args){
        const me = this;
        if ((0, $hMEmV.default)(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        let mode = (0, $7ElX1.default)(args);
        let autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!(0, $lT4NS.default).sorted) {
                (0, $lT4NS.default).autodetect = (0, $lT4NS.default).autodetect.sort((a, b)=>b.p - a.p);
                (0, $lT4NS.default).sorted = true;
            }
            // auto-detect format
            for (let chk of (0, $lT4NS.default).autodetect){
                mode = chk.test(...args);
                if (mode) break;
            }
        }
        if ((0, $lT4NS.default).format[mode]) {
            const rgb = (0, $lT4NS.default).format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = (0, $8TO5X.default)(rgb);
        } else throw new Error('unknown format: ' + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    }
    toString() {
        if ((0, $hMEmV.default)(this.hex) == 'function') return this.hex();
        return `[${this._rgb.join(',')}]`;
    }
}
var $a48615e4fc00386b$export$2e2bcd8739ae039 = $a48615e4fc00386b$var$Color;

});
parcelRegister("i4gda", function(module, exports) {

$parcel$export(module.exports, "min", () => $0364fc9895a99d2c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $0364fc9895a99d2c$export$8960430cfd85939f);
$parcel$export(module.exports, "rnd2", () => $0364fc9895a99d2c$export$c6d486233e29f7d1);
$parcel$export(module.exports, "rnd3", () => $0364fc9895a99d2c$export$6ed426801b9660b8);
$parcel$export(module.exports, "TWOPI", () => $0364fc9895a99d2c$export$af54f71c879f5ba9);
$parcel$export(module.exports, "PITHIRD", () => $0364fc9895a99d2c$export$e734282486210baf);
$parcel$export(module.exports, "DEG2RAD", () => $0364fc9895a99d2c$export$460c4029b1a54a2e);
$parcel$export(module.exports, "RAD2DEG", () => $0364fc9895a99d2c$export$914076c8150813e5);
$parcel$export(module.exports, "reverse3", () => $0364fc9895a99d2c$export$d0e1128e52417073);
$parcel$export(module.exports, "clip_rgb", () => (parcelRequire("8TO5X")).default);
$parcel$export(module.exports, "limit", () => (parcelRequire("gb2Ug")).default);
$parcel$export(module.exports, "type", () => (parcelRequire("hMEmV")).default);
$parcel$export(module.exports, "unpack", () => (parcelRequire("43ZPL")).default);
$parcel$export(module.exports, "last", () => (parcelRequire("7ElX1")).default);

var $8TO5X = parcelRequire("8TO5X");

var $gb2Ug = parcelRequire("gb2Ug");

var $hMEmV = parcelRequire("hMEmV");

var $43ZPL = parcelRequire("43ZPL");

var $7ElX1 = parcelRequire("7ElX1");
const { PI: $0364fc9895a99d2c$export$6b5c1ceb16d01dc3, min: $0364fc9895a99d2c$export$96ec731ed4dcb222, max: $0364fc9895a99d2c$export$8960430cfd85939f } = Math;
const $0364fc9895a99d2c$export$c6d486233e29f7d1 = (a)=>Math.round(a * 100) / 100;
const $0364fc9895a99d2c$export$6ed426801b9660b8 = (a)=>Math.round(a * 100) / 100;
const $0364fc9895a99d2c$export$af54f71c879f5ba9 = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 * 2;
const $0364fc9895a99d2c$export$e734282486210baf = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 / 3;
const $0364fc9895a99d2c$export$460c4029b1a54a2e = $0364fc9895a99d2c$export$6b5c1ceb16d01dc3 / 180;
const $0364fc9895a99d2c$export$914076c8150813e5 = 180 / $0364fc9895a99d2c$export$6b5c1ceb16d01dc3;
/**
 * Reverse the first three elements of an array
 *
 * @param {any[]} arr
 * @returns {any[]}
 */ function $0364fc9895a99d2c$export$d0e1128e52417073(arr) {
    return [
        ...arr.slice(0, 3).reverse(),
        ...arr.slice(3)
    ];
}

});
parcelRegister("8TO5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $67aa519ab0061f26$export$2e2bcd8739ae039);

var $gb2Ug = parcelRequire("gb2Ug");
var $67aa519ab0061f26$export$2e2bcd8739ae039 = (rgb)=>{
    rgb._clipped = false;
    rgb._unclipped = rgb.slice(0);
    for(let i = 0; i <= 3; i++){
        if (i < 3) {
            if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
            rgb[i] = (0, $gb2Ug.default)(rgb[i], 0, 255);
        } else if (i === 3) rgb[i] = (0, $gb2Ug.default)(rgb[i], 0, 1);
    }
    return rgb;
};

});
parcelRegister("gb2Ug", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc6fed995261efd6$export$2e2bcd8739ae039);
const { min: $bc6fed995261efd6$var$min, max: $bc6fed995261efd6$var$max } = Math;
var $bc6fed995261efd6$export$2e2bcd8739ae039 = (x, low = 0, high = 1)=>{
    return $bc6fed995261efd6$var$min($bc6fed995261efd6$var$max(low, x), high);
};

});


parcelRegister("hMEmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf263bc72046187c$export$2e2bcd8739ae039);
// ported from jQuery's $.type
const $cf263bc72046187c$var$classToType = {};
for (let name of [
    'Boolean',
    'Number',
    'String',
    'Function',
    'Array',
    'Date',
    'RegExp',
    'Undefined',
    'Null'
])$cf263bc72046187c$var$classToType[`[object ${name}]`] = name.toLowerCase();
function $cf263bc72046187c$export$2e2bcd8739ae039(obj) {
    return $cf263bc72046187c$var$classToType[Object.prototype.toString.call(obj)] || 'object';
}

});

parcelRegister("43ZPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f57682b2b3fd0b6$export$2e2bcd8739ae039);

var $hMEmV = parcelRequire("hMEmV");
var $2f57682b2b3fd0b6$export$2e2bcd8739ae039 = (args, keyOrder = null)=>{
    // if called with more than 3 arguments, we return the arguments
    if (args.length >= 3) return Array.prototype.slice.call(args);
    // with less than 3 args we check if first arg is object
    // and use the keyOrder string to extract and sort properties
    if ((0, $hMEmV.default)(args[0]) == 'object' && keyOrder) return keyOrder.split('').filter((k)=>args[0][k] !== undefined).map((k)=>args[0][k]);
    // otherwise we just return the first argument
    // (which we suppose is an array of args)
    return args[0].slice(0);
};

});

parcelRegister("7ElX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $591d4bdad7401082$export$2e2bcd8739ae039);

var $hMEmV = parcelRequire("hMEmV");
var $591d4bdad7401082$export$2e2bcd8739ae039 = (args)=>{
    if (args.length < 2) return null;
    const l = args.length - 1;
    if ((0, $hMEmV.default)(args[l]) == 'string') return args[l].toLowerCase();
    return null;
};

});


parcelRegister("lT4NS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef275e9b9623611$export$2e2bcd8739ae039);
var $fef275e9b9623611$export$2e2bcd8739ae039 = {
    format: {},
    autodetect: []
};

});


parcelRegister("6QlZc", function(module, exports) {

$parcel$export(module.exports, "version", () => $4fb8a75d624eee90$export$83d89fbfd8236492);
// this gets updated automatically
const $4fb8a75d624eee90$export$83d89fbfd8236492 = '3.1.2';

});


parcelRegister("cF22K", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $2LSBy = parcelRequire("2LSBy");

var $2BpKe = parcelRequire("2BpKe");

var $eL95G = parcelRequire("eL95G");
(0, $e7KSJ.default).prototype.name = function() {
    const hex = (0, $eL95G.default)(this._rgb, 'rgb');
    for (let n of Object.keys((0, $2LSBy.default))){
        if ((0, $2LSBy.default)[n] === hex) return n.toLowerCase();
    }
    return hex;
};
(0, $lT4NS.default).format.named = (name)=>{
    name = name.toLowerCase();
    if ((0, $2LSBy.default)[name]) return (0, $2BpKe.default)((0, $2LSBy.default)[name]);
    throw new Error('unknown color name: ' + name);
};
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && (0, $2LSBy.default)[h.toLowerCase()]) return 'named';
    }
});

});
parcelRegister("2LSBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $204a53f04c74292a$export$2e2bcd8739ae039);
/**
	X11 color names

	http://www.w3.org/TR/css3-color/#svg-color
*/ const $204a53f04c74292a$var$w3cx11 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    laserlemon: '#ffff54',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrod: '#fafad2',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    maroon2: '#7f0000',
    maroon3: '#b03060',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    purple2: '#7f007f',
    purple3: '#a020f0',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};
var $204a53f04c74292a$export$2e2bcd8739ae039 = $204a53f04c74292a$var$w3cx11;

});

parcelRegister("2BpKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5301da89c3e9c8$export$2e2bcd8739ae039);
const $1e5301da89c3e9c8$var$RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const $1e5301da89c3e9c8$var$RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
const $1e5301da89c3e9c8$var$hex2rgb = (hex)=>{
    if (hex.match($1e5301da89c3e9c8$var$RE_HEX)) {
        // remove optional leading #
        if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
        // expand short-notation to full six-digit
        if (hex.length === 3) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const u = parseInt(hex, 16);
        const r = u >> 16;
        const g = u >> 8 & 0xff;
        const b = u & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    // match rgba hex format, eg #FF000077
    if (hex.match($1e5301da89c3e9c8$var$RE_HEXA)) {
        if (hex.length === 5 || hex.length === 9) // remove optional leading #
        hex = hex.substr(1);
        // expand short-notation to full eight-digit
        if (hex.length === 4) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
        }
        const u = parseInt(hex, 16);
        const r = u >> 24 & 0xff;
        const g = u >> 16 & 0xff;
        const b = u >> 8 & 0xff;
        const a = Math.round((u & 0xff) / 0xff * 100) / 100;
        return [
            r,
            g,
            b,
            a
        ];
    }
    // we used to check for css colors here
    // if _input.css? and rgb = _input.css hex
    //     return rgb
    throw new Error(`unknown hex color: ${hex}`);
};
var $1e5301da89c3e9c8$export$2e2bcd8739ae039 = $1e5301da89c3e9c8$var$hex2rgb;

});

parcelRegister("eL95G", function(module, exports) {

$parcel$export(module.exports, "default", () => $abec81afd0345325$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $43ZPL = parcelRequire("43ZPL");
const { round: $abec81afd0345325$var$round } = Math;
const $abec81afd0345325$var$rgb2hex = (...args)=>{
    let [r, g, b, a] = (0, $43ZPL.default)(args, 'rgba');
    let mode = (0, $7ElX1.default)(args) || 'auto';
    if (a === undefined) a = 1;
    if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
    r = $abec81afd0345325$var$round(r);
    g = $abec81afd0345325$var$round(g);
    b = $abec81afd0345325$var$round(b);
    const u = r << 16 | g << 8 | b;
    let str = '000000' + u.toString(16); //#.toUpperCase();
    str = str.substr(str.length - 6);
    let hxa = '0' + $abec81afd0345325$var$round(a * 255).toString(16);
    hxa = hxa.substr(hxa.length - 2);
    switch(mode.toLowerCase()){
        case 'rgba':
            return `#${str}${hxa}`;
        case 'argb':
            return `#${hxa}${str}`;
        default:
            return `#${str}`;
    }
};
var $abec81afd0345325$export$2e2bcd8739ae039 = $abec81afd0345325$var$rgb2hex;

});


parcelRegister("iygXn", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
(0, $e7KSJ.default).prototype.alpha = function(a, mutate = false) {
    if (a !== undefined && (0, $hMEmV.default)(a) === 'number') {
        if (mutate) {
            this._rgb[3] = a;
            return this;
        }
        return new (0, $e7KSJ.default)([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ], 'rgb');
    }
    return this._rgb[3];
};

});

parcelRegister("QEjK4", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.clipped = function() {
    return this._rgb._clipped || false;
};

});

parcelRegister("kytU9", function(module, exports) {
parcelRequire("996dd");

var $e7KSJ = parcelRequire("e7KSJ");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.darken = function(amount = 1) {
    const me = this;
    const lab = me.lab();
    lab[0] -= (0, $8weUB.default).Kn * amount;
    return new (0, $e7KSJ.default)(lab, 'lab').alpha(me.alpha(), true);
};
(0, $e7KSJ.default).prototype.brighten = function(amount = 1) {
    return this.darken(-amount);
};
(0, $e7KSJ.default).prototype.darker = (0, $e7KSJ.default).prototype.darken;
(0, $e7KSJ.default).prototype.brighter = (0, $e7KSJ.default).prototype.brighten;

});
parcelRegister("996dd", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $jenZn = parcelRequire("jenZn");

var $luvnN = parcelRequire("luvnN");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.lab = function() {
    return (0, $luvnN.default)(this._rgb);
};
const $6a89c5f2d5780cd3$export$c83fb8f9027a6338 = (...args)=>new (0, $e7KSJ.default)(...args, 'lab');
Object.assign((0, $gaK1V.default), {
    lab: $6a89c5f2d5780cd3$export$c83fb8f9027a6338,
    getLabWhitePoint: $8weUB.getLabWhitePoint,
    setLabWhitePoint: $8weUB.setLabWhitePoint
});
(0, $lT4NS.default).format.lab = (0, $jenZn.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'lab');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'lab';
    }
});

});
parcelRegister("jenZn", function(module, exports) {

$parcel$export(module.exports, "xyz2rgb", () => $e001eed8d7ff32c4$export$22cbacf088b0f5c6);
$parcel$export(module.exports, "default", () => $e001eed8d7ff32c4$export$2e2bcd8739ae039);

var $8weUB = parcelRequire("8weUB");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */ const $e001eed8d7ff32c4$var$lab2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lab');
    const [L, a, b] = args;
    const [x, y, z] = $e001eed8d7ff32c4$var$lab2xyz(L, a, b);
    const [r, g, b_] = $e001eed8d7ff32c4$export$22cbacf088b0f5c6(x, y, z);
    return [
        r,
        g,
        b_,
        args.length > 3 ? args[3] : 1
    ];
};
const $e001eed8d7ff32c4$var$lab2xyz = (L, a, b)=>{
    const { kE: kE, kK: kK, kKE: kKE, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $8weUB.default);
    const fy = (L + 16.0) / 116.0;
    const fx = 0.002 * a + fy;
    const fz = fy - 0.005 * b;
    const fx3 = fx * fx * fx;
    const fz3 = fz * fz * fz;
    const xr = fx3 > kE ? fx3 : (116.0 * fx - 16.0) / kK;
    const yr = L > kKE ? Math.pow((L + 16.0) / 116.0, 3.0) : L / kK;
    const zr = fz3 > kE ? fz3 : (116.0 * fz - 16.0) / kK;
    const x = xr * Xn;
    const y = yr * Yn;
    const z = zr * Zn;
    return [
        x,
        y,
        z
    ];
};
const $e001eed8d7ff32c4$var$compand = (linear)=>{
    /* sRGB */ const sign = Math.sign(linear);
    linear = Math.abs(linear);
    return (linear <= 0.0031308 ? linear * 12.92 : 1.055 * Math.pow(linear, 1.0 / 2.4) - 0.055) * sign;
};
const $e001eed8d7ff32c4$export$22cbacf088b0f5c6 = (x, y, z)=>{
    const { MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, MtxXYZ2RGB: MtxXYZ2RGB, RefWhiteRGB: RefWhiteRGB, Xn: Xn, Yn: Yn, Zn: Zn } = (0, $8weUB.default);
    const As = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bs = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cs = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    const Ad = RefWhiteRGB.X * MtxAdaptMa.m00 + RefWhiteRGB.Y * MtxAdaptMa.m10 + RefWhiteRGB.Z * MtxAdaptMa.m20;
    const Bd = RefWhiteRGB.X * MtxAdaptMa.m01 + RefWhiteRGB.Y * MtxAdaptMa.m11 + RefWhiteRGB.Z * MtxAdaptMa.m21;
    const Cd = RefWhiteRGB.X * MtxAdaptMa.m02 + RefWhiteRGB.Y * MtxAdaptMa.m12 + RefWhiteRGB.Z * MtxAdaptMa.m22;
    const X1 = (x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20) * (Ad / As);
    const Y1 = (x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21) * (Bd / Bs);
    const Z1 = (x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22) * (Cd / Cs);
    const X2 = X1 * MtxAdaptMaI.m00 + Y1 * MtxAdaptMaI.m10 + Z1 * MtxAdaptMaI.m20;
    const Y2 = X1 * MtxAdaptMaI.m01 + Y1 * MtxAdaptMaI.m11 + Z1 * MtxAdaptMaI.m21;
    const Z2 = X1 * MtxAdaptMaI.m02 + Y1 * MtxAdaptMaI.m12 + Z1 * MtxAdaptMaI.m22;
    const r = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m00 + Y2 * MtxXYZ2RGB.m10 + Z2 * MtxXYZ2RGB.m20);
    const g = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m01 + Y2 * MtxXYZ2RGB.m11 + Z2 * MtxXYZ2RGB.m21);
    const b = $e001eed8d7ff32c4$var$compand(X2 * MtxXYZ2RGB.m02 + Y2 * MtxXYZ2RGB.m12 + Z2 * MtxXYZ2RGB.m22);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
var $e001eed8d7ff32c4$export$2e2bcd8739ae039 = $e001eed8d7ff32c4$var$lab2rgb;

});
parcelRegister("8weUB", function(module, exports) {

$parcel$export(module.exports, "default", () => $633ce119b108995d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "setLabWhitePoint", () => $633ce119b108995d$export$23f27f4cae67c045);
$parcel$export(module.exports, "getLabWhitePoint", () => $633ce119b108995d$export$922c3afbcbc31cb3);
const $633ce119b108995d$var$labConstants = {
    // Corresponds roughly to RGB brighter/darker
    Kn: 18,
    // D65 standard referent
    labWhitePoint: 'd65',
    Xn: 0.95047,
    Yn: 1,
    Zn: 1.08883,
    t0: 0.137931034,
    t1: 0.206896552,
    t2: 0.12841855,
    t3: 0.008856452,
    kE: 216.0 / 24389.0,
    kKE: 8.0,
    kK: 24389.0 / 27.0,
    RefWhiteRGB: {
        // sRGB
        X: 0.95047,
        Y: 1,
        Z: 1.08883
    },
    MtxRGB2XYZ: {
        m00: 0.4124564390896922,
        m01: 0.21267285140562253,
        m02: 0.0193338955823293,
        m10: 0.357576077643909,
        m11: 0.715152155287818,
        m12: 0.11919202588130297,
        m20: 0.18043748326639894,
        m21: 0.07217499330655958,
        m22: 0.9503040785363679
    },
    MtxXYZ2RGB: {
        m00: 3.2404541621141045,
        m01: -0.9692660305051868,
        m02: 0.055643430959114726,
        m10: -1.5371385127977166,
        m11: 1.8760108454466942,
        m12: -0.2040259135167538,
        m20: -0.498531409556016,
        m21: 0.041556017530349834,
        m22: 1.0572251882231791
    },
    // used in rgb2xyz
    As: 0.9414285350000001,
    Bs: 1.040417467,
    Cs: 1.089532651,
    MtxAdaptMa: {
        m00: 0.8951,
        m01: -0.7502,
        m02: 0.0389,
        m10: 0.2664,
        m11: 1.7135,
        m12: -0.0685,
        m20: -0.1614,
        m21: 0.0367,
        m22: 1.0296
    },
    MtxAdaptMaI: {
        m00: 0.9869929054667123,
        m01: 0.43230526972339456,
        m02: -0.008528664575177328,
        m10: -0.14705425642099013,
        m11: 0.5183602715367776,
        m12: 0.04004282165408487,
        m20: 0.15996265166373125,
        m21: 0.0492912282128556,
        m22: 0.9684866957875502
    }
};
var $633ce119b108995d$export$2e2bcd8739ae039 = $633ce119b108995d$var$labConstants;
// taken from https://de.mathworks.com/help/images/ref/whitepoint.html
const $633ce119b108995d$var$ILLUMINANTS = new Map([
    // ASTM E308-01
    [
        'a',
        [
            1.0985,
            0.35585
        ]
    ],
    // Wyszecki & Stiles, p. 769
    [
        'b',
        [
            1.0985,
            0.35585
        ]
    ],
    // C ASTM E308-01
    [
        'c',
        [
            0.98074,
            1.18232
        ]
    ],
    // D50 (ASTM E308-01)
    [
        'd50',
        [
            0.96422,
            0.82521
        ]
    ],
    // D55 (ASTM E308-01)
    [
        'd55',
        [
            0.95682,
            0.92149
        ]
    ],
    // D65 (ASTM E308-01)
    [
        'd65',
        [
            0.95047,
            1.08883
        ]
    ],
    // E (ASTM E308-01)
    [
        'e',
        [
            1,
            1,
            1
        ]
    ],
    // F2 (ASTM E308-01)
    [
        'f2',
        [
            0.99186,
            0.67393
        ]
    ],
    // F7 (ASTM E308-01)
    [
        'f7',
        [
            0.95041,
            1.08747
        ]
    ],
    // F11 (ASTM E308-01)
    [
        'f11',
        [
            1.00962,
            0.6435
        ]
    ],
    [
        'icc',
        [
            0.96422,
            0.82521
        ]
    ]
]);
function $633ce119b108995d$export$23f27f4cae67c045(name) {
    const ill = $633ce119b108995d$var$ILLUMINANTS.get(String(name).toLowerCase());
    if (!ill) throw new Error('unknown Lab illuminant ' + name);
    $633ce119b108995d$var$labConstants.labWhitePoint = name;
    $633ce119b108995d$var$labConstants.Xn = ill[0];
    $633ce119b108995d$var$labConstants.Zn = ill[1];
}
function $633ce119b108995d$export$922c3afbcbc31cb3() {
    return $633ce119b108995d$var$labConstants.labWhitePoint;
}

});


parcelRegister("luvnN", function(module, exports) {

$parcel$export(module.exports, "rgb2xyz", () => $fa54be4b38a62f7b$export$fca6d690f89f5907);
$parcel$export(module.exports, "default", () => $fa54be4b38a62f7b$export$2e2bcd8739ae039);

var $8weUB = parcelRequire("8weUB");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $fa54be4b38a62f7b$var$rgb2lab = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [x, y, z] = $fa54be4b38a62f7b$export$fca6d690f89f5907(r, g, b);
    const [L, a, b_] = $fa54be4b38a62f7b$var$xyz2lab(x, y, z);
    return [
        L,
        a,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
function $fa54be4b38a62f7b$var$xyz2lab(x, y, z) {
    const { Xn: Xn, Yn: Yn, Zn: Zn, kE: kE, kK: kK } = (0, $8weUB.default);
    const xr = x / Xn;
    const yr = y / Yn;
    const zr = z / Zn;
    const fx = xr > kE ? Math.pow(xr, 1.0 / 3.0) : (kK * xr + 16.0) / 116.0;
    const fy = yr > kE ? Math.pow(yr, 1.0 / 3.0) : (kK * yr + 16.0) / 116.0;
    const fz = zr > kE ? Math.pow(zr, 1.0 / 3.0) : (kK * zr + 16.0) / 116.0;
    return [
        116.0 * fy - 16.0,
        500.0 * (fx - fy),
        200.0 * (fy - fz)
    ];
}
function $fa54be4b38a62f7b$var$gammaAdjustSRGB(companded) {
    const sign = Math.sign(companded);
    companded = Math.abs(companded);
    const linear = companded <= 0.04045 ? companded / 12.92 : Math.pow((companded + 0.055) / 1.055, 2.4);
    return linear * sign;
}
const $fa54be4b38a62f7b$export$fca6d690f89f5907 = (r, g, b)=>{
    // normalize and gamma adjust
    r = $fa54be4b38a62f7b$var$gammaAdjustSRGB(r / 255);
    g = $fa54be4b38a62f7b$var$gammaAdjustSRGB(g / 255);
    b = $fa54be4b38a62f7b$var$gammaAdjustSRGB(b / 255);
    const { MtxRGB2XYZ: MtxRGB2XYZ, MtxAdaptMa: MtxAdaptMa, MtxAdaptMaI: MtxAdaptMaI, Xn: Xn, Yn: Yn, Zn: Zn, As: As, Bs: Bs, Cs: Cs } = (0, $8weUB.default);
    let x = r * MtxRGB2XYZ.m00 + g * MtxRGB2XYZ.m10 + b * MtxRGB2XYZ.m20;
    let y = r * MtxRGB2XYZ.m01 + g * MtxRGB2XYZ.m11 + b * MtxRGB2XYZ.m21;
    let z = r * MtxRGB2XYZ.m02 + g * MtxRGB2XYZ.m12 + b * MtxRGB2XYZ.m22;
    const Ad = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
    const Bd = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
    const Cd = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
    let X = x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20;
    let Y = x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21;
    let Z = x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22;
    X *= Ad / As;
    Y *= Bd / Bs;
    Z *= Cd / Cs;
    x = X * MtxAdaptMaI.m00 + Y * MtxAdaptMaI.m10 + Z * MtxAdaptMaI.m20;
    y = X * MtxAdaptMaI.m01 + Y * MtxAdaptMaI.m11 + Z * MtxAdaptMaI.m21;
    z = X * MtxAdaptMaI.m02 + Y * MtxAdaptMaI.m12 + Z * MtxAdaptMaI.m22;
    return [
        x,
        y,
        z
    ];
};
var $fa54be4b38a62f7b$export$2e2bcd8739ae039 = $fa54be4b38a62f7b$var$rgb2lab;

});



parcelRegister("kn0Pa", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.get = function(mc) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) return src[i];
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};

});

parcelRegister("hDPZe", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
const { pow: $cd7e67a33d66dde3$var$pow } = Math;
const $cd7e67a33d66dde3$var$EPS = 1e-7;
const $cd7e67a33d66dde3$var$MAX_ITER = 20;
(0, $e7KSJ.default).prototype.luminance = function(lum, mode = 'rgb') {
    if (lum !== undefined && (0, $hMEmV.default)(lum) === 'number') {
        if (lum === 0) // return pure black
        return new (0, $e7KSJ.default)([
            0,
            0,
            0,
            this._rgb[3]
        ], 'rgb');
        if (lum === 1) // return pure white
        return new (0, $e7KSJ.default)([
            255,
            255,
            255,
            this._rgb[3]
        ], 'rgb');
        // compute new color using...
        let cur_lum = this.luminance();
        let max_iter = $cd7e67a33d66dde3$var$MAX_ITER;
        const test = (low, high)=>{
            const mid = low.interpolate(high, 0.5, mode);
            const lm = mid.luminance();
            if (Math.abs(lum - lm) < $cd7e67a33d66dde3$var$EPS || !max_iter--) // close enough
            return mid;
            return lm > lum ? test(low, mid) : test(mid, high);
        };
        const rgb = (cur_lum > lum ? test(new (0, $e7KSJ.default)([
            0,
            0,
            0
        ]), this) : test(this, new (0, $e7KSJ.default)([
            255,
            255,
            255
        ]))).rgb();
        return new (0, $e7KSJ.default)([
            ...rgb,
            this._rgb[3]
        ]);
    }
    return $cd7e67a33d66dde3$var$rgb2luminance(...this._rgb.slice(0, 3));
};
const $cd7e67a33d66dde3$var$rgb2luminance = (r, g, b)=>{
    // relative luminance
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    r = $cd7e67a33d66dde3$var$luminance_x(r);
    g = $cd7e67a33d66dde3$var$luminance_x(g);
    b = $cd7e67a33d66dde3$var$luminance_x(b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const $cd7e67a33d66dde3$var$luminance_x = (x)=>{
    x /= 255;
    return x <= 0.03928 ? x / 12.92 : $cd7e67a33d66dde3$var$pow((x + 0.055) / 1.055, 2.4);
};

});

parcelRegister("eDzBg", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
(0, $e7KSJ.default).prototype.mix = (0, $e7KSJ.default).prototype.interpolate = function(col2, f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, col2, f, ...rest);
};

});
parcelRegister("dvq8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d52731f6acc42df$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $5flPP = parcelRequire("5flPP");
var $9d52731f6acc42df$export$2e2bcd8739ae039 = (col1, col2, f = 0.5, ...rest)=>{
    let mode = rest[0] || 'lrgb';
    if (!(0, $5flPP.default)[mode] && !rest.length) // fall back to the first supported mode
    mode = Object.keys((0, $5flPP.default))[0];
    if (!(0, $5flPP.default)[mode]) throw new Error(`interpolation mode ${mode} is not defined`);
    if ((0, $hMEmV.default)(col1) !== 'object') col1 = new (0, $e7KSJ.default)(col1);
    if ((0, $hMEmV.default)(col2) !== 'object') col2 = new (0, $e7KSJ.default)(col2);
    return (0, $5flPP.default)[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
};

});
parcelRegister("5flPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d1f4a69308124ed$export$2e2bcd8739ae039);
var $3d1f4a69308124ed$export$2e2bcd8739ae039 = {};

});



parcelRegister("7pAyc", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
(0, $e7KSJ.default).prototype.premultiply = function(mutate = false) {
    const rgb = this._rgb;
    const a = rgb[3];
    if (mutate) {
        this._rgb = [
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ];
        return this;
    } else return new (0, $e7KSJ.default)([
        rgb[0] * a,
        rgb[1] * a,
        rgb[2] * a,
        a
    ], 'rgb');
};

});

parcelRegister("kXega", function(module, exports) {
parcelRequire("getAx");

var $e7KSJ = parcelRequire("e7KSJ");

var $8weUB = parcelRequire("8weUB");
(0, $e7KSJ.default).prototype.saturate = function(amount = 1) {
    const me = this;
    const lch = me.lch();
    lch[1] += (0, $8weUB.default).Kn * amount;
    if (lch[1] < 0) lch[1] = 0;
    return new (0, $e7KSJ.default)(lch, 'lch').alpha(me.alpha(), true);
};
(0, $e7KSJ.default).prototype.desaturate = function(amount = 1) {
    return this.saturate(-amount);
};

});
parcelRegister("getAx", function(module, exports) {

var $i4gda = parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $g4jd5 = parcelRequire("g4jd5");

var $c2Ykn = parcelRequire("c2Ykn");

var $jSfgf = parcelRequire("jSfgf");
(0, $e7KSJ.default).prototype.lch = function() {
    return (0, $jSfgf.default)(this._rgb);
};
(0, $e7KSJ.default).prototype.hcl = function() {
    return (0, $i4gda.reverse3)((0, $jSfgf.default)(this._rgb));
};
const $bd14e7c45dd3e1a2$export$5a21418738164530 = (...args)=>new (0, $e7KSJ.default)(...args, 'lch');
const $bd14e7c45dd3e1a2$export$d0e870ba50062ff1 = (...args)=>new (0, $e7KSJ.default)(...args, 'hcl');
Object.assign((0, $gaK1V.default), {
    lch: $bd14e7c45dd3e1a2$export$5a21418738164530,
    hcl: $bd14e7c45dd3e1a2$export$d0e870ba50062ff1
});
(0, $lT4NS.default).format.lch = (0, $g4jd5.default);
(0, $lT4NS.default).format.hcl = (0, $c2Ykn.default);
[
    'lch',
    'hcl'
].forEach((m)=>(0, $lT4NS.default).autodetect.push({
        p: 2,
        test: (...args)=>{
            args = (0, $43ZPL.default)(args, m);
            if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return m;
        }
    }));

});
parcelRegister("g4jd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb2bebced39c863d$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $d6n2X = parcelRequire("d6n2X");

var $jenZn = parcelRequire("jenZn");
const $bb2bebced39c863d$var$lch2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lch');
    const [l, c, h] = args;
    const [L, a, b_] = (0, $d6n2X.default)(l, c, h);
    const [r, g, b] = (0, $jenZn.default)(L, a, b_);
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $bb2bebced39c863d$export$2e2bcd8739ae039 = $bb2bebced39c863d$var$lch2rgb;

});
parcelRegister("d6n2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $989db6829fcafd4a$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { sin: $989db6829fcafd4a$var$sin, cos: $989db6829fcafd4a$var$cos } = Math;
const $989db6829fcafd4a$var$lch2lab = (...args)=>{
    /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.

    A saturation multiplier was added by Gregor Aisch
    */ let [l, c, h] = (0, $43ZPL.default)(args, 'lch');
    if (isNaN(h)) h = 0;
    h = h * (0, $i4gda.DEG2RAD);
    return [
        l,
        $989db6829fcafd4a$var$cos(h) * c,
        $989db6829fcafd4a$var$sin(h) * c
    ];
};
var $989db6829fcafd4a$export$2e2bcd8739ae039 = $989db6829fcafd4a$var$lch2lab;

});


parcelRegister("c2Ykn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5477bbf42a48d0$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $g4jd5 = parcelRequire("g4jd5");
const $8c5477bbf42a48d0$var$hcl2rgb = (...args)=>{
    const hcl = (0, $i4gda.reverse3)((0, $43ZPL.default)(args, 'hcl'));
    return (0, $g4jd5.default)(...hcl);
};
var $8c5477bbf42a48d0$export$2e2bcd8739ae039 = $8c5477bbf42a48d0$var$hcl2rgb;

});

parcelRegister("jSfgf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e77ee5fe83442dbf$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $luvnN = parcelRequire("luvnN");

var $36WLn = parcelRequire("36WLn");
const $e77ee5fe83442dbf$var$rgb2lch = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [l, a, b_] = (0, $luvnN.default)(r, g, b);
    const [L, c, h] = (0, $36WLn.default)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $e77ee5fe83442dbf$export$2e2bcd8739ae039 = $e77ee5fe83442dbf$var$rgb2lch;

});
parcelRegister("36WLn", function(module, exports) {

$parcel$export(module.exports, "default", () => $243f83c61b0760ca$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { sqrt: $243f83c61b0760ca$var$sqrt, atan2: $243f83c61b0760ca$var$atan2, round: $243f83c61b0760ca$var$round } = Math;
const $243f83c61b0760ca$var$lab2lch = (...args)=>{
    const [l, a, b] = (0, $43ZPL.default)(args, 'lab');
    const c = $243f83c61b0760ca$var$sqrt(a * a + b * b);
    let h = ($243f83c61b0760ca$var$atan2(b, a) * (0, $i4gda.RAD2DEG) + 360) % 360;
    if ($243f83c61b0760ca$var$round(c * 10000) === 0) h = Number.NaN;
    return [
        l,
        c,
        h
    ];
};
var $243f83c61b0760ca$export$2e2bcd8739ae039 = $243f83c61b0760ca$var$lab2lch;

});




parcelRegister("8P76D", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
(0, $e7KSJ.default).prototype.set = function(mc, value, mutate = false) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) {
            if ((0, $hMEmV.default)(value) == 'string') switch(value.charAt(0)){
                case '+':
                    src[i] += +value;
                    break;
                case '-':
                    src[i] += +value;
                    break;
                case '*':
                    src[i] *= +value.substr(1);
                    break;
                case '/':
                    src[i] /= +value.substr(1);
                    break;
                default:
                    src[i] = +value;
            }
            else if ((0, $hMEmV.default)(value) === 'number') src[i] = value;
            else throw new Error(`unsupported value for Color.set`);
            const out = new (0, $e7KSJ.default)(src, mode);
            if (mutate) {
                this._rgb = out._rgb;
                return this;
            }
            return out;
        }
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};

});

parcelRegister("bEZjX", function(module, exports) {
parcelRequire("996dd");

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
(0, $e7KSJ.default).prototype.tint = function(f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, 'white', f, ...rest);
};
(0, $e7KSJ.default).prototype.shade = function(f = 0.5, ...rest) {
    return (0, $dvq8W.default)(this, 'black', f, ...rest);
};

});

parcelRegister("jywIV", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $5flPP = parcelRequire("5flPP");
const $e3ca93847035084a$var$rgb = (col1, col2, f)=>{
    const xyz0 = col1._rgb;
    const xyz1 = col2._rgb;
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'rgb');
};
// register interpolator
(0, $5flPP.default).rgb = $e3ca93847035084a$var$rgb;
var $e3ca93847035084a$export$2e2bcd8739ae039 = $e3ca93847035084a$var$rgb;

});

parcelRegister("4Zhp6", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $5flPP = parcelRequire("5flPP");
const { sqrt: $3a1a5bf678f2834b$var$sqrt, pow: $3a1a5bf678f2834b$var$pow } = Math;
const $3a1a5bf678f2834b$var$lrgb = (col1, col2, f)=>{
    const [x1, y1, z1] = col1._rgb;
    const [x2, y2, z2] = col2._rgb;
    return new (0, $e7KSJ.default)($3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(x1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(x2, 2) * f), $3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(y1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(y2, 2) * f), $3a1a5bf678f2834b$var$sqrt($3a1a5bf678f2834b$var$pow(z1, 2) * (1 - f) + $3a1a5bf678f2834b$var$pow(z2, 2) * f), 'rgb');
};
// register interpolator
(0, $5flPP.default).lrgb = $3a1a5bf678f2834b$var$lrgb;
var $3a1a5bf678f2834b$export$2e2bcd8739ae039 = $3a1a5bf678f2834b$var$lrgb;

});

parcelRegister("kMTGA", function(module, exports) {
parcelRequire("996dd");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $f2237c656cb48337$var$lab = (col1, col2, f)=>{
    const xyz0 = col1.lab();
    const xyz1 = col2.lab();
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'lab');
};
// register interpolator
(0, $5flPP.default).lab = $f2237c656cb48337$var$lab;
var $f2237c656cb48337$export$2e2bcd8739ae039 = $f2237c656cb48337$var$lab;

});

parcelRegister("dkzY3", function(module, exports) {
parcelRequire("getAx");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $9b490b0c3a354cd6$var$lch = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'lch');
};
// register interpolator
(0, $5flPP.default).lch = $9b490b0c3a354cd6$var$lch;
(0, $5flPP.default).hcl = $9b490b0c3a354cd6$var$lch;
var $9b490b0c3a354cd6$export$2e2bcd8739ae039 = $9b490b0c3a354cd6$var$lch;

});
parcelRegister("9mSMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d20aa787a33a4e5$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
var $6d20aa787a33a4e5$export$2e2bcd8739ae039 = (col1, col2, f, m)=>{
    let xyz0, xyz1;
    if (m === 'hsl') {
        xyz0 = col1.hsl();
        xyz1 = col2.hsl();
    } else if (m === 'hsv') {
        xyz0 = col1.hsv();
        xyz1 = col2.hsv();
    } else if (m === 'hcg') {
        xyz0 = col1.hcg();
        xyz1 = col2.hcg();
    } else if (m === 'hsi') {
        xyz0 = col1.hsi();
        xyz1 = col2.hsi();
    } else if (m === 'lch' || m === 'hcl') {
        m = 'hcl';
        xyz0 = col1.hcl();
        xyz1 = col2.hcl();
    } else if (m === 'oklch') {
        xyz0 = col1.oklch().reverse();
        xyz1 = col2.oklch().reverse();
    }
    let hue0, hue1, sat0, sat1, lbv0, lbv1;
    if (m.substr(0, 1) === 'h' || m === 'oklch') {
        [hue0, sat0, lbv0] = xyz0;
        [hue1, sat1, lbv1] = xyz1;
    }
    let sat, hue, lbv, dh;
    if (!isNaN(hue0) && !isNaN(hue1)) {
        // both colors have hue
        if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
        else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
        else dh = hue1 - hue0;
        hue = hue0 + f * dh;
    } else if (!isNaN(hue0)) {
        hue = hue0;
        if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') sat = sat0;
    } else if (!isNaN(hue1)) {
        hue = hue1;
        if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') sat = sat1;
    } else hue = Number.NaN;
    if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
    lbv = lbv0 + f * (lbv1 - lbv0);
    return m === 'oklch' ? new (0, $e7KSJ.default)([
        lbv,
        sat,
        hue
    ], m) : new (0, $e7KSJ.default)([
        hue,
        sat,
        lbv
    ], m);
};

});


parcelRegister("gac9F", function(module, exports) {
parcelRequire("eSrDz");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $bc4702376fdac141$var$num = (col1, col2, f)=>{
    const c1 = col1.num();
    const c2 = col2.num();
    return new (0, $e7KSJ.default)(c1 + f * (c2 - c1), 'num');
};
// register interpolator
(0, $5flPP.default).num = $bc4702376fdac141$var$num;
var $bc4702376fdac141$export$2e2bcd8739ae039 = $bc4702376fdac141$var$num;

});
parcelRegister("eSrDz", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $2UY7c = parcelRequire("2UY7c");

var $gkdTd = parcelRequire("gkdTd");
(0, $e7KSJ.default).prototype.num = function() {
    return (0, $gkdTd.default)(this._rgb);
};
const $ad4b8c09bf38a2ac$export$61cc6a0be4938a2a = (...args)=>new (0, $e7KSJ.default)(...args, 'num');
Object.assign((0, $gaK1V.default), {
    num: $ad4b8c09bf38a2ac$export$61cc6a0be4938a2a
});
(0, $lT4NS.default).format.num = (0, $2UY7c.default);
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (...args)=>{
        if (args.length === 1 && (0, $hMEmV.default)(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xffffff) return 'num';
    }
});

});
parcelRegister("2UY7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $21ff7154ad573d00$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
const $21ff7154ad573d00$var$num2rgb = (num)=>{
    if ((0, $hMEmV.default)(num) == 'number' && num >= 0 && num <= 0xffffff) {
        const r = num >> 16;
        const g = num >> 8 & 0xff;
        const b = num & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    throw new Error('unknown num color: ' + num);
};
var $21ff7154ad573d00$export$2e2bcd8739ae039 = $21ff7154ad573d00$var$num2rgb;

});

parcelRegister("gkdTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2949c4ecd598fe$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $be2949c4ecd598fe$var$rgb2num = (...args)=>{
    const [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    return (r << 16) + (g << 8) + b;
};
var $be2949c4ecd598fe$export$2e2bcd8739ae039 = $be2949c4ecd598fe$var$rgb2num;

});



parcelRegister("fWmFX", function(module, exports) {
parcelRequire("hskHC");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $b9addcb425bc1f3f$var$hcg = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hcg');
};
// register interpolator
(0, $5flPP.default).hcg = $b9addcb425bc1f3f$var$hcg;
var $b9addcb425bc1f3f$export$2e2bcd8739ae039 = $b9addcb425bc1f3f$var$hcg;

});
parcelRegister("hskHC", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $lQebz = parcelRequire("lQebz");

var $66Tfa = parcelRequire("66Tfa");
(0, $e7KSJ.default).prototype.hcg = function() {
    return (0, $66Tfa.default)(this._rgb);
};
const $cb551c44f4ef224a$export$e588e1c8c259384c = (...args)=>new (0, $e7KSJ.default)(...args, 'hcg');
(0, $gaK1V.default).hcg = $cb551c44f4ef224a$export$e588e1c8c259384c;
(0, $lT4NS.default).format.hcg = (0, $lQebz.default);
(0, $lT4NS.default).autodetect.push({
    p: 1,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hcg');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hcg';
    }
});

});
parcelRegister("lQebz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe697541ee37e71b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { floor: $fe697541ee37e71b$var$floor } = Math;
/*
 * this is basically just HSV with some minor tweaks
 *
 * hue.. [0..360]
 * chroma .. [0..1]
 * grayness .. [0..1]
 */ const $fe697541ee37e71b$var$hcg2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hcg');
    let [h, c, _g] = args;
    let r, g, b;
    _g = _g * 255;
    const _c = c * 255;
    if (c === 0) r = g = b = _g;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $fe697541ee37e71b$var$floor(h);
        const f = h - i;
        const p = _g * (1 - c);
        const q = p + _c * (1 - f);
        const t = p + _c * f;
        const v = p + _c;
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $fe697541ee37e71b$export$2e2bcd8739ae039 = $fe697541ee37e71b$var$hcg2rgb;

});

parcelRegister("66Tfa", function(module, exports) {

$parcel$export(module.exports, "default", () => $472e27dbd8c4997e$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $472e27dbd8c4997e$var$rgb2hcg = (...args)=>{
    const [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    const minRgb = (0, $i4gda.min)(r, g, b);
    const maxRgb = (0, $i4gda.max)(r, g, b);
    const delta = maxRgb - minRgb;
    const c = delta * 100 / 255;
    const _g = minRgb / (255 - delta) * 100;
    let h;
    if (delta === 0) h = Number.NaN;
    else {
        if (r === maxRgb) h = (g - b) / delta;
        if (g === maxRgb) h = 2 + (b - r) / delta;
        if (b === maxRgb) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        c,
        _g
    ];
};
var $472e27dbd8c4997e$export$2e2bcd8739ae039 = $472e27dbd8c4997e$var$rgb2hcg;

});



parcelRegister("3s82t", function(module, exports) {
parcelRequire("2yZD4");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $283a38fc382f3b9d$var$hsi = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsi');
};
// register interpolator
(0, $5flPP.default).hsi = $283a38fc382f3b9d$var$hsi;
var $283a38fc382f3b9d$export$2e2bcd8739ae039 = $283a38fc382f3b9d$var$hsi;

});
parcelRegister("2yZD4", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $l5tcy = parcelRequire("l5tcy");

var $jIBUL = parcelRequire("jIBUL");
(0, $e7KSJ.default).prototype.hsi = function() {
    return (0, $jIBUL.default)(this._rgb);
};
const $1dde90099f253c78$export$ec0e0a10cc3c404a = (...args)=>new (0, $e7KSJ.default)(...args, 'hsi');
(0, $gaK1V.default).hsi = $1dde90099f253c78$export$ec0e0a10cc3c404a;
(0, $lT4NS.default).format.hsi = (0, $l5tcy.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsi');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsi';
    }
});

});
parcelRegister("l5tcy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a0b7662948a353$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $gb2Ug = parcelRequire("gb2Ug");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { cos: $f5a0b7662948a353$var$cos } = Math;
/*
 * hue [0..360]
 * saturation [0..1]
 * intensity [0..1]
 */ const $f5a0b7662948a353$var$hsi2rgb = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
    */ args = (0, $43ZPL.default)(args, 'hsi');
    let [h, s, i] = args;
    let r, g, b;
    if (isNaN(h)) h = 0;
    if (isNaN(s)) s = 0;
    // normalize hue
    if (h > 360) h -= 360;
    if (h < 0) h += 360;
    h /= 360;
    if (h < 1 / 3) {
        b = (1 - s) / 3;
        r = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        g = 1 - (b + r);
    } else if (h < 2 / 3) {
        h -= 1 / 3;
        r = (1 - s) / 3;
        g = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        b = 1 - (r + g);
    } else {
        h -= 2 / 3;
        g = (1 - s) / 3;
        b = (1 + s * $f5a0b7662948a353$var$cos((0, $i4gda.TWOPI) * h) / $f5a0b7662948a353$var$cos((0, $i4gda.PITHIRD) - (0, $i4gda.TWOPI) * h)) / 3;
        r = 1 - (g + b);
    }
    r = (0, $gb2Ug.default)(i * r * 3);
    g = (0, $gb2Ug.default)(i * g * 3);
    b = (0, $gb2Ug.default)(i * b * 3);
    return [
        r * 255,
        g * 255,
        b * 255,
        args.length > 3 ? args[3] : 1
    ];
};
var $f5a0b7662948a353$export$2e2bcd8739ae039 = $f5a0b7662948a353$var$hsi2rgb;

});

parcelRegister("jIBUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5af8966c377d585$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { min: $e5af8966c377d585$var$min, sqrt: $e5af8966c377d585$var$sqrt, acos: $e5af8966c377d585$var$acos } = Math;
const $e5af8966c377d585$var$rgb2hsi = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
    */ let [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    r /= 255;
    g /= 255;
    b /= 255;
    let h;
    const min_ = $e5af8966c377d585$var$min(r, g, b);
    const i = (r + g + b) / 3;
    const s = i > 0 ? 1 - min_ / i : 0;
    if (s === 0) h = NaN;
    else {
        h = (r - g + (r - b)) / 2;
        h /= $e5af8966c377d585$var$sqrt((r - g) * (r - g) + (r - b) * (g - b));
        h = $e5af8966c377d585$var$acos(h);
        if (b > g) h = (0, $i4gda.TWOPI) - h;
        h /= (0, $i4gda.TWOPI);
    }
    return [
        h * 360,
        s,
        i
    ];
};
var $e5af8966c377d585$export$2e2bcd8739ae039 = $e5af8966c377d585$var$rgb2hsi;

});



parcelRegister("75dqB", function(module, exports) {
parcelRequire("fbI2I");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $52836a91adc4a3f4$var$hsl = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsl');
};
// register interpolator
(0, $5flPP.default).hsl = $52836a91adc4a3f4$var$hsl;
var $52836a91adc4a3f4$export$2e2bcd8739ae039 = $52836a91adc4a3f4$var$hsl;

});
parcelRegister("fbI2I", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $7PGtI = parcelRequire("7PGtI");

var $f9fTr = parcelRequire("f9fTr");
(0, $e7KSJ.default).prototype.hsl = function() {
    return (0, $f9fTr.default)(this._rgb);
};
const $b0ea0c19eddc0159$export$8f4a7c0bb78e6ea8 = (...args)=>new (0, $e7KSJ.default)(...args, 'hsl');
(0, $gaK1V.default).hsl = $b0ea0c19eddc0159$export$8f4a7c0bb78e6ea8;
(0, $lT4NS.default).format.hsl = (0, $7PGtI.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsl');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsl';
    }
});

});
parcelRegister("7PGtI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3e3f1c3bcf972f$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $5b3e3f1c3bcf972f$var$hsl2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hsl');
    const [h, s, l] = args;
    let r, g, b;
    if (s === 0) r = g = b = l * 255;
    else {
        const t3 = [
            0,
            0,
            0
        ];
        const c = [
            0,
            0,
            0
        ];
        const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const t1 = 2 * l - t2;
        const h_ = h / 360;
        t3[0] = h_ + 1 / 3;
        t3[1] = h_;
        t3[2] = h_ - 1 / 3;
        for(let i = 0; i < 3; i++){
            if (t3[i] < 0) t3[i] += 1;
            if (t3[i] > 1) t3[i] -= 1;
            if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
            else if (2 * t3[i] < 1) c[i] = t2;
            else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
            else c[i] = t1;
        }
        [r, g, b] = [
            c[0] * 255,
            c[1] * 255,
            c[2] * 255
        ];
    }
    if (args.length > 3) // keep alpha channel
    return [
        r,
        g,
        b,
        args[3]
    ];
    return [
        r,
        g,
        b,
        1
    ];
};
var $5b3e3f1c3bcf972f$export$2e2bcd8739ae039 = $5b3e3f1c3bcf972f$var$hsl2rgb;

});

parcelRegister("f9fTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0740654f8b78640$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - rgb2hsl(r,g,b)
 * - rgb2hsl(r,g,b,a)
 * - rgb2hsl([r,g,b])
 * - rgb2hsl([r,g,b,a])
 * - rgb2hsl({r,g,b,a})
 */ const $b0740654f8b78640$var$rgb2hsl = (...args)=>{
    args = (0, $43ZPL.default)(args, 'rgba');
    let [r, g, b] = args;
    r /= 255;
    g /= 255;
    b /= 255;
    const minRgb = (0, $i4gda.min)(r, g, b);
    const maxRgb = (0, $i4gda.max)(r, g, b);
    const l = (maxRgb + minRgb) / 2;
    let s, h;
    if (maxRgb === minRgb) {
        s = 0;
        h = Number.NaN;
    } else s = l < 0.5 ? (maxRgb - minRgb) / (maxRgb + minRgb) : (maxRgb - minRgb) / (2 - maxRgb - minRgb);
    if (r == maxRgb) h = (g - b) / (maxRgb - minRgb);
    else if (g == maxRgb) h = 2 + (b - r) / (maxRgb - minRgb);
    else if (b == maxRgb) h = 4 + (r - g) / (maxRgb - minRgb);
    h *= 60;
    if (h < 0) h += 360;
    if (args.length > 3 && args[3] !== undefined) return [
        h,
        s,
        l,
        args[3]
    ];
    return [
        h,
        s,
        l
    ];
};
var $b0740654f8b78640$export$2e2bcd8739ae039 = $b0740654f8b78640$var$rgb2hsl;

});



parcelRegister("2ISBM", function(module, exports) {
parcelRequire("7Z9E2");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $1fba0cefa8ec10d2$var$hsv = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'hsv');
};
// register interpolator
(0, $5flPP.default).hsv = $1fba0cefa8ec10d2$var$hsv;
var $1fba0cefa8ec10d2$export$2e2bcd8739ae039 = $1fba0cefa8ec10d2$var$hsv;

});
parcelRegister("7Z9E2", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $eNZr2 = parcelRequire("eNZr2");

var $8GFTU = parcelRequire("8GFTU");
(0, $e7KSJ.default).prototype.hsv = function() {
    return (0, $8GFTU.default)(this._rgb);
};
const $5d05b62ca5e0b832$export$a5d7c789f12d2213 = (...args)=>new (0, $e7KSJ.default)(...args, 'hsv');
(0, $gaK1V.default).hsv = $5d05b62ca5e0b832$export$a5d7c789f12d2213;
(0, $lT4NS.default).format.hsv = (0, $eNZr2.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'hsv');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'hsv';
    }
});

});
parcelRegister("eNZr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c815df05a1cd8b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { floor: $02c815df05a1cd8b$var$floor } = Math;
const $02c815df05a1cd8b$var$hsv2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'hsv');
    let [h, s, v] = args;
    let r, g, b;
    v *= 255;
    if (s === 0) r = g = b = v;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $02c815df05a1cd8b$var$floor(h);
        const f = h - i;
        const p = v * (1 - s);
        const q = v * (1 - s * f);
        const t = v * (1 - s * (1 - f));
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $02c815df05a1cd8b$export$2e2bcd8739ae039 = $02c815df05a1cd8b$var$hsv2rgb;

});

parcelRegister("8GFTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6532bf9b6866bc48$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { min: $6532bf9b6866bc48$var$min, max: $6532bf9b6866bc48$var$max } = Math;
/*
 * supported arguments:
 * - rgb2hsv(r,g,b)
 * - rgb2hsv([r,g,b])
 * - rgb2hsv({r,g,b})
 */ const $6532bf9b6866bc48$var$rgb2hsl = (...args)=>{
    args = (0, $43ZPL.default)(args, 'rgb');
    let [r, g, b] = args;
    const min_ = $6532bf9b6866bc48$var$min(r, g, b);
    const max_ = $6532bf9b6866bc48$var$max(r, g, b);
    const delta = max_ - min_;
    let h, s, v;
    v = max_ / 255.0;
    if (max_ === 0) {
        h = Number.NaN;
        s = 0;
    } else {
        s = delta / max_;
        if (r === max_) h = (g - b) / delta;
        if (g === max_) h = 2 + (b - r) / delta;
        if (b === max_) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        s,
        v
    ];
};
var $6532bf9b6866bc48$export$2e2bcd8739ae039 = $6532bf9b6866bc48$var$rgb2hsl;

});



parcelRegister("52gBS", function(module, exports) {
parcelRequire("j6weT");

var $5flPP = parcelRequire("5flPP");

var $e7KSJ = parcelRequire("e7KSJ");
const $3aaa060894ca8484$var$oklab = (col1, col2, f)=>{
    const xyz0 = col1.oklab();
    const xyz1 = col2.oklab();
    return new (0, $e7KSJ.default)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'oklab');
};
// register interpolator
(0, $5flPP.default).oklab = $3aaa060894ca8484$var$oklab;
var $3aaa060894ca8484$export$2e2bcd8739ae039 = $3aaa060894ca8484$var$oklab;

});
parcelRegister("j6weT", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $5D4bx = parcelRequire("5D4bx");

var $eJb2q = parcelRequire("eJb2q");
(0, $e7KSJ.default).prototype.oklab = function() {
    return (0, $eJb2q.default)(this._rgb);
};
const $de8795def78a20d0$export$b14b17e4e916d621 = (...args)=>new (0, $e7KSJ.default)(...args, 'oklab');
Object.assign((0, $gaK1V.default), {
    oklab: $de8795def78a20d0$export$b14b17e4e916d621
});
(0, $lT4NS.default).format.oklab = (0, $5D4bx.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'oklab');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'oklab';
    }
});

});
parcelRegister("5D4bx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4193d753772cec6b$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $iIsar = parcelRequire("iIsar");

var $jenZn = parcelRequire("jenZn");
const $4193d753772cec6b$var$oklab2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lab');
    const [L, a, b, ...rest] = args;
    const [X, Y, Z] = $4193d753772cec6b$var$OKLab_to_XYZ([
        L,
        a,
        b
    ]);
    const [r, g, b_] = (0, $jenZn.xyz2rgb)(X, Y, Z);
    return [
        r,
        g,
        b_,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $4193d753772cec6b$var$OKLab_to_XYZ(OKLab) {
    // Given OKLab, convert to XYZ relative to D65
    var LMStoXYZ = [
        [
            1.2268798758459243,
            -0.5578149944602171,
            0.2813910456659647
        ],
        [
            -0.0405757452148008,
            1.112286803280317,
            -0.0717110580655164
        ],
        [
            -0.0763729366746601,
            -0.4214933324022432,
            1.5869240198367816
        ]
    ];
    var OKLabtoLMS = [
        [
            1.0,
            0.3963377773761749,
            0.2158037573099136
        ],
        [
            1.0,
            -0.1055613458156586,
            -0.0638541728258133
        ],
        [
            1.0,
            -0.0894841775298119,
            -1.2914855480194092
        ]
    ];
    var LMSnl = (0, $iIsar.default)(OKLabtoLMS, OKLab);
    return (0, $iIsar.default)(LMStoXYZ, LMSnl.map((c)=>c ** 3));
}
var $4193d753772cec6b$export$2e2bcd8739ae039 = $4193d753772cec6b$var$oklab2rgb;

});
parcelRegister("iIsar", function(module, exports) {

$parcel$export(module.exports, "default", () => $da022f8598f5340d$export$2e2bcd8739ae039);
// from https://www.w3.org/TR/css-color-4/multiply-matrices.js
function $da022f8598f5340d$export$2e2bcd8739ae039(A, B) {
    let m = A.length;
    if (!Array.isArray(A[0])) // A is vector, convert to [[a, b, c, ...]]
    A = [
        A
    ];
    if (!Array.isArray(B[0])) // B is vector, convert to [[a], [b], [c], ...]]
    B = B.map((x)=>[
            x
        ]);
    let p = B[0].length;
    let B_cols = B[0].map((_, i)=>B.map((x)=>x[i])); // transpose B
    let product = A.map((row)=>B_cols.map((col)=>{
            if (!Array.isArray(row)) return col.reduce((a, c)=>a + c * row, 0);
            return row.reduce((a, c, i)=>a + c * (col[i] || 0), 0);
        }));
    if (m === 1) product = product[0]; // Avoid [[a, b, c, ...]]
    if (p === 1) return product.map((x)=>x[0]); // Avoid [[a], [b], [c], ...]]
    return product;
}

});


parcelRegister("eJb2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8dd493bc48c920$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $iIsar = parcelRequire("iIsar");

var $luvnN = parcelRequire("luvnN");
const $ab8dd493bc48c920$var$rgb2oklab = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const xyz = (0, $luvnN.rgb2xyz)(r, g, b);
    const oklab = $ab8dd493bc48c920$var$XYZ_to_OKLab(xyz);
    return [
        ...oklab,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function $ab8dd493bc48c920$var$XYZ_to_OKLab(XYZ) {
    // Given XYZ relative to D65, convert to OKLab
    const XYZtoLMS = [
        [
            0.819022437996703,
            0.3619062600528904,
            -0.1288737815209879
        ],
        [
            0.0329836539323885,
            0.9292868615863434,
            0.0361446663506424
        ],
        [
            0.0481771893596242,
            0.2642395317527308,
            0.6335478284694309
        ]
    ];
    const LMStoOKLab = [
        [
            0.210454268309314,
            0.7936177747023054,
            -0.0040720430116193
        ],
        [
            1.9779985324311684,
            -2.42859224204858,
            0.450593709617411
        ],
        [
            0.0259040424655478,
            0.7827717124575296,
            -0.8086757549230774
        ]
    ];
    const LMS = (0, $iIsar.default)(XYZtoLMS, XYZ);
    // JavaScript Math.cbrt returns a sign-matched cube root
    // beware if porting to other languages
    // especially if tempted to use a general power function
    return (0, $iIsar.default)(LMStoOKLab, LMS.map((c)=>Math.cbrt(c)));
// L in range [0,1]. For use in CSS, multiply by 100 and add a percent
}
var $ab8dd493bc48c920$export$2e2bcd8739ae039 = $ab8dd493bc48c920$var$rgb2oklab;

});



parcelRegister("3wKag", function(module, exports) {
parcelRequire("getAx");

var $9mSMN = parcelRequire("9mSMN");

var $5flPP = parcelRequire("5flPP");
const $29182b9272ebb9ac$var$oklch = (col1, col2, f)=>{
    return (0, $9mSMN.default)(col1, col2, f, 'oklch');
};
// register interpolator
(0, $5flPP.default).oklch = $29182b9272ebb9ac$var$oklch;
var $29182b9272ebb9ac$export$2e2bcd8739ae039 = $29182b9272ebb9ac$var$oklch;

});

parcelRegister("8UmTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c54fb1da1f0bdc$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
const { pow: $67c54fb1da1f0bdc$var$pow, sqrt: $67c54fb1da1f0bdc$var$sqrt, PI: $67c54fb1da1f0bdc$var$PI, cos: $67c54fb1da1f0bdc$var$cos, sin: $67c54fb1da1f0bdc$var$sin, atan2: $67c54fb1da1f0bdc$var$atan2 } = Math;
var $67c54fb1da1f0bdc$export$2e2bcd8739ae039 = (colors, mode = 'lrgb', weights = null)=>{
    const l = colors.length;
    if (!weights) weights = Array.from(new Array(l)).map(()=>1);
    // normalize weights
    const k = l / weights.reduce(function(a, b) {
        return a + b;
    });
    weights.forEach((w, i)=>{
        weights[i] *= k;
    });
    // convert colors to Color objects
    colors = colors.map((c)=>new (0, $e7KSJ.default)(c));
    if (mode === 'lrgb') return $67c54fb1da1f0bdc$var$_average_lrgb(colors, weights);
    const first = colors.shift();
    const xyz = first.get(mode);
    const cnt = [];
    let dx = 0;
    let dy = 0;
    // initial color
    for(let i = 0; i < xyz.length; i++){
        xyz[i] = (xyz[i] || 0) * weights[0];
        cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
        if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
            const A = xyz[i] / 180 * $67c54fb1da1f0bdc$var$PI;
            dx += $67c54fb1da1f0bdc$var$cos(A) * weights[0];
            dy += $67c54fb1da1f0bdc$var$sin(A) * weights[0];
        }
    }
    let alpha = first.alpha() * weights[0];
    colors.forEach((c, ci)=>{
        const xyz2 = c.get(mode);
        alpha += c.alpha() * weights[ci + 1];
        for(let i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
            cnt[i] += weights[ci + 1];
            if (mode.charAt(i) === 'h') {
                const A = xyz2[i] / 180 * $67c54fb1da1f0bdc$var$PI;
                dx += $67c54fb1da1f0bdc$var$cos(A) * weights[ci + 1];
                dy += $67c54fb1da1f0bdc$var$sin(A) * weights[ci + 1];
            } else xyz[i] += xyz2[i] * weights[ci + 1];
        }
    });
    for(let i = 0; i < xyz.length; i++)if (mode.charAt(i) === 'h') {
        let A = $67c54fb1da1f0bdc$var$atan2(dy / cnt[i], dx / cnt[i]) / $67c54fb1da1f0bdc$var$PI * 180;
        while(A < 0)A += 360;
        while(A >= 360)A -= 360;
        xyz[i] = A;
    } else xyz[i] = xyz[i] / cnt[i];
    alpha /= l;
    return new (0, $e7KSJ.default)(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
};
const $67c54fb1da1f0bdc$var$_average_lrgb = (colors, weights)=>{
    const l = colors.length;
    const xyz = [
        0,
        0,
        0,
        0
    ];
    for(let i = 0; i < colors.length; i++){
        const col = colors[i];
        const f = weights[i] / l;
        const rgb = col._rgb;
        xyz[0] += $67c54fb1da1f0bdc$var$pow(rgb[0], 2) * f;
        xyz[1] += $67c54fb1da1f0bdc$var$pow(rgb[1], 2) * f;
        xyz[2] += $67c54fb1da1f0bdc$var$pow(rgb[2], 2) * f;
        xyz[3] += rgb[3] * f;
    }
    xyz[0] = $67c54fb1da1f0bdc$var$sqrt(xyz[0]);
    xyz[1] = $67c54fb1da1f0bdc$var$sqrt(xyz[1]);
    xyz[2] = $67c54fb1da1f0bdc$var$sqrt(xyz[2]);
    if (xyz[3] > 0.9999999) xyz[3] = 1;
    return new (0, $e7KSJ.default)((0, $8TO5X.default)(xyz));
};

});

parcelRegister("9u72g", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7c5f855046555e$export$2e2bcd8739ae039);
//
// interpolates between a set of colors uzing a bezier spline
//
// @requires utils lab

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("996dd");

var $4ZQS0 = parcelRequire("4ZQS0");
// nth row of the pascal triangle
const $6e7c5f855046555e$var$binom_row = function(n) {
    let row = [
        1,
        1
    ];
    for(let i = 1; i < n; i++){
        let newrow = [
            1
        ];
        for(let j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
        row = newrow;
    }
    return row;
};
const $6e7c5f855046555e$var$bezier = function(colors) {
    let I, lab0, lab1, lab2;
    colors = colors.map((c)=>new (0, $e7KSJ.default)(c));
    if (colors.length === 2) {
        // linear interpolation
        [lab0, lab1] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>lab0[i] + t * (lab1[i] - lab0[i]));
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length === 3) {
        // quadratic bezier interpolation
        [lab0, lab1, lab2] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length === 4) {
        // cubic bezier interpolation
        let lab3;
        [lab0, lab1, lab2, lab3] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else if (colors.length >= 5) {
        // general case (degree n bezier)
        let labs, row, n;
        labs = colors.map((c)=>c.lab());
        n = colors.length - 1;
        row = $6e7c5f855046555e$var$binom_row(n);
        I = function(t) {
            const u = 1 - t;
            const lab = [
                0,
                1,
                2
            ].map((i)=>labs.reduce((sum, el, j)=>sum + row[j] * u ** (n - j) * t ** j * el[i], 0));
            return new (0, $e7KSJ.default)(lab, 'lab');
        };
    } else throw new RangeError('No point in running bezier with only one color.');
    return I;
};
var $6e7c5f855046555e$export$2e2bcd8739ae039 = (colors)=>{
    const f = $6e7c5f855046555e$var$bezier(colors);
    f.scale = ()=>(0, $4ZQS0.default)(f);
    return f;
};

});
parcelRegister("4ZQS0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a35ded86e36da0d$export$2e2bcd8739ae039);
// minimal multi-purpose interface
// @requires utils color analyze

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("i4gda");
var $gb2Ug = parcelRequire("gb2Ug");
var $hMEmV = parcelRequire("hMEmV");
const { pow: $3a35ded86e36da0d$var$pow } = Math;
function $3a35ded86e36da0d$export$2e2bcd8739ae039(colors) {
    // constructor
    let _mode = 'rgb';
    let _nacol = (0, $gaK1V.default)('#ccc');
    let _spread = 0;
    // const _fixed = false;
    let _domain = [
        0,
        1
    ];
    let _pos = [];
    let _padding = [
        0,
        0
    ];
    let _classes = false;
    let _colors = [];
    let _out = false;
    let _min = 0;
    let _max = 1;
    let _correctLightness = false;
    let _colorCache = {};
    let _useCache = true;
    let _gamma = 1;
    // private methods
    const setColors = function(colors) {
        colors = colors || [
            '#fff',
            '#000'
        ];
        if (colors && (0, $hMEmV.default)(colors) === 'string' && (0, $gaK1V.default).brewer && (0, $gaK1V.default).brewer[colors.toLowerCase()]) colors = (0, $gaK1V.default).brewer[colors.toLowerCase()];
        if ((0, $hMEmV.default)(colors) === 'array') {
            // handle single color
            if (colors.length === 1) colors = [
                colors[0],
                colors[0]
            ];
            // make a copy of the colors
            colors = colors.slice(0);
            // convert to chroma classes
            for(let c = 0; c < colors.length; c++)colors[c] = (0, $gaK1V.default)(colors[c]);
            // auto-fill color position
            _pos.length = 0;
            for(let c = 0; c < colors.length; c++)_pos.push(c / (colors.length - 1));
        }
        resetCache();
        return _colors = colors;
    };
    const getClass = function(value) {
        if (_classes != null) {
            const n = _classes.length - 1;
            let i = 0;
            while(i < n && value >= _classes[i])i++;
            return i - 1;
        }
        return 0;
    };
    let tMapLightness = (t)=>t;
    let tMapDomain = (t)=>t;
    // const classifyValue = function(value) {
    //     let val = value;
    //     if (_classes.length > 2) {
    //         const n = _classes.length-1;
    //         const i = getClass(value);
    //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
    //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
    //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
    //     }
    //     return val;
    // };
    const getColor = function(val, bypassMap) {
        let col, t;
        if (bypassMap == null) bypassMap = false;
        if (isNaN(val) || val === null) return _nacol;
        if (!bypassMap) {
            if (_classes && _classes.length > 2) {
                // find the class
                const c = getClass(val);
                t = c / (_classes.length - 2);
            } else if (_max !== _min) // just interpolate between min/max
            t = (val - _min) / (_max - _min);
            else t = 1;
        } else t = val;
        // domain map
        t = tMapDomain(t);
        if (!bypassMap) t = tMapLightness(t); // lightness correction
        if (_gamma !== 1) t = $3a35ded86e36da0d$var$pow(t, _gamma);
        t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
        t = (0, $gb2Ug.default)(t, 0, 1);
        const k = Math.floor(t * 10000);
        if (_useCache && _colorCache[k]) col = _colorCache[k];
        else {
            if ((0, $hMEmV.default)(_colors) === 'array') //for i in [0.._pos.length-1]
            for(let i = 0; i < _pos.length; i++){
                const p = _pos[i];
                if (t <= p) {
                    col = _colors[i];
                    break;
                }
                if (t >= p && i === _pos.length - 1) {
                    col = _colors[i];
                    break;
                }
                if (t > p && t < _pos[i + 1]) {
                    t = (t - p) / (_pos[i + 1] - p);
                    col = (0, $gaK1V.default).interpolate(_colors[i], _colors[i + 1], t, _mode);
                    break;
                }
            }
            else if ((0, $hMEmV.default)(_colors) === 'function') col = _colors(t);
            if (_useCache) _colorCache[k] = col;
        }
        return col;
    };
    var resetCache = ()=>_colorCache = {};
    setColors(colors);
    // public interface
    const f = function(v) {
        const c = (0, $gaK1V.default)(getColor(v));
        if (_out && c[_out]) return c[_out]();
        else return c;
    };
    f.classes = function(classes) {
        if (classes != null) {
            if ((0, $hMEmV.default)(classes) === 'array') {
                _classes = classes;
                _domain = [
                    classes[0],
                    classes[classes.length - 1]
                ];
            } else {
                const d = (0, $gaK1V.default).analyze(_domain);
                if (classes === 0) _classes = [
                    d.min,
                    d.max
                ];
                else _classes = (0, $gaK1V.default).limits(d, 'e', classes);
            }
            return f;
        }
        return _classes;
    };
    f.domain = function(domain) {
        if (!arguments.length) return _domain;
        _min = domain[0];
        _max = domain[domain.length - 1];
        _pos = [];
        const k = _colors.length;
        if (domain.length === k && _min !== _max) // update positions
        for (let d of Array.from(domain))_pos.push((d - _min) / (_max - _min));
        else {
            for(let c = 0; c < k; c++)_pos.push(c / (k - 1));
            if (domain.length > 2) {
                // set domain map
                const tOut = domain.map((d, i)=>i / (domain.length - 1));
                const tBreaks = domain.map((d)=>(d - _min) / (_max - _min));
                if (!tBreaks.every((val, i)=>tOut[i] === val)) tMapDomain = (t)=>{
                    if (t <= 0 || t >= 1) return t;
                    let i = 0;
                    while(t >= tBreaks[i + 1])i++;
                    const f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                    const out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                    return out;
                };
            }
        }
        _domain = [
            _min,
            _max
        ];
        return f;
    };
    f.mode = function(_m) {
        if (!arguments.length) return _mode;
        _mode = _m;
        resetCache();
        return f;
    };
    f.range = function(colors, _pos) {
        setColors(colors, _pos);
        return f;
    };
    f.out = function(_o) {
        _out = _o;
        return f;
    };
    f.spread = function(val) {
        if (!arguments.length) return _spread;
        _spread = val;
        return f;
    };
    f.correctLightness = function(v) {
        if (v == null) v = true;
        _correctLightness = v;
        resetCache();
        if (_correctLightness) tMapLightness = function(t) {
            const L0 = getColor(0, true).lab()[0];
            const L1 = getColor(1, true).lab()[0];
            const pol = L0 > L1;
            let L_actual = getColor(t, true).lab()[0];
            const L_ideal = L0 + (L1 - L0) * t;
            let L_diff = L_actual - L_ideal;
            let t0 = 0;
            let t1 = 1;
            let max_iter = 20;
            while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                if (pol) L_diff *= -1;
                if (L_diff < 0) {
                    t0 = t;
                    t += (t1 - t) * 0.5;
                } else {
                    t1 = t;
                    t += (t0 - t) * 0.5;
                }
                L_actual = getColor(t, true).lab()[0];
                return L_diff = L_actual - L_ideal;
            })();
            return t;
        };
        else tMapLightness = (t)=>t;
        return f;
    };
    f.padding = function(p) {
        if (p != null) {
            if ((0, $hMEmV.default)(p) === 'number') p = [
                p,
                p
            ];
            _padding = p;
            return f;
        } else return _padding;
    };
    f.colors = function(numColors, out) {
        // If no arguments are given, return the original colors that were provided
        if (arguments.length < 2) out = 'hex';
        let result = [];
        if (arguments.length === 0) result = _colors.slice(0);
        else if (numColors === 1) result = [
            f(0.5)
        ];
        else if (numColors > 1) {
            const dm = _domain[0];
            const dd = _domain[1] - dm;
            result = $3a35ded86e36da0d$var$__range__(0, numColors, false).map((i)=>f(dm + i / (numColors - 1) * dd));
        } else {
            // returns all colors based on the defined classes
            colors = [];
            let samples = [];
            if (_classes && _classes.length > 2) for(let i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
            else samples = _domain;
            result = samples.map((v)=>f(v));
        }
        if ((0, $gaK1V.default)[out]) result = result.map((c)=>c[out]());
        return result;
    };
    f.cache = function(c) {
        if (c != null) {
            _useCache = c;
            return f;
        } else return _useCache;
    };
    f.gamma = function(g) {
        if (g != null) {
            _gamma = g;
            return f;
        } else return _gamma;
    };
    f.nodata = function(d) {
        if (d != null) {
            _nacol = (0, $gaK1V.default)(d);
            return f;
        } else return _nacol;
    };
    return f;
}
function $3a35ded86e36da0d$var$__range__(left, right, inclusive) {
    let range = [];
    let ascending = left < right;
    let end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(let i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
}

});


parcelRegister("hKhjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceb429f3a9f3c855$export$2e2bcd8739ae039);
/*
 * interpolates between a set of colors uzing a bezier spline
 * blend mode formulas taken from https://web.archive.org/web/20180110014946/http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
 */ parcelRequire("ayOPU");

var $gaK1V = parcelRequire("gaK1V");
const $ceb429f3a9f3c855$var$blend = (bottom, top, mode)=>{
    if (!$ceb429f3a9f3c855$var$blend[mode]) throw new Error('unknown blend mode ' + mode);
    return $ceb429f3a9f3c855$var$blend[mode](bottom, top);
};
const $ceb429f3a9f3c855$var$blend_f = (f)=>(bottom, top)=>{
        const c0 = (0, $gaK1V.default)(top).rgb();
        const c1 = (0, $gaK1V.default)(bottom).rgb();
        return (0, $gaK1V.default).rgb(f(c0, c1));
    };
const $ceb429f3a9f3c855$var$each = (f)=>(c0, c1)=>{
        const out = [];
        out[0] = f(c0[0], c1[0]);
        out[1] = f(c0[1], c1[1]);
        out[2] = f(c0[2], c1[2]);
        return out;
    };
const $ceb429f3a9f3c855$var$normal = (a)=>a;
const $ceb429f3a9f3c855$var$multiply = (a, b)=>a * b / 255;
const $ceb429f3a9f3c855$var$darken = (a, b)=>a > b ? b : a;
const $ceb429f3a9f3c855$var$lighten = (a, b)=>a > b ? a : b;
const $ceb429f3a9f3c855$var$screen = (a, b)=>255 * (1 - (1 - a / 255) * (1 - b / 255));
const $ceb429f3a9f3c855$var$overlay = (a, b)=>b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
const $ceb429f3a9f3c855$var$burn = (a, b)=>255 * (1 - (1 - b / 255) / (a / 255));
const $ceb429f3a9f3c855$var$dodge = (a, b)=>{
    if (a === 255) return 255;
    a = 255 * (b / 255) / (1 - a / 255);
    return a > 255 ? 255 : a;
};
// # add = (a,b) ->
// #     if (a + b > 255) then 255 else a + b
$ceb429f3a9f3c855$var$blend.normal = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$normal));
$ceb429f3a9f3c855$var$blend.multiply = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$multiply));
$ceb429f3a9f3c855$var$blend.screen = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$screen));
$ceb429f3a9f3c855$var$blend.overlay = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$overlay));
$ceb429f3a9f3c855$var$blend.darken = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$darken));
$ceb429f3a9f3c855$var$blend.lighten = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$lighten));
$ceb429f3a9f3c855$var$blend.dodge = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$dodge));
$ceb429f3a9f3c855$var$blend.burn = $ceb429f3a9f3c855$var$blend_f($ceb429f3a9f3c855$var$each($ceb429f3a9f3c855$var$burn));
var // blend.add = blend_f(each(add));
$ceb429f3a9f3c855$export$2e2bcd8739ae039 = $ceb429f3a9f3c855$var$blend;

});
parcelRegister("ayOPU", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");
const { round: $7b04835af4de31ed$var$round } = Math;
(0, $e7KSJ.default).prototype.rgb = function(rnd = true) {
    if (rnd === false) return this._rgb.slice(0, 3);
    return this._rgb.slice(0, 3).map($7b04835af4de31ed$var$round);
};
(0, $e7KSJ.default).prototype.rgba = function(rnd = true) {
    return this._rgb.slice(0, 4).map((v, i)=>{
        return i < 3 ? rnd === false ? v : $7b04835af4de31ed$var$round(v) : v;
    });
};
const $7b04835af4de31ed$export$8972dc0e6ad9238f = (...args)=>new (0, $e7KSJ.default)(...args, 'rgb');
Object.assign((0, $gaK1V.default), {
    rgb: $7b04835af4de31ed$export$8972dc0e6ad9238f
});
(0, $lT4NS.default).format.rgb = (...args)=>{
    const rgba = (0, $43ZPL.default)(args, 'rgba');
    if (rgba[3] === undefined) rgba[3] = 1;
    return rgba;
};
(0, $lT4NS.default).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'rgba');
        if ((0, $hMEmV.default)(args) === 'array' && (args.length === 3 || args.length === 4 && (0, $hMEmV.default)(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) return 'rgb';
    }
});

});


parcelRegister("jpCQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e21e7c3c7180c018$export$2e2bcd8739ae039);
// cubehelix interpolation
// based on D.A. Green "A colour scheme for the display of astronomical intensity images"
// http://astron-soc.in/bulletin/11June/289392011.pdf
parcelRequire("i4gda");
var $8TO5X = parcelRequire("8TO5X");
var $i4gda = parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $gaK1V = parcelRequire("gaK1V");
const { pow: $e21e7c3c7180c018$var$pow, sin: $e21e7c3c7180c018$var$sin, cos: $e21e7c3c7180c018$var$cos } = Math;
function $e21e7c3c7180c018$export$2e2bcd8739ae039(start = 300, rotations = -1.5, hue = 1, gamma = 1, lightness = [
    0,
    1
]) {
    let dh = 0, dl;
    if ((0, $hMEmV.default)(lightness) === 'array') dl = lightness[1] - lightness[0];
    else {
        dl = 0;
        lightness = [
            lightness,
            lightness
        ];
    }
    const f = function(fract) {
        const a = (0, $i4gda.TWOPI) * ((start + 120) / 360 + rotations * fract);
        const l = $e21e7c3c7180c018$var$pow(lightness[0] + dl * fract, gamma);
        const h = dh !== 0 ? hue[0] + fract * dh : hue;
        const amp = h * l * (1 - l) / 2;
        const cos_a = $e21e7c3c7180c018$var$cos(a);
        const sin_a = $e21e7c3c7180c018$var$sin(a);
        const r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
        const g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
        const b = l + amp * (1.97294 * cos_a);
        return (0, $gaK1V.default)((0, $8TO5X.default)([
            r * 255,
            g * 255,
            b * 255,
            1
        ]));
    };
    f.start = function(s) {
        if (s == null) return start;
        start = s;
        return f;
    };
    f.rotations = function(r) {
        if (r == null) return rotations;
        rotations = r;
        return f;
    };
    f.gamma = function(g) {
        if (g == null) return gamma;
        gamma = g;
        return f;
    };
    f.hue = function(h) {
        if (h == null) return hue;
        hue = h;
        if ((0, $hMEmV.default)(hue) === 'array') {
            dh = hue[1] - hue[0];
            if (dh === 0) hue = hue[1];
        } else dh = 0;
        return f;
    };
    f.lightness = function(h) {
        if (h == null) return lightness;
        if ((0, $hMEmV.default)(h) === 'array') {
            lightness = h;
            dl = h[1] - h[0];
        } else {
            lightness = [
                h,
                h
            ];
            dl = 0;
        }
        return f;
    };
    f.scale = ()=>(0, $gaK1V.default).scale(f);
    f.hue(hue);
    return f;
}

});

parcelRegister("eIGWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab767cecc86e20d8$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
const $ab767cecc86e20d8$var$digits = '0123456789abcdef';
const { floor: $ab767cecc86e20d8$var$floor, random: $ab767cecc86e20d8$var$random } = Math;
var $ab767cecc86e20d8$export$2e2bcd8739ae039 = ()=>{
    let code = '#';
    for(let i = 0; i < 6; i++)code += $ab767cecc86e20d8$var$digits.charAt($ab767cecc86e20d8$var$floor($ab767cecc86e20d8$var$random() * 16));
    return new (0, $e7KSJ.default)(code, 'hex');
};

});

parcelRegister("cgHIr", function(module, exports) {

$parcel$export(module.exports, "analyze", () => $8ee8e3ba2352afc1$export$7cbcccfbecde6416);
$parcel$export(module.exports, "limits", () => $8ee8e3ba2352afc1$export$e331ca4ad6a82555);

var $hMEmV = parcelRequire("hMEmV");
const { log: $8ee8e3ba2352afc1$var$log, pow: $8ee8e3ba2352afc1$var$pow, floor: $8ee8e3ba2352afc1$var$floor, abs: $8ee8e3ba2352afc1$var$abs } = Math;
function $8ee8e3ba2352afc1$export$7cbcccfbecde6416(data, key = null) {
    const r = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
    };
    if ((0, $hMEmV.default)(data) === 'object') data = Object.values(data);
    data.forEach((val)=>{
        if (key && (0, $hMEmV.default)(val) === 'object') val = val[key];
        if (val !== undefined && val !== null && !isNaN(val)) {
            r.values.push(val);
            r.sum += val;
            if (val < r.min) r.min = val;
            if (val > r.max) r.max = val;
            r.count += 1;
        }
    });
    r.domain = [
        r.min,
        r.max
    ];
    r.limits = (mode, num)=>$8ee8e3ba2352afc1$export$e331ca4ad6a82555(r, mode, num);
    return r;
}
function $8ee8e3ba2352afc1$export$e331ca4ad6a82555(data, mode = 'equal', num = 7) {
    if ((0, $hMEmV.default)(data) == 'array') data = $8ee8e3ba2352afc1$export$7cbcccfbecde6416(data);
    const { min: min, max: max } = data;
    const values = data.values.sort((a, b)=>a - b);
    if (num === 1) return [
        min,
        max
    ];
    const limits1 = [];
    if (mode.substr(0, 1) === 'c') {
        // continuous
        limits1.push(min);
        limits1.push(max);
    }
    if (mode.substr(0, 1) === 'e') {
        // equal interval
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push(min + i / num * (max - min));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'l') {
        // log scale
        if (min <= 0) throw new Error('Logarithmic scales are only possible for values > 0');
        const min_log = Math.LOG10E * $8ee8e3ba2352afc1$var$log(min);
        const max_log = Math.LOG10E * $8ee8e3ba2352afc1$var$log(max);
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push($8ee8e3ba2352afc1$var$pow(10, min_log + i / num * (max_log - min_log)));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'q') {
        // quantile scale
        limits1.push(min);
        for(let i = 1; i < num; i++){
            const p = (values.length - 1) * i / num;
            const pb = $8ee8e3ba2352afc1$var$floor(p);
            if (pb === p) limits1.push(values[pb]);
            else {
                // p > pb
                const pr = p - pb;
                limits1.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
            }
        }
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'k') {
        // k-means clustering
        /*
        implementation based on
        http://code.google.com/p/figue/source/browse/trunk/figue.js#336
        simplified for 1-d input values
        */ let cluster;
        const n = values.length;
        const assignments = new Array(n);
        const clusterSizes = new Array(num);
        let repeat = true;
        let nb_iters = 0;
        let centroids = null;
        // get seed values
        centroids = [];
        centroids.push(min);
        for(let i = 1; i < num; i++)centroids.push(min + i / num * (max - min));
        centroids.push(max);
        while(repeat){
            // assignment step
            for(let j = 0; j < num; j++)clusterSizes[j] = 0;
            for(let i = 0; i < n; i++){
                const value = values[i];
                let mindist = Number.MAX_VALUE;
                let best;
                for(let j = 0; j < num; j++){
                    const dist = $8ee8e3ba2352afc1$var$abs(centroids[j] - value);
                    if (dist < mindist) {
                        mindist = dist;
                        best = j;
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
            }
            // update centroids step
            const newCentroids = new Array(num);
            for(let j = 0; j < num; j++)newCentroids[j] = null;
            for(let i = 0; i < n; i++){
                cluster = assignments[i];
                if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                else newCentroids[cluster] += values[i];
            }
            for(let j = 0; j < num; j++)newCentroids[j] *= 1 / clusterSizes[j];
            // check convergence
            repeat = false;
            for(let j = 0; j < num; j++)if (newCentroids[j] !== centroids[j]) {
                repeat = true;
                break;
            }
            centroids = newCentroids;
            nb_iters++;
            if (nb_iters > 200) repeat = false;
        }
        // finished k-means clustering
        // the next part is borrowed from gabrielflor.it
        const kClusters = {};
        for(let j = 0; j < num; j++)kClusters[j] = [];
        for(let i = 0; i < n; i++){
            cluster = assignments[i];
            kClusters[cluster].push(values[i]);
        }
        let tmpKMeansBreaks = [];
        for(let j = 0; j < num; j++){
            tmpKMeansBreaks.push(kClusters[j][0]);
            tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
        }
        tmpKMeansBreaks = tmpKMeansBreaks.sort((a, b)=>a - b);
        limits1.push(tmpKMeansBreaks[0]);
        for(let i = 1; i < tmpKMeansBreaks.length; i += 2){
            const v = tmpKMeansBreaks[i];
            if (!isNaN(v) && limits1.indexOf(v) === -1) limits1.push(v);
        }
    }
    return limits1;
}

});

parcelRegister("5BDZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $414f6dca23b2a9de$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
parcelRequire("hDPZe");
var $414f6dca23b2a9de$export$2e2bcd8739ae039 = (a, b)=>{
    // WCAG contrast ratio
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const l1 = a.luminance();
    const l2 = b.luminance();
    return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
};

});

parcelRegister("iM4ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab003980244b19f$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");

var $dvq8W = parcelRequire("dvq8W");
/**
 * @license
 *
 * The APCA contrast prediction algorithm is based of the formulas published
 * in the APCA-1.0.98G specification by Myndex. The specification is available at:
 * https://raw.githubusercontent.com/Myndex/apca-w3/master/images/APCAw3_0.1.17_APCA0.0.98G.svg
 *
 * Note that the APCA implementation is still beta, so please update to
 * future versions of chroma.js when they become available.
 *
 * You can read more about the APCA Readability Criterion at
 * https://readtech.org/ARC/
 */ // constants
const $dab003980244b19f$var$W_offset = 0.027;
const $dab003980244b19f$var$P_in = 0.0005;
const $dab003980244b19f$var$P_out = 0.1;
const $dab003980244b19f$var$R_scale = 1.14;
const $dab003980244b19f$var$B_threshold = 0.022;
const $dab003980244b19f$var$B_exp = 1.414;
var $dab003980244b19f$export$2e2bcd8739ae039 = (text, bg)=>{
    // parse input colors
    text = new (0, $e7KSJ.default)(text);
    bg = new (0, $e7KSJ.default)(bg);
    // if text color has alpha, blend against background
    if (text.alpha() < 1) text = (0, $dvq8W.default)(bg, text, text.alpha(), 'rgb');
    const l_text = $dab003980244b19f$var$lum(...text.rgb());
    const l_bg = $dab003980244b19f$var$lum(...bg.rgb());
    // soft clamp black levels
    const Y_text = l_text >= $dab003980244b19f$var$B_threshold ? l_text : l_text + Math.pow($dab003980244b19f$var$B_threshold - l_text, $dab003980244b19f$var$B_exp);
    const Y_bg = l_bg >= $dab003980244b19f$var$B_threshold ? l_bg : l_bg + Math.pow($dab003980244b19f$var$B_threshold - l_bg, $dab003980244b19f$var$B_exp);
    // normal polarity (dark text on light background)
    const S_norm = Math.pow(Y_bg, 0.56) - Math.pow(Y_text, 0.57);
    // reverse polarity (light text on dark background)
    const S_rev = Math.pow(Y_bg, 0.65) - Math.pow(Y_text, 0.62);
    // clamp noise then scale
    const C = Math.abs(Y_bg - Y_text) < $dab003980244b19f$var$P_in ? 0 : Y_text < Y_bg ? S_norm * $dab003980244b19f$var$R_scale : S_rev * $dab003980244b19f$var$R_scale;
    // clamp minimum contrast then offset
    const S_apc = Math.abs(C) < $dab003980244b19f$var$P_out ? 0 : C > 0 ? C - $dab003980244b19f$var$W_offset : C + $dab003980244b19f$var$W_offset;
    // scale to 100
    return S_apc * 100;
};
function $dab003980244b19f$var$lum(r, g, b) {
    return 0.2126729 * Math.pow(r / 255, 2.4) + 0.7151522 * Math.pow(g / 255, 2.4) + 0.072175 * Math.pow(b / 255, 2.4);
}

});

parcelRegister("xkLDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $064331241a6f3932$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
const { sqrt: $064331241a6f3932$var$sqrt, pow: $064331241a6f3932$var$pow, min: $064331241a6f3932$var$min, max: $064331241a6f3932$var$max, atan2: $064331241a6f3932$var$atan2, abs: $064331241a6f3932$var$abs, cos: $064331241a6f3932$var$cos, sin: $064331241a6f3932$var$sin, exp: $064331241a6f3932$var$exp, PI: $064331241a6f3932$var$PI } = Math;
function $064331241a6f3932$export$2e2bcd8739ae039(a, b, Kl = 1, Kc = 1, Kh = 1) {
    // Delta E (CIE 2000)
    // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
    var rad2deg = function(rad) {
        return 360 * rad / (2 * $064331241a6f3932$var$PI);
    };
    var deg2rad = function(deg) {
        return 2 * $064331241a6f3932$var$PI * deg / 360;
    };
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const [L1, a1, b1] = Array.from(a.lab());
    const [L2, a2, b2] = Array.from(b.lab());
    const avgL = (L1 + L2) / 2;
    const C1 = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a1, 2) + $064331241a6f3932$var$pow(b1, 2));
    const C2 = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a2, 2) + $064331241a6f3932$var$pow(b2, 2));
    const avgC = (C1 + C2) / 2;
    const G = 0.5 * (1 - $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(avgC, 7) / ($064331241a6f3932$var$pow(avgC, 7) + $064331241a6f3932$var$pow(25, 7))));
    const a1p = a1 * (1 + G);
    const a2p = a2 * (1 + G);
    const C1p = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a1p, 2) + $064331241a6f3932$var$pow(b1, 2));
    const C2p = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(a2p, 2) + $064331241a6f3932$var$pow(b2, 2));
    const avgCp = (C1p + C2p) / 2;
    const arctan1 = rad2deg($064331241a6f3932$var$atan2(b1, a1p));
    const arctan2 = rad2deg($064331241a6f3932$var$atan2(b2, a2p));
    const h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
    const h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
    const avgHp = $064331241a6f3932$var$abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
    const T = 1 - 0.17 * $064331241a6f3932$var$cos(deg2rad(avgHp - 30)) + 0.24 * $064331241a6f3932$var$cos(deg2rad(2 * avgHp)) + 0.32 * $064331241a6f3932$var$cos(deg2rad(3 * avgHp + 6)) - 0.2 * $064331241a6f3932$var$cos(deg2rad(4 * avgHp - 63));
    let deltaHp = h2p - h1p;
    deltaHp = $064331241a6f3932$var$abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
    deltaHp = 2 * $064331241a6f3932$var$sqrt(C1p * C2p) * $064331241a6f3932$var$sin(deg2rad(deltaHp) / 2);
    const deltaL = L2 - L1;
    const deltaCp = C2p - C1p;
    const sl = 1 + 0.015 * $064331241a6f3932$var$pow(avgL - 50, 2) / $064331241a6f3932$var$sqrt(20 + $064331241a6f3932$var$pow(avgL - 50, 2));
    const sc = 1 + 0.045 * avgCp;
    const sh = 1 + 0.015 * avgCp * T;
    const deltaTheta = 30 * $064331241a6f3932$var$exp(-$064331241a6f3932$var$pow((avgHp - 275) / 25, 2));
    const Rc = 2 * $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(avgCp, 7) / ($064331241a6f3932$var$pow(avgCp, 7) + $064331241a6f3932$var$pow(25, 7)));
    const Rt = -Rc * $064331241a6f3932$var$sin(2 * deg2rad(deltaTheta));
    const result = $064331241a6f3932$var$sqrt($064331241a6f3932$var$pow(deltaL / (Kl * sl), 2) + $064331241a6f3932$var$pow(deltaCp / (Kc * sc), 2) + $064331241a6f3932$var$pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
    return $064331241a6f3932$var$max(0, $064331241a6f3932$var$min(100, result));
}

});

parcelRegister("iB6ta", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8a0b365443a1f76$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
function $d8a0b365443a1f76$export$2e2bcd8739ae039(a, b, mode = 'lab') {
    // Delta E (CIE 1976)
    // see http://www.brucelindbloom.com/index.html?Equations.html
    a = new (0, $e7KSJ.default)(a);
    b = new (0, $e7KSJ.default)(b);
    const l1 = a.get(mode);
    const l2 = b.get(mode);
    let sum_sq = 0;
    for(let i in l1){
        const d = (l1[i] || 0) - (l2[i] || 0);
        sum_sq += d * d;
    }
    return Math.sqrt(sum_sq);
}

});

parcelRegister("dID0y", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fcda4939aef1ea4$export$2e2bcd8739ae039);

var $e7KSJ = parcelRequire("e7KSJ");
var $9fcda4939aef1ea4$export$2e2bcd8739ae039 = (...args)=>{
    try {
        new (0, $e7KSJ.default)(...args);
        return true;
    // eslint-disable-next-line
    } catch (e) {
        return false;
    }
};

});

parcelRegister("1vtEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $118fb0138dc62de8$export$2e2bcd8739ae039);
// some pre-defined color scales:

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("fbI2I");

var $4ZQS0 = parcelRequire("4ZQS0");
var $118fb0138dc62de8$export$2e2bcd8739ae039 = {
    cool () {
        return (0, $4ZQS0.default)([
            (0, $gaK1V.default).hsl(180, 1, 0.9),
            (0, $gaK1V.default).hsl(250, 0.7, 0.4)
        ]);
    },
    hot () {
        return (0, $4ZQS0.default)([
            '#000',
            '#f00',
            '#ff0',
            '#fff'
        ], [
            0,
            0.25,
            0.75,
            1
        ]).mode('rgb');
    }
};

});

parcelRegister("6Sny4", function(module, exports) {

$parcel$export(module.exports, "default", () => $501a0d7a311e121c$export$2e2bcd8739ae039);
/**
    ColorBrewer colors for chroma.js

    Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
    Pennsylvania State University.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software distributed
    under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
    CONDITIONS OF ANY KIND, either express or implied. See the License for the
    specific language governing permissions and limitations under the License.
*/ const $501a0d7a311e121c$var$colorbrewer = {
    // sequential
    OrRd: [
        '#fff7ec',
        '#fee8c8',
        '#fdd49e',
        '#fdbb84',
        '#fc8d59',
        '#ef6548',
        '#d7301f',
        '#b30000',
        '#7f0000'
    ],
    PuBu: [
        '#fff7fb',
        '#ece7f2',
        '#d0d1e6',
        '#a6bddb',
        '#74a9cf',
        '#3690c0',
        '#0570b0',
        '#045a8d',
        '#023858'
    ],
    BuPu: [
        '#f7fcfd',
        '#e0ecf4',
        '#bfd3e6',
        '#9ebcda',
        '#8c96c6',
        '#8c6bb1',
        '#88419d',
        '#810f7c',
        '#4d004b'
    ],
    Oranges: [
        '#fff5eb',
        '#fee6ce',
        '#fdd0a2',
        '#fdae6b',
        '#fd8d3c',
        '#f16913',
        '#d94801',
        '#a63603',
        '#7f2704'
    ],
    BuGn: [
        '#f7fcfd',
        '#e5f5f9',
        '#ccece6',
        '#99d8c9',
        '#66c2a4',
        '#41ae76',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlOrBr: [
        '#ffffe5',
        '#fff7bc',
        '#fee391',
        '#fec44f',
        '#fe9929',
        '#ec7014',
        '#cc4c02',
        '#993404',
        '#662506'
    ],
    YlGn: [
        '#ffffe5',
        '#f7fcb9',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#006837',
        '#004529'
    ],
    Reds: [
        '#fff5f0',
        '#fee0d2',
        '#fcbba1',
        '#fc9272',
        '#fb6a4a',
        '#ef3b2c',
        '#cb181d',
        '#a50f15',
        '#67000d'
    ],
    RdPu: [
        '#fff7f3',
        '#fde0dd',
        '#fcc5c0',
        '#fa9fb5',
        '#f768a1',
        '#dd3497',
        '#ae017e',
        '#7a0177',
        '#49006a'
    ],
    Greens: [
        '#f7fcf5',
        '#e5f5e0',
        '#c7e9c0',
        '#a1d99b',
        '#74c476',
        '#41ab5d',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlGnBu: [
        '#ffffd9',
        '#edf8b1',
        '#c7e9b4',
        '#7fcdbb',
        '#41b6c4',
        '#1d91c0',
        '#225ea8',
        '#253494',
        '#081d58'
    ],
    Purples: [
        '#fcfbfd',
        '#efedf5',
        '#dadaeb',
        '#bcbddc',
        '#9e9ac8',
        '#807dba',
        '#6a51a3',
        '#54278f',
        '#3f007d'
    ],
    GnBu: [
        '#f7fcf0',
        '#e0f3db',
        '#ccebc5',
        '#a8ddb5',
        '#7bccc4',
        '#4eb3d3',
        '#2b8cbe',
        '#0868ac',
        '#084081'
    ],
    Greys: [
        '#ffffff',
        '#f0f0f0',
        '#d9d9d9',
        '#bdbdbd',
        '#969696',
        '#737373',
        '#525252',
        '#252525',
        '#000000'
    ],
    YlOrRd: [
        '#ffffcc',
        '#ffeda0',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#bd0026',
        '#800026'
    ],
    PuRd: [
        '#f7f4f9',
        '#e7e1ef',
        '#d4b9da',
        '#c994c7',
        '#df65b0',
        '#e7298a',
        '#ce1256',
        '#980043',
        '#67001f'
    ],
    Blues: [
        '#f7fbff',
        '#deebf7',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#08519c',
        '#08306b'
    ],
    PuBuGn: [
        '#fff7fb',
        '#ece2f0',
        '#d0d1e6',
        '#a6bddb',
        '#67a9cf',
        '#3690c0',
        '#02818a',
        '#016c59',
        '#014636'
    ],
    Viridis: [
        '#440154',
        '#482777',
        '#3f4a8a',
        '#31678e',
        '#26838f',
        '#1f9d8a',
        '#6cce5a',
        '#b6de2b',
        '#fee825'
    ],
    // diverging
    Spectral: [
        '#9e0142',
        '#d53e4f',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#e6f598',
        '#abdda4',
        '#66c2a5',
        '#3288bd',
        '#5e4fa2'
    ],
    RdYlGn: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837'
    ],
    RdBu: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#f7f7f7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
        '#053061'
    ],
    PiYG: [
        '#8e0152',
        '#c51b7d',
        '#de77ae',
        '#f1b6da',
        '#fde0ef',
        '#f7f7f7',
        '#e6f5d0',
        '#b8e186',
        '#7fbc41',
        '#4d9221',
        '#276419'
    ],
    PRGn: [
        '#40004b',
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#f7f7f7',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
        '#00441b'
    ],
    RdYlBu: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#ffffbf',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
        '#313695'
    ],
    BrBG: [
        '#543005',
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#f5f5f5',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
        '#003c30'
    ],
    RdGy: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#ffffff',
        '#e0e0e0',
        '#bababa',
        '#878787',
        '#4d4d4d',
        '#1a1a1a'
    ],
    PuOr: [
        '#7f3b08',
        '#b35806',
        '#e08214',
        '#fdb863',
        '#fee0b6',
        '#f7f7f7',
        '#d8daeb',
        '#b2abd2',
        '#8073ac',
        '#542788',
        '#2d004b'
    ],
    // qualitative
    Set2: [
        '#66c2a5',
        '#fc8d62',
        '#8da0cb',
        '#e78ac3',
        '#a6d854',
        '#ffd92f',
        '#e5c494',
        '#b3b3b3'
    ],
    Accent: [
        '#7fc97f',
        '#beaed4',
        '#fdc086',
        '#ffff99',
        '#386cb0',
        '#f0027f',
        '#bf5b17',
        '#666666'
    ],
    Set1: [
        '#e41a1c',
        '#377eb8',
        '#4daf4a',
        '#984ea3',
        '#ff7f00',
        '#ffff33',
        '#a65628',
        '#f781bf',
        '#999999'
    ],
    Set3: [
        '#8dd3c7',
        '#ffffb3',
        '#bebada',
        '#fb8072',
        '#80b1d3',
        '#fdb462',
        '#b3de69',
        '#fccde5',
        '#d9d9d9',
        '#bc80bd',
        '#ccebc5',
        '#ffed6f'
    ],
    Dark2: [
        '#1b9e77',
        '#d95f02',
        '#7570b3',
        '#e7298a',
        '#66a61e',
        '#e6ab02',
        '#a6761d',
        '#666666'
    ],
    Paired: [
        '#a6cee3',
        '#1f78b4',
        '#b2df8a',
        '#33a02c',
        '#fb9a99',
        '#e31a1c',
        '#fdbf6f',
        '#ff7f00',
        '#cab2d6',
        '#6a3d9a',
        '#ffff99',
        '#b15928'
    ],
    Pastel2: [
        '#b3e2cd',
        '#fdcdac',
        '#cbd5e8',
        '#f4cae4',
        '#e6f5c9',
        '#fff2ae',
        '#f1e2cc',
        '#cccccc'
    ],
    Pastel1: [
        '#fbb4ae',
        '#b3cde3',
        '#ccebc5',
        '#decbe4',
        '#fed9a6',
        '#ffffcc',
        '#e5d8bd',
        '#fddaec',
        '#f2f2f2'
    ]
};
const $501a0d7a311e121c$var$colorbrewerTypes = Object.keys($501a0d7a311e121c$var$colorbrewer);
const $501a0d7a311e121c$var$typeMap = new Map($501a0d7a311e121c$var$colorbrewerTypes.map((key)=>[
        key.toLowerCase(),
        key
    ]));
// use Proxy to allow case-insensitive access to palettes
const $501a0d7a311e121c$var$colorbrewerProxy = typeof Proxy === 'function' ? new Proxy($501a0d7a311e121c$var$colorbrewer, {
    get (target, prop) {
        const lower = prop.toLowerCase();
        if ($501a0d7a311e121c$var$typeMap.has(lower)) return target[$501a0d7a311e121c$var$typeMap.get(lower)];
    },
    getOwnPropertyNames () {
        return Object.getOwnPropertyNames($501a0d7a311e121c$var$colorbrewerTypes);
    }
}) : $501a0d7a311e121c$var$colorbrewer;
var $501a0d7a311e121c$export$2e2bcd8739ae039 = $501a0d7a311e121c$var$colorbrewerProxy;

});

parcelRegister("7hd9c", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $jKxIE = parcelRequire("jKxIE");

var $2o2Lo = parcelRequire("2o2Lo");
(0, $e7KSJ.default).prototype.cmyk = function() {
    return (0, $2o2Lo.default)(this._rgb);
};
const $54c451bcc042ac64$export$358b1a66a3c77756 = (...args)=>new (0, $e7KSJ.default)(...args, 'cmyk');
Object.assign((0, $gaK1V.default), {
    cmyk: $54c451bcc042ac64$export$358b1a66a3c77756
});
(0, $lT4NS.default).format.cmyk = (0, $jKxIE.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'cmyk');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 4) return 'cmyk';
    }
});

});
parcelRegister("jKxIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e60c7822c37b0c25$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $e60c7822c37b0c25$var$cmyk2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'cmyk');
    const [c, m, y, k] = args;
    const alpha = args.length > 4 ? args[4] : 1;
    if (k === 1) return [
        0,
        0,
        0,
        alpha
    ];
    return [
        c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
        m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
        y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
        alpha
    ];
};
var $e60c7822c37b0c25$export$2e2bcd8739ae039 = $e60c7822c37b0c25$var$cmyk2rgb;

});

parcelRegister("2o2Lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bcff769908141f5$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { max: $1bcff769908141f5$var$max } = Math;
const $1bcff769908141f5$var$rgb2cmyk = (...args)=>{
    let [r, g, b] = (0, $43ZPL.default)(args, 'rgb');
    r = r / 255;
    g = g / 255;
    b = b / 255;
    const k = 1 - $1bcff769908141f5$var$max(r, $1bcff769908141f5$var$max(g, b));
    const f = k < 1 ? 1 / (1 - k) : 0;
    const c = (1 - r - k) * f;
    const m = (1 - g - k) * f;
    const y = (1 - b - k) * f;
    return [
        c,
        m,
        y,
        k
    ];
};
var $1bcff769908141f5$export$2e2bcd8739ae039 = $1bcff769908141f5$var$rgb2cmyk;

});


parcelRegister("cIiSk", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $iwUkC = parcelRequire("iwUkC");

var $lmq0O = parcelRequire("lmq0O");
(0, $e7KSJ.default).prototype.css = function(mode) {
    return (0, $iwUkC.default)(this._rgb, mode);
};
const $94183c5a55123dcc$export$dbf350e5966cf602 = (...args)=>new (0, $e7KSJ.default)(...args, 'css');
(0, $gaK1V.default).css = $94183c5a55123dcc$export$dbf350e5966cf602;
(0, $lT4NS.default).format.css = (0, $lmq0O.default);
(0, $lT4NS.default).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && (0, $lmq0O.default).test(h)) return 'css';
    }
});

});
parcelRegister("iwUkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7d6e97251c964b7$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $43ZPL = parcelRequire("43ZPL");

var $8r7If = parcelRequire("8r7If");

var $f9fTr = parcelRequire("f9fTr");

var $6Sszj = parcelRequire("6Sszj");

var $luvnN = parcelRequire("luvnN");

var $c020c = parcelRequire("c020c");

var $jSfgf = parcelRequire("jSfgf");

var $eJb2q = parcelRequire("eJb2q");

var $5KW7E = parcelRequire("5KW7E");

var $855Nw = parcelRequire("855Nw");

var $a0o1I = parcelRequire("a0o1I");

var $8weUB = parcelRequire("8weUB");
const { round: $d7d6e97251c964b7$var$round } = Math;
/*
 * supported arguments:
 * - rgb2css(r,g,b)
 * - rgb2css(r,g,b,a)
 * - rgb2css([r,g,b], mode)
 * - rgb2css([r,g,b,a], mode)
 * - rgb2css({r,g,b,a}, mode)
 */ const $d7d6e97251c964b7$var$rgb2css = (...args)=>{
    const rgba = (0, $43ZPL.default)(args, 'rgba');
    let mode = (0, $7ElX1.default)(args) || 'rgb';
    if (mode.substr(0, 3) === 'hsl') return (0, $8r7If.default)((0, $f9fTr.default)(rgba), mode);
    if (mode.substr(0, 3) === 'lab') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const cssColor = (0, $6Sszj.default)((0, $luvnN.default)(rgba), mode);
        (0, $8weUB.setLabWhitePoint)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 3) === 'lch') {
        // change to D50 lab whitepoint since this is what W3C is using for CSS Lab colors
        const prevWhitePoint = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const cssColor = (0, $c020c.default)((0, $jSfgf.default)(rgba), mode);
        (0, $8weUB.setLabWhitePoint)(prevWhitePoint);
        return cssColor;
    }
    if (mode.substr(0, 5) === 'oklab') return (0, $5KW7E.default)((0, $eJb2q.default)(rgba));
    if (mode.substr(0, 5) === 'oklch') return (0, $a0o1I.default)((0, $855Nw.default)(rgba));
    rgba[0] = $d7d6e97251c964b7$var$round(rgba[0]);
    rgba[1] = $d7d6e97251c964b7$var$round(rgba[1]);
    rgba[2] = $d7d6e97251c964b7$var$round(rgba[2]);
    if (mode === 'rgba' || rgba.length > 3 && rgba[3] < 1) {
        rgba[3] = '/ ' + (rgba.length > 3 ? rgba[3] : 1);
        mode = 'rgba';
    }
    return `${mode.substr(0, 3)}(${rgba.slice(0, mode === 'rgb' ? 3 : 4).join(' ')})`;
};
var $d7d6e97251c964b7$export$2e2bcd8739ae039 = $d7d6e97251c964b7$var$rgb2css;

});
parcelRegister("8r7If", function(module, exports) {

$parcel$export(module.exports, "default", () => $6246d3ee765f7d54$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - hsl2css(h,s,l)
 * - hsl2css(h,s,l,a)
 * - hsl2css([h,s,l], mode)
 * - hsl2css([h,s,l,a], mode)
 * - hsl2css({h,s,l,a}, mode)
 */ const $6246d3ee765f7d54$var$hsl2css = (...args)=>{
    const hsla = (0, $43ZPL.default)(args, 'hsla');
    let mode = (0, $7ElX1.default)(args) || 'lsa';
    hsla[0] = (0, $i4gda.rnd2)(hsla[0] || 0) + 'deg';
    hsla[1] = (0, $i4gda.rnd2)(hsla[1] * 100) + '%';
    hsla[2] = (0, $i4gda.rnd2)(hsla[2] * 100) + '%';
    if (mode === 'hsla' || hsla.length > 3 && hsla[3] < 1) {
        hsla[3] = '/ ' + (hsla.length > 3 ? hsla[3] : 1);
        mode = 'hsla';
    } else hsla.length = 3;
    return `${mode.substr(0, 3)}(${hsla.join(' ')})`;
};
var $6246d3ee765f7d54$export$2e2bcd8739ae039 = $6246d3ee765f7d54$var$hsl2css;

});

parcelRegister("6Sszj", function(module, exports) {

$parcel$export(module.exports, "default", () => $501df25942503107$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $501df25942503107$var$lab2css = (...args)=>{
    const laba = (0, $43ZPL.default)(args, 'lab');
    let mode = (0, $7ElX1.default)(args) || 'lab';
    laba[0] = (0, $i4gda.rnd2)(laba[0]) + '%';
    laba[1] = (0, $i4gda.rnd2)(laba[1]);
    laba[2] = (0, $i4gda.rnd2)(laba[2]);
    if (mode === 'laba' || laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `lab(${laba.join(' ')})`;
};
var $501df25942503107$export$2e2bcd8739ae039 = $501df25942503107$var$lab2css;

});

parcelRegister("c020c", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc709b6cfda3284$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $7ElX1 = parcelRequire("7ElX1");
var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
/*
 * supported arguments:
 * - lab2css(l,a,b)
 * - lab2css(l,a,b,alpha)
 * - lab2css([l,a,b], mode)
 * - lab2css([l,a,b,alpha], mode)
 */ const $8bc709b6cfda3284$var$lch2css = (...args)=>{
    const lcha = (0, $43ZPL.default)(args, 'lch');
    let mode = (0, $7ElX1.default)(args) || 'lab';
    lcha[0] = (0, $i4gda.rnd2)(lcha[0]) + '%';
    lcha[1] = (0, $i4gda.rnd2)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $i4gda.rnd2)(lcha[2]) + 'deg'; // add deg unit to hue
    if (mode === 'lcha' || lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `lch(${lcha.join(' ')})`;
};
var $8bc709b6cfda3284$export$2e2bcd8739ae039 = $8bc709b6cfda3284$var$lch2css;

});

parcelRegister("5KW7E", function(module, exports) {

$parcel$export(module.exports, "default", () => $430e55826084c20e$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $430e55826084c20e$var$oklab2css = (...args)=>{
    const laba = (0, $43ZPL.default)(args, 'lab');
    laba[0] = (0, $i4gda.rnd2)(laba[0] * 100) + '%';
    laba[1] = (0, $i4gda.rnd3)(laba[1]);
    laba[2] = (0, $i4gda.rnd3)(laba[2]);
    if (laba.length > 3 && laba[3] < 1) laba[3] = '/ ' + (laba.length > 3 ? laba[3] : 1);
    else laba.length = 3;
    return `oklab(${laba.join(' ')})`;
};
var $430e55826084c20e$export$2e2bcd8739ae039 = $430e55826084c20e$var$oklab2css;

});

parcelRegister("855Nw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2349b11f40bce3$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $eJb2q = parcelRequire("eJb2q");

var $36WLn = parcelRequire("36WLn");
const $5e2349b11f40bce3$var$rgb2oklch = (...args)=>{
    const [r, g, b, ...rest] = (0, $43ZPL.default)(args, 'rgb');
    const [l, a, b_] = (0, $eJb2q.default)(r, g, b);
    const [L, c, h] = (0, $36WLn.default)(l, a, b_);
    return [
        L,
        c,
        h,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $5e2349b11f40bce3$export$2e2bcd8739ae039 = $5e2349b11f40bce3$var$rgb2oklch;

});

parcelRegister("a0o1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $748c8aa705dcdecb$export$2e2bcd8739ae039);

var $i4gda = parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const $748c8aa705dcdecb$var$oklch2css = (...args)=>{
    const lcha = (0, $43ZPL.default)(args, 'lch');
    lcha[0] = (0, $i4gda.rnd2)(lcha[0] * 100) + '%';
    lcha[1] = (0, $i4gda.rnd3)(lcha[1]);
    lcha[2] = isNaN(lcha[2]) ? 'none' : (0, $i4gda.rnd2)(lcha[2]) + 'deg'; // add deg unit to hue
    if (lcha.length > 3 && lcha[3] < 1) lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
    else lcha.length = 3;
    return `oklch(${lcha.join(' ')})`;
};
var $748c8aa705dcdecb$export$2e2bcd8739ae039 = $748c8aa705dcdecb$var$oklch2css;

});


parcelRegister("lmq0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8cfd480aa486045$export$2e2bcd8739ae039);

var $7PGtI = parcelRequire("7PGtI");

var $jenZn = parcelRequire("jenZn");

var $g4jd5 = parcelRequire("g4jd5");

var $5D4bx = parcelRequire("5D4bx");

var $9cCPH = parcelRequire("9cCPH");

var $lT4NS = parcelRequire("lT4NS");

var $gb2Ug = parcelRequire("gb2Ug");

var $8weUB = parcelRequire("8weUB");
const $f8cfd480aa486045$var$INT_OR_PCT = /((?:-?\d+)|(?:-?\d+(?:\.\d+)?)%|none)/.source;
const $f8cfd480aa486045$var$FLOAT_OR_PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%?)|none)/.source;
const $f8cfd480aa486045$var$PCT = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)%)|none)/.source;
const $f8cfd480aa486045$var$RE_S = /\s*/.source;
const $f8cfd480aa486045$var$SEP = /\s+/.source;
const $f8cfd480aa486045$var$COMMA = /\s*,\s*/.source;
const $f8cfd480aa486045$var$ANLGE = /((?:-?(?:\d+(?:\.\d*)?|\.\d+)(?:deg)?)|none)/.source;
const $f8cfd480aa486045$var$ALPHA = /\s*(?:\/\s*((?:[01]|[01]?\.\d+)|\d+(?:\.\d+)?%))?/.source;
// e.g. rgb(250 20 0), rgb(100% 50% 20%), rgb(100% 50% 20% / 0.5)
const $f8cfd480aa486045$var$RE_RGB = new RegExp('^rgba?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_RGB_LEGACY = new RegExp('^rgb\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_RGBA_LEGACY = new RegExp('^rgba\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$INT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_HSL = new RegExp('^hsla?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$ANLGE,
    $f8cfd480aa486045$var$PCT,
    $f8cfd480aa486045$var$PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_HSL_LEGACY = new RegExp('^hsl?\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$ANLGE,
    $f8cfd480aa486045$var$PCT,
    $f8cfd480aa486045$var$PCT
].join($f8cfd480aa486045$var$COMMA) + $f8cfd480aa486045$var$RE_S + '\\)$');
const $f8cfd480aa486045$var$RE_HSLA_LEGACY = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
const $f8cfd480aa486045$var$RE_LAB = new RegExp('^lab\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_LCH = new RegExp('^lch\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$ANLGE
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_OKLAB = new RegExp('^oklab\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const $f8cfd480aa486045$var$RE_OKLCH = new RegExp('^oklch\\(' + $f8cfd480aa486045$var$RE_S + [
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$FLOAT_OR_PCT,
    $f8cfd480aa486045$var$ANLGE
].join($f8cfd480aa486045$var$SEP) + $f8cfd480aa486045$var$ALPHA + '\\)$');
const { round: $f8cfd480aa486045$var$round } = Math;
const $f8cfd480aa486045$var$roundRGB = (rgb)=>{
    return rgb.map((v, i)=>i <= 2 ? (0, $gb2Ug.default)($f8cfd480aa486045$var$round(v), 0, 255) : v);
};
const $f8cfd480aa486045$var$percentToAbsolute = (pct, min = 0, max = 100, signed = false)=>{
    if (typeof pct === 'string' && pct.endsWith('%')) {
        pct = parseFloat(pct.substring(0, pct.length - 1)) / 100;
        if (signed) // signed percentages are in the range -100% to 100%
        pct = min + (pct + 1) * 0.5 * (max - min);
        else pct = min + pct * (max - min);
    }
    return +pct;
};
const $f8cfd480aa486045$var$noneToValue = (v, noneValue)=>{
    return v === 'none' ? noneValue : v;
};
const $f8cfd480aa486045$var$css2rgb = (css)=>{
    css = css.toLowerCase().trim();
    if (css === 'transparent') return [
        0,
        0,
        0,
        0
    ];
    let m;
    if ((0, $lT4NS.default).format.named) try {
        return (0, $lT4NS.default).format.named(css);
    // eslint-disable-next-line
    } catch (e) {}
    // rgb(250 20 0) or rgb(250,20,0)
    if ((m = css.match($f8cfd480aa486045$var$RE_RGB)) || (m = css.match($f8cfd480aa486045$var$RE_RGB_LEGACY))) {
        let rgb = m.slice(1, 4);
        for(let i = 0; i < 3; i++)rgb[i] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(rgb[i], 0), 0, 255);
        rgb = $f8cfd480aa486045$var$roundRGB(rgb);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha; // default alpha
        return rgb;
    }
    // rgba(250,20,0,0.4)
    if (m = css.match($f8cfd480aa486045$var$RE_RGBA_LEGACY)) {
        const rgb = m.slice(1, 5);
        for(let i = 0; i < 4; i++)rgb[i] = +$f8cfd480aa486045$var$percentToAbsolute(rgb[i], 0, 255);
        return rgb;
    }
    // hsl(0,100%,50%)
    if ((m = css.match($f8cfd480aa486045$var$RE_HSL)) || (m = css.match($f8cfd480aa486045$var$RE_HSL_LEGACY))) {
        const hsl = m.slice(1, 4);
        hsl[0] = +$f8cfd480aa486045$var$noneToValue(hsl[0].replace('deg', ''), 0);
        hsl[1] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(hsl[1], 0), 0, 100) * 0.01;
        hsl[2] = +$f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(hsl[2], 0), 0, 100) * 0.01;
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $7PGtI.default)(hsl));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    // hsla(0,100%,50%,0.5)
    if (m = css.match($f8cfd480aa486045$var$RE_HSLA_LEGACY)) {
        const hsl = m.slice(1, 4);
        hsl[1] *= 0.01;
        hsl[2] *= 0.01;
        const rgb = (0, $7PGtI.default)(hsl);
        for(let i = 0; i < 3; i++)rgb[i] = $f8cfd480aa486045$var$round(rgb[i]);
        rgb[3] = +m[4]; // default alpha = 1
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_LAB)) {
        const lab = m.slice(1, 4);
        lab[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[0], 0), 0, 100);
        lab[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[1], 0), -125, 125, true);
        lab[2] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lab[2], 0), -125, 125, true);
        // convert to D50 Lab whitepoint
        const wp = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $jenZn.default)(lab));
        // convert back to original Lab whitepoint
        (0, $8weUB.setLabWhitePoint)(wp);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_LCH)) {
        const lch = m.slice(1, 4);
        lch[0] = $f8cfd480aa486045$var$percentToAbsolute(lch[0], 0, 100);
        lch[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(lch[1], 0), 0, 150, false);
        lch[2] = +$f8cfd480aa486045$var$noneToValue(lch[2].replace('deg', ''), 0);
        // convert to D50 Lab whitepoint
        const wp = (0, $8weUB.getLabWhitePoint)();
        (0, $8weUB.setLabWhitePoint)('d50');
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $g4jd5.default)(lch));
        // convert back to original Lab whitepoint
        (0, $8weUB.setLabWhitePoint)(wp);
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_OKLAB)) {
        const oklab = m.slice(1, 4);
        oklab[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[0], 0), 0, 1);
        oklab[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[1], 0), -0.4, 0.4, true);
        oklab[2] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklab[2], 0), -0.4, 0.4, true);
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $5D4bx.default)(oklab));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
    if (m = css.match($f8cfd480aa486045$var$RE_OKLCH)) {
        const oklch = m.slice(1, 4);
        oklch[0] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklch[0], 0), 0, 1);
        oklch[1] = $f8cfd480aa486045$var$percentToAbsolute($f8cfd480aa486045$var$noneToValue(oklch[1], 0), 0, 0.4, false);
        oklch[2] = +$f8cfd480aa486045$var$noneToValue(oklch[2].replace('deg', ''), 0);
        const rgb = $f8cfd480aa486045$var$roundRGB((0, $9cCPH.default)(oklch));
        const alpha = m[4] !== undefined ? +$f8cfd480aa486045$var$percentToAbsolute(m[4], 0, 1) : 1;
        rgb[3] = alpha;
        return rgb;
    }
};
$f8cfd480aa486045$var$css2rgb.test = (s)=>{
    return(// modern
    $f8cfd480aa486045$var$RE_RGB.test(s) || $f8cfd480aa486045$var$RE_HSL.test(s) || $f8cfd480aa486045$var$RE_LAB.test(s) || $f8cfd480aa486045$var$RE_LCH.test(s) || $f8cfd480aa486045$var$RE_OKLAB.test(s) || $f8cfd480aa486045$var$RE_OKLCH.test(s) || // legacy
    $f8cfd480aa486045$var$RE_RGB_LEGACY.test(s) || $f8cfd480aa486045$var$RE_RGBA_LEGACY.test(s) || $f8cfd480aa486045$var$RE_HSL_LEGACY.test(s) || $f8cfd480aa486045$var$RE_HSLA_LEGACY.test(s) || s === 'transparent');
};
var $f8cfd480aa486045$export$2e2bcd8739ae039 = $f8cfd480aa486045$var$css2rgb;

});
parcelRegister("9cCPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b335b6c71084560$export$2e2bcd8739ae039);
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");

var $d6n2X = parcelRequire("d6n2X");

var $5D4bx = parcelRequire("5D4bx");
const $6b335b6c71084560$var$oklch2rgb = (...args)=>{
    args = (0, $43ZPL.default)(args, 'lch');
    const [l, c, h, ...rest] = args;
    const [L, a, b_] = (0, $d6n2X.default)(l, c, h);
    const [r, g, b] = (0, $5D4bx.default)(L, a, b_);
    return [
        r,
        g,
        b,
        ...rest.length > 0 && rest[0] < 1 ? [
            rest[0]
        ] : []
    ];
};
var $6b335b6c71084560$export$2e2bcd8739ae039 = $6b335b6c71084560$var$oklch2rgb;

});



parcelRegister("kBR14", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $gaK1V = parcelRequire("gaK1V");

var $lT4NS = parcelRequire("lT4NS");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
(0, $lT4NS.default).format.gl = (...args)=>{
    const rgb = (0, $43ZPL.default)(args, 'rgba');
    rgb[0] *= 255;
    rgb[1] *= 255;
    rgb[2] *= 255;
    return rgb;
};
const $f010634c2ba757fa$export$5822a9d0880a5d82 = (...args)=>new (0, $e7KSJ.default)(...args, 'gl');
(0, $gaK1V.default).gl = $f010634c2ba757fa$export$5822a9d0880a5d82;
(0, $e7KSJ.default).prototype.gl = function() {
    const rgb = this._rgb;
    return [
        rgb[0] / 255,
        rgb[1] / 255,
        rgb[2] / 255,
        rgb[3]
    ];
};

});

parcelRegister("bmZFS", function(module, exports) {

var $e7KSJ = parcelRequire("e7KSJ");

var $gaK1V = parcelRequire("gaK1V");
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");

var $lT4NS = parcelRequire("lT4NS");

var $2BpKe = parcelRequire("2BpKe");

var $eL95G = parcelRequire("eL95G");
(0, $e7KSJ.default).prototype.hex = function(mode) {
    return (0, $eL95G.default)(this._rgb, mode);
};
const $84719710001139ea$export$834dfc94dde4b3d8 = (...args)=>new (0, $e7KSJ.default)(...args, 'hex');
(0, $gaK1V.default).hex = $84719710001139ea$export$834dfc94dde4b3d8;
(0, $lT4NS.default).format.hex = (0, $2BpKe.default);
(0, $lT4NS.default).autodetect.push({
    p: 4,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $hMEmV.default)(h) === 'string' && [
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].indexOf(h.length) >= 0) return 'hex';
    }
});

});

parcelRegister("i89Hq", function(module, exports) {

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $4vyUC = parcelRequire("4vyUC");

var $1X2Gd = parcelRequire("1X2Gd");
(0, $e7KSJ.default).prototype.temp = (0, $e7KSJ.default).prototype.kelvin = (0, $e7KSJ.default).prototype.temperature = function() {
    return (0, $1X2Gd.default)(this._rgb);
};
const $d3307f7157ff91e7$export$8d72b093afd1813e = (...args)=>new (0, $e7KSJ.default)(...args, 'temp');
Object.assign((0, $gaK1V.default), {
    temp: $d3307f7157ff91e7$export$8d72b093afd1813e,
    kelvin: $d3307f7157ff91e7$export$8d72b093afd1813e,
    temperature: $d3307f7157ff91e7$export$8d72b093afd1813e
});
(0, $lT4NS.default).format.temp = (0, $lT4NS.default).format.kelvin = (0, $lT4NS.default).format.temperature = (0, $4vyUC.default);

});
parcelRegister("4vyUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $34852385cec165f3$export$2e2bcd8739ae039);
/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 */ const { log: $34852385cec165f3$var$log } = Math;
const $34852385cec165f3$var$temperature2rgb = (kelvin)=>{
    const temp = kelvin / 100;
    let r, g, b;
    if (temp < 66) {
        r = 255;
        g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * $34852385cec165f3$var$log(g);
        b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * $34852385cec165f3$var$log(b);
    } else {
        r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * $34852385cec165f3$var$log(r);
        g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * $34852385cec165f3$var$log(g);
        b = 255;
    }
    return [
        r,
        g,
        b,
        1
    ];
};
var $34852385cec165f3$export$2e2bcd8739ae039 = $34852385cec165f3$var$temperature2rgb;

});

parcelRegister("1X2Gd", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bd614d337f08eb$export$2e2bcd8739ae039);
/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 **/ 
var $4vyUC = parcelRequire("4vyUC");
parcelRequire("i4gda");
var $43ZPL = parcelRequire("43ZPL");
const { round: $16bd614d337f08eb$var$round } = Math;
const $16bd614d337f08eb$var$rgb2temperature = (...args)=>{
    const rgb = (0, $43ZPL.default)(args, 'rgb');
    const r = rgb[0], b = rgb[2];
    let minTemp = 1000;
    let maxTemp = 40000;
    const eps = 0.4;
    let temp;
    while(maxTemp - minTemp > eps){
        temp = (maxTemp + minTemp) * 0.5;
        const rgb = (0, $4vyUC.default)(temp);
        if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
        else minTemp = temp;
    }
    return $16bd614d337f08eb$var$round(temp);
};
var $16bd614d337f08eb$export$2e2bcd8739ae039 = $16bd614d337f08eb$var$rgb2temperature;

});


parcelRegister("35MHU", function(module, exports) {
parcelRequire("i4gda");
var $hMEmV = parcelRequire("hMEmV");
var $43ZPL = parcelRequire("43ZPL");

var $gaK1V = parcelRequire("gaK1V");

var $e7KSJ = parcelRequire("e7KSJ");

var $lT4NS = parcelRequire("lT4NS");

var $9cCPH = parcelRequire("9cCPH");

var $855Nw = parcelRequire("855Nw");
(0, $e7KSJ.default).prototype.oklch = function() {
    return (0, $855Nw.default)(this._rgb);
};
const $24079ef8e8403722$export$c21b932a666e3753 = (...args)=>new (0, $e7KSJ.default)(...args, 'oklch');
Object.assign((0, $gaK1V.default), {
    oklch: $24079ef8e8403722$export$c21b932a666e3753
});
(0, $lT4NS.default).format.oklch = (0, $9cCPH.default);
(0, $lT4NS.default).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $43ZPL.default)(args, 'oklch');
        if ((0, $hMEmV.default)(args) === 'array' && args.length === 3) return 'oklch';
    }
});

});



parcelRegister("ceOOn", function(module, exports) {

$parcel$export(module.exports, "getAllCookies", () => $8e8e34fa89bb9263$export$1191989ae3ee4c15);
const $8e8e34fa89bb9263$export$1191989ae3ee4c15 = ()=>{
    const cookies = document.cookie.split('; ');
    const allCookies = [];
    cookies.forEach((cookie)=>{
        const cookieParts = cookie.split('=');
        allCookies[cookieParts[0]] = cookieParts[1];
    });
    return allCookies;
};

});

parcelRegister("a3TA1", function(module, exports) {

$parcel$export(module.exports, "elementReady", () => $75354c334d353ce6$export$5a68694636710d38);
const $75354c334d353ce6$export$5a68694636710d38 = (selector)=>new Promise((resolve)=>{
        const el = document.querySelectorAll(selector);
        if (el.length) {
            resolve(el);
            return;
        }
        new MutationObserver(()=>{
            // Query for elements matching the specified selector
            Array.from(document.querySelectorAll(selector)).forEach((element)=>{
                resolve(element);
            });
        }).observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    });

});

parcelRegister("6oLIz", function(module, exports) {

$parcel$export(module.exports, "addWindowResizeEvent", () => $4a89ffbcc8257418$export$5f2cd73bfe4df536);
$parcel$export(module.exports, "addWindowScrollEvent", () => $4a89ffbcc8257418$export$b502183889628ce0);
const $4a89ffbcc8257418$export$5f2cd73bfe4df536 = (callback)=>{
    let timeout;
    window.addEventListener('resize', ()=>{
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};
const $4a89ffbcc8257418$export$b502183889628ce0 = (callback)=>{
    let timeout;
    window.addEventListener('scroll', ()=>{
        clearTimeout(timeout);
        timeout = setTimeout(callback, 250);
    });
};

});

parcelRegister("isKkJ", function(module, exports) {

$parcel$export(module.exports, "getReCAPTCHAResponse", () => $d70ec861cf7f176b$export$26ae508a4c7ca84d);

var $6sEQA = parcelRequire("6sEQA");
const $d70ec861cf7f176b$export$26ae508a4c7ca84d = async (action)=>{
    try {
        const themeData = await (0, $6sEQA.getThemeData)();
        if (!themeData.recaptcha_site_key) throw new Error('Missing Google reCAPTCHA Site Key in theme configuration');
        if (!themeData.ajax_actions?.recaptcha_verify) throw new Error('Missing AJAX route to verify reCAPTCHA token');
        if (!themeData.ajax_route) throw new Error('Missing global AJAX route');
        return new Promise((resolve, reject)=>{
            if (window.grecaptcha === undefined) {
                console.warn('Google reCAPTCHA is not loaded');
                resolve({
                    success: true,
                    score: 1
                });
            } else grecaptcha.ready(function() {
                grecaptcha.execute(themeData.recaptcha_site_key, {
                    action: action
                }).then(async function(token) {
                    const formData = new FormData();
                    formData.append('action', themeData.ajax_actions.recaptcha_verify);
                    // Determine if request is just a test
                    const testParam = 'e2e-test';
                    const url = new URL(window.location);
                    if (url.searchParams.has(testParam)) token = 'e2e-test-valid-user';
                    // Set reCATPCHA token
                    formData.append('recaptcha_token', token);
                    try {
                        const response = await fetch(themeData.ajax_route, {
                            method: 'POST',
                            body: formData
                        });
                        const json = await response.json();
                        if (json.success) resolve(json);
                        else if (json['error-codes']) {
                            /**
								 * reCATPCHA verification error codes
								 * @link https://developers.google.com/recaptcha/docs/verify#error_code_reference
								 *
								 * missing-input-secret	  The secret parameter is missing.
								 * invalid-input-secret	  The secret parameter is invalid or malformed.
								 * missing-input-response	The response parameter is missing.
								 * invalid-input-response	The response parameter is invalid or malformed.
								 * bad-request	          The request is invalid or malformed.
								 * timeout-or-duplicate	  The response is no longer valid: either is too old or has been used previously.
								 */ let errorMessages = [];
                            json['error-codes'].forEach((errorCode)=>{
                                switch(errorCode){
                                    case 'missing-input-secret':
                                        errorMessages.push('The secret parameter is missing.');
                                        break;
                                    case 'invalid-input-secret':
                                        errorMessages.push('The secret parameter is invalid or malformed.');
                                        break;
                                    case 'missing-input-response':
                                        errorMessages.push('The response parameter is missing.');
                                        break;
                                    case 'invalid-input-response':
                                        errorMessages.push('The response parameter is invalid or malformed.');
                                        break;
                                    case 'bad-request':
                                        errorMessages.push('The request is invalid or malformed.');
                                        break;
                                    case 'timeout-or-duplicate':
                                        errorMessages.push('The response is no longer valid: either is too old or has been used previously.');
                                        break;
                                    default:
                                        errorMessages.push('Unknown reCATPCHA error code');
                                }
                            });
                            throw new Error(`There was an error when trying to verify the user's response by reCATPCHA:\n${errorMessages.join('\n')}`);
                        } else if (json.data) throw new Error(`The request to verify the reCAPTCHA user token failed: ${response.data}`);
                        else throw new Error('Unknown error occurred when trying to verify the reCATPCHA user token');
                    } catch (e) {
                        reject(e);
                    }
                });
            });
        });
    } catch (e) {
        console.error(e);
    }
};

});
parcelRegister("6sEQA", function(module, exports) {

$parcel$export(module.exports, "getThemeData", () => $4b450af9f6d18c72$export$3c72f11fd9e5031f);
const $4b450af9f6d18c72$export$3c72f11fd9e5031f = ()=>{
    if (!window.themeDataRestUrl) throw new Error('Missing themeDataRestUrl in global context');
    else {
        const sessionStorageKey = 'themeData';
        return new Promise((resolve, reject)=>{
            if (sessionStorage.getItem('themeData')) resolve(JSON.parse(sessionStorage.getItem(sessionStorageKey)));
            else fetch(window.themeDataRestUrl).then((res)=>res.json()).then((data)=>{
                try {
                    sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
                } catch (e) {
                    console.warn(e);
                }
                resolve(data);
            }).catch((e)=>reject(e));
        });
    }
};

});


parcelRegister("h30hJ", function(module, exports) {

$parcel$export(module.exports, "slideUp", () => $c692f0128d3d0bc1$export$deed561b1a0ff1ea);
$parcel$export(module.exports, "slideDown", () => $c692f0128d3d0bc1$export$abdd11a06a163232);
const $c692f0128d3d0bc1$export$deed561b1a0ff1ea = (target, duration = 500)=>{
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    [
        'height',
        'paddingTop',
        'paddingBottom',
        'marginTop',
        'marginBottom'
    ].forEach((prop)=>{
        target.style[prop] = 0;
    });
    window.setTimeout(()=>{
        target.style.display = 'none';
        [
            'height',
            'padding-top',
            'padding-bottom',
            'margin-top',
            'margin-bottom',
            'overflow',
            'transition-duration',
            'transition-property'
        ].forEach((prop)=>target.style.removeProperty(prop));
    }, duration);
};
const $c692f0128d3d0bc1$export$abdd11a06a163232 = (target, duration = 500)=>{
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    display === 'none' && (display = 'block');
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    [
        'height',
        'paddingTop',
        'paddingBottom',
        'marginTop',
        'marginBottom'
    ].forEach((prop)=>{
        target.style[prop] = 0;
    });
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    [
        'padding-top',
        'padding-bottom',
        'margin-top',
        'margin-bottom'
    ].forEach((prop)=>target.style.removeProperty(prop));
    window.setTimeout(()=>{
        [
            'height',
            'overflow',
            'transition-duration',
            'transition-property'
        ].forEach((prop)=>target.style.removeProperty(prop));
    }, duration);
};
const $c692f0128d3d0bc1$export$715de50cedc228a8 = (target, duration = 500)=>window.getComputedStyle(target).display === 'none' ? $c692f0128d3d0bc1$export$abdd11a06a163232(target, duration) : $c692f0128d3d0bc1$export$deed561b1a0ff1ea(target, duration);

});

parcelRegister("jWfAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83f87d19c5951a4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "scrollToElement", () => $e83f87d19c5951a4$export$2353115f31f4d15);
var $e83f87d19c5951a4$export$2e2bcd8739ae039 = ()=>{
    // ! Important: Wait until page has fully loaded before scrolling (#Chrome bug)
    window.addEventListener('load', ()=>{
        if (window.location.hash) {
            window.scrollTo(0, 0);
            setTimeout(()=>{
                $e83f87d19c5951a4$export$2353115f31f4d15(window.location.hash);
            }, 1);
        }
    });
    document.addEventListener('click', function(e) {
        // loop parent nodes from the target to the delegation node
        for(let target = e.target; target && target != this; target = target.parentNode)if (target.matches('a[href^="#"]:not([href="#"]):not([href="#/"]):not(._brlbs-btn)')) {
            e.preventDefault();
            $e83f87d19c5951a4$export$2353115f31f4d15(target.getAttribute('href'));
            break;
        }
    }, false);
};
const $e83f87d19c5951a4$export$2353115f31f4d15 = (selector)=>{
    const targetEl = document.querySelector(selector);
    if (!targetEl) return;
    // Set initial scroll to an offset to increase headroom
    let scrollOffset = 32;
    // Add header height to offset if necessary
    const headerBar = document.querySelector('header.nav');
    scrollOffset += headerBar?.getBoundingClientRect().height || 0;
    // Add height of WP admin bar for logged in users
    if (document.querySelector('#wpadminbar')) scrollOffset += document.querySelector('#wpadminbar').getBoundingClientRect().height;
    // Start scrolling
    window.scrollTo(0, window.scrollY + targetEl.getBoundingClientRect().top - scrollOffset);
};

});

parcelRegister("hxRak", function(module, exports) {

$parcel$export(module.exports, "waitForElement", () => $cc5ec25473bb8d84$export$1a1c301579a08d1e);
const $cc5ec25473bb8d84$export$1a1c301579a08d1e = (selector)=>{
    return new Promise((resolve)=>{
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        const observer = new MutationObserver(()=>{
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};

});


parcelRegister("613bB", function(module, exports) {

$parcel$export(module.exports, "markFieldError", () => $46154ec4936d1277$export$62894790ff73cc21);
$parcel$export(module.exports, "markFieldAsValid", () => $46154ec4936d1277$export$8c1ebd23297ed672);
$parcel$export(module.exports, "resetFieldState", () => $46154ec4936d1277$export$8d5aa774dee7db0);

var $kOwRn = parcelRequire("kOwRn");
const $46154ec4936d1277$var$activeErrorClass = 'active';
const $46154ec4936d1277$var$resetFieldErrors = (field)=>{
    field.classList.remove((0, $kOwRn.classes).error);
    field.querySelectorAll((0, $kOwRn.selectors).fieldError).forEach((errorMessage)=>{
        errorMessage.classList.remove($46154ec4936d1277$var$activeErrorClass);
    });
};
const $46154ec4936d1277$export$62894790ff73cc21 = (field, error)=>{
    $46154ec4936d1277$var$resetFieldValid(field);
    $46154ec4936d1277$var$resetFieldErrors(field);
    // Add error class
    field.classList.add((0, $kOwRn.classes).error);
    // Show individual error icon
    field.querySelector(`${(0, $kOwRn.selectors).fieldError}--${error}`).classList.add($46154ec4936d1277$var$activeErrorClass);
};
const $46154ec4936d1277$var$resetFieldValid = (field)=>{
    field.classList.remove((0, $kOwRn.classes).valid);
};
const $46154ec4936d1277$export$8c1ebd23297ed672 = (field)=>{
    $46154ec4936d1277$var$resetFieldErrors(field);
    field.classList.add((0, $kOwRn.classes).valid);
};
const $46154ec4936d1277$export$8d5aa774dee7db0 = (field)=>{
    $46154ec4936d1277$var$resetFieldErrors(field);
    $46154ec4936d1277$var$resetFieldValid(field);
};

});
parcelRegister("kOwRn", function(module, exports) {

$parcel$export(module.exports, "selectors", () => $f271f776916c2f5b$export$e1252723db1c541);
$parcel$export(module.exports, "classes", () => $f271f776916c2f5b$export$188d75d71883854a);
$parcel$export(module.exports, "dataAttributes", () => $f271f776916c2f5b$export$15d6ddc168d35719);
const $f271f776916c2f5b$export$e1252723db1c541 = {
    field: 'div.form-field',
    fieldError: '.field-error'
};
const $f271f776916c2f5b$export$188d75d71883854a = {
    valid: 'form-field--valid',
    error: 'form-field--error',
    required: 'form-field--required'
};
const $f271f776916c2f5b$export$15d6ddc168d35719 = {
    fieldType: 'data-field-type',
    fieldName: 'data-field-name',
    fieldError: 'data-field-error',
    fieldPattern: 'data-pattern'
};

});


parcelRegister("kgd8P", function(module, exports) {

$parcel$export(module.exports, "validateInput", () => $ebff7ee1a9607aef$export$4d09d4ac8ba225dd);
$parcel$export(module.exports, "validateMultiPattern", () => $ebff7ee1a9607aef$export$34cff50e36962659);
$parcel$export(module.exports, "validateMultiSwitch", () => $ebff7ee1a9607aef$export$a2bfd6cfaaba21d1);
$parcel$export(module.exports, "validateMultiRadio", () => $ebff7ee1a9607aef$export$4c31d8ac9e91aaa6);
$parcel$export(module.exports, "validateSwitch", () => $ebff7ee1a9607aef$export$216d5642575b8c06);
$parcel$export(module.exports, "validateSelect", () => $ebff7ee1a9607aef$export$9cd486fd06b2d311);
$parcel$export(module.exports, "validateForm", () => $ebff7ee1a9607aef$export$ed692cabb252e59b);
$parcel$export(module.exports, "resetForm", () => $ebff7ee1a9607aef$export$a2a1e8c320d4e05d);
$parcel$export(module.exports, "lockForm", () => $ebff7ee1a9607aef$export$1c0a3ac618381296);
$parcel$export(module.exports, "unlockForm", () => $ebff7ee1a9607aef$export$99c08c3a9a42f215);

var $613bB = parcelRequire("613bB");

var $kOwRn = parcelRequire("kOwRn");
const $ebff7ee1a9607aef$var$fieldIsRequired = (field)=>{
    return field.classList.contains((0, $kOwRn.classes).required);
};
const $ebff7ee1a9607aef$export$4d09d4ac8ba225dd = (field)=>{
    let fieldIsValid = true;
    const input = field.querySelector('input, textarea');
    // Check if field is empty or invalid
    if (!input.value) {
        // Field is empty
        if ($ebff7ee1a9607aef$var$fieldIsRequired(field)) {
            (0, $613bB.markFieldError)(field, 'empty');
            fieldIsValid = false;
        } else (0, $613bB.resetFieldState)(field);
    } else if (!input.checkValidity()) {
        // Field value is invalid
        (0, $613bB.markFieldError)(field, 'invalid');
        fieldIsValid = false;
    } else if (window.blacklist.length && input.type === 'email' && window.blacklist.filter((v)=>input.value.split('@')[1] === v).length > 0) {
        // The entered email is blacklisted
        (0, $613bB.markFieldError)(field, 'blacklisted');
        fieldIsValid = false;
    } else // Field is neither empty nor invalid => Field is valid!
    (0, $613bB.markFieldAsValid)(field);
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$34cff50e36962659 = (field)=>{
    let fieldIsValid = true;
    const input = field.querySelector('input, textarea');
    const patterns = JSON.parse(input.getAttribute((0, $kOwRn.dataAttributes).fieldPattern));
    for(let key in patterns){
        const pattern = patterns[key];
        input.setAttribute('pattern', pattern);
        if (input.value.match(pattern)) (0, $613bB.markFieldAsValid)(field);
        else {
            (0, $613bB.markFieldError)(field, key);
            fieldIsValid = false;
            break;
        }
    }
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$a2bfd6cfaaba21d1 = (field)=>{
    let fieldIsValid = true;
    const switches = field.querySelectorAll('.form-binary-input');
    if (!$ebff7ee1a9607aef$var$fieldIsRequired(field)) // Field is not required
    return fieldIsValid;
    for(let i = 0; i < switches.length; i++){
        const cb = switches[i].querySelector('input');
        if (cb.checked) {
            (0, $613bB.markFieldAsValid)(field);
            break;
        } else if (i === switches.length - 1) {
            (0, $613bB.markFieldError)(field, 'empty');
            fieldIsValid = false;
        }
    }
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$4c31d8ac9e91aaa6 = (field)=>{
    let fieldIsValid = true;
    const switches = field.querySelectorAll('.form-binary-input');
    if (!$ebff7ee1a9607aef$var$fieldIsRequired(field)) // Field is not required
    return fieldIsValid;
    for(let i = 0; i < switches.length; i++){
        const cb = switches[i].querySelector('input');
        if (cb.checked) {
            (0, $613bB.markFieldAsValid)(field);
            break;
        } else if (i === switches.length - 1) {
            (0, $613bB.markFieldError)(field, 'empty');
            fieldIsValid = false;
        }
    }
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$216d5642575b8c06 = (field)=>{
    let fieldIsValid = true;
    // Only do validity checks if switch has an "off" state
    if (!field.querySelector('.custom-switch-wrapper')) {
        const cb = field.querySelector('input');
        if (!cb.checkValidity() && $ebff7ee1a9607aef$var$fieldIsRequired(field)) {
            (0, $613bB.markFieldError)(field, 'empty');
            fieldIsValid = false;
        } else (0, $613bB.markFieldAsValid)(field);
    }
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$9cd486fd06b2d311 = (field)=>{
    let fieldIsValid = true;
    const select = field.querySelector('select');
    if (!select.value) {
        // Select has empty value
        if ($ebff7ee1a9607aef$var$fieldIsRequired(field)) {
            (0, $613bB.markFieldError)(field, 'empty');
            fieldIsValid = false;
        } else (0, $613bB.resetFieldState)(field);
    } else // Select has value
    (0, $613bB.markFieldAsValid)(field);
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$ed692cabb252e59b = (form, returnFields = false)=>{
    const fields = {};
    // Validate every field in the form
    form.querySelectorAll((0, $kOwRn.selectors).field).forEach((field)=>{
        const fieldType = field.getAttribute((0, $kOwRn.dataAttributes).fieldType);
        const fieldName = field.getAttribute((0, $kOwRn.dataAttributes).fieldName);
        if ([
            'text',
            'textarea',
            'number',
            'email',
            'tel',
            'url',
            'password'
        ].includes(fieldType)) fields[fieldName] = $ebff7ee1a9607aef$export$4d09d4ac8ba225dd(field);
        else if (fieldType === 'switch') fields[fieldName] = $ebff7ee1a9607aef$export$216d5642575b8c06(field);
        else if (fieldType === 'multi_switch') fields[fieldName] = $ebff7ee1a9607aef$export$a2bfd6cfaaba21d1(field);
        else if (fieldType === 'select') fields[fieldName] = $ebff7ee1a9607aef$export$9cd486fd06b2d311(field);
        else if (fieldType === 'radio') fields[fieldName] = $ebff7ee1a9607aef$export$4c31d8ac9e91aaa6(field);
    });
    return returnFields ? fields : !Object.values(fields).includes(false);
};
const $ebff7ee1a9607aef$export$a2a1e8c320d4e05d = (form)=>{
    form.reset();
    form.querySelectorAll((0, $kOwRn.selectors).field).forEach((field)=>{
        (0, $613bB.resetFieldState)(field);
        field.disabled = false;
    });
};
const $ebff7ee1a9607aef$export$1c0a3ac618381296 = (form)=>{
    form.querySelectorAll((0, $kOwRn.selectors).field).forEach((field)=>field.disabled = true);
};
const $ebff7ee1a9607aef$export$99c08c3a9a42f215 = (form)=>{
    form.querySelectorAll((0, $kOwRn.selectors).field).forEach((field)=>field.disabled = false);
};

});

parcelRequire("kOgzt");
var $a3TA1 = parcelRequire("a3TA1");
var $ceOOn = parcelRequire("ceOOn");
const $b60a95926cba5528$var$svgNS = 'http://www.w3.org/2000/svg';
let $b60a95926cba5528$var$locationHref = '';
let $b60a95926cba5528$var$_useWebWorker = false;
const $b60a95926cba5528$var$initialDefaultFrame = -999999;
const $b60a95926cba5528$var$setWebWorker = (flag)=>{
    $b60a95926cba5528$var$_useWebWorker = !!flag;
};
const $b60a95926cba5528$var$getWebWorker = ()=>$b60a95926cba5528$var$_useWebWorker;
const $b60a95926cba5528$var$setLocationHref = (value)=>{
    $b60a95926cba5528$var$locationHref = value;
};
const $b60a95926cba5528$var$getLocationHref = ()=>$b60a95926cba5528$var$locationHref;
function $b60a95926cba5528$var$createTag(type) {
    // return {appendChild:function(){},setAttribute:function(){},style:{}}
    return document.createElement(type);
}
function $b60a95926cba5528$var$extendPrototype(sources, destination) {
    var i;
    var len = sources.length;
    var sourcePrototype;
    for(i = 0; i < len; i += 1){
        sourcePrototype = sources[i].prototype;
        for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
    }
}
function $b60a95926cba5528$var$getDescriptor(object, prop) {
    return Object.getOwnPropertyDescriptor(object, prop);
}
function $b60a95926cba5528$var$createProxyFunction(prototype) {
    function ProxyFunction() {}
    ProxyFunction.prototype = prototype;
    return ProxyFunction;
}
// import Howl from '../../3rd_party/howler';
const $b60a95926cba5528$var$audioControllerFactory = function() {
    function AudioController(audioFactory) {
        this.audios = [];
        this.audioFactory = audioFactory;
        this._volume = 1;
        this._isMuted = false;
    }
    AudioController.prototype = {
        addAudio: function(audio) {
            this.audios.push(audio);
        },
        pause: function() {
            var i;
            var len = this.audios.length;
            for(i = 0; i < len; i += 1)this.audios[i].pause();
        },
        resume: function() {
            var i;
            var len = this.audios.length;
            for(i = 0; i < len; i += 1)this.audios[i].resume();
        },
        setRate: function(rateValue) {
            var i;
            var len = this.audios.length;
            for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
        },
        createAudio: function(assetPath) {
            if (this.audioFactory) return this.audioFactory(assetPath);
            if (window.Howl) return new window.Howl({
                src: [
                    assetPath
                ]
            });
            return {
                isPlaying: false,
                play: function() {
                    this.isPlaying = true;
                },
                seek: function() {
                    this.isPlaying = false;
                },
                playing: function() {},
                rate: function() {},
                setVolume: function() {}
            };
        },
        setAudioFactory: function(audioFactory) {
            this.audioFactory = audioFactory;
        },
        setVolume: function(value) {
            this._volume = value;
            this._updateVolume();
        },
        mute: function() {
            this._isMuted = true;
            this._updateVolume();
        },
        unmute: function() {
            this._isMuted = false;
            this._updateVolume();
        },
        getVolume: function() {
            return this._volume;
        },
        _updateVolume: function() {
            var i;
            var len = this.audios.length;
            for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
        }
    };
    return function() {
        return new AudioController();
    };
}();
const $b60a95926cba5528$var$createTypedArray = function() {
    function createRegularArray(type, len) {
        var i = 0;
        var arr = [];
        var value;
        switch(type){
            case 'int16':
            case 'uint8c':
                value = 1;
                break;
            default:
                value = 1.1;
                break;
        }
        for(i = 0; i < len; i += 1)arr.push(value);
        return arr;
    }
    function createTypedArrayFactory(type, len) {
        if (type === 'float32') return new Float32Array(len);
        if (type === 'int16') return new Int16Array(len);
        if (type === 'uint8c') return new Uint8ClampedArray(len);
        return createRegularArray(type, len);
    }
    if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') return createTypedArrayFactory;
    return createRegularArray;
}();
function $b60a95926cba5528$var$createSizedArray(len) {
    return Array.apply(null, {
        length: len
    });
}
let $b60a95926cba5528$var$subframeEnabled = true;
let $b60a95926cba5528$var$expressionsPlugin = null;
let $b60a95926cba5528$var$expressionsInterfaces = null;
let $b60a95926cba5528$var$idPrefix$1 = '';
const $b60a95926cba5528$var$isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
let $b60a95926cba5528$var$_shouldRoundValues = false;
const $b60a95926cba5528$var$bmPow = Math.pow;
const $b60a95926cba5528$var$bmSqrt = Math.sqrt;
const $b60a95926cba5528$var$bmFloor = Math.floor;
const $b60a95926cba5528$var$bmMax = Math.max;
const $b60a95926cba5528$var$bmMin = Math.min;
const $b60a95926cba5528$var$BMMath = {};
(function() {
    var propertyNames = [
        'abs',
        'acos',
        'acosh',
        'asin',
        'asinh',
        'atan',
        'atanh',
        'atan2',
        'ceil',
        'cbrt',
        'expm1',
        'clz32',
        'cos',
        'cosh',
        'exp',
        'floor',
        'fround',
        'hypot',
        'imul',
        'log',
        'log1p',
        'log2',
        'log10',
        'max',
        'min',
        'pow',
        'random',
        'round',
        'sign',
        'sin',
        'sinh',
        'sqrt',
        'tan',
        'tanh',
        'trunc',
        'E',
        'LN10',
        'LN2',
        'LOG10E',
        'LOG2E',
        'PI',
        'SQRT1_2',
        'SQRT2'
    ];
    var i;
    var len = propertyNames.length;
    for(i = 0; i < len; i += 1)$b60a95926cba5528$var$BMMath[propertyNames[i]] = Math[propertyNames[i]];
})();
function $b60a95926cba5528$var$ProjectInterface$1() {
    return {};
}
$b60a95926cba5528$var$BMMath.random = Math.random;
$b60a95926cba5528$var$BMMath.abs = function(val) {
    var tOfVal = typeof val;
    if (tOfVal === 'object' && val.length) {
        var absArr = $b60a95926cba5528$var$createSizedArray(val.length);
        var i;
        var len = val.length;
        for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
        return absArr;
    }
    return Math.abs(val);
};
let $b60a95926cba5528$var$defaultCurveSegments = 150;
const $b60a95926cba5528$var$degToRads = Math.PI / 180;
const $b60a95926cba5528$var$roundCorner = 0.5519;
function $b60a95926cba5528$var$roundValues(flag) {
    $b60a95926cba5528$var$_shouldRoundValues = !!flag;
}
function $b60a95926cba5528$var$bmRnd(value) {
    if ($b60a95926cba5528$var$_shouldRoundValues) return Math.round(value);
    return value;
}
function $b60a95926cba5528$var$styleDiv(element) {
    element.style.position = 'absolute';
    element.style.top = 0;
    element.style.left = 0;
    element.style.display = 'block';
    element.style.transformOrigin = '0 0';
    element.style.webkitTransformOrigin = '0 0';
    element.style.backfaceVisibility = 'visible';
    element.style.webkitBackfaceVisibility = 'visible';
    element.style.transformStyle = 'preserve-3d';
    element.style.webkitTransformStyle = 'preserve-3d';
    element.style.mozTransformStyle = 'preserve-3d';
}
function $b60a95926cba5528$var$BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
    this.type = type;
    this.currentTime = currentTime;
    this.totalTime = totalTime;
    this.direction = frameMultiplier < 0 ? -1 : 1;
}
function $b60a95926cba5528$var$BMCompleteEvent(type, frameMultiplier) {
    this.type = type;
    this.direction = frameMultiplier < 0 ? -1 : 1;
}
function $b60a95926cba5528$var$BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
    this.type = type;
    this.currentLoop = currentLoop;
    this.totalLoops = totalLoops;
    this.direction = frameMultiplier < 0 ? -1 : 1;
}
function $b60a95926cba5528$var$BMSegmentStartEvent(type, firstFrame, totalFrames) {
    this.type = type;
    this.firstFrame = firstFrame;
    this.totalFrames = totalFrames;
}
function $b60a95926cba5528$var$BMDestroyEvent(type, target) {
    this.type = type;
    this.target = target;
}
function $b60a95926cba5528$var$BMRenderFrameErrorEvent(nativeError, currentTime) {
    this.type = 'renderFrameError';
    this.nativeError = nativeError;
    this.currentTime = currentTime;
}
function $b60a95926cba5528$var$BMConfigErrorEvent(nativeError) {
    this.type = 'configError';
    this.nativeError = nativeError;
}
function $b60a95926cba5528$var$BMAnimationConfigErrorEvent(type, nativeError) {
    this.type = type;
    this.nativeError = nativeError;
}
const $b60a95926cba5528$var$createElementID = function() {
    var _count = 0;
    return function createID() {
        _count += 1;
        return $b60a95926cba5528$var$idPrefix$1 + '__lottie_element_' + _count;
    };
}();
function $b60a95926cba5528$var$HSVtoRGB(h, s, v) {
    var r;
    var g;
    var b;
    var i;
    var f;
    var p;
    var q;
    var t;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch(i % 6){
        case 0:
            r = v;
            g = t;
            b = p;
            break;
        case 1:
            r = q;
            g = v;
            b = p;
            break;
        case 2:
            r = p;
            g = v;
            b = t;
            break;
        case 3:
            r = p;
            g = q;
            b = v;
            break;
        case 4:
            r = t;
            g = p;
            b = v;
            break;
        case 5:
            r = v;
            g = p;
            b = q;
            break;
        default:
            break;
    }
    return [
        r,
        g,
        b
    ];
}
function $b60a95926cba5528$var$RGBtoHSV(r, g, b) {
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    var h;
    var s = max === 0 ? 0 : d / max;
    var v = max / 255;
    switch(max){
        case min:
            h = 0;
            break;
        case r:
            h = g - b + d * (g < b ? 6 : 0);
            h /= 6 * d;
            break;
        case g:
            h = b - r + d * 2;
            h /= 6 * d;
            break;
        case b:
            h = r - g + d * 4;
            h /= 6 * d;
            break;
        default:
            break;
    }
    return [
        h,
        s,
        v
    ];
}
function $b60a95926cba5528$var$addSaturationToRGB(color, offset) {
    var hsv = $b60a95926cba5528$var$RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[1] += offset;
    if (hsv[1] > 1) hsv[1] = 1;
    else if (hsv[1] <= 0) hsv[1] = 0;
    return $b60a95926cba5528$var$HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}
function $b60a95926cba5528$var$addBrightnessToRGB(color, offset) {
    var hsv = $b60a95926cba5528$var$RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[2] += offset;
    if (hsv[2] > 1) hsv[2] = 1;
    else if (hsv[2] < 0) hsv[2] = 0;
    return $b60a95926cba5528$var$HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}
function $b60a95926cba5528$var$addHueToRGB(color, offset) {
    var hsv = $b60a95926cba5528$var$RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[0] += offset / 360;
    if (hsv[0] > 1) hsv[0] -= 1;
    else if (hsv[0] < 0) hsv[0] += 1;
    return $b60a95926cba5528$var$HSVtoRGB(hsv[0], hsv[1], hsv[2]);
}
const $b60a95926cba5528$var$rgbToHex = function() {
    var colorMap = [];
    var i;
    var hex;
    for(i = 0; i < 256; i += 1){
        hex = i.toString(16);
        colorMap[i] = hex.length === 1 ? '0' + hex : hex;
    }
    return function(r, g, b) {
        if (r < 0) r = 0;
        if (g < 0) g = 0;
        if (b < 0) b = 0;
        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
    };
}();
const $b60a95926cba5528$var$setSubframeEnabled = (flag)=>{
    $b60a95926cba5528$var$subframeEnabled = !!flag;
};
const $b60a95926cba5528$var$getSubframeEnabled = ()=>$b60a95926cba5528$var$subframeEnabled;
const $b60a95926cba5528$var$setExpressionsPlugin = (value)=>{
    $b60a95926cba5528$var$expressionsPlugin = value;
};
const $b60a95926cba5528$var$getExpressionsPlugin = ()=>$b60a95926cba5528$var$expressionsPlugin;
const $b60a95926cba5528$var$setExpressionInterfaces = (value)=>{
    $b60a95926cba5528$var$expressionsInterfaces = value;
};
const $b60a95926cba5528$var$getExpressionInterfaces = ()=>$b60a95926cba5528$var$expressionsInterfaces;
const $b60a95926cba5528$var$setDefaultCurveSegments = (value)=>{
    $b60a95926cba5528$var$defaultCurveSegments = value;
};
const $b60a95926cba5528$var$getDefaultCurveSegments = ()=>$b60a95926cba5528$var$defaultCurveSegments;
const $b60a95926cba5528$var$setIdPrefix = (value)=>{
    $b60a95926cba5528$var$idPrefix$1 = value;
};
const $b60a95926cba5528$var$getIdPrefix = ()=>$b60a95926cba5528$var$idPrefix$1;
function $b60a95926cba5528$var$createNS(type) {
    // return {appendChild:function(){},setAttribute:function(){},style:{}}
    return document.createElementNS($b60a95926cba5528$var$svgNS, type);
}
const $b60a95926cba5528$var$dataManager = function() {
    var _counterId = 1;
    var processes = [];
    var workerFn;
    var workerInstance;
    var workerProxy = {
        onmessage: function() {},
        postMessage: function(path) {
            workerFn({
                data: path
            });
        }
    };
    var _workerSelf = {
        postMessage: function(data) {
            workerProxy.onmessage({
                data: data
            });
        }
    };
    function createWorker(fn) {
        if (window.Worker && window.Blob && $b60a95926cba5528$var$getWebWorker()) {
            var blob = new Blob([
                'var _workerSelf = self; self.onmessage = ',
                fn.toString()
            ], {
                type: 'text/javascript'
            });
            // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
            var url = URL.createObjectURL(blob);
            return new Worker(url);
        }
        workerFn = fn;
        return workerProxy;
    }
    function setupWorker() {
        if (!workerInstance) {
            workerInstance = createWorker(function workerStart(e) {
                function dataFunctionManager() {
                    function completeLayers(layers, comps) {
                        var layerData;
                        var i;
                        var len = layers.length;
                        var j;
                        var jLen;
                        var k;
                        var kLen;
                        for(i = 0; i < len; i += 1){
                            layerData = layers[i];
                            if ('ks' in layerData && !layerData.completed) {
                                layerData.completed = true;
                                if (layerData.hasMask) {
                                    var maskProps = layerData.masksProperties;
                                    jLen = maskProps.length;
                                    for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                    else {
                                        kLen = maskProps[j].pt.k.length;
                                        for(k = 0; k < kLen; k += 1){
                                            if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                            if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                        }
                                    }
                                }
                                if (layerData.ty === 0) {
                                    layerData.layers = findCompLayers(layerData.refId, comps);
                                    completeLayers(layerData.layers, comps);
                                } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                else if (layerData.ty === 5) completeText(layerData);
                            }
                        }
                    }
                    function completeChars(chars, assets) {
                        if (chars) {
                            var i = 0;
                            var len = chars.length;
                            for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                // var compData = findComp(chars[i].data.refId, assets);
                                chars[i].data.layers = findCompLayers(chars[i].data.refId, assets);
                                // chars[i].data.ip = 0;
                                // chars[i].data.op = 99999;
                                // chars[i].data.st = 0;
                                // chars[i].data.sr = 1;
                                // chars[i].w = compData.w;
                                // chars[i].data.ks = {
                                //   a: { k: [0, 0, 0], a: 0 },
                                //   p: { k: [0, -compData.h, 0], a: 0 },
                                //   r: { k: 0, a: 0 },
                                //   s: { k: [100, 100], a: 0 },
                                //   o: { k: 100, a: 0 },
                                // };
                                completeLayers(chars[i].data.layers, assets);
                            }
                        }
                    }
                    function findComp(id, comps) {
                        var i = 0;
                        var len = comps.length;
                        while(i < len){
                            if (comps[i].id === id) return comps[i];
                            i += 1;
                        }
                        return null;
                    }
                    function findCompLayers(id, comps) {
                        var comp = findComp(id, comps);
                        if (comp) {
                            if (!comp.layers.__used) {
                                comp.layers.__used = true;
                                return comp.layers;
                            }
                            return JSON.parse(JSON.stringify(comp.layers));
                        }
                        return null;
                    }
                    function completeShapes(arr) {
                        var i;
                        var len = arr.length;
                        var j;
                        var jLen;
                        for(i = len - 1; i >= 0; i -= 1){
                            if (arr[i].ty === 'sh') {
                                if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                else {
                                    jLen = arr[i].ks.k.length;
                                    for(j = 0; j < jLen; j += 1){
                                        if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                        if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                    }
                                }
                            } else if (arr[i].ty === 'gr') completeShapes(arr[i].it);
                        }
                    }
                    function convertPathsToAbsoluteValues(path) {
                        var i;
                        var len = path.i.length;
                        for(i = 0; i < len; i += 1){
                            path.i[i][0] += path.v[i][0];
                            path.i[i][1] += path.v[i][1];
                            path.o[i][0] += path.v[i][0];
                            path.o[i][1] += path.v[i][1];
                        }
                    }
                    function checkVersion(minimum, animVersionString) {
                        var animVersion = animVersionString ? animVersionString.split('.') : [
                            100,
                            100,
                            100
                        ];
                        if (minimum[0] > animVersion[0]) return true;
                        if (animVersion[0] > minimum[0]) return false;
                        if (minimum[1] > animVersion[1]) return true;
                        if (animVersion[1] > minimum[1]) return false;
                        if (minimum[2] > animVersion[2]) return true;
                        if (animVersion[2] > minimum[2]) return false;
                        return null;
                    }
                    var checkText = function() {
                        var minimumVersion = [
                            4,
                            4,
                            14
                        ];
                        function updateTextLayer(textLayer) {
                            var documentData = textLayer.t.d;
                            textLayer.t.d = {
                                k: [
                                    {
                                        s: documentData,
                                        t: 0
                                    }
                                ]
                            };
                        }
                        function iterateLayers(layers) {
                            var i;
                            var len = layers.length;
                            for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                        }
                        return function(animationData) {
                            if (checkVersion(minimumVersion, animationData.v)) {
                                iterateLayers(animationData.layers);
                                if (animationData.assets) {
                                    var i;
                                    var len = animationData.assets.length;
                                    for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                }
                            }
                        };
                    }();
                    var checkChars = function() {
                        var minimumVersion = [
                            4,
                            7,
                            99
                        ];
                        return function(animationData) {
                            if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                var i;
                                var len = animationData.chars.length;
                                for(i = 0; i < len; i += 1){
                                    var charData = animationData.chars[i];
                                    if (charData.data && charData.data.shapes) {
                                        completeShapes(charData.data.shapes);
                                        charData.data.ip = 0;
                                        charData.data.op = 99999;
                                        charData.data.st = 0;
                                        charData.data.sr = 1;
                                        charData.data.ks = {
                                            p: {
                                                k: [
                                                    0,
                                                    0
                                                ],
                                                a: 0
                                            },
                                            s: {
                                                k: [
                                                    100,
                                                    100
                                                ],
                                                a: 0
                                            },
                                            a: {
                                                k: [
                                                    0,
                                                    0
                                                ],
                                                a: 0
                                            },
                                            r: {
                                                k: 0,
                                                a: 0
                                            },
                                            o: {
                                                k: 100,
                                                a: 0
                                            }
                                        };
                                        if (!animationData.chars[i].t) {
                                            charData.data.shapes.push({
                                                ty: 'no'
                                            });
                                            charData.data.shapes[0].it.push({
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                },
                                                sk: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                sa: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                ty: 'tr'
                                            });
                                        }
                                    }
                                }
                            }
                        };
                    }();
                    var checkPathProperties = function() {
                        var minimumVersion = [
                            5,
                            7,
                            15
                        ];
                        function updateTextLayer(textLayer) {
                            var pathData = textLayer.t.p;
                            if (typeof pathData.a === 'number') pathData.a = {
                                a: 0,
                                k: pathData.a
                            };
                            if (typeof pathData.p === 'number') pathData.p = {
                                a: 0,
                                k: pathData.p
                            };
                            if (typeof pathData.r === 'number') pathData.r = {
                                a: 0,
                                k: pathData.r
                            };
                        }
                        function iterateLayers(layers) {
                            var i;
                            var len = layers.length;
                            for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                        }
                        return function(animationData) {
                            if (checkVersion(minimumVersion, animationData.v)) {
                                iterateLayers(animationData.layers);
                                if (animationData.assets) {
                                    var i;
                                    var len = animationData.assets.length;
                                    for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                }
                            }
                        };
                    }();
                    var checkColors = function() {
                        var minimumVersion = [
                            4,
                            1,
                            9
                        ];
                        function iterateShapes(shapes) {
                            var i;
                            var len = shapes.length;
                            var j;
                            var jLen;
                            for(i = 0; i < len; i += 1){
                                if (shapes[i].ty === 'gr') iterateShapes(shapes[i].it);
                                else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                                    if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                        jLen = shapes[i].c.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (shapes[i].c.k[j].s) {
                                                shapes[i].c.k[j].s[0] /= 255;
                                                shapes[i].c.k[j].s[1] /= 255;
                                                shapes[i].c.k[j].s[2] /= 255;
                                                shapes[i].c.k[j].s[3] /= 255;
                                            }
                                            if (shapes[i].c.k[j].e) {
                                                shapes[i].c.k[j].e[0] /= 255;
                                                shapes[i].c.k[j].e[1] /= 255;
                                                shapes[i].c.k[j].e[2] /= 255;
                                                shapes[i].c.k[j].e[3] /= 255;
                                            }
                                        }
                                    } else {
                                        shapes[i].c.k[0] /= 255;
                                        shapes[i].c.k[1] /= 255;
                                        shapes[i].c.k[2] /= 255;
                                        shapes[i].c.k[3] /= 255;
                                    }
                                }
                            }
                        }
                        function iterateLayers(layers) {
                            var i;
                            var len = layers.length;
                            for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                        }
                        return function(animationData) {
                            if (checkVersion(minimumVersion, animationData.v)) {
                                iterateLayers(animationData.layers);
                                if (animationData.assets) {
                                    var i;
                                    var len = animationData.assets.length;
                                    for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                }
                            }
                        };
                    }();
                    var checkShapes = function() {
                        var minimumVersion = [
                            4,
                            4,
                            18
                        ];
                        function completeClosingShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === 'sh') {
                                    if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                            if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                        }
                                    }
                                } else if (arr[i].ty === 'gr') completeClosingShapes(arr[i].it);
                            }
                        }
                        function iterateLayers(layers) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if (layerData.hasMask) {
                                    var maskProps = layerData.masksProperties;
                                    jLen = maskProps.length;
                                    for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                    else {
                                        kLen = maskProps[j].pt.k.length;
                                        for(k = 0; k < kLen; k += 1){
                                            if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                            if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                        }
                                    }
                                }
                                if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                            }
                        }
                        return function(animationData) {
                            if (checkVersion(minimumVersion, animationData.v)) {
                                iterateLayers(animationData.layers);
                                if (animationData.assets) {
                                    var i;
                                    var len = animationData.assets.length;
                                    for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                }
                            }
                        };
                    }();
                    function completeData(animationData) {
                        if (animationData.__complete) return;
                        checkColors(animationData);
                        checkText(animationData);
                        checkChars(animationData);
                        checkPathProperties(animationData);
                        checkShapes(animationData);
                        completeLayers(animationData.layers, animationData.assets);
                        completeChars(animationData.chars, animationData.assets);
                        animationData.__complete = true;
                    }
                    function completeText(data) {
                        data.t.a.length === 0 && data.t.p;
                    }
                    var moduleOb = {};
                    moduleOb.completeData = completeData;
                    moduleOb.checkColors = checkColors;
                    moduleOb.checkChars = checkChars;
                    moduleOb.checkPathProperties = checkPathProperties;
                    moduleOb.checkShapes = checkShapes;
                    moduleOb.completeLayers = completeLayers;
                    return moduleOb;
                }
                if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                    function formatResponse(xhr) {
                        // using typeof doubles the time of execution of this method,
                        // so if available, it's better to use the header to validate the type
                        var contentTypeHeader = xhr.getResponseHeader('content-type');
                        if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) return xhr.response;
                        if (xhr.response && typeof xhr.response === 'object') return xhr.response;
                        if (xhr.response && typeof xhr.response === 'string') return JSON.parse(xhr.response);
                        if (xhr.responseText) return JSON.parse(xhr.responseText);
                        return null;
                    }
                    function loadAsset(path, fullPath, callback, errorCallback) {
                        var response;
                        var xhr = new XMLHttpRequest();
                        // set responseType after calling open or IE will break.
                        try {
                            // This crashes on Android WebView prior to KitKat
                            xhr.responseType = 'json';
                        } catch (err) {} // eslint-disable-line no-empty
                        xhr.onreadystatechange = function() {
                            if (xhr.readyState === 4) {
                                if (xhr.status === 200) {
                                    response = formatResponse(xhr);
                                    callback(response);
                                } else try {
                                    response = formatResponse(xhr);
                                    callback(response);
                                } catch (err) {
                                    if (errorCallback) errorCallback(err);
                                }
                            }
                        };
                        try {
                            // Hack to workaround banner validation
                            xhr.open([
                                'G',
                                'E',
                                'T'
                            ].join(''), path, true);
                        } catch (error) {
                            // Hack to workaround banner validation
                            xhr.open([
                                'G',
                                'E',
                                'T'
                            ].join(''), fullPath + '/' + path, true);
                        }
                        xhr.send();
                    }
                    return {
                        load: loadAsset
                    };
                }();
                if (e.data.type === 'loadAnimation') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                    _workerSelf.dataManager.completeData(data);
                    _workerSelf.postMessage({
                        id: e.data.id,
                        payload: data,
                        status: 'success'
                    });
                }, function() {
                    _workerSelf.postMessage({
                        id: e.data.id,
                        status: 'error'
                    });
                });
                else if (e.data.type === 'complete') {
                    var animation = e.data.animation;
                    _workerSelf.dataManager.completeData(animation);
                    _workerSelf.postMessage({
                        id: e.data.id,
                        payload: animation,
                        status: 'success'
                    });
                } else if (e.data.type === 'loadData') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                    _workerSelf.postMessage({
                        id: e.data.id,
                        payload: data,
                        status: 'success'
                    });
                }, function() {
                    _workerSelf.postMessage({
                        id: e.data.id,
                        status: 'error'
                    });
                });
            });
            workerInstance.onmessage = function(event) {
                var data = event.data;
                var id = data.id;
                var process = processes[id];
                processes[id] = null;
                if (data.status === 'success') process.onComplete(data.payload);
                else if (process.onError) process.onError();
            };
        }
    }
    function createProcess(onComplete, onError) {
        _counterId += 1;
        var id = 'processId_' + _counterId;
        processes[id] = {
            onComplete: onComplete,
            onError: onError
        };
        return id;
    }
    function loadAnimation(path, onComplete, onError) {
        setupWorker();
        var processId = createProcess(onComplete, onError);
        workerInstance.postMessage({
            type: 'loadAnimation',
            path: path,
            fullPath: window.location.origin + window.location.pathname,
            id: processId
        });
    }
    function loadData(path, onComplete, onError) {
        setupWorker();
        var processId = createProcess(onComplete, onError);
        workerInstance.postMessage({
            type: 'loadData',
            path: path,
            fullPath: window.location.origin + window.location.pathname,
            id: processId
        });
    }
    function completeAnimation(anim, onComplete, onError) {
        setupWorker();
        var processId = createProcess(onComplete, onError);
        workerInstance.postMessage({
            type: 'complete',
            animation: anim,
            id: processId
        });
    }
    return {
        loadAnimation: loadAnimation,
        loadData: loadData,
        completeAnimation: completeAnimation
    };
}();
const $b60a95926cba5528$var$ImagePreloader = function() {
    var proxyImage = function() {
        var canvas = $b60a95926cba5528$var$createTag('canvas');
        canvas.width = 1;
        canvas.height = 1;
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = 'rgba(0,0,0,0)';
        ctx.fillRect(0, 0, 1, 1);
        return canvas;
    }();
    function imageLoaded() {
        this.loadedAssets += 1;
        if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
            if (this.imagesLoadedCb) this.imagesLoadedCb(null);
        }
    }
    function footageLoaded() {
        this.loadedFootagesCount += 1;
        if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
            if (this.imagesLoadedCb) this.imagesLoadedCb(null);
        }
    }
    function getAssetsPath(assetData, assetsPath, originalPath) {
        var path = '';
        if (assetData.e) path = assetData.p;
        else if (assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
            path = assetsPath + imagePath;
        } else {
            path = originalPath;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    }
    function testImageLoaded(img) {
        var _count = 0;
        var intervalId = setInterval((function() {
            var box = img.getBBox();
            if (box.width || _count > 500) {
                this._imageLoaded();
                clearInterval(intervalId);
            }
            _count += 1;
        }).bind(this), 50);
    }
    function createImageData(assetData) {
        var path = getAssetsPath(assetData, this.assetsPath, this.path);
        var img = $b60a95926cba5528$var$createNS('image');
        if ($b60a95926cba5528$var$isSafari) this.testImageLoaded(img);
        else img.addEventListener('load', this._imageLoaded, false);
        img.addEventListener('error', (function() {
            ob.img = proxyImage;
            this._imageLoaded();
        }).bind(this), false);
        img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
        if (this._elementHelper.append) this._elementHelper.append(img);
        else this._elementHelper.appendChild(img);
        var ob = {
            img: img,
            assetData: assetData
        };
        return ob;
    }
    function createImgData(assetData) {
        var path = getAssetsPath(assetData, this.assetsPath, this.path);
        var img = $b60a95926cba5528$var$createTag('img');
        img.crossOrigin = 'anonymous';
        img.addEventListener('load', this._imageLoaded, false);
        img.addEventListener('error', (function() {
            ob.img = proxyImage;
            this._imageLoaded();
        }).bind(this), false);
        img.src = path;
        var ob = {
            img: img,
            assetData: assetData
        };
        return ob;
    }
    function createFootageData(data) {
        var ob = {
            assetData: data
        };
        var path = getAssetsPath(data, this.assetsPath, this.path);
        $b60a95926cba5528$var$dataManager.loadData(path, (function(footageData) {
            ob.img = footageData;
            this._footageLoaded();
        }).bind(this), (function() {
            ob.img = {};
            this._footageLoaded();
        }).bind(this));
        return ob;
    }
    function loadAssets(assets, cb) {
        this.imagesLoadedCb = cb;
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (!assets[i].layers) {
            if (!assets[i].t || assets[i].t === 'seq') {
                this.totalImages += 1;
                this.images.push(this._createImageData(assets[i]));
            } else if (assets[i].t === 3) {
                this.totalFootages += 1;
                this.images.push(this.createFootageData(assets[i]));
            }
        }
    }
    function setPath(path) {
        this.path = path || '';
    }
    function setAssetsPath(path) {
        this.assetsPath = path || '';
    }
    function getAsset(assetData) {
        var i = 0;
        var len = this.images.length;
        while(i < len){
            if (this.images[i].assetData === assetData) return this.images[i].img;
            i += 1;
        }
        return null;
    }
    function destroy() {
        this.imagesLoadedCb = null;
        this.images.length = 0;
    }
    function loadedImages() {
        return this.totalImages === this.loadedAssets;
    }
    function loadedFootages() {
        return this.totalFootages === this.loadedFootagesCount;
    }
    function setCacheType(type, elementHelper) {
        if (type === 'svg') {
            this._elementHelper = elementHelper;
            this._createImageData = this.createImageData.bind(this);
        } else this._createImageData = this.createImgData.bind(this);
    }
    function ImagePreloaderFactory() {
        this._imageLoaded = imageLoaded.bind(this);
        this._footageLoaded = footageLoaded.bind(this);
        this.testImageLoaded = testImageLoaded.bind(this);
        this.createFootageData = createFootageData.bind(this);
        this.assetsPath = '';
        this.path = '';
        this.totalImages = 0;
        this.totalFootages = 0;
        this.loadedAssets = 0;
        this.loadedFootagesCount = 0;
        this.imagesLoadedCb = null;
        this.images = [];
    }
    ImagePreloaderFactory.prototype = {
        loadAssets: loadAssets,
        setAssetsPath: setAssetsPath,
        setPath: setPath,
        loadedImages: loadedImages,
        loadedFootages: loadedFootages,
        destroy: destroy,
        getAsset: getAsset,
        createImgData: createImgData,
        createImageData: createImageData,
        imageLoaded: imageLoaded,
        footageLoaded: footageLoaded,
        setCacheType: setCacheType
    };
    return ImagePreloaderFactory;
}();
function $b60a95926cba5528$var$BaseEvent() {}
$b60a95926cba5528$var$BaseEvent.prototype = {
    triggerEvent: function(eventName, args) {
        if (this._cbs[eventName]) {
            var callbacks = this._cbs[eventName];
            for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
        }
    },
    addEventListener: function(eventName, callback) {
        if (!this._cbs[eventName]) this._cbs[eventName] = [];
        this._cbs[eventName].push(callback);
        return (function() {
            this.removeEventListener(eventName, callback);
        }).bind(this);
    },
    removeEventListener: function(eventName, callback) {
        if (!callback) this._cbs[eventName] = null;
        else if (this._cbs[eventName]) {
            var i = 0;
            var len = this._cbs[eventName].length;
            while(i < len){
                if (this._cbs[eventName][i] === callback) {
                    this._cbs[eventName].splice(i, 1);
                    i -= 1;
                    len -= 1;
                }
                i += 1;
            }
            if (!this._cbs[eventName].length) this._cbs[eventName] = null;
        }
    }
};
const $b60a95926cba5528$var$markerParser = function() {
    function parsePayloadLines(payload) {
        var lines = payload.split('\r\n');
        var keys = {};
        var line;
        var keysCount = 0;
        for(var i = 0; i < lines.length; i += 1){
            line = lines[i].split(':');
            if (line.length === 2) {
                keys[line[0]] = line[1].trim();
                keysCount += 1;
            }
        }
        if (keysCount === 0) throw new Error();
        return keys;
    }
    return function(_markers) {
        var markers = [];
        for(var i = 0; i < _markers.length; i += 1){
            var _marker = _markers[i];
            var markerData = {
                time: _marker.tm,
                duration: _marker.dr
            };
            try {
                markerData.payload = JSON.parse(_markers[i].cm);
            } catch (_) {
                try {
                    markerData.payload = parsePayloadLines(_markers[i].cm);
                } catch (__) {
                    markerData.payload = {
                        name: _markers[i].cm
                    };
                }
            }
            markers.push(markerData);
        }
        return markers;
    };
}();
const $b60a95926cba5528$var$ProjectInterface = function() {
    function registerComposition(comp) {
        this.compositions.push(comp);
    }
    return function() {
        function _thisProjectFunction(name) {
            var i = 0;
            var len = this.compositions.length;
            while(i < len){
                if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                    if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                    return this.compositions[i].compInterface;
                }
                i += 1;
            }
            return null;
        }
        _thisProjectFunction.compositions = [];
        _thisProjectFunction.currentFrame = 0;
        _thisProjectFunction.registerComposition = registerComposition;
        return _thisProjectFunction;
    };
}();
const $b60a95926cba5528$var$renderers = {};
const $b60a95926cba5528$var$registerRenderer = (key, value)=>{
    $b60a95926cba5528$var$renderers[key] = value;
};
function $b60a95926cba5528$var$getRenderer(key) {
    return $b60a95926cba5528$var$renderers[key];
}
function $b60a95926cba5528$var$getRegisteredRenderer() {
    // Returns canvas by default for compatibility
    if ($b60a95926cba5528$var$renderers.canvas) return 'canvas';
    // Returns any renderer that is registered
    for(const key in $b60a95926cba5528$var$renderers){
        if ($b60a95926cba5528$var$renderers[key]) return key;
    }
    return '';
}
const $b60a95926cba5528$var$AnimationItem = function() {
    this._cbs = [];
    this.name = '';
    this.path = '';
    this.isLoaded = false;
    this.currentFrame = 0;
    this.currentRawFrame = 0;
    this.firstFrame = 0;
    this.totalFrames = 0;
    this.frameRate = 0;
    this.frameMult = 0;
    this.playSpeed = 1;
    this.playDirection = 1;
    this.playCount = 0;
    this.animationData = {};
    this.assets = [];
    this.isPaused = true;
    this.autoplay = false;
    this.loop = true;
    this.renderer = null;
    this.animationID = $b60a95926cba5528$var$createElementID();
    this.assetsPath = '';
    this.timeCompleted = 0;
    this.segmentPos = 0;
    this.isSubframeEnabled = $b60a95926cba5528$var$getSubframeEnabled();
    this.segments = [];
    this._idle = true;
    this._completedLoop = false;
    this.projectInterface = $b60a95926cba5528$var$ProjectInterface();
    this.imagePreloader = new $b60a95926cba5528$var$ImagePreloader();
    this.audioController = $b60a95926cba5528$var$audioControllerFactory();
    this.markers = [];
    this.configAnimation = this.configAnimation.bind(this);
    this.onSetupError = this.onSetupError.bind(this);
    this.onSegmentComplete = this.onSegmentComplete.bind(this);
    this.drawnFrameEvent = new $b60a95926cba5528$var$BMEnterFrameEvent('drawnFrame', 0, 0, 0);
    this.expressionsPlugin = $b60a95926cba5528$var$getExpressionsPlugin();
};
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$BaseEvent
], $b60a95926cba5528$var$AnimationItem);
$b60a95926cba5528$var$AnimationItem.prototype.setParams = function(params) {
    if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
    var animType = 'svg';
    if (params.animType) animType = params.animType;
    else if (params.renderer) animType = params.renderer;
    const RendererClass = $b60a95926cba5528$var$getRenderer(animType);
    this.renderer = new RendererClass(this, params.rendererSettings);
    this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
    this.renderer.setProjectInterface(this.projectInterface);
    this.animType = animType;
    if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
    else if (params.loop === false) this.loop = false;
    else this.loop = parseInt(params.loop, 10);
    this.autoplay = 'autoplay' in params ? params.autoplay : true;
    this.name = params.name ? params.name : '';
    this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
    this.assetsPath = params.assetsPath;
    this.initialSegment = params.initialSegment;
    if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
    if (params.animationData) this.setupAnimation(params.animationData);
    else if (params.path) {
        if (params.path.lastIndexOf('\\') !== -1) this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
        else this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
        this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
        this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
        $b60a95926cba5528$var$dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
    }
};
$b60a95926cba5528$var$AnimationItem.prototype.onSetupError = function() {
    this.trigger('data_failed');
};
$b60a95926cba5528$var$AnimationItem.prototype.setupAnimation = function(data) {
    $b60a95926cba5528$var$dataManager.completeAnimation(data, this.configAnimation);
};
$b60a95926cba5528$var$AnimationItem.prototype.setData = function(wrapper, animationData) {
    if (animationData) {
        if (typeof animationData !== 'object') animationData = JSON.parse(animationData);
    }
    var params = {
        wrapper: wrapper,
        animationData: animationData
    };
    var wrapperAttributes = wrapper.attributes;
    params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
    params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : $b60a95926cba5528$var$getRegisteredRenderer() || 'canvas';
    var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
    if (loop === 'false') params.loop = false;
    else if (loop === 'true') params.loop = true;
    else if (loop !== '') params.loop = parseInt(loop, 10);
    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
    params.autoplay = autoplay !== 'false';
    params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
     ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
    if (prerender === 'false') params.prerender = false;
    if (!params.path) this.trigger('destroy');
    else this.setParams(params);
};
$b60a95926cba5528$var$AnimationItem.prototype.includeLayers = function(data) {
    if (data.op > this.animationData.op) {
        this.animationData.op = data.op;
        this.totalFrames = Math.floor(data.op - this.animationData.ip);
    }
    var layers = this.animationData.layers;
    var i;
    var len = layers.length;
    var newLayers = data.layers;
    var j;
    var jLen = newLayers.length;
    for(j = 0; j < jLen; j += 1){
        i = 0;
        while(i < len){
            if (layers[i].id === newLayers[j].id) {
                layers[i] = newLayers[j];
                break;
            }
            i += 1;
        }
    }
    if (data.chars || data.fonts) {
        this.renderer.globalData.fontManager.addChars(data.chars);
        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
    }
    if (data.assets) {
        len = data.assets.length;
        for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
    }
    this.animationData.__complete = false;
    $b60a95926cba5528$var$dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
};
$b60a95926cba5528$var$AnimationItem.prototype.onSegmentComplete = function(data) {
    this.animationData = data;
    var expressionsPlugin = $b60a95926cba5528$var$getExpressionsPlugin();
    if (expressionsPlugin) expressionsPlugin.initExpressions(this);
    this.loadNextSegment();
};
$b60a95926cba5528$var$AnimationItem.prototype.loadNextSegment = function() {
    var segments = this.animationData.segments;
    if (!segments || segments.length === 0 || !this.autoloadSegments) {
        this.trigger('data_ready');
        this.timeCompleted = this.totalFrames;
        return;
    }
    var segment = segments.shift();
    this.timeCompleted = segment.time * this.frameRate;
    var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
    this.segmentPos += 1;
    $b60a95926cba5528$var$dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
        this.trigger('data_failed');
    }).bind(this));
};
$b60a95926cba5528$var$AnimationItem.prototype.loadSegments = function() {
    var segments = this.animationData.segments;
    if (!segments) this.timeCompleted = this.totalFrames;
    this.loadNextSegment();
};
$b60a95926cba5528$var$AnimationItem.prototype.imagesLoaded = function() {
    this.trigger('loaded_images');
    this.checkLoaded();
};
$b60a95926cba5528$var$AnimationItem.prototype.preloadImages = function() {
    this.imagePreloader.setAssetsPath(this.assetsPath);
    this.imagePreloader.setPath(this.path);
    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
};
$b60a95926cba5528$var$AnimationItem.prototype.configAnimation = function(animData) {
    if (!this.renderer) return;
    try {
        this.animationData = animData;
        if (this.initialSegment) {
            this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
            this.firstFrame = Math.round(this.initialSegment[0]);
        } else {
            this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
            this.firstFrame = Math.round(this.animationData.ip);
        }
        this.renderer.configAnimation(animData);
        if (!animData.assets) animData.assets = [];
        this.assets = this.animationData.assets;
        this.frameRate = this.animationData.fr;
        this.frameMult = this.animationData.fr / 1000;
        this.renderer.searchExtraCompositions(animData.assets);
        this.markers = $b60a95926cba5528$var$markerParser(animData.markers || []);
        this.trigger('config_ready');
        this.preloadImages();
        this.loadSegments();
        this.updaFrameModifier();
        this.waitForFontsLoaded();
        if (this.isPaused) this.audioController.pause();
    } catch (error) {
        this.triggerConfigError(error);
    }
};
$b60a95926cba5528$var$AnimationItem.prototype.waitForFontsLoaded = function() {
    if (!this.renderer) return;
    if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
    else setTimeout(this.waitForFontsLoaded.bind(this), 20);
};
$b60a95926cba5528$var$AnimationItem.prototype.checkLoaded = function() {
    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
        this.isLoaded = true;
        var expressionsPlugin = $b60a95926cba5528$var$getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.renderer.initItems();
        setTimeout((function() {
            this.trigger('DOMLoaded');
        }).bind(this), 0);
        this.gotoFrame();
        if (this.autoplay) this.play();
    }
};
$b60a95926cba5528$var$AnimationItem.prototype.resize = function(width, height) {
    // Adding this validation for backwards compatibility in case an event object was being passed down
    var _width = typeof width === 'number' ? width : undefined;
    var _height = typeof height === 'number' ? height : undefined;
    this.renderer.updateContainerSize(_width, _height);
};
$b60a95926cba5528$var$AnimationItem.prototype.setSubframe = function(flag) {
    this.isSubframeEnabled = !!flag;
};
$b60a95926cba5528$var$AnimationItem.prototype.gotoFrame = function() {
    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
    if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
    this.trigger('enterFrame');
    this.renderFrame();
    this.trigger('drawnFrame');
};
$b60a95926cba5528$var$AnimationItem.prototype.renderFrame = function() {
    if (this.isLoaded === false || !this.renderer) return;
    try {
        if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
        this.renderer.renderFrame(this.currentFrame + this.firstFrame);
    } catch (error) {
        this.triggerRenderFrameError(error);
    }
};
$b60a95926cba5528$var$AnimationItem.prototype.play = function(name) {
    if (name && this.name !== name) return;
    if (this.isPaused === true) {
        this.isPaused = false;
        this.trigger('_play');
        this.audioController.resume();
        if (this._idle) {
            this._idle = false;
            this.trigger('_active');
        }
    }
};
$b60a95926cba5528$var$AnimationItem.prototype.pause = function(name) {
    if (name && this.name !== name) return;
    if (this.isPaused === false) {
        this.isPaused = true;
        this.trigger('_pause');
        this._idle = true;
        this.trigger('_idle');
        this.audioController.pause();
    }
};
$b60a95926cba5528$var$AnimationItem.prototype.togglePause = function(name) {
    if (name && this.name !== name) return;
    if (this.isPaused === true) this.play();
    else this.pause();
};
$b60a95926cba5528$var$AnimationItem.prototype.stop = function(name) {
    if (name && this.name !== name) return;
    this.pause();
    this.playCount = 0;
    this._completedLoop = false;
    this.setCurrentRawFrameValue(0);
};
$b60a95926cba5528$var$AnimationItem.prototype.getMarkerData = function(markerName) {
    var marker;
    for(var i = 0; i < this.markers.length; i += 1){
        marker = this.markers[i];
        if (marker.payload && marker.payload.name === markerName) return marker;
    }
    return null;
};
$b60a95926cba5528$var$AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
    if (name && this.name !== name) return;
    var numValue = Number(value);
    if (isNaN(numValue)) {
        var marker = this.getMarkerData(value);
        if (marker) this.goToAndStop(marker.time, true);
    } else if (isFrame) this.setCurrentRawFrameValue(value);
    else this.setCurrentRawFrameValue(value * this.frameModifier);
    this.pause();
};
$b60a95926cba5528$var$AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
    if (name && this.name !== name) return;
    var numValue = Number(value);
    if (isNaN(numValue)) {
        var marker = this.getMarkerData(value);
        if (marker) {
            if (!marker.duration) this.goToAndStop(marker.time, true);
            else this.playSegments([
                marker.time,
                marker.time + marker.duration
            ], true);
        }
    } else this.goToAndStop(numValue, isFrame, name);
    this.play();
};
$b60a95926cba5528$var$AnimationItem.prototype.advanceTime = function(value) {
    if (this.isPaused === true || this.isLoaded === false) return;
    var nextValue = this.currentRawFrame + value * this.frameModifier;
    var _isComplete = false;
    // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
        if (!this.loop || this.playCount === this.loop) {
            if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                _isComplete = true;
                nextValue = this.totalFrames - 1;
            }
        } else if (nextValue >= this.totalFrames) {
            this.playCount += 1;
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                this._completedLoop = true;
                this.trigger('loopComplete');
            }
        } else this.setCurrentRawFrameValue(nextValue);
    } else if (nextValue < 0) {
        if (!this.checkSegments(nextValue % this.totalFrames)) {
            if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                if (!this._completedLoop) this._completedLoop = true;
                else this.trigger('loopComplete');
            } else {
                _isComplete = true;
                nextValue = 0;
            }
        }
    } else this.setCurrentRawFrameValue(nextValue);
    if (_isComplete) {
        this.setCurrentRawFrameValue(nextValue);
        this.pause();
        this.trigger('complete');
    }
};
$b60a95926cba5528$var$AnimationItem.prototype.adjustSegment = function(arr, offset) {
    this.playCount = 0;
    if (arr[1] < arr[0]) {
        if (this.frameModifier > 0) {
            if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
            else this.setDirection(-1);
        }
        this.totalFrames = arr[0] - arr[1];
        this.timeCompleted = this.totalFrames;
        this.firstFrame = arr[1];
        this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
    } else if (arr[1] > arr[0]) {
        if (this.frameModifier < 0) {
            if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
            else this.setDirection(1);
        }
        this.totalFrames = arr[1] - arr[0];
        this.timeCompleted = this.totalFrames;
        this.firstFrame = arr[0];
        this.setCurrentRawFrameValue(0.001 + offset);
    }
    this.trigger('segmentStart');
};
$b60a95926cba5528$var$AnimationItem.prototype.setSegment = function(init, end) {
    var pendingFrame = -1;
    if (this.isPaused) {
        if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
        else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
    }
    this.firstFrame = init;
    this.totalFrames = end - init;
    this.timeCompleted = this.totalFrames;
    if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
};
$b60a95926cba5528$var$AnimationItem.prototype.playSegments = function(arr, forceFlag) {
    if (forceFlag) this.segments.length = 0;
    if (typeof arr[0] === 'object') {
        var i;
        var len = arr.length;
        for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
    } else this.segments.push(arr);
    if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
    if (this.isPaused) this.play();
};
$b60a95926cba5528$var$AnimationItem.prototype.resetSegments = function(forceFlag) {
    this.segments.length = 0;
    this.segments.push([
        this.animationData.ip,
        this.animationData.op
    ]);
    if (forceFlag) this.checkSegments(0);
};
$b60a95926cba5528$var$AnimationItem.prototype.checkSegments = function(offset) {
    if (this.segments.length) {
        this.adjustSegment(this.segments.shift(), offset);
        return true;
    }
    return false;
};
$b60a95926cba5528$var$AnimationItem.prototype.destroy = function(name) {
    if (name && this.name !== name || !this.renderer) return;
    this.renderer.destroy();
    this.imagePreloader.destroy();
    this.trigger('destroy');
    this._cbs = null;
    this.onEnterFrame = null;
    this.onLoopComplete = null;
    this.onComplete = null;
    this.onSegmentStart = null;
    this.onDestroy = null;
    this.renderer = null;
    this.expressionsPlugin = null;
    this.imagePreloader = null;
    this.projectInterface = null;
};
$b60a95926cba5528$var$AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
    this.currentRawFrame = value;
    this.gotoFrame();
};
$b60a95926cba5528$var$AnimationItem.prototype.setSpeed = function(val) {
    this.playSpeed = val;
    this.updaFrameModifier();
};
$b60a95926cba5528$var$AnimationItem.prototype.setDirection = function(val) {
    this.playDirection = val < 0 ? -1 : 1;
    this.updaFrameModifier();
};
$b60a95926cba5528$var$AnimationItem.prototype.setLoop = function(isLooping) {
    this.loop = isLooping;
};
$b60a95926cba5528$var$AnimationItem.prototype.setVolume = function(val, name) {
    if (name && this.name !== name) return;
    this.audioController.setVolume(val);
};
$b60a95926cba5528$var$AnimationItem.prototype.getVolume = function() {
    return this.audioController.getVolume();
};
$b60a95926cba5528$var$AnimationItem.prototype.mute = function(name) {
    if (name && this.name !== name) return;
    this.audioController.mute();
};
$b60a95926cba5528$var$AnimationItem.prototype.unmute = function(name) {
    if (name && this.name !== name) return;
    this.audioController.unmute();
};
$b60a95926cba5528$var$AnimationItem.prototype.updaFrameModifier = function() {
    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
    this.audioController.setRate(this.playSpeed * this.playDirection);
};
$b60a95926cba5528$var$AnimationItem.prototype.getPath = function() {
    return this.path;
};
$b60a95926cba5528$var$AnimationItem.prototype.getAssetsPath = function(assetData) {
    var path = '';
    if (assetData.e) path = assetData.p;
    else if (this.assetsPath) {
        var imagePath = assetData.p;
        if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
        path = this.assetsPath + imagePath;
    } else {
        path = this.path;
        path += assetData.u ? assetData.u : '';
        path += assetData.p;
    }
    return path;
};
$b60a95926cba5528$var$AnimationItem.prototype.getAssetData = function(id) {
    var i = 0;
    var len = this.assets.length;
    while(i < len){
        if (id === this.assets[i].id) return this.assets[i];
        i += 1;
    }
    return null;
};
$b60a95926cba5528$var$AnimationItem.prototype.hide = function() {
    this.renderer.hide();
};
$b60a95926cba5528$var$AnimationItem.prototype.show = function() {
    this.renderer.show();
};
$b60a95926cba5528$var$AnimationItem.prototype.getDuration = function(isFrame) {
    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
};
$b60a95926cba5528$var$AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
    try {
        var element = this.renderer.getElementByPath(path);
        element.updateDocumentData(documentData, index);
    } catch (error) {
    // TODO: decide how to handle catch case
    }
};
$b60a95926cba5528$var$AnimationItem.prototype.trigger = function(name) {
    if (this._cbs && this._cbs[name]) switch(name){
        case 'enterFrame':
            this.triggerEvent(name, new $b60a95926cba5528$var$BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
        case 'drawnFrame':
            this.drawnFrameEvent.currentTime = this.currentFrame;
            this.drawnFrameEvent.totalTime = this.totalFrames;
            this.drawnFrameEvent.direction = this.frameModifier;
            this.triggerEvent(name, this.drawnFrameEvent);
            break;
        case 'loopComplete':
            this.triggerEvent(name, new $b60a95926cba5528$var$BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
            break;
        case 'complete':
            this.triggerEvent(name, new $b60a95926cba5528$var$BMCompleteEvent(name, this.frameMult));
            break;
        case 'segmentStart':
            this.triggerEvent(name, new $b60a95926cba5528$var$BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
            break;
        case 'destroy':
            this.triggerEvent(name, new $b60a95926cba5528$var$BMDestroyEvent(name, this));
            break;
        default:
            this.triggerEvent(name);
    }
    if (name === 'enterFrame' && this.onEnterFrame) this.onEnterFrame.call(this, new $b60a95926cba5528$var$BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
    if (name === 'loopComplete' && this.onLoopComplete) this.onLoopComplete.call(this, new $b60a95926cba5528$var$BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
    if (name === 'complete' && this.onComplete) this.onComplete.call(this, new $b60a95926cba5528$var$BMCompleteEvent(name, this.frameMult));
    if (name === 'segmentStart' && this.onSegmentStart) this.onSegmentStart.call(this, new $b60a95926cba5528$var$BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
    if (name === 'destroy' && this.onDestroy) this.onDestroy.call(this, new $b60a95926cba5528$var$BMDestroyEvent(name, this));
};
$b60a95926cba5528$var$AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
    var error = new $b60a95926cba5528$var$BMRenderFrameErrorEvent(nativeError, this.currentFrame);
    this.triggerEvent('error', error);
    if (this.onError) this.onError.call(this, error);
};
$b60a95926cba5528$var$AnimationItem.prototype.triggerConfigError = function(nativeError) {
    var error = new $b60a95926cba5528$var$BMConfigErrorEvent(nativeError, this.currentFrame);
    this.triggerEvent('error', error);
    if (this.onError) this.onError.call(this, error);
};
const $b60a95926cba5528$var$animationManager = function() {
    var moduleOb = {};
    var registeredAnimations = [];
    var initTime = 0;
    var len = 0;
    var playingAnimationsNum = 0;
    var _stopped = true;
    var _isFrozen = false;
    function removeElement(ev) {
        var i = 0;
        var animItem = ev.target;
        while(i < len){
            if (registeredAnimations[i].animation === animItem) {
                registeredAnimations.splice(i, 1);
                i -= 1;
                len -= 1;
                if (!animItem.isPaused) subtractPlayingCount();
            }
            i += 1;
        }
    }
    function registerAnimation(element, animationData) {
        if (!element) return null;
        var i = 0;
        while(i < len){
            if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
            i += 1;
        }
        var animItem = new $b60a95926cba5528$var$AnimationItem();
        setupAnimation(animItem, element);
        animItem.setData(element, animationData);
        return animItem;
    }
    function getRegisteredAnimations() {
        var i;
        var lenAnims = registeredAnimations.length;
        var animations = [];
        for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
        return animations;
    }
    function addPlayingCount() {
        playingAnimationsNum += 1;
        activate();
    }
    function subtractPlayingCount() {
        playingAnimationsNum -= 1;
    }
    function setupAnimation(animItem, element) {
        animItem.addEventListener('destroy', removeElement);
        animItem.addEventListener('_active', addPlayingCount);
        animItem.addEventListener('_idle', subtractPlayingCount);
        registeredAnimations.push({
            elem: element,
            animation: animItem
        });
        len += 1;
    }
    function loadAnimation(params) {
        var animItem = new $b60a95926cba5528$var$AnimationItem();
        setupAnimation(animItem, null);
        animItem.setParams(params);
        return animItem;
    }
    function setSpeed(val, animation) {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
    }
    function setDirection(val, animation) {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
    }
    function play(animation) {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
    }
    function resume(nowTime) {
        var elapsedTime = nowTime - initTime;
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
        initTime = nowTime;
        if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
        else _stopped = true;
    }
    function first(nowTime) {
        initTime = nowTime;
        window.requestAnimationFrame(resume);
    }
    function pause(animation) {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
    }
    function goToAndStop(value, isFrame, animation) {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
    }
    function stop(animation) {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
    }
    function togglePause(animation) {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
    }
    function destroy(animation) {
        var i;
        for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
    }
    function searchAnimations(animationData, standalone, renderer) {
        var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
        var i;
        var lenAnims = animElements.length;
        for(i = 0; i < lenAnims; i += 1){
            if (renderer) animElements[i].setAttribute('data-bm-type', renderer);
            registerAnimation(animElements[i], animationData);
        }
        if (standalone && lenAnims === 0) {
            if (!renderer) renderer = 'svg';
            var body = document.getElementsByTagName('body')[0];
            body.innerText = '';
            var div = $b60a95926cba5528$var$createTag('div');
            div.style.width = '100%';
            div.style.height = '100%';
            div.setAttribute('data-bm-type', renderer);
            body.appendChild(div);
            registerAnimation(div, animationData);
        }
    }
    function resize() {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
    }
    function activate() {
        if (!_isFrozen && playingAnimationsNum) {
            if (_stopped) {
                window.requestAnimationFrame(first);
                _stopped = false;
            }
        }
    }
    function freeze() {
        _isFrozen = true;
    }
    function unfreeze() {
        _isFrozen = false;
        activate();
    }
    function setVolume(val, animation) {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
    }
    function mute(animation) {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
    }
    function unmute(animation) {
        var i;
        for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
    }
    moduleOb.registerAnimation = registerAnimation;
    moduleOb.loadAnimation = loadAnimation;
    moduleOb.setSpeed = setSpeed;
    moduleOb.setDirection = setDirection;
    moduleOb.play = play;
    moduleOb.pause = pause;
    moduleOb.stop = stop;
    moduleOb.togglePause = togglePause;
    moduleOb.searchAnimations = searchAnimations;
    moduleOb.resize = resize;
    // moduleOb.start = start;
    moduleOb.goToAndStop = goToAndStop;
    moduleOb.destroy = destroy;
    moduleOb.freeze = freeze;
    moduleOb.unfreeze = unfreeze;
    moduleOb.setVolume = setVolume;
    moduleOb.mute = mute;
    moduleOb.unmute = unmute;
    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
    return moduleOb;
}();
/* eslint-disable */ const $b60a95926cba5528$var$BezierFactory = function() {
    /**
     * BezierEasing - use bezier curve for transition easing function
     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
     *
     * Credits: is based on Firefox's nsSMILKeySpline.cpp
     * Usage:
     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
     * spline.get(x) => returns the easing value | x must be in [0, 1] range
     *
     */ var ob = {};
    ob.getBezierEasing = getBezierEasing;
    var beziers = {};
    function getBezierEasing(a, b, c, d, nm) {
        var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
        if (beziers[str]) return beziers[str];
        var bezEasing = new BezierEasing([
            a,
            b,
            c,
            d
        ]);
        beziers[str] = bezEasing;
        return bezEasing;
    }
    // These values are established by empiricism with tests (tradeoff: performance VS precision)
    var NEWTON_ITERATIONS = 4;
    var NEWTON_MIN_SLOPE = 0.001;
    var SUBDIVISION_PRECISION = 0.0000001;
    var SUBDIVISION_MAX_ITERATIONS = 10;
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    var float32ArraySupported = typeof Float32Array === 'function';
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    }
    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for(var i = 0; i < NEWTON_ITERATIONS; ++i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    /**
     * points is an array of [ mX1, mY1, mX2, mY2 ]
     */ function BezierEasing(points) {
        this._p = points;
        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
        this._precomputed = false;
        this.get = this.get.bind(this);
    }
    BezierEasing.prototype = {
        get: function(x) {
            var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
            if (!this._precomputed) this._precompute();
            if (mX1 === mY1 && mX2 === mY2) return x; // linear
            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
            if (x === 0) return 0;
            if (x === 1) return 1;
            return calcBezier(this._getTForX(x), mY1, mY2);
        },
        // Private part
        _precompute: function() {
            var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
            this._precomputed = true;
            if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
        },
        _calcSampleValues: function() {
            var mX1 = this._p[0], mX2 = this._p[2];
            for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        },
        /**
         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
         */ _getTForX: function(aX) {
            var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
            var intervalStart = 0.0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;
            for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
            --currentSample;
            // Interpolate to provide an initial guess for t
            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;
            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            if (initialSlope === 0.0) return guessForT;
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
    };
    return ob;
}();
const $b60a95926cba5528$var$pooling = function() {
    function double(arr) {
        return arr.concat($b60a95926cba5528$var$createSizedArray(arr.length));
    }
    return {
        double: double
    };
}();
const $b60a95926cba5528$var$poolFactory = function() {
    return function(initialLength, _create, _release) {
        var _length = 0;
        var _maxLength = initialLength;
        var pool = $b60a95926cba5528$var$createSizedArray(_maxLength);
        var ob = {
            newElement: newElement,
            release: release
        };
        function newElement() {
            var element;
            if (_length) {
                _length -= 1;
                element = pool[_length];
            } else element = _create();
            return element;
        }
        function release(element) {
            if (_length === _maxLength) {
                pool = $b60a95926cba5528$var$pooling.double(pool);
                _maxLength *= 2;
            }
            if (_release) _release(element);
            pool[_length] = element;
            _length += 1;
        }
        return ob;
    };
}();
const $b60a95926cba5528$var$bezierLengthPool = function() {
    function create() {
        return {
            addedLength: 0,
            percents: $b60a95926cba5528$var$createTypedArray('float32', $b60a95926cba5528$var$getDefaultCurveSegments()),
            lengths: $b60a95926cba5528$var$createTypedArray('float32', $b60a95926cba5528$var$getDefaultCurveSegments())
        };
    }
    return $b60a95926cba5528$var$poolFactory(8, create);
}();
const $b60a95926cba5528$var$segmentsLengthPool = function() {
    function create() {
        return {
            lengths: [],
            totalLength: 0
        };
    }
    function release(element) {
        var i;
        var len = element.lengths.length;
        for(i = 0; i < len; i += 1)$b60a95926cba5528$var$bezierLengthPool.release(element.lengths[i]);
        element.lengths.length = 0;
    }
    return $b60a95926cba5528$var$poolFactory(8, create, release);
}();
function $b60a95926cba5528$var$bezFunction() {
    var math = Math;
    function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
        var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
        return det1 > -0.001 && det1 < 0.001;
    }
    function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
        if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
        var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
        var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
        var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
        var diffDist;
        if (dist1 > dist2) {
            if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
            else diffDist = dist3 - dist2 - dist1;
        } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
        else diffDist = dist2 - dist1 - dist3;
        return diffDist > -0.0001 && diffDist < 0.0001;
    }
    var getBezierLength = function() {
        return function(pt1, pt2, pt3, pt4) {
            var curveSegments = $b60a95926cba5528$var$getDefaultCurveSegments();
            var k;
            var i;
            var len;
            var ptCoord;
            var perc;
            var addedLength = 0;
            var ptDistance;
            var point = [];
            var lastPoint = [];
            var lengthData = $b60a95926cba5528$var$bezierLengthPool.newElement();
            len = pt3.length;
            for(k = 0; k < curveSegments; k += 1){
                perc = k / (curveSegments - 1);
                ptDistance = 0;
                for(i = 0; i < len; i += 1){
                    ptCoord = $b60a95926cba5528$var$bmPow(1 - perc, 3) * pt1[i] + 3 * $b60a95926cba5528$var$bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * $b60a95926cba5528$var$bmPow(perc, 2) * pt4[i] + $b60a95926cba5528$var$bmPow(perc, 3) * pt2[i];
                    point[i] = ptCoord;
                    if (lastPoint[i] !== null) ptDistance += $b60a95926cba5528$var$bmPow(point[i] - lastPoint[i], 2);
                    lastPoint[i] = point[i];
                }
                if (ptDistance) {
                    ptDistance = $b60a95926cba5528$var$bmSqrt(ptDistance);
                    addedLength += ptDistance;
                }
                lengthData.percents[k] = perc;
                lengthData.lengths[k] = addedLength;
            }
            lengthData.addedLength = addedLength;
            return lengthData;
        };
    }();
    function getSegmentsLength(shapeData) {
        var segmentsLength = $b60a95926cba5528$var$segmentsLengthPool.newElement();
        var closed = shapeData.c;
        var pathV = shapeData.v;
        var pathO = shapeData.o;
        var pathI = shapeData.i;
        var i;
        var len = shapeData._length;
        var lengths = segmentsLength.lengths;
        var totalLength = 0;
        for(i = 0; i < len - 1; i += 1){
            lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
            totalLength += lengths[i].addedLength;
        }
        if (closed && len) {
            lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
            totalLength += lengths[i].addedLength;
        }
        segmentsLength.totalLength = totalLength;
        return segmentsLength;
    }
    function BezierData(length) {
        this.segmentLength = 0;
        this.points = new Array(length);
    }
    function PointData(partial, point) {
        this.partialLength = partial;
        this.point = point;
    }
    var buildBezierData = function() {
        var storedData = {};
        return function(pt1, pt2, pt3, pt4) {
            var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
            if (!storedData[bezierName]) {
                var curveSegments = $b60a95926cba5528$var$getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point;
                var lastPoint = null;
                if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                var bezierData = new BezierData(curveSegments);
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    point = $b60a95926cba5528$var$createSizedArray(len);
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = $b60a95926cba5528$var$bmPow(1 - perc, 3) * pt1[i] + 3 * $b60a95926cba5528$var$bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * $b60a95926cba5528$var$bmPow(perc, 2) * (pt2[i] + pt4[i]) + $b60a95926cba5528$var$bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint !== null) ptDistance += $b60a95926cba5528$var$bmPow(point[i] - lastPoint[i], 2);
                    }
                    ptDistance = $b60a95926cba5528$var$bmSqrt(ptDistance);
                    addedLength += ptDistance;
                    bezierData.points[k] = new PointData(ptDistance, point);
                    lastPoint = point;
                }
                bezierData.segmentLength = addedLength;
                storedData[bezierName] = bezierData;
            }
            return storedData[bezierName];
        };
    }();
    function getDistancePerc(perc, bezierData) {
        var percents = bezierData.percents;
        var lengths = bezierData.lengths;
        var len = percents.length;
        var initPos = $b60a95926cba5528$var$bmFloor((len - 1) * perc);
        var lengthPos = perc * bezierData.addedLength;
        var lPerc = 0;
        if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
        var dir = lengths[initPos] > lengthPos ? -1 : 1;
        var flag = true;
        while(flag){
            if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                flag = false;
            } else initPos += dir;
            if (initPos < 0 || initPos >= len - 1) {
                // FIX for TypedArrays that don't store floating point values with enough accuracy
                if (initPos === len - 1) return percents[initPos];
                flag = false;
            }
        }
        return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
    }
    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
        var t1 = getDistancePerc(percent, bezierData);
        var u1 = 1 - t1;
        var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
        var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
        return [
            ptX,
            ptY
        ];
    }
    var bezierSegmentPoints = $b60a95926cba5528$var$createTypedArray('float32', 8);
    function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
        if (startPerc < 0) startPerc = 0;
        else if (startPerc > 1) startPerc = 1;
        var t0 = getDistancePerc(startPerc, bezierData);
        endPerc = endPerc > 1 ? 1 : endPerc;
        var t1 = getDistancePerc(endPerc, bezierData);
        var i;
        var len = pt1.length;
        var u0 = 1 - t0;
        var u1 = 1 - t1;
        var u0u0u0 = u0 * u0 * u0;
        var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
        var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
        var t0t0t0 = t0 * t0 * t0;
        //
        var u0u0u1 = u0 * u0 * u1;
        var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
        var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
        var t0t0t1 = t0 * t0 * t1;
        //
        var u0u1u1 = u0 * u1 * u1;
        var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
        var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
        var t0t1t1 = t0 * t1 * t1;
        //
        var u1u1u1 = u1 * u1 * u1;
        var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
        var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
        var t1t1t1 = t1 * t1 * t1;
        for(i = 0; i < len; i += 1){
            bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
        }
        return bezierSegmentPoints;
    }
    return {
        getSegmentsLength: getSegmentsLength,
        getNewSegment: getNewSegment,
        getPointInSegment: getPointInSegment,
        buildBezierData: buildBezierData,
        pointOnLine2D: pointOnLine2D,
        pointOnLine3D: pointOnLine3D
    };
}
const $b60a95926cba5528$var$bez = $b60a95926cba5528$var$bezFunction();
var $b60a95926cba5528$var$initFrame = $b60a95926cba5528$var$initialDefaultFrame;
var $b60a95926cba5528$var$mathAbs = Math.abs;
function $b60a95926cba5528$var$interpolateValue(frameNum, caching) {
    var offsetTime = this.offsetTime;
    var newValue;
    if (this.propType === 'multidimensional') newValue = $b60a95926cba5528$var$createTypedArray('float32', this.pv.length);
    var iterationIndex = caching.lastIndex;
    var i = iterationIndex;
    var len = this.keyframes.length - 1;
    var flag = true;
    var keyData;
    var nextKeyData;
    var keyframeMetadata;
    while(flag){
        keyData = this.keyframes[i];
        nextKeyData = this.keyframes[i + 1];
        if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
            if (keyData.h) keyData = nextKeyData;
            iterationIndex = 0;
            break;
        }
        if (nextKeyData.t - offsetTime > frameNum) {
            iterationIndex = i;
            break;
        }
        if (i < len - 1) i += 1;
        else {
            iterationIndex = 0;
            flag = false;
        }
    }
    keyframeMetadata = this.keyframesMetadata[i] || {};
    var k;
    var kLen;
    var perc;
    var jLen;
    var j;
    var fnc;
    var nextKeyTime = nextKeyData.t - offsetTime;
    var keyTime = keyData.t - offsetTime;
    var endValue;
    if (keyData.to) {
        if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = $b60a95926cba5528$var$bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
        var bezierData = keyframeMetadata.bezierData;
        if (frameNum >= nextKeyTime || frameNum < keyTime) {
            var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
            kLen = bezierData.points[ind].point.length;
            for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
        // caching._lastKeyframeIndex = -1;
        } else {
            if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
            else {
                fnc = $b60a95926cba5528$var$BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                keyframeMetadata.__fnct = fnc;
            }
            perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
            var distanceInLine = bezierData.segmentLength * perc;
            var segmentPerc;
            var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
            j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
            flag = true;
            jLen = bezierData.points.length;
            while(flag){
                addedLength += bezierData.points[j].partialLength;
                if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                    kLen = bezierData.points[j].point.length;
                    for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                    break;
                } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                    segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                    kLen = bezierData.points[j].point.length;
                    for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                    break;
                }
                if (j < jLen - 1) j += 1;
                else flag = false;
            }
            caching._lastPoint = j;
            caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
            caching._lastKeyframeIndex = i;
        }
    } else {
        var outX;
        var outY;
        var inX;
        var inY;
        var keyValue;
        len = keyData.s.length;
        endValue = nextKeyData.s || keyData.e;
        if (this.sh && keyData.h !== 1) {
            if (frameNum >= nextKeyTime) {
                newValue[0] = endValue[0];
                newValue[1] = endValue[1];
                newValue[2] = endValue[2];
            } else if (frameNum <= keyTime) {
                newValue[0] = keyData.s[0];
                newValue[1] = keyData.s[1];
                newValue[2] = keyData.s[2];
            } else {
                var quatStart = $b60a95926cba5528$var$createQuaternion(keyData.s);
                var quatEnd = $b60a95926cba5528$var$createQuaternion(endValue);
                var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                $b60a95926cba5528$var$quaternionToEuler(newValue, $b60a95926cba5528$var$slerp(quatStart, quatEnd, time));
            }
        } else for(i = 0; i < len; i += 1){
            if (keyData.h !== 1) {
                if (frameNum >= nextKeyTime) perc = 1;
                else if (frameNum < keyTime) perc = 0;
                else {
                    if (keyData.o.x.constructor === Array) {
                        if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                        if (!keyframeMetadata.__fnct[i]) {
                            outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                            outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                            inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                            inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                            fnc = $b60a95926cba5528$var$BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyframeMetadata.__fnct[i] = fnc;
                        } else fnc = keyframeMetadata.__fnct[i];
                    } else if (!keyframeMetadata.__fnct) {
                        outX = keyData.o.x;
                        outY = keyData.o.y;
                        inX = keyData.i.x;
                        inY = keyData.i.y;
                        fnc = $b60a95926cba5528$var$BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                        keyData.keyframeMetadata = fnc;
                    } else fnc = keyframeMetadata.__fnct;
                    perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                }
            }
            endValue = nextKeyData.s || keyData.e;
            keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
            if (this.propType === 'multidimensional') newValue[i] = keyValue;
            else newValue = keyValue;
        }
    }
    caching.lastIndex = iterationIndex;
    return newValue;
}
// based on @Toji's https://github.com/toji/gl-matrix/
function $b60a95926cba5528$var$slerp(a, b, t) {
    var out = [];
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    var bx = b[0];
    var by = b[1];
    var bz = b[2];
    var bw = b[3];
    var omega;
    var cosom;
    var sinom;
    var scale0;
    var scale1;
    cosom = ax * bx + ay * by + az * bz + aw * bw;
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    }
    if (1.0 - cosom > 0.000001) {
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        scale0 = 1.0 - t;
        scale1 = t;
    }
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
function $b60a95926cba5528$var$quaternionToEuler(out, quat) {
    var qx = quat[0];
    var qy = quat[1];
    var qz = quat[2];
    var qw = quat[3];
    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
    out[0] = heading / $b60a95926cba5528$var$degToRads;
    out[1] = attitude / $b60a95926cba5528$var$degToRads;
    out[2] = bank / $b60a95926cba5528$var$degToRads;
}
function $b60a95926cba5528$var$createQuaternion(values) {
    var heading = values[0] * $b60a95926cba5528$var$degToRads;
    var attitude = values[1] * $b60a95926cba5528$var$degToRads;
    var bank = values[2] * $b60a95926cba5528$var$degToRads;
    var c1 = Math.cos(heading / 2);
    var c2 = Math.cos(attitude / 2);
    var c3 = Math.cos(bank / 2);
    var s1 = Math.sin(heading / 2);
    var s2 = Math.sin(attitude / 2);
    var s3 = Math.sin(bank / 2);
    var w = c1 * c2 * c3 - s1 * s2 * s3;
    var x = s1 * s2 * c3 + c1 * c2 * s3;
    var y = s1 * c2 * c3 + c1 * s2 * s3;
    var z = c1 * s2 * c3 - s1 * c2 * s3;
    return [
        x,
        y,
        z,
        w
    ];
}
function $b60a95926cba5528$var$getValueAtCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
    if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== $b60a95926cba5528$var$initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
        if (this._caching.lastFrame >= frameNum) {
            this._caching._lastKeyframeIndex = -1;
            this._caching.lastIndex = 0;
        }
        var renderResult = this.interpolateValue(frameNum, this._caching);
        this.pv = renderResult;
    }
    this._caching.lastFrame = frameNum;
    return this.pv;
}
function $b60a95926cba5528$var$setVValue(val) {
    var multipliedValue;
    if (this.propType === 'unidimensional') {
        multipliedValue = val * this.mult;
        if ($b60a95926cba5528$var$mathAbs(this.v - multipliedValue) > 0.00001) {
            this.v = multipliedValue;
            this._mdf = true;
        }
    } else {
        var i = 0;
        var len = this.v.length;
        while(i < len){
            multipliedValue = val[i] * this.mult;
            if ($b60a95926cba5528$var$mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                this.v[i] = multipliedValue;
                this._mdf = true;
            }
            i += 1;
        }
    }
}
function $b60a95926cba5528$var$processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
    if (this.lock) {
        this.setVValue(this.pv);
        return;
    }
    this.lock = true;
    this._mdf = this._isFirstFrame;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = this.kf ? this.pv : this.data.k;
    for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
    this.setVValue(finalValue);
    this._isFirstFrame = false;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
}
function $b60a95926cba5528$var$addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
}
function $b60a95926cba5528$var$ValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.mult = mult || 1;
    this.data = data;
    this.v = mult ? data.k * mult : data.k;
    this.pv = data.k;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.vel = 0;
    this.effectsSequence = [];
    this._isFirstFrame = true;
    this.getValue = $b60a95926cba5528$var$processEffectsSequence;
    this.setVValue = $b60a95926cba5528$var$setVValue;
    this.addEffect = $b60a95926cba5528$var$addEffect;
}
function $b60a95926cba5528$var$MultiDimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    this.mult = mult || 1;
    this.data = data;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.frameId = -1;
    var i;
    var len = data.k.length;
    this.v = $b60a95926cba5528$var$createTypedArray('float32', len);
    this.pv = $b60a95926cba5528$var$createTypedArray('float32', len);
    this.vel = $b60a95926cba5528$var$createTypedArray('float32', len);
    for(i = 0; i < len; i += 1){
        this.v[i] = data.k[i] * this.mult;
        this.pv[i] = data.k[i];
    }
    this._isFirstFrame = true;
    this.effectsSequence = [];
    this.getValue = $b60a95926cba5528$var$processEffectsSequence;
    this.setVValue = $b60a95926cba5528$var$setVValue;
    this.addEffect = $b60a95926cba5528$var$addEffect;
}
function $b60a95926cba5528$var$KeyframedValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.frameId = -1;
    this._caching = {
        lastFrame: $b60a95926cba5528$var$initFrame,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
    };
    this.k = true;
    this.kf = true;
    this.data = data;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.v = $b60a95926cba5528$var$initFrame;
    this.pv = $b60a95926cba5528$var$initFrame;
    this._isFirstFrame = true;
    this.getValue = $b60a95926cba5528$var$processEffectsSequence;
    this.setVValue = $b60a95926cba5528$var$setVValue;
    this.interpolateValue = $b60a95926cba5528$var$interpolateValue;
    this.effectsSequence = [
        $b60a95926cba5528$var$getValueAtCurrentTime.bind(this)
    ];
    this.addEffect = $b60a95926cba5528$var$addEffect;
}
function $b60a95926cba5528$var$KeyframedMultidimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    var i;
    var len = data.k.length;
    var s;
    var e;
    var to;
    var ti;
    for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
        s = data.k[i].s;
        e = data.k[i + 1].s;
        to = data.k[i].to;
        ti = data.k[i].ti;
        if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && $b60a95926cba5528$var$bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && $b60a95926cba5528$var$bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && $b60a95926cba5528$var$bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && $b60a95926cba5528$var$bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
            data.k[i].to = null;
            data.k[i].ti = null;
        }
        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
            if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
        }
    }
    this.effectsSequence = [
        $b60a95926cba5528$var$getValueAtCurrentTime.bind(this)
    ];
    this.data = data;
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.k = true;
    this.kf = true;
    this._isFirstFrame = true;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.getValue = $b60a95926cba5528$var$processEffectsSequence;
    this.setVValue = $b60a95926cba5528$var$setVValue;
    this.interpolateValue = $b60a95926cba5528$var$interpolateValue;
    this.frameId = -1;
    var arrLen = data.k[0].s.length;
    this.v = $b60a95926cba5528$var$createTypedArray('float32', arrLen);
    this.pv = $b60a95926cba5528$var$createTypedArray('float32', arrLen);
    for(i = 0; i < arrLen; i += 1){
        this.v[i] = $b60a95926cba5528$var$initFrame;
        this.pv[i] = $b60a95926cba5528$var$initFrame;
    }
    this._caching = {
        lastFrame: $b60a95926cba5528$var$initFrame,
        lastIndex: 0,
        value: $b60a95926cba5528$var$createTypedArray('float32', arrLen)
    };
    this.addEffect = $b60a95926cba5528$var$addEffect;
}
const $b60a95926cba5528$var$PropertyFactory = function() {
    function getProp(elem, data, type, mult, container) {
        if (data.sid) data = elem.globalData.slotManager.getProp(data);
        var p;
        if (!data.k.length) p = new $b60a95926cba5528$var$ValueProperty(elem, data, mult, container);
        else if (typeof data.k[0] === 'number') p = new $b60a95926cba5528$var$MultiDimensionalProperty(elem, data, mult, container);
        else switch(type){
            case 0:
                p = new $b60a95926cba5528$var$KeyframedValueProperty(elem, data, mult, container);
                break;
            case 1:
                p = new $b60a95926cba5528$var$KeyframedMultidimensionalProperty(elem, data, mult, container);
                break;
            default:
                break;
        }
        if (p.effectsSequence.length) container.addDynamicProperty(p);
        return p;
    }
    var ob = {
        getProp: getProp
    };
    return ob;
}();
function $b60a95926cba5528$var$DynamicPropertyContainer() {}
$b60a95926cba5528$var$DynamicPropertyContainer.prototype = {
    addDynamicProperty: function(prop) {
        if (this.dynamicProperties.indexOf(prop) === -1) {
            this.dynamicProperties.push(prop);
            this.container.addDynamicProperty(this);
            this._isAnimated = true;
        }
    },
    iterateDynamicProperties: function() {
        this._mdf = false;
        var i;
        var len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1){
            this.dynamicProperties[i].getValue();
            if (this.dynamicProperties[i]._mdf) this._mdf = true;
        }
    },
    initDynamicPropertyContainer: function(container) {
        this.container = container;
        this.dynamicProperties = [];
        this._mdf = false;
        this._isAnimated = false;
    }
};
const $b60a95926cba5528$var$pointPool = function() {
    function create() {
        return $b60a95926cba5528$var$createTypedArray('float32', 2);
    }
    return $b60a95926cba5528$var$poolFactory(8, create);
}();
function $b60a95926cba5528$var$ShapePath() {
    this.c = false;
    this._length = 0;
    this._maxLength = 8;
    this.v = $b60a95926cba5528$var$createSizedArray(this._maxLength);
    this.o = $b60a95926cba5528$var$createSizedArray(this._maxLength);
    this.i = $b60a95926cba5528$var$createSizedArray(this._maxLength);
}
$b60a95926cba5528$var$ShapePath.prototype.setPathData = function(closed, len) {
    this.c = closed;
    this.setLength(len);
    var i = 0;
    while(i < len){
        this.v[i] = $b60a95926cba5528$var$pointPool.newElement();
        this.o[i] = $b60a95926cba5528$var$pointPool.newElement();
        this.i[i] = $b60a95926cba5528$var$pointPool.newElement();
        i += 1;
    }
};
$b60a95926cba5528$var$ShapePath.prototype.setLength = function(len) {
    while(this._maxLength < len)this.doubleArrayLength();
    this._length = len;
};
$b60a95926cba5528$var$ShapePath.prototype.doubleArrayLength = function() {
    this.v = this.v.concat($b60a95926cba5528$var$createSizedArray(this._maxLength));
    this.i = this.i.concat($b60a95926cba5528$var$createSizedArray(this._maxLength));
    this.o = this.o.concat($b60a95926cba5528$var$createSizedArray(this._maxLength));
    this._maxLength *= 2;
};
$b60a95926cba5528$var$ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
    var arr;
    this._length = Math.max(this._length, pos + 1);
    if (this._length >= this._maxLength) this.doubleArrayLength();
    switch(type){
        case 'v':
            arr = this.v;
            break;
        case 'i':
            arr = this.i;
            break;
        case 'o':
            arr = this.o;
            break;
        default:
            arr = [];
            break;
    }
    if (!arr[pos] || arr[pos] && !replace) arr[pos] = $b60a95926cba5528$var$pointPool.newElement();
    arr[pos][0] = x;
    arr[pos][1] = y;
};
$b60a95926cba5528$var$ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
    this.setXYAt(vX, vY, 'v', pos, replace);
    this.setXYAt(oX, oY, 'o', pos, replace);
    this.setXYAt(iX, iY, 'i', pos, replace);
};
$b60a95926cba5528$var$ShapePath.prototype.reverse = function() {
    var newPath = new $b60a95926cba5528$var$ShapePath();
    newPath.setPathData(this.c, this._length);
    var vertices = this.v;
    var outPoints = this.o;
    var inPoints = this.i;
    var init = 0;
    if (this.c) {
        newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
        init = 1;
    }
    var cnt = this._length - 1;
    var len = this._length;
    var i;
    for(i = init; i < len; i += 1){
        newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
        cnt -= 1;
    }
    return newPath;
};
$b60a95926cba5528$var$ShapePath.prototype.length = function() {
    return this._length;
};
const $b60a95926cba5528$var$shapePool = function() {
    function create() {
        return new $b60a95926cba5528$var$ShapePath();
    }
    function release(shapePath) {
        var len = shapePath._length;
        var i;
        for(i = 0; i < len; i += 1){
            $b60a95926cba5528$var$pointPool.release(shapePath.v[i]);
            $b60a95926cba5528$var$pointPool.release(shapePath.i[i]);
            $b60a95926cba5528$var$pointPool.release(shapePath.o[i]);
            shapePath.v[i] = null;
            shapePath.i[i] = null;
            shapePath.o[i] = null;
        }
        shapePath._length = 0;
        shapePath.c = false;
    }
    function clone(shape) {
        var cloned = factory.newElement();
        var i;
        var len = shape._length === undefined ? shape.v.length : shape._length;
        cloned.setLength(len);
        cloned.c = shape.c;
        for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
        return cloned;
    }
    var factory = $b60a95926cba5528$var$poolFactory(4, create, release);
    factory.clone = clone;
    return factory;
}();
function $b60a95926cba5528$var$ShapeCollection() {
    this._length = 0;
    this._maxLength = 4;
    this.shapes = $b60a95926cba5528$var$createSizedArray(this._maxLength);
}
$b60a95926cba5528$var$ShapeCollection.prototype.addShape = function(shapeData) {
    if (this._length === this._maxLength) {
        this.shapes = this.shapes.concat($b60a95926cba5528$var$createSizedArray(this._maxLength));
        this._maxLength *= 2;
    }
    this.shapes[this._length] = shapeData;
    this._length += 1;
};
$b60a95926cba5528$var$ShapeCollection.prototype.releaseShapes = function() {
    var i;
    for(i = 0; i < this._length; i += 1)$b60a95926cba5528$var$shapePool.release(this.shapes[i]);
    this._length = 0;
};
const $b60a95926cba5528$var$shapeCollectionPool = function() {
    var ob = {
        newShapeCollection: newShapeCollection,
        release: release
    };
    var _length = 0;
    var _maxLength = 4;
    var pool = $b60a95926cba5528$var$createSizedArray(_maxLength);
    function newShapeCollection() {
        var shapeCollection;
        if (_length) {
            _length -= 1;
            shapeCollection = pool[_length];
        } else shapeCollection = new $b60a95926cba5528$var$ShapeCollection();
        return shapeCollection;
    }
    function release(shapeCollection) {
        var i;
        var len = shapeCollection._length;
        for(i = 0; i < len; i += 1)$b60a95926cba5528$var$shapePool.release(shapeCollection.shapes[i]);
        shapeCollection._length = 0;
        if (_length === _maxLength) {
            pool = $b60a95926cba5528$var$pooling.double(pool);
            _maxLength *= 2;
        }
        pool[_length] = shapeCollection;
        _length += 1;
    }
    return ob;
}();
const $b60a95926cba5528$var$ShapePropertyFactory = function() {
    var initFrame = -999999;
    function interpolateShape(frameNum, previousValue, caching) {
        var iterationIndex = caching.lastIndex;
        var keyPropS;
        var keyPropE;
        var isHold;
        var j;
        var k;
        var jLen;
        var kLen;
        var perc;
        var vertexValue;
        var kf = this.keyframes;
        if (frameNum < kf[0].t - this.offsetTime) {
            keyPropS = kf[0].s[0];
            isHold = true;
            iterationIndex = 0;
        } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
            keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
            /* if(kf[kf.length - 1].s){
                keyPropS = kf[kf.length - 1].s[0];
            }else{
                keyPropS = kf[kf.length - 2].e[0];
            } */ isHold = true;
        } else {
            var i = iterationIndex;
            var len = kf.length - 1;
            var flag = true;
            var keyData;
            var nextKeyData;
            var keyframeMetadata;
            while(flag){
                keyData = kf[i];
                nextKeyData = kf[i + 1];
                if (nextKeyData.t - this.offsetTime > frameNum) break;
                if (i < len - 1) i += 1;
                else flag = false;
            }
            keyframeMetadata = this.keyframesMetadata[i] || {};
            isHold = keyData.h === 1;
            iterationIndex = i;
            if (!isHold) {
                if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                else {
                    var fnc;
                    if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                    else {
                        fnc = $b60a95926cba5528$var$BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                        keyframeMetadata.__fnct = fnc;
                    }
                    perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                }
                keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
            }
            keyPropS = keyData.s[0];
        }
        jLen = previousValue._length;
        kLen = keyPropS.i[0].length;
        caching.lastIndex = iterationIndex;
        for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
            vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
            previousValue.i[j][k] = vertexValue;
            vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
            previousValue.o[j][k] = vertexValue;
            vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
            previousValue.v[j][k] = vertexValue;
        }
    }
    function interpolateShapeCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        var lastFrame = this._caching.lastFrame;
        if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
            /// /
            this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
            this.interpolateShape(frameNum, this.pv, this._caching);
        /// /
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function resetShape() {
        this.paths = this.localShapeCollection;
    }
    function shapesEqual(shape1, shape2) {
        if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
        var i;
        var len = shape1._length;
        for(i = 0; i < len; i += 1){
            if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
        }
        return true;
    }
    function setVValue(newPath) {
        if (!shapesEqual(this.v, newPath)) {
            this.v = $b60a95926cba5528$var$shapePool.clone(newPath);
            this.localShapeCollection.releaseShapes();
            this.localShapeCollection.addShape(this.v);
            this._mdf = true;
            this.paths = this.localShapeCollection;
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId) return;
        if (!this.effectsSequence.length) {
            this._mdf = false;
            return;
        }
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var finalValue;
        if (this.kf) finalValue = this.pv;
        else if (this.data.ks) finalValue = this.data.ks.k;
        else finalValue = this.data.pt.k;
        var i;
        var len = this.effectsSequence.length;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function ShapeProperty(elem, data, type) {
        this.propType = 'shape';
        this.comp = elem.comp;
        this.container = elem;
        this.elem = elem;
        this.data = data;
        this.k = false;
        this.kf = false;
        this._mdf = false;
        var pathData = type === 3 ? data.pt.k : data.ks.k;
        this.v = $b60a95926cba5528$var$shapePool.clone(pathData);
        this.pv = $b60a95926cba5528$var$shapePool.clone(this.v);
        this.localShapeCollection = $b60a95926cba5528$var$shapeCollectionPool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.paths.addShape(this.v);
        this.reset = resetShape;
        this.effectsSequence = [];
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    ShapeProperty.prototype.interpolateShape = interpolateShape;
    ShapeProperty.prototype.getValue = processEffectsSequence;
    ShapeProperty.prototype.setVValue = setVValue;
    ShapeProperty.prototype.addEffect = addEffect;
    function KeyframedShapeProperty(elem, data, type) {
        this.propType = 'shape';
        this.comp = elem.comp;
        this.elem = elem;
        this.container = elem;
        this.offsetTime = elem.data.st;
        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
        this.keyframesMetadata = [];
        this.k = true;
        this.kf = true;
        var len = this.keyframes[0].s[0].i.length;
        this.v = $b60a95926cba5528$var$shapePool.newElement();
        this.v.setPathData(this.keyframes[0].s[0].c, len);
        this.pv = $b60a95926cba5528$var$shapePool.clone(this.v);
        this.localShapeCollection = $b60a95926cba5528$var$shapeCollectionPool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.paths.addShape(this.v);
        this.lastFrame = initFrame;
        this.reset = resetShape;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0
        };
        this.effectsSequence = [
            interpolateShapeCurrentTime.bind(this)
        ];
    }
    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
    KeyframedShapeProperty.prototype.setVValue = setVValue;
    KeyframedShapeProperty.prototype.addEffect = addEffect;
    var EllShapeProperty = function() {
        var cPoint = $b60a95926cba5528$var$roundCorner;
        function EllShapePropertyFactory(elem, data) {
            this.v = $b60a95926cba5528$var$shapePool.newElement();
            this.v.setPathData(true, 4);
            this.localShapeCollection = $b60a95926cba5528$var$shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.localShapeCollection.addShape(this.v);
            this.d = data.d;
            this.elem = elem;
            this.comp = elem.comp;
            this.frameId = -1;
            this.initDynamicPropertyContainer(elem);
            this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.p, 1, 0, this);
            this.s = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.s, 1, 0, this);
            if (this.dynamicProperties.length) this.k = true;
            else {
                this.k = false;
                this.convertEllToPath();
            }
        }
        EllShapePropertyFactory.prototype = {
            reset: resetShape,
            getValue: function() {
                if (this.elem.globalData.frameId === this.frameId) return;
                this.frameId = this.elem.globalData.frameId;
                this.iterateDynamicProperties();
                if (this._mdf) this.convertEllToPath();
            },
            convertEllToPath: function() {
                var p0 = this.p.v[0];
                var p1 = this.p.v[1];
                var s0 = this.s.v[0] / 2;
                var s1 = this.s.v[1] / 2;
                var _cw = this.d !== 3;
                var _v = this.v;
                _v.v[0][0] = p0;
                _v.v[0][1] = p1 - s1;
                _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                _v.v[1][1] = p1;
                _v.v[2][0] = p0;
                _v.v[2][1] = p1 + s1;
                _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                _v.v[3][1] = p1;
                _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                _v.i[0][1] = p1 - s1;
                _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                _v.i[1][1] = p1 - s1 * cPoint;
                _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                _v.i[2][1] = p1 + s1;
                _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                _v.i[3][1] = p1 + s1 * cPoint;
                _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                _v.o[0][1] = p1 - s1;
                _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                _v.o[1][1] = p1 + s1 * cPoint;
                _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                _v.o[2][1] = p1 + s1;
                _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                _v.o[3][1] = p1 - s1 * cPoint;
            }
        };
        $b60a95926cba5528$var$extendPrototype([
            $b60a95926cba5528$var$DynamicPropertyContainer
        ], EllShapePropertyFactory);
        return EllShapePropertyFactory;
    }();
    var StarShapeProperty = function() {
        function StarShapePropertyFactory(elem, data) {
            this.v = $b60a95926cba5528$var$shapePool.newElement();
            this.v.setPathData(true, 0);
            this.elem = elem;
            this.comp = elem.comp;
            this.data = data;
            this.frameId = -1;
            this.d = data.d;
            this.initDynamicPropertyContainer(elem);
            if (data.sy === 1) {
                this.ir = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                this.is = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                this.convertToPath = this.convertStarToPath;
            } else this.convertToPath = this.convertPolygonToPath;
            this.pt = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.pt, 0, 0, this);
            this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.p, 1, 0, this);
            this.r = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.r, 0, $b60a95926cba5528$var$degToRads, this);
            this.or = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.or, 0, 0, this);
            this.os = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
            this.localShapeCollection = $b60a95926cba5528$var$shapeCollectionPool.newShapeCollection();
            this.localShapeCollection.addShape(this.v);
            this.paths = this.localShapeCollection;
            if (this.dynamicProperties.length) this.k = true;
            else {
                this.k = false;
                this.convertToPath();
            }
        }
        StarShapePropertyFactory.prototype = {
            reset: resetShape,
            getValue: function() {
                if (this.elem.globalData.frameId === this.frameId) return;
                this.frameId = this.elem.globalData.frameId;
                this.iterateDynamicProperties();
                if (this._mdf) this.convertToPath();
            },
            convertStarToPath: function() {
                var numPts = Math.floor(this.pt.v) * 2;
                var angle = Math.PI * 2 / numPts;
                /* this.v.v.length = numPts;
                this.v.i.length = numPts;
                this.v.o.length = numPts; */ var longFlag = true;
                var longRad = this.or.v;
                var shortRad = this.ir.v;
                var longRound = this.os.v;
                var shortRound = this.is.v;
                var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                var i;
                var rad;
                var roundness;
                var perimSegment;
                var currentAng = -Math.PI / 2;
                currentAng += this.r.v;
                var dir = this.data.d === 3 ? -1 : 1;
                this.v._length = 0;
                for(i = 0; i < numPts; i += 1){
                    rad = longFlag ? longRad : shortRad;
                    roundness = longFlag ? longRound : shortRound;
                    perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                    var x = rad * Math.cos(currentAng);
                    var y = rad * Math.sin(currentAng);
                    var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                    var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                    x += +this.p.v[0];
                    y += +this.p.v[1];
                    this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                    /* this.v.v[i] = [x,y];
                    this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                    this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                    this.v._length = numPts; */ longFlag = !longFlag;
                    currentAng += angle * dir;
                }
            },
            convertPolygonToPath: function() {
                var numPts = Math.floor(this.pt.v);
                var angle = Math.PI * 2 / numPts;
                var rad = this.or.v;
                var roundness = this.os.v;
                var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                var i;
                var currentAng = -Math.PI * 0.5;
                var dir = this.data.d === 3 ? -1 : 1;
                currentAng += this.r.v;
                this.v._length = 0;
                for(i = 0; i < numPts; i += 1){
                    var x = rad * Math.cos(currentAng);
                    var y = rad * Math.sin(currentAng);
                    var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                    var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                    x += +this.p.v[0];
                    y += +this.p.v[1];
                    this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                    currentAng += angle * dir;
                }
                this.paths.length = 0;
                this.paths[0] = this.v;
            }
        };
        $b60a95926cba5528$var$extendPrototype([
            $b60a95926cba5528$var$DynamicPropertyContainer
        ], StarShapePropertyFactory);
        return StarShapePropertyFactory;
    }();
    var RectShapeProperty = function() {
        function RectShapePropertyFactory(elem, data) {
            this.v = $b60a95926cba5528$var$shapePool.newElement();
            this.v.c = true;
            this.localShapeCollection = $b60a95926cba5528$var$shapeCollectionPool.newShapeCollection();
            this.localShapeCollection.addShape(this.v);
            this.paths = this.localShapeCollection;
            this.elem = elem;
            this.comp = elem.comp;
            this.frameId = -1;
            this.d = data.d;
            this.initDynamicPropertyContainer(elem);
            this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.p, 1, 0, this);
            this.s = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.s, 1, 0, this);
            this.r = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.r, 0, 0, this);
            if (this.dynamicProperties.length) this.k = true;
            else {
                this.k = false;
                this.convertRectToPath();
            }
        }
        RectShapePropertyFactory.prototype = {
            convertRectToPath: function() {
                var p0 = this.p.v[0];
                var p1 = this.p.v[1];
                var v0 = this.s.v[0] / 2;
                var v1 = this.s.v[1] / 2;
                var round = $b60a95926cba5528$var$bmMin(v0, v1, this.r.v);
                var cPoint = round * (1 - $b60a95926cba5528$var$roundCorner);
                this.v._length = 0;
                if (this.d === 2 || this.d === 1) {
                    this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                    this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                    if (round !== 0) {
                        this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                        this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                        this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                        this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                        this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                        this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                    } else {
                        this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                        this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                    }
                } else {
                    this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                    if (round !== 0) {
                        this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                        this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                        this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                        this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                        this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                        this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                    } else {
                        this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                        this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                    }
                }
            },
            getValue: function() {
                if (this.elem.globalData.frameId === this.frameId) return;
                this.frameId = this.elem.globalData.frameId;
                this.iterateDynamicProperties();
                if (this._mdf) this.convertRectToPath();
            },
            reset: resetShape
        };
        $b60a95926cba5528$var$extendPrototype([
            $b60a95926cba5528$var$DynamicPropertyContainer
        ], RectShapePropertyFactory);
        return RectShapePropertyFactory;
    }();
    function getShapeProp(elem, data, type) {
        var prop;
        if (type === 3 || type === 4) {
            var dataProp = type === 3 ? data.pt : data.ks;
            var keys = dataProp.k;
            if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
            else prop = new ShapeProperty(elem, data, type);
        } else if (type === 5) prop = new RectShapeProperty(elem, data);
        else if (type === 6) prop = new EllShapeProperty(elem, data);
        else if (type === 7) prop = new StarShapeProperty(elem, data);
        if (prop.k) elem.addDynamicProperty(prop);
        return prop;
    }
    function getConstructorFunction() {
        return ShapeProperty;
    }
    function getKeyframedConstructorFunction() {
        return KeyframedShapeProperty;
    }
    var ob = {};
    ob.getShapeProp = getShapeProp;
    ob.getConstructorFunction = getConstructorFunction;
    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
    return ob;
}();
/*!
 Transformation Matrix v2.0
 (c) Epistemex 2014-2015
 www.epistemex.com
 By Ken Fyrstenberg
 Contributions by leeoniya.
 License: MIT, header required.
 */ /**
 * 2D transformation matrix object initialized with identity matrix.
 *
 * The matrix can synchronize a canvas context by supplying the context
 * as an argument, or later apply current absolute transform to an
 * existing context.
 *
 * All values are handled as floating point values.
 *
 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
 * @prop {number} a - scale x
 * @prop {number} b - shear y
 * @prop {number} c - shear x
 * @prop {number} d - scale y
 * @prop {number} e - translate x
 * @prop {number} f - translate y
 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
 * @constructor
 */ const $b60a95926cba5528$var$Matrix = function() {
    var _cos = Math.cos;
    var _sin = Math.sin;
    var _tan = Math.tan;
    var _rnd = Math.round;
    function reset() {
        this.props[0] = 1;
        this.props[1] = 0;
        this.props[2] = 0;
        this.props[3] = 0;
        this.props[4] = 0;
        this.props[5] = 1;
        this.props[6] = 0;
        this.props[7] = 0;
        this.props[8] = 0;
        this.props[9] = 0;
        this.props[10] = 1;
        this.props[11] = 0;
        this.props[12] = 0;
        this.props[13] = 0;
        this.props[14] = 0;
        this.props[15] = 1;
        return this;
    }
    function rotate(angle) {
        if (angle === 0) return this;
        var mCos = _cos(angle);
        var mSin = _sin(angle);
        return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }
    function rotateX(angle) {
        if (angle === 0) return this;
        var mCos = _cos(angle);
        var mSin = _sin(angle);
        return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
    }
    function rotateY(angle) {
        if (angle === 0) return this;
        var mCos = _cos(angle);
        var mSin = _sin(angle);
        return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
    }
    function rotateZ(angle) {
        if (angle === 0) return this;
        var mCos = _cos(angle);
        var mSin = _sin(angle);
        return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }
    function shear(sx, sy) {
        return this._t(1, sy, sx, 1, 0, 0);
    }
    function skew(ax, ay) {
        return this.shear(_tan(ax), _tan(ay));
    }
    function skewFromAxis(ax, angle) {
        var mCos = _cos(angle);
        var mSin = _sin(angle);
        return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
    }
    function scale(sx, sy, sz) {
        if (!sz && sz !== 0) sz = 1;
        if (sx === 1 && sy === 1 && sz === 1) return this;
        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
    }
    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
        this.props[0] = a;
        this.props[1] = b;
        this.props[2] = c;
        this.props[3] = d;
        this.props[4] = e;
        this.props[5] = f;
        this.props[6] = g;
        this.props[7] = h;
        this.props[8] = i;
        this.props[9] = j;
        this.props[10] = k;
        this.props[11] = l;
        this.props[12] = m;
        this.props[13] = n;
        this.props[14] = o;
        this.props[15] = p;
        return this;
    }
    function translate(tx, ty, tz) {
        tz = tz || 0;
        if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
        return this;
    }
    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
        var _p = this.props;
        if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
            // NOTE: commenting this condition because TurboFan deoptimizes code when present
            // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
            _p[12] = _p[12] * a2 + _p[15] * m2;
            _p[13] = _p[13] * f2 + _p[15] * n2;
            _p[14] = _p[14] * k2 + _p[15] * o2;
            _p[15] *= p2;
            // }
            this._identityCalculated = false;
            return this;
        }
        var a1 = _p[0];
        var b1 = _p[1];
        var c1 = _p[2];
        var d1 = _p[3];
        var e1 = _p[4];
        var f1 = _p[5];
        var g1 = _p[6];
        var h1 = _p[7];
        var i1 = _p[8];
        var j1 = _p[9];
        var k1 = _p[10];
        var l1 = _p[11];
        var m1 = _p[12];
        var n1 = _p[13];
        var o1 = _p[14];
        var p1 = _p[15];
        /* matrix order (canvas compatible):
         * ace
         * bdf
         * 001
         */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
        _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
        _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
        _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
        _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
        _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
        _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
        _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
        _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
        _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
        _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
        _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
        _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
        _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
        _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
        _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
        this._identityCalculated = false;
        return this;
    }
    function multiply(matrix) {
        var matrixProps = matrix.props;
        return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
    }
    function isIdentity() {
        if (!this._identityCalculated) {
            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
            this._identityCalculated = true;
        }
        return this._identity;
    }
    function equals(matr) {
        var i = 0;
        while(i < 16){
            if (matr.props[i] !== this.props[i]) return false;
            i += 1;
        }
        return true;
    }
    function clone(matr) {
        var i;
        for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
        return matr;
    }
    function cloneFromProps(props) {
        var i;
        for(i = 0; i < 16; i += 1)this.props[i] = props[i];
    }
    function applyToPoint(x, y, z) {
        return {
            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
        };
    /* return {
         x: x * me.a + y * me.c + me.e,
         y: x * me.b + y * me.d + me.f
         }; */ }
    function applyToX(x, y, z) {
        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
    }
    function applyToY(x, y, z) {
        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
    }
    function applyToZ(x, y, z) {
        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
    }
    function getInverseMatrix() {
        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
        var a = this.props[5] / determinant;
        var b = -this.props[1] / determinant;
        var c = -this.props[4] / determinant;
        var d = this.props[0] / determinant;
        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
        var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
        var inverseMatrix = new $b60a95926cba5528$var$Matrix();
        inverseMatrix.props[0] = a;
        inverseMatrix.props[1] = b;
        inverseMatrix.props[4] = c;
        inverseMatrix.props[5] = d;
        inverseMatrix.props[12] = e;
        inverseMatrix.props[13] = f;
        return inverseMatrix;
    }
    function inversePoint(pt) {
        var inverseMatrix = this.getInverseMatrix();
        return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
    }
    function inversePoints(pts) {
        var i;
        var len = pts.length;
        var retPts = [];
        for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
        return retPts;
    }
    function applyToTriplePoints(pt1, pt2, pt3) {
        var arr = $b60a95926cba5528$var$createTypedArray('float32', 6);
        if (this.isIdentity()) {
            arr[0] = pt1[0];
            arr[1] = pt1[1];
            arr[2] = pt2[0];
            arr[3] = pt2[1];
            arr[4] = pt3[0];
            arr[5] = pt3[1];
        } else {
            var p0 = this.props[0];
            var p1 = this.props[1];
            var p4 = this.props[4];
            var p5 = this.props[5];
            var p12 = this.props[12];
            var p13 = this.props[13];
            arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
            arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
            arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
            arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
            arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
            arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
        }
        return arr;
    }
    function applyToPointArray(x, y, z) {
        var arr;
        if (this.isIdentity()) arr = [
            x,
            y,
            z
        ];
        else arr = [
            x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
            x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
            x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
        ];
        return arr;
    }
    function applyToPointStringified(x, y) {
        if (this.isIdentity()) return x + ',' + y;
        var _p = this.props;
        return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
    }
    function toCSS() {
        // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
        /* if(this.isIdentity()) {
            return '';
        } */ var i = 0;
        var props = this.props;
        var cssValue = 'matrix3d(';
        var v = 10000;
        while(i < 16){
            cssValue += _rnd(props[i] * v) / v;
            cssValue += i === 15 ? ')' : ',';
            i += 1;
        }
        return cssValue;
    }
    function roundMatrixProperty(val) {
        var v = 10000;
        if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
        return val;
    }
    function to2dCSS() {
        // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
        /* if(this.isIdentity()) {
            return '';
        } */ var props = this.props;
        var _a = roundMatrixProperty(props[0]);
        var _b = roundMatrixProperty(props[1]);
        var _c = roundMatrixProperty(props[4]);
        var _d = roundMatrixProperty(props[5]);
        var _e = roundMatrixProperty(props[12]);
        var _f = roundMatrixProperty(props[13]);
        return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
    }
    return function() {
        this.reset = reset;
        this.rotate = rotate;
        this.rotateX = rotateX;
        this.rotateY = rotateY;
        this.rotateZ = rotateZ;
        this.skew = skew;
        this.skewFromAxis = skewFromAxis;
        this.shear = shear;
        this.scale = scale;
        this.setTransform = setTransform;
        this.translate = translate;
        this.transform = transform;
        this.multiply = multiply;
        this.applyToPoint = applyToPoint;
        this.applyToX = applyToX;
        this.applyToY = applyToY;
        this.applyToZ = applyToZ;
        this.applyToPointArray = applyToPointArray;
        this.applyToTriplePoints = applyToTriplePoints;
        this.applyToPointStringified = applyToPointStringified;
        this.toCSS = toCSS;
        this.to2dCSS = to2dCSS;
        this.clone = clone;
        this.cloneFromProps = cloneFromProps;
        this.equals = equals;
        this.inversePoints = inversePoints;
        this.inversePoint = inversePoint;
        this.getInverseMatrix = getInverseMatrix;
        this._t = this.transform;
        this.isIdentity = isIdentity;
        this._identity = true;
        this._identityCalculated = false;
        this.props = $b60a95926cba5528$var$createTypedArray('float32', 16);
        this.reset();
    };
}();
const $b60a95926cba5528$export$2e2bcd8739ae039 = {};
var $b60a95926cba5528$var$standalone = '__[STANDALONE]__';
var $b60a95926cba5528$var$animationData = '__[ANIMATIONDATA]__';
var $b60a95926cba5528$var$renderer = '';
function $b60a95926cba5528$var$setLocation(href) {
    $b60a95926cba5528$var$setLocationHref(href);
}
function $b60a95926cba5528$var$searchAnimations() {
    if ($b60a95926cba5528$var$standalone === true) $b60a95926cba5528$var$animationManager.searchAnimations($b60a95926cba5528$var$animationData, $b60a95926cba5528$var$standalone, $b60a95926cba5528$var$renderer);
    else $b60a95926cba5528$var$animationManager.searchAnimations();
}
function $b60a95926cba5528$var$setSubframeRendering(flag) {
    $b60a95926cba5528$var$setSubframeEnabled(flag);
}
function $b60a95926cba5528$var$setPrefix(prefix) {
    $b60a95926cba5528$var$setIdPrefix(prefix);
}
function $b60a95926cba5528$var$loadAnimation(params) {
    if ($b60a95926cba5528$var$standalone === true) params.animationData = JSON.parse($b60a95926cba5528$var$animationData);
    return $b60a95926cba5528$var$animationManager.loadAnimation(params);
}
function $b60a95926cba5528$var$setQuality(value) {
    if (typeof value === 'string') switch(value){
        case 'high':
            $b60a95926cba5528$var$setDefaultCurveSegments(200);
            break;
        default:
        case 'medium':
            $b60a95926cba5528$var$setDefaultCurveSegments(50);
            break;
        case 'low':
            $b60a95926cba5528$var$setDefaultCurveSegments(10);
            break;
    }
    else if (!isNaN(value) && value > 1) $b60a95926cba5528$var$setDefaultCurveSegments(value);
    if ($b60a95926cba5528$var$getDefaultCurveSegments() >= 50) $b60a95926cba5528$var$roundValues(false);
    else $b60a95926cba5528$var$roundValues(true);
}
function $b60a95926cba5528$var$inBrowser() {
    return typeof navigator !== 'undefined';
}
function $b60a95926cba5528$var$installPlugin(type, plugin) {
    if (type === 'expressions') $b60a95926cba5528$var$setExpressionsPlugin(plugin);
}
function $b60a95926cba5528$var$getFactory(name) {
    switch(name){
        case 'propertyFactory':
            return $b60a95926cba5528$var$PropertyFactory;
        case 'shapePropertyFactory':
            return $b60a95926cba5528$var$ShapePropertyFactory;
        case 'matrix':
            return $b60a95926cba5528$var$Matrix;
        default:
            return null;
    }
}
$b60a95926cba5528$export$2e2bcd8739ae039.play = $b60a95926cba5528$var$animationManager.play;
$b60a95926cba5528$export$2e2bcd8739ae039.pause = $b60a95926cba5528$var$animationManager.pause;
$b60a95926cba5528$export$2e2bcd8739ae039.setLocationHref = $b60a95926cba5528$var$setLocation;
$b60a95926cba5528$export$2e2bcd8739ae039.togglePause = $b60a95926cba5528$var$animationManager.togglePause;
$b60a95926cba5528$export$2e2bcd8739ae039.setSpeed = $b60a95926cba5528$var$animationManager.setSpeed;
$b60a95926cba5528$export$2e2bcd8739ae039.setDirection = $b60a95926cba5528$var$animationManager.setDirection;
$b60a95926cba5528$export$2e2bcd8739ae039.stop = $b60a95926cba5528$var$animationManager.stop;
$b60a95926cba5528$export$2e2bcd8739ae039.searchAnimations = $b60a95926cba5528$var$searchAnimations;
$b60a95926cba5528$export$2e2bcd8739ae039.registerAnimation = $b60a95926cba5528$var$animationManager.registerAnimation;
$b60a95926cba5528$export$2e2bcd8739ae039.loadAnimation = $b60a95926cba5528$var$loadAnimation;
$b60a95926cba5528$export$2e2bcd8739ae039.setSubframeRendering = $b60a95926cba5528$var$setSubframeRendering;
$b60a95926cba5528$export$2e2bcd8739ae039.resize = $b60a95926cba5528$var$animationManager.resize;
// lottie.start = start;
$b60a95926cba5528$export$2e2bcd8739ae039.goToAndStop = $b60a95926cba5528$var$animationManager.goToAndStop;
$b60a95926cba5528$export$2e2bcd8739ae039.destroy = $b60a95926cba5528$var$animationManager.destroy;
$b60a95926cba5528$export$2e2bcd8739ae039.setQuality = $b60a95926cba5528$var$setQuality;
$b60a95926cba5528$export$2e2bcd8739ae039.inBrowser = $b60a95926cba5528$var$inBrowser;
$b60a95926cba5528$export$2e2bcd8739ae039.installPlugin = $b60a95926cba5528$var$installPlugin;
$b60a95926cba5528$export$2e2bcd8739ae039.freeze = $b60a95926cba5528$var$animationManager.freeze;
$b60a95926cba5528$export$2e2bcd8739ae039.unfreeze = $b60a95926cba5528$var$animationManager.unfreeze;
$b60a95926cba5528$export$2e2bcd8739ae039.setVolume = $b60a95926cba5528$var$animationManager.setVolume;
$b60a95926cba5528$export$2e2bcd8739ae039.mute = $b60a95926cba5528$var$animationManager.mute;
$b60a95926cba5528$export$2e2bcd8739ae039.unmute = $b60a95926cba5528$var$animationManager.unmute;
$b60a95926cba5528$export$2e2bcd8739ae039.getRegisteredAnimations = $b60a95926cba5528$var$animationManager.getRegisteredAnimations;
$b60a95926cba5528$export$2e2bcd8739ae039.useWebWorker = $b60a95926cba5528$var$setWebWorker;
$b60a95926cba5528$export$2e2bcd8739ae039.setIDPrefix = $b60a95926cba5528$var$setPrefix;
$b60a95926cba5528$export$2e2bcd8739ae039.__getFactory = $b60a95926cba5528$var$getFactory;
$b60a95926cba5528$export$2e2bcd8739ae039.version = '[[BM_VERSION]]';
function $b60a95926cba5528$var$checkReady() {
    if (document.readyState === 'complete') {
        clearInterval($b60a95926cba5528$var$readyStateCheckInterval);
        $b60a95926cba5528$var$searchAnimations();
    }
}
function $b60a95926cba5528$var$getQueryVariable(variable) {
    var vars = $b60a95926cba5528$var$queryString.split('&');
    for(var i = 0; i < vars.length; i += 1){
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) return decodeURIComponent(pair[1]);
    }
    return null;
}
var $b60a95926cba5528$var$queryString = '';
if ($b60a95926cba5528$var$standalone) {
    var $b60a95926cba5528$var$scripts = document.getElementsByTagName('script');
    var $b60a95926cba5528$var$index = $b60a95926cba5528$var$scripts.length - 1;
    var $b60a95926cba5528$var$myScript = $b60a95926cba5528$var$scripts[$b60a95926cba5528$var$index] || {
        src: ''
    };
    $b60a95926cba5528$var$queryString = $b60a95926cba5528$var$myScript.src ? $b60a95926cba5528$var$myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
    $b60a95926cba5528$var$renderer = $b60a95926cba5528$var$getQueryVariable('renderer');
}
var $b60a95926cba5528$var$readyStateCheckInterval = setInterval($b60a95926cba5528$var$checkReady, 100);
const $b60a95926cba5528$var$ShapeModifiers = function() {
    var ob = {};
    var modifiers = {};
    ob.registerModifier = registerModifier;
    ob.getModifier = getModifier;
    function registerModifier(nm, factory) {
        if (!modifiers[nm]) modifiers[nm] = factory;
    }
    function getModifier(nm, elem, data) {
        return new modifiers[nm](elem, data);
    }
    return ob;
}();
function $b60a95926cba5528$var$ShapeModifier() {}
$b60a95926cba5528$var$ShapeModifier.prototype.initModifierProperties = function() {};
$b60a95926cba5528$var$ShapeModifier.prototype.addShapeToModifier = function() {};
$b60a95926cba5528$var$ShapeModifier.prototype.addShape = function(data) {
    if (!this.closed) {
        // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
        data.sh.container.addDynamicProperty(data.sh);
        var shapeData = {
            shape: data.sh,
            data: data,
            localShapeCollection: $b60a95926cba5528$var$shapeCollectionPool.newShapeCollection()
        };
        this.shapes.push(shapeData);
        this.addShapeToModifier(shapeData);
        if (this._isAnimated) data.setAsAnimated();
    }
};
$b60a95926cba5528$var$ShapeModifier.prototype.init = function(elem, data) {
    this.shapes = [];
    this.elem = elem;
    this.initDynamicPropertyContainer(elem);
    this.initModifierProperties(elem, data);
    this.frameId = $b60a95926cba5528$var$initialDefaultFrame;
    this.closed = false;
    this.k = false;
    if (this.dynamicProperties.length) this.k = true;
    else this.getValue(true);
};
$b60a95926cba5528$var$ShapeModifier.prototype.processKeys = function() {
    if (this.elem.globalData.frameId === this.frameId) return;
    this.frameId = this.elem.globalData.frameId;
    this.iterateDynamicProperties();
};
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$DynamicPropertyContainer
], $b60a95926cba5528$var$ShapeModifier);
function $b60a95926cba5528$var$TrimModifier() {}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$ShapeModifier
], $b60a95926cba5528$var$TrimModifier);
$b60a95926cba5528$var$TrimModifier.prototype.initModifierProperties = function(elem, data) {
    this.s = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
    this.e = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
    this.o = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.o, 0, 0, this);
    this.sValue = 0;
    this.eValue = 0;
    this.getValue = this.processKeys;
    this.m = data.m;
    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
};
$b60a95926cba5528$var$TrimModifier.prototype.addShapeToModifier = function(shapeData) {
    shapeData.pathsData = [];
};
$b60a95926cba5528$var$TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
    var segments = [];
    if (e <= 1) segments.push({
        s: s,
        e: e
    });
    else if (s >= 1) segments.push({
        s: s - 1,
        e: e - 1
    });
    else {
        segments.push({
            s: s,
            e: 1
        });
        segments.push({
            s: 0,
            e: e - 1
        });
    }
    var shapeSegments = [];
    var i;
    var len = segments.length;
    var segmentOb;
    for(i = 0; i < len; i += 1){
        segmentOb = segments[i];
        if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
            var shapeS;
            var shapeE;
            if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
            else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
            if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
            else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
            shapeSegments.push([
                shapeS,
                shapeE
            ]);
        }
    }
    if (!shapeSegments.length) shapeSegments.push([
        0,
        0
    ]);
    return shapeSegments;
};
$b60a95926cba5528$var$TrimModifier.prototype.releasePathsData = function(pathsData) {
    var i;
    var len = pathsData.length;
    for(i = 0; i < len; i += 1)$b60a95926cba5528$var$segmentsLengthPool.release(pathsData[i]);
    pathsData.length = 0;
    return pathsData;
};
$b60a95926cba5528$var$TrimModifier.prototype.processShapes = function(_isFirstFrame) {
    var s;
    var e;
    if (this._mdf || _isFirstFrame) {
        var o = this.o.v % 360 / 360;
        if (o < 0) o += 1;
        if (this.s.v > 1) s = 1 + o;
        else if (this.s.v < 0) s = 0 + o;
        else s = this.s.v + o;
        if (this.e.v > 1) e = 1 + o;
        else if (this.e.v < 0) e = 0 + o;
        else e = this.e.v + o;
        if (s > e) {
            var _s = s;
            s = e;
            e = _s;
        }
        s = Math.round(s * 10000) * 0.0001;
        e = Math.round(e * 10000) * 0.0001;
        this.sValue = s;
        this.eValue = e;
    } else {
        s = this.sValue;
        e = this.eValue;
    }
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var pathsData;
    var pathData;
    var totalShapeLength;
    var totalModifierLength = 0;
    if (e === s) for(i = 0; i < len; i += 1){
        this.shapes[i].localShapeCollection.releaseShapes();
        this.shapes[i].shape._mdf = true;
        this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
        if (this._mdf) this.shapes[i].pathsData.length = 0;
    }
    else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
        var segments = [];
        var shapeData;
        var localShapeCollection;
        for(i = 0; i < len; i += 1){
            shapeData = this.shapes[i];
            // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
            if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
            else {
                shapePaths = shapeData.shape.paths;
                jLen = shapePaths._length;
                totalShapeLength = 0;
                if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                else {
                    pathsData = this.releasePathsData(shapeData.pathsData);
                    for(j = 0; j < jLen; j += 1){
                        pathData = $b60a95926cba5528$var$bez.getSegmentsLength(shapePaths.shapes[j]);
                        pathsData.push(pathData);
                        totalShapeLength += pathData.totalLength;
                    }
                    shapeData.totalShapeLength = totalShapeLength;
                    shapeData.pathsData = pathsData;
                }
                totalModifierLength += totalShapeLength;
                shapeData.shape._mdf = true;
            }
        }
        var shapeS = s;
        var shapeE = e;
        var addedLength = 0;
        var edges;
        for(i = len - 1; i >= 0; i -= 1){
            shapeData = this.shapes[i];
            if (shapeData.shape._mdf) {
                localShapeCollection = shapeData.localShapeCollection;
                localShapeCollection.releaseShapes();
                // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                if (this.m === 2 && len > 1) {
                    edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                    addedLength += shapeData.totalShapeLength;
                } else edges = [
                    [
                        shapeS,
                        shapeE
                    ]
                ];
                jLen = edges.length;
                for(j = 0; j < jLen; j += 1){
                    shapeS = edges[j][0];
                    shapeE = edges[j][1];
                    segments.length = 0;
                    if (shapeE <= 1) segments.push({
                        s: shapeData.totalShapeLength * shapeS,
                        e: shapeData.totalShapeLength * shapeE
                    });
                    else if (shapeS >= 1) segments.push({
                        s: shapeData.totalShapeLength * (shapeS - 1),
                        e: shapeData.totalShapeLength * (shapeE - 1)
                    });
                    else {
                        segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength
                        });
                        segments.push({
                            s: 0,
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                    }
                    var newShapesData = this.addShapes(shapeData, segments[0]);
                    if (segments[0].s !== segments[0].e) {
                        if (segments.length > 1) {
                            var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                            if (lastShapeInCollection.c) {
                                var lastShape = newShapesData.pop();
                                this.addPaths(newShapesData, localShapeCollection);
                                newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                            } else {
                                this.addPaths(newShapesData, localShapeCollection);
                                newShapesData = this.addShapes(shapeData, segments[1]);
                            }
                        }
                        this.addPaths(newShapesData, localShapeCollection);
                    }
                }
                shapeData.shape.paths = localShapeCollection;
            }
        }
    } else if (this._mdf) for(i = 0; i < len; i += 1){
        // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
        // Don't remove this even if it's losing cached info.
        this.shapes[i].pathsData.length = 0;
        this.shapes[i].shape._mdf = true;
    }
};
$b60a95926cba5528$var$TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
    var i;
    var len = newPaths.length;
    for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
};
$b60a95926cba5528$var$TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
    if (newShape) shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
};
$b60a95926cba5528$var$TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
    shapePath.setXYAt(points[1], points[5], 'o', pos);
    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
    if (newShape) shapePath.setXYAt(points[0], points[4], 'v', pos);
    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
};
$b60a95926cba5528$var$TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
    var pathsData = shapeData.pathsData;
    var shapePaths = shapeData.shape.paths.shapes;
    var i;
    var len = shapeData.shape.paths._length;
    var j;
    var jLen;
    var addedLength = 0;
    var currentLengthData;
    var segmentCount;
    var lengths;
    var segment;
    var shapes = [];
    var initPos;
    var newShape = true;
    if (!shapePath) {
        shapePath = $b60a95926cba5528$var$shapePool.newElement();
        segmentCount = 0;
        initPos = 0;
    } else {
        segmentCount = shapePath._length;
        initPos = shapePath._length;
    }
    shapes.push(shapePath);
    for(i = 0; i < len; i += 1){
        lengths = pathsData[i].lengths;
        shapePath.c = shapePaths[i].c;
        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
        for(j = 1; j < jLen; j += 1){
            currentLengthData = lengths[j - 1];
            if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                addedLength += currentLengthData.addedLength;
                shapePath.c = false;
            } else if (addedLength > shapeSegment.e) {
                shapePath.c = false;
                break;
            } else {
                if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                    this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                    newShape = false;
                } else {
                    segment = $b60a95926cba5528$var$bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                    this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
                    // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                    newShape = false;
                    shapePath.c = false;
                }
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
        }
        if (shapePaths[i].c && lengths.length) {
            currentLengthData = lengths[j - 1];
            if (addedLength <= shapeSegment.e) {
                var segmentLength = lengths[j - 1].addedLength;
                if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                    this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                    newShape = false;
                } else {
                    segment = $b60a95926cba5528$var$bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                    this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
                    // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                    newShape = false;
                    shapePath.c = false;
                }
            } else shapePath.c = false;
            addedLength += currentLengthData.addedLength;
            segmentCount += 1;
        }
        if (shapePath._length) {
            shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
        }
        if (addedLength > shapeSegment.e) break;
        if (i < len - 1) {
            shapePath = $b60a95926cba5528$var$shapePool.newElement();
            newShape = true;
            shapes.push(shapePath);
            segmentCount = 0;
        }
    }
    return shapes;
};
function $b60a95926cba5528$var$PuckerAndBloatModifier() {}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$ShapeModifier
], $b60a95926cba5528$var$PuckerAndBloatModifier);
$b60a95926cba5528$var$PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
    this.getValue = this.processKeys;
    this.amount = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.a, 0, null, this);
    this._isAnimated = !!this.amount.effectsSequence.length;
};
$b60a95926cba5528$var$PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
    var percent = amount / 100;
    var centerPoint = [
        0,
        0
    ];
    var pathLength = path._length;
    var i = 0;
    for(i = 0; i < pathLength; i += 1){
        centerPoint[0] += path.v[i][0];
        centerPoint[1] += path.v[i][1];
    }
    centerPoint[0] /= pathLength;
    centerPoint[1] /= pathLength;
    var clonedPath = $b60a95926cba5528$var$shapePool.newElement();
    clonedPath.c = path.c;
    var vX;
    var vY;
    var oX;
    var oY;
    var iX;
    var iY;
    for(i = 0; i < pathLength; i += 1){
        vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
        vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
        oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
        oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
        iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
        iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
        clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
    }
    return clonedPath;
};
$b60a95926cba5528$var$PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amount = this.amount.v;
    if (amount !== 0) {
        var shapeData;
        var localShapeCollection;
        for(i = 0; i < len; i += 1){
            shapeData = this.shapes[i];
            localShapeCollection = shapeData.localShapeCollection;
            if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                localShapeCollection.releaseShapes();
                shapeData.shape._mdf = true;
                shapePaths = shapeData.shape.paths.shapes;
                jLen = shapeData.shape.paths._length;
                for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
        }
    }
    if (!this.dynamicProperties.length) this._mdf = false;
};
const $b60a95926cba5528$var$TransformPropertyFactory = function() {
    var defaultVector = [
        0,
        0
    ];
    function applyToMatrix(mat) {
        var _mdf = this._mdf;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || _mdf;
        if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
        if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
        if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
        if (this.r) mat.rotate(-this.r.v);
        else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
        if (this.data.p.s) {
            if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
            else mat.translate(this.px.v, this.py.v, 0);
        } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
    }
    function processKeys(forceRender) {
        if (this.elem.globalData.frameId === this.frameId) return;
        if (this._isDirty) {
            this.precalculateMatrix();
            this._isDirty = false;
        }
        this.iterateDynamicProperties();
        if (this._mdf || forceRender) {
            var frameRate;
            this.v.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
            else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.autoOriented) {
                var v1;
                var v2;
                frameRate = this.elem.globalData.frameRate;
                if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                    if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                        v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                        v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                    } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                        v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                        v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                    } else {
                        v1 = this.p.pv;
                        v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                    }
                } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                    v1 = [];
                    v2 = [];
                    var px = this.px;
                    var py = this.py;
                    if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                        v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                        v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                        v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                        v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                    } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                        v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                        v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                        v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                    } else {
                        v1 = [
                            px.pv,
                            py.pv
                        ];
                        v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                        v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                    }
                } else {
                    v2 = defaultVector;
                    v1 = v2;
                }
                this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
            }
            if (this.data.p && this.data.p.s) {
                if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                else this.v.translate(this.px.v, this.py.v, 0);
            } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        this.frameId = this.elem.globalData.frameId;
    }
    function precalculateMatrix() {
        this.appliedTransformations = 0;
        this.pre.reset();
        if (!this.a.effectsSequence.length) {
            this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            this.appliedTransformations = 1;
        } else return;
        if (!this.s.effectsSequence.length) {
            this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            this.appliedTransformations = 2;
        } else return;
        if (this.sk) {
            if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                this.appliedTransformations = 3;
            } else return;
        }
        if (this.r) {
            if (!this.r.effectsSequence.length) {
                this.pre.rotate(-this.r.v);
                this.appliedTransformations = 4;
            }
        } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
            this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            this.appliedTransformations = 4;
        }
    }
    function autoOrient() {
    //
    // var prevP = this.getValueAtTime();
    }
    function addDynamicProperty(prop) {
        this._addDynamicProperty(prop);
        this.elem.addDynamicProperty(prop);
        this._isDirty = true;
    }
    function TransformProperty(elem, data, container) {
        this.elem = elem;
        this.frameId = -1;
        this.propType = 'transform';
        this.data = data;
        this.v = new $b60a95926cba5528$var$Matrix();
        // Precalculated matrix with non animated properties
        this.pre = new $b60a95926cba5528$var$Matrix();
        this.appliedTransformations = 0;
        this.initDynamicPropertyContainer(container || elem);
        if (data.p && data.p.s) {
            this.px = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
            this.py = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
            if (data.p.z) this.pz = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
        } else this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.p || {
            k: [
                0,
                0,
                0
            ]
        }, 1, 0, this);
        if (data.rx) {
            this.rx = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.rx, 0, $b60a95926cba5528$var$degToRads, this);
            this.ry = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.ry, 0, $b60a95926cba5528$var$degToRads, this);
            this.rz = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.rz, 0, $b60a95926cba5528$var$degToRads, this);
            if (data.or.k[0].ti) {
                var i;
                var len = data.or.k.length;
                for(i = 0; i < len; i += 1){
                    data.or.k[i].to = null;
                    data.or.k[i].ti = null;
                }
            }
            this.or = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.or, 1, $b60a95926cba5528$var$degToRads, this);
            // sh Indicates it needs to be capped between -180 and 180
            this.or.sh = true;
        } else this.r = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.r || {
            k: 0
        }, 0, $b60a95926cba5528$var$degToRads, this);
        if (data.sk) {
            this.sk = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.sk, 0, $b60a95926cba5528$var$degToRads, this);
            this.sa = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.sa, 0, $b60a95926cba5528$var$degToRads, this);
        }
        this.a = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.a || {
            k: [
                0,
                0,
                0
            ]
        }, 1, 0, this);
        this.s = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.s || {
            k: [
                100,
                100,
                100
            ]
        }, 1, 0.01, this);
        // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
        if (data.o) this.o = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
        else this.o = {
            _mdf: false,
            v: 1
        };
        this._isDirty = true;
        if (!this.dynamicProperties.length) this.getValue(true);
    }
    TransformProperty.prototype = {
        applyToMatrix: applyToMatrix,
        getValue: processKeys,
        precalculateMatrix: precalculateMatrix,
        autoOrient: autoOrient
    };
    $b60a95926cba5528$var$extendPrototype([
        $b60a95926cba5528$var$DynamicPropertyContainer
    ], TransformProperty);
    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
    TransformProperty.prototype._addDynamicProperty = $b60a95926cba5528$var$DynamicPropertyContainer.prototype.addDynamicProperty;
    function getTransformProperty(elem, data, container) {
        return new TransformProperty(elem, data, container);
    }
    return {
        getTransformProperty: getTransformProperty
    };
}();
function $b60a95926cba5528$var$RepeaterModifier() {}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$ShapeModifier
], $b60a95926cba5528$var$RepeaterModifier);
$b60a95926cba5528$var$RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
    this.getValue = this.processKeys;
    this.c = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.c, 0, null, this);
    this.o = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.o, 0, null, this);
    this.tr = $b60a95926cba5528$var$TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
    this.so = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
    this.eo = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
    this.data = data;
    if (!this.dynamicProperties.length) this.getValue(true);
    this._isAnimated = !!this.dynamicProperties.length;
    this.pMatrix = new $b60a95926cba5528$var$Matrix();
    this.rMatrix = new $b60a95926cba5528$var$Matrix();
    this.sMatrix = new $b60a95926cba5528$var$Matrix();
    this.tMatrix = new $b60a95926cba5528$var$Matrix();
    this.matrix = new $b60a95926cba5528$var$Matrix();
};
$b60a95926cba5528$var$RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
    var dir = inv ? -1 : 1;
    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    rMatrix.rotate(-transform.r.v * dir * perc);
    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
};
$b60a95926cba5528$var$RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
    this.elem = elem;
    this.arr = arr;
    this.pos = pos;
    this.elemsData = elemsData;
    this._currentCopies = 0;
    this._elements = [];
    this._groups = [];
    this.frameId = -1;
    this.initDynamicPropertyContainer(elem);
    this.initModifierProperties(elem, arr[pos]);
    while(pos > 0){
        pos -= 1;
        // this._elements.unshift(arr.splice(pos,1)[0]);
        this._elements.unshift(arr[pos]);
    }
    if (this.dynamicProperties.length) this.k = true;
    else this.getValue(true);
};
$b60a95926cba5528$var$RepeaterModifier.prototype.resetElements = function(elements) {
    var i;
    var len = elements.length;
    for(i = 0; i < len; i += 1){
        elements[i]._processed = false;
        if (elements[i].ty === 'gr') this.resetElements(elements[i].it);
    }
};
$b60a95926cba5528$var$RepeaterModifier.prototype.cloneElements = function(elements) {
    var newElements = JSON.parse(JSON.stringify(elements));
    this.resetElements(newElements);
    return newElements;
};
$b60a95926cba5528$var$RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
    var i;
    var len = elements.length;
    for(i = 0; i < len; i += 1){
        elements[i]._render = renderFlag;
        if (elements[i].ty === 'gr') this.changeGroupRender(elements[i].it, renderFlag);
    }
};
$b60a95926cba5528$var$RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
    var items;
    var itemsTransform;
    var i;
    var dir;
    var cont;
    var hasReloaded = false;
    if (this._mdf || _isFirstFrame) {
        var copies = Math.ceil(this.c.v);
        if (this._groups.length < copies) {
            while(this._groups.length < copies){
                var group = {
                    it: this.cloneElements(this._elements),
                    ty: 'gr'
                };
                group.it.push({
                    a: {
                        a: 0,
                        ix: 1,
                        k: [
                            0,
                            0
                        ]
                    },
                    nm: 'Transform',
                    o: {
                        a: 0,
                        ix: 7,
                        k: 100
                    },
                    p: {
                        a: 0,
                        ix: 2,
                        k: [
                            0,
                            0
                        ]
                    },
                    r: {
                        a: 1,
                        ix: 6,
                        k: [
                            {
                                s: 0,
                                e: 0,
                                t: 0
                            },
                            {
                                s: 0,
                                e: 0,
                                t: 1
                            }
                        ]
                    },
                    s: {
                        a: 0,
                        ix: 3,
                        k: [
                            100,
                            100
                        ]
                    },
                    sa: {
                        a: 0,
                        ix: 5,
                        k: 0
                    },
                    sk: {
                        a: 0,
                        ix: 4,
                        k: 0
                    },
                    ty: 'tr'
                });
                this.arr.splice(0, 0, group);
                this._groups.splice(0, 0, group);
                this._currentCopies += 1;
            }
            this.elem.reloadShapes();
            hasReloaded = true;
        }
        cont = 0;
        var renderFlag;
        for(i = 0; i <= this._groups.length - 1; i += 1){
            renderFlag = cont < copies;
            this._groups[i]._render = renderFlag;
            this.changeGroupRender(this._groups[i].it, renderFlag);
            if (!renderFlag) {
                var elems = this.elemsData[i].it;
                var transformData = elems[elems.length - 1];
                if (transformData.transform.op.v !== 0) {
                    transformData.transform.op._mdf = true;
                    transformData.transform.op.v = 0;
                } else transformData.transform.op._mdf = false;
            }
            cont += 1;
        }
        this._currentCopies = copies;
        /// /
        var offset = this.o.v;
        var offsetModulo = offset % 1;
        var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
        var pProps = this.pMatrix.props;
        var rProps = this.rMatrix.props;
        var sProps = this.sMatrix.props;
        this.pMatrix.reset();
        this.rMatrix.reset();
        this.sMatrix.reset();
        this.tMatrix.reset();
        this.matrix.reset();
        var iteration = 0;
        if (offset > 0) {
            while(iteration < roundOffset){
                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                iteration += 1;
            }
            if (offsetModulo) {
                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                iteration += offsetModulo;
            }
        } else if (offset < 0) {
            while(iteration > roundOffset){
                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                iteration -= 1;
            }
            if (offsetModulo) {
                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                iteration -= offsetModulo;
            }
        }
        i = this.data.m === 1 ? 0 : this._currentCopies - 1;
        dir = this.data.m === 1 ? 1 : -1;
        cont = this._currentCopies;
        var j;
        var jLen;
        while(cont){
            items = this.elemsData[i].it;
            itemsTransform = items[items.length - 1].transform.mProps.v.props;
            jLen = itemsTransform.length;
            items[items.length - 1].transform.mProps._mdf = true;
            items[items.length - 1].transform.op._mdf = true;
            items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
            if (iteration !== 0) {
                if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                this.matrix.reset();
            } else {
                this.matrix.reset();
                for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
            }
            iteration += 1;
            cont -= 1;
            i += dir;
        }
    } else {
        cont = this._currentCopies;
        i = 0;
        dir = 1;
        while(cont){
            items = this.elemsData[i].it;
            itemsTransform = items[items.length - 1].transform.mProps.v.props;
            items[items.length - 1].transform.mProps._mdf = false;
            items[items.length - 1].transform.op._mdf = false;
            cont -= 1;
            i += dir;
        }
    }
    return hasReloaded;
};
$b60a95926cba5528$var$RepeaterModifier.prototype.addShape = function() {};
function $b60a95926cba5528$var$RoundCornersModifier() {}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$ShapeModifier
], $b60a95926cba5528$var$RoundCornersModifier);
$b60a95926cba5528$var$RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
    this.getValue = this.processKeys;
    this.rd = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.r, 0, null, this);
    this._isAnimated = !!this.rd.effectsSequence.length;
};
$b60a95926cba5528$var$RoundCornersModifier.prototype.processPath = function(path, round) {
    var clonedPath = $b60a95926cba5528$var$shapePool.newElement();
    clonedPath.c = path.c;
    var i;
    var len = path._length;
    var currentV;
    var currentI;
    var currentO;
    var closerV;
    var distance;
    var newPosPerc;
    var index = 0;
    var vX;
    var vY;
    var oX;
    var oY;
    var iX;
    var iY;
    for(i = 0; i < len; i += 1){
        currentV = path.v[i];
        currentO = path.o[i];
        currentI = path.i[i];
        if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
            if ((i === 0 || i === len - 1) && !path.c) {
                clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                /* clonedPath.v[index] = currentV;
                clonedPath.o[index] = currentO;
                clonedPath.i[index] = currentI; */ index += 1;
            } else {
                if (i === 0) closerV = path.v[len - 1];
                else closerV = path.v[i - 1];
                distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                vX = iX;
                iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                vY = iY;
                oX = vX - (vX - currentV[0]) * $b60a95926cba5528$var$roundCorner;
                oY = vY - (vY - currentV[1]) * $b60a95926cba5528$var$roundCorner;
                clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                index += 1;
                if (i === len - 1) closerV = path.v[0];
                else closerV = path.v[i + 1];
                distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                vX = oX;
                oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                vY = oY;
                iX = vX - (vX - currentV[0]) * $b60a95926cba5528$var$roundCorner;
                iY = vY - (vY - currentV[1]) * $b60a95926cba5528$var$roundCorner;
                clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                index += 1;
            }
        } else {
            clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
            index += 1;
        }
    }
    return clonedPath;
};
$b60a95926cba5528$var$RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var rd = this.rd.v;
    if (rd !== 0) {
        var shapeData;
        var localShapeCollection;
        for(i = 0; i < len; i += 1){
            shapeData = this.shapes[i];
            localShapeCollection = shapeData.localShapeCollection;
            if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                localShapeCollection.releaseShapes();
                shapeData.shape._mdf = true;
                shapePaths = shapeData.shape.paths.shapes;
                jLen = shapeData.shape.paths._length;
                for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
        }
    }
    if (!this.dynamicProperties.length) this._mdf = false;
};
function $b60a95926cba5528$var$floatEqual(a, b) {
    return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
}
function $b60a95926cba5528$var$floatZero(f) {
    return Math.abs(f) <= 0.00001;
}
function $b60a95926cba5528$var$lerp(p0, p1, amount) {
    return p0 * (1 - amount) + p1 * amount;
}
function $b60a95926cba5528$var$lerpPoint(p0, p1, amount) {
    return [
        $b60a95926cba5528$var$lerp(p0[0], p1[0], amount),
        $b60a95926cba5528$var$lerp(p0[1], p1[1], amount)
    ];
}
function $b60a95926cba5528$var$quadRoots(a, b, c) {
    // no root
    if (a === 0) return [];
    var s = b * b - 4 * a * c;
    // Complex roots
    if (s < 0) return [];
    var singleRoot = -b / (2 * a);
    // 1 root
    if (s === 0) return [
        singleRoot
    ];
    var delta = Math.sqrt(s) / (2 * a);
    // 2 roots
    return [
        singleRoot - delta,
        singleRoot + delta
    ];
}
function $b60a95926cba5528$var$polynomialCoefficients(p0, p1, p2, p3) {
    return [
        -p0 + 3 * p1 - 3 * p2 + p3,
        3 * p0 - 6 * p1 + 3 * p2,
        -3 * p0 + 3 * p1,
        p0
    ];
}
function $b60a95926cba5528$var$singlePoint(p) {
    return new $b60a95926cba5528$var$PolynomialBezier(p, p, p, p, false);
}
function $b60a95926cba5528$var$PolynomialBezier(p0, p1, p2, p3, linearize) {
    if (linearize && $b60a95926cba5528$var$pointEqual(p0, p1)) p1 = $b60a95926cba5528$var$lerpPoint(p0, p3, 1 / 3);
    if (linearize && $b60a95926cba5528$var$pointEqual(p2, p3)) p2 = $b60a95926cba5528$var$lerpPoint(p0, p3, 2 / 3);
    var coeffx = $b60a95926cba5528$var$polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
    var coeffy = $b60a95926cba5528$var$polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
    this.a = [
        coeffx[0],
        coeffy[0]
    ];
    this.b = [
        coeffx[1],
        coeffy[1]
    ];
    this.c = [
        coeffx[2],
        coeffy[2]
    ];
    this.d = [
        coeffx[3],
        coeffy[3]
    ];
    this.points = [
        p0,
        p1,
        p2,
        p3
    ];
}
$b60a95926cba5528$var$PolynomialBezier.prototype.point = function(t) {
    return [
        ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
        ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
    ];
};
$b60a95926cba5528$var$PolynomialBezier.prototype.derivative = function(t) {
    return [
        (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
        (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
    ];
};
$b60a95926cba5528$var$PolynomialBezier.prototype.tangentAngle = function(t) {
    var p = this.derivative(t);
    return Math.atan2(p[1], p[0]);
};
$b60a95926cba5528$var$PolynomialBezier.prototype.normalAngle = function(t) {
    var p = this.derivative(t);
    return Math.atan2(p[0], p[1]);
};
$b60a95926cba5528$var$PolynomialBezier.prototype.inflectionPoints = function() {
    var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
    if ($b60a95926cba5528$var$floatZero(denom)) return [];
    var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
    var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
    if (square < 0) return [];
    var root = Math.sqrt(square);
    if ($b60a95926cba5528$var$floatZero(root)) {
        if (root > 0 && root < 1) return [
            tcusp
        ];
        return [];
    }
    return [
        tcusp - root,
        tcusp + root
    ].filter(function(r) {
        return r > 0 && r < 1;
    });
};
$b60a95926cba5528$var$PolynomialBezier.prototype.split = function(t) {
    if (t <= 0) return [
        $b60a95926cba5528$var$singlePoint(this.points[0]),
        this
    ];
    if (t >= 1) return [
        this,
        $b60a95926cba5528$var$singlePoint(this.points[this.points.length - 1])
    ];
    var p10 = $b60a95926cba5528$var$lerpPoint(this.points[0], this.points[1], t);
    var p11 = $b60a95926cba5528$var$lerpPoint(this.points[1], this.points[2], t);
    var p12 = $b60a95926cba5528$var$lerpPoint(this.points[2], this.points[3], t);
    var p20 = $b60a95926cba5528$var$lerpPoint(p10, p11, t);
    var p21 = $b60a95926cba5528$var$lerpPoint(p11, p12, t);
    var p3 = $b60a95926cba5528$var$lerpPoint(p20, p21, t);
    return [
        new $b60a95926cba5528$var$PolynomialBezier(this.points[0], p10, p20, p3, true),
        new $b60a95926cba5528$var$PolynomialBezier(p3, p21, p12, this.points[3], true)
    ];
};
function $b60a95926cba5528$var$extrema(bez, comp) {
    var min = bez.points[0][comp];
    var max = bez.points[bez.points.length - 1][comp];
    if (min > max) {
        var e = max;
        max = min;
        min = e;
    }
    // Derivative roots to find min/max
    var f = $b60a95926cba5528$var$quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
    for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
        var val = bez.point(f[i])[comp];
        if (val < min) min = val;
        else if (val > max) max = val;
    }
    return {
        min: min,
        max: max
    };
}
$b60a95926cba5528$var$PolynomialBezier.prototype.bounds = function() {
    return {
        x: $b60a95926cba5528$var$extrema(this, 0),
        y: $b60a95926cba5528$var$extrema(this, 1)
    };
};
$b60a95926cba5528$var$PolynomialBezier.prototype.boundingBox = function() {
    var bounds = this.bounds();
    return {
        left: bounds.x.min,
        right: bounds.x.max,
        top: bounds.y.min,
        bottom: bounds.y.max,
        width: bounds.x.max - bounds.x.min,
        height: bounds.y.max - bounds.y.min,
        cx: (bounds.x.max + bounds.x.min) / 2,
        cy: (bounds.y.max + bounds.y.min) / 2
    };
};
function $b60a95926cba5528$var$intersectData(bez, t1, t2) {
    var box = bez.boundingBox();
    return {
        cx: box.cx,
        cy: box.cy,
        width: box.width,
        height: box.height,
        bez: bez,
        t: (t1 + t2) / 2,
        t1: t1,
        t2: t2
    };
}
function $b60a95926cba5528$var$splitData(data) {
    var split = data.bez.split(0.5);
    return [
        $b60a95926cba5528$var$intersectData(split[0], data.t1, data.t),
        $b60a95926cba5528$var$intersectData(split[1], data.t, data.t2)
    ];
}
function $b60a95926cba5528$var$boxIntersect(b1, b2) {
    return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
}
function $b60a95926cba5528$var$intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
    if (!$b60a95926cba5528$var$boxIntersect(d1, d2)) return;
    if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
        intersections.push([
            d1.t,
            d2.t
        ]);
        return;
    }
    var d1s = $b60a95926cba5528$var$splitData(d1);
    var d2s = $b60a95926cba5528$var$splitData(d2);
    $b60a95926cba5528$var$intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
    $b60a95926cba5528$var$intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    $b60a95926cba5528$var$intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
    $b60a95926cba5528$var$intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
}
$b60a95926cba5528$var$PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
    if (tolerance === undefined) tolerance = 2;
    if (maxRecursion === undefined) maxRecursion = 7;
    var intersections = [];
    $b60a95926cba5528$var$intersectsImpl($b60a95926cba5528$var$intersectData(this, 0, 1), $b60a95926cba5528$var$intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
    return intersections;
};
$b60a95926cba5528$var$PolynomialBezier.shapeSegment = function(shapePath, index) {
    var nextIndex = (index + 1) % shapePath.length();
    return new $b60a95926cba5528$var$PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
};
$b60a95926cba5528$var$PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
    var nextIndex = (index + 1) % shapePath.length();
    return new $b60a95926cba5528$var$PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
};
function $b60a95926cba5528$var$crossProduct(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $b60a95926cba5528$var$lineIntersection(start1, end1, start2, end2) {
    var v1 = [
        start1[0],
        start1[1],
        1
    ];
    var v2 = [
        end1[0],
        end1[1],
        1
    ];
    var v3 = [
        start2[0],
        start2[1],
        1
    ];
    var v4 = [
        end2[0],
        end2[1],
        1
    ];
    var r = $b60a95926cba5528$var$crossProduct($b60a95926cba5528$var$crossProduct(v1, v2), $b60a95926cba5528$var$crossProduct(v3, v4));
    if ($b60a95926cba5528$var$floatZero(r[2])) return null;
    return [
        r[0] / r[2],
        r[1] / r[2]
    ];
}
function $b60a95926cba5528$var$polarOffset(p, angle, length) {
    return [
        p[0] + Math.cos(angle) * length,
        p[1] - Math.sin(angle) * length
    ];
}
function $b60a95926cba5528$var$pointDistance(p1, p2) {
    return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
}
function $b60a95926cba5528$var$pointEqual(p1, p2) {
    return $b60a95926cba5528$var$floatEqual(p1[0], p2[0]) && $b60a95926cba5528$var$floatEqual(p1[1], p2[1]);
}
function $b60a95926cba5528$var$ZigZagModifier() {}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$ShapeModifier
], $b60a95926cba5528$var$ZigZagModifier);
$b60a95926cba5528$var$ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
    this.getValue = this.processKeys;
    this.amplitude = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.s, 0, null, this);
    this.frequency = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.r, 0, null, this);
    this.pointsType = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.pt, 0, null, this);
    this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
};
function $b60a95926cba5528$var$setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
    var angO = angle - Math.PI / 2;
    var angI = angle + Math.PI / 2;
    var px = point[0] + Math.cos(angle) * direction * amplitude;
    var py = point[1] - Math.sin(angle) * direction * amplitude;
    outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
}
function $b60a95926cba5528$var$getPerpendicularVector(pt1, pt2) {
    var vector = [
        pt2[0] - pt1[0],
        pt2[1] - pt1[1]
    ];
    var rot = -Math.PI * 0.5;
    var rotatedVector = [
        Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
        Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
    ];
    return rotatedVector;
}
function $b60a95926cba5528$var$getProjectingAngle(path, cur) {
    var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
    var nextIndex = (cur + 1) % path.length();
    var prevPoint = path.v[prevIndex];
    var nextPoint = path.v[nextIndex];
    var pVector = $b60a95926cba5528$var$getPerpendicularVector(prevPoint, nextPoint);
    return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
}
function $b60a95926cba5528$var$zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
    var angle = $b60a95926cba5528$var$getProjectingAngle(path, cur);
    var point = path.v[cur % path._length];
    var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
    var nextPoint = path.v[(cur + 1) % path._length];
    var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
    var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
    $b60a95926cba5528$var$setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
}
function $b60a95926cba5528$var$zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
    for(var i = 0; i < frequency; i += 1){
        var t = (i + 1) / (frequency + 1);
        var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
        var angle = segment.normalAngle(t);
        var point = segment.point(t);
        $b60a95926cba5528$var$setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
        direction = -direction;
    }
    return direction;
}
$b60a95926cba5528$var$ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
    var count = path._length;
    var clonedPath = $b60a95926cba5528$var$shapePool.newElement();
    clonedPath.c = path.c;
    if (!path.c) count -= 1;
    if (count === 0) return clonedPath;
    var direction = -1;
    var segment = $b60a95926cba5528$var$PolynomialBezier.shapeSegment(path, 0);
    $b60a95926cba5528$var$zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
    for(var i = 0; i < count; i += 1){
        direction = $b60a95926cba5528$var$zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
        if (i === count - 1 && !path.c) segment = null;
        else segment = $b60a95926cba5528$var$PolynomialBezier.shapeSegment(path, (i + 1) % count);
        $b60a95926cba5528$var$zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
    }
    return clonedPath;
};
$b60a95926cba5528$var$ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amplitude = this.amplitude.v;
    var frequency = Math.max(0, Math.round(this.frequency.v));
    var pointType = this.pointsType.v;
    if (amplitude !== 0) {
        var shapeData;
        var localShapeCollection;
        for(i = 0; i < len; i += 1){
            shapeData = this.shapes[i];
            localShapeCollection = shapeData.localShapeCollection;
            if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                localShapeCollection.releaseShapes();
                shapeData.shape._mdf = true;
                shapePaths = shapeData.shape.paths.shapes;
                jLen = shapeData.shape.paths._length;
                for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
        }
    }
    if (!this.dynamicProperties.length) this._mdf = false;
};
function $b60a95926cba5528$var$linearOffset(p1, p2, amount) {
    var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
    return [
        $b60a95926cba5528$var$polarOffset(p1, angle, amount),
        $b60a95926cba5528$var$polarOffset(p2, angle, amount)
    ];
}
function $b60a95926cba5528$var$offsetSegment(segment, amount) {
    var p0;
    var p1a;
    var p1b;
    var p2b;
    var p2a;
    var p3;
    var e;
    e = $b60a95926cba5528$var$linearOffset(segment.points[0], segment.points[1], amount);
    p0 = e[0];
    p1a = e[1];
    e = $b60a95926cba5528$var$linearOffset(segment.points[1], segment.points[2], amount);
    p1b = e[0];
    p2b = e[1];
    e = $b60a95926cba5528$var$linearOffset(segment.points[2], segment.points[3], amount);
    p2a = e[0];
    p3 = e[1];
    var p1 = $b60a95926cba5528$var$lineIntersection(p0, p1a, p1b, p2b);
    if (p1 === null) p1 = p1a;
    var p2 = $b60a95926cba5528$var$lineIntersection(p2a, p3, p1b, p2b);
    if (p2 === null) p2 = p2a;
    return new $b60a95926cba5528$var$PolynomialBezier(p0, p1, p2, p3);
}
function $b60a95926cba5528$var$joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
    var p0 = seg1.points[3];
    var p1 = seg2.points[0];
    // Bevel
    if (lineJoin === 3) return p0;
    // Connected, they don't need a joint
    if ($b60a95926cba5528$var$pointEqual(p0, p1)) return p0;
    // Round
    if (lineJoin === 2) {
        var angleOut = -seg1.tangentAngle(1);
        var angleIn = -seg2.tangentAngle(0) + Math.PI;
        var center = $b60a95926cba5528$var$lineIntersection(p0, $b60a95926cba5528$var$polarOffset(p0, angleOut + Math.PI / 2, 100), p1, $b60a95926cba5528$var$polarOffset(p1, angleOut + Math.PI / 2, 100));
        var radius = center ? $b60a95926cba5528$var$pointDistance(center, p0) : $b60a95926cba5528$var$pointDistance(p0, p1) / 2;
        var tan = $b60a95926cba5528$var$polarOffset(p0, angleOut, 2 * radius * $b60a95926cba5528$var$roundCorner);
        outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
        tan = $b60a95926cba5528$var$polarOffset(p1, angleIn, 2 * radius * $b60a95926cba5528$var$roundCorner);
        outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
        return p1;
    }
    // Miter
    var t0 = $b60a95926cba5528$var$pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
    var t1 = $b60a95926cba5528$var$pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
    var intersection = $b60a95926cba5528$var$lineIntersection(t0, p0, p1, t1);
    if (intersection && $b60a95926cba5528$var$pointDistance(intersection, p0) < miterLimit) {
        outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
        return intersection;
    }
    return p0;
}
function $b60a95926cba5528$var$getIntersection(a, b) {
    const intersect = a.intersections(b);
    if (intersect.length && $b60a95926cba5528$var$floatEqual(intersect[0][0], 1)) intersect.shift();
    if (intersect.length) return intersect[0];
    return null;
}
function $b60a95926cba5528$var$pruneSegmentIntersection(a, b) {
    var outa = a.slice();
    var outb = b.slice();
    var intersect = $b60a95926cba5528$var$getIntersection(a[a.length - 1], b[0]);
    if (intersect) {
        outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
        outb[0] = b[0].split(intersect[1])[1];
    }
    if (a.length > 1 && b.length > 1) {
        intersect = $b60a95926cba5528$var$getIntersection(a[0], b[b.length - 1]);
        if (intersect) return [
            [
                a[0].split(intersect[0])[0]
            ],
            [
                b[b.length - 1].split(intersect[1])[1]
            ]
        ];
    }
    return [
        outa,
        outb
    ];
}
function $b60a95926cba5528$var$pruneIntersections(segments) {
    var e;
    for(var i = 1; i < segments.length; i += 1){
        e = $b60a95926cba5528$var$pruneSegmentIntersection(segments[i - 1], segments[i]);
        segments[i - 1] = e[0];
        segments[i] = e[1];
    }
    if (segments.length > 1) {
        e = $b60a95926cba5528$var$pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
        segments[segments.length - 1] = e[0];
        segments[0] = e[1];
    }
    return segments;
}
function $b60a95926cba5528$var$offsetSegmentSplit(segment, amount) {
    /*
    We split each bezier segment into smaller pieces based
    on inflection points, this ensures the control point
    polygon is convex.

    (A cubic bezier can have none, one, or two inflection points)
  */ var flex = segment.inflectionPoints();
    var left;
    var right;
    var split;
    var mid;
    if (flex.length === 0) return [
        $b60a95926cba5528$var$offsetSegment(segment, amount)
    ];
    if (flex.length === 1 || $b60a95926cba5528$var$floatEqual(flex[1], 1)) {
        split = segment.split(flex[0]);
        left = split[0];
        right = split[1];
        return [
            $b60a95926cba5528$var$offsetSegment(left, amount),
            $b60a95926cba5528$var$offsetSegment(right, amount)
        ];
    }
    split = segment.split(flex[0]);
    left = split[0];
    var t = (flex[1] - flex[0]) / (1 - flex[0]);
    split = split[1].split(t);
    mid = split[0];
    right = split[1];
    return [
        $b60a95926cba5528$var$offsetSegment(left, amount),
        $b60a95926cba5528$var$offsetSegment(mid, amount),
        $b60a95926cba5528$var$offsetSegment(right, amount)
    ];
}
function $b60a95926cba5528$var$OffsetPathModifier() {}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$ShapeModifier
], $b60a95926cba5528$var$OffsetPathModifier);
$b60a95926cba5528$var$OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
    this.getValue = this.processKeys;
    this.amount = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.a, 0, null, this);
    this.miterLimit = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.ml, 0, null, this);
    this.lineJoin = data.lj;
    this._isAnimated = this.amount.effectsSequence.length !== 0;
};
$b60a95926cba5528$var$OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
    var outputBezier = $b60a95926cba5528$var$shapePool.newElement();
    outputBezier.c = inputBezier.c;
    var count = inputBezier.length();
    if (!inputBezier.c) count -= 1;
    var i;
    var j;
    var segment;
    var multiSegments = [];
    for(i = 0; i < count; i += 1){
        segment = $b60a95926cba5528$var$PolynomialBezier.shapeSegment(inputBezier, i);
        multiSegments.push($b60a95926cba5528$var$offsetSegmentSplit(segment, amount));
    }
    if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
        segment = $b60a95926cba5528$var$PolynomialBezier.shapeSegmentInverted(inputBezier, i);
        multiSegments.push($b60a95926cba5528$var$offsetSegmentSplit(segment, amount));
    }
    multiSegments = $b60a95926cba5528$var$pruneIntersections(multiSegments);
    // Add bezier segments to the output and apply line joints
    var lastPoint = null;
    var lastSeg = null;
    for(i = 0; i < multiSegments.length; i += 1){
        var multiSegment = multiSegments[i];
        if (lastSeg) lastPoint = $b60a95926cba5528$var$joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
        lastSeg = multiSegment[multiSegment.length - 1];
        for(j = 0; j < multiSegment.length; j += 1){
            segment = multiSegment[j];
            if (lastPoint && $b60a95926cba5528$var$pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
            else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
            outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
            lastPoint = segment.points[3];
        }
    }
    if (multiSegments.length) $b60a95926cba5528$var$joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
    return outputBezier;
};
$b60a95926cba5528$var$OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amount = this.amount.v;
    var miterLimit = this.miterLimit.v;
    var lineJoin = this.lineJoin;
    if (amount !== 0) {
        var shapeData;
        var localShapeCollection;
        for(i = 0; i < len; i += 1){
            shapeData = this.shapes[i];
            localShapeCollection = shapeData.localShapeCollection;
            if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                localShapeCollection.releaseShapes();
                shapeData.shape._mdf = true;
                shapePaths = shapeData.shape.paths.shapes;
                jLen = shapeData.shape.paths._length;
                for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
            }
            shapeData.shape.paths = shapeData.localShapeCollection;
        }
    }
    if (!this.dynamicProperties.length) this._mdf = false;
};
function $b60a95926cba5528$var$getFontProperties(fontData) {
    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
    var fWeight = 'normal';
    var fStyle = 'normal';
    var len = styles.length;
    var styleName;
    for(var i = 0; i < len; i += 1){
        styleName = styles[i].toLowerCase();
        switch(styleName){
            case 'italic':
                fStyle = 'italic';
                break;
            case 'bold':
                fWeight = '700';
                break;
            case 'black':
                fWeight = '900';
                break;
            case 'medium':
                fWeight = '500';
                break;
            case 'regular':
            case 'normal':
                fWeight = '400';
                break;
            case 'light':
            case 'thin':
                fWeight = '200';
                break;
            default:
                break;
        }
    }
    return {
        style: fStyle,
        weight: fontData.fWeight || fWeight
    };
}
const $b60a95926cba5528$var$FontManager = function() {
    var maxWaitingTime = 5000;
    var emptyChar = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
            shapes: []
        }
    };
    var combinedCharacters = [];
    // Hindi characters
    combinedCharacters = combinedCharacters.concat([
        2304,
        2305,
        2306,
        2307,
        2362,
        2363,
        2364,
        2364,
        2366,
        2367,
        2368,
        2369,
        2370,
        2371,
        2372,
        2373,
        2374,
        2375,
        2376,
        2377,
        2378,
        2379,
        2380,
        2381,
        2382,
        2383,
        2387,
        2388,
        2389,
        2390,
        2391,
        2402,
        2403
    ]);
    var BLACK_FLAG_CODE_POINT = 127988;
    var CANCEL_TAG_CODE_POINT = 917631;
    var A_TAG_CODE_POINT = 917601;
    var Z_TAG_CODE_POINT = 917626;
    var VARIATION_SELECTOR_16_CODE_POINT = 65039;
    var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
    var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
    var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
    var surrogateModifiers = [
        'd83cdffb',
        'd83cdffc',
        'd83cdffd',
        'd83cdffe',
        'd83cdfff'
    ];
    function trimFontOptions(font) {
        var familyArray = font.split(',');
        var i;
        var len = familyArray.length;
        var enabledFamilies = [];
        for(i = 0; i < len; i += 1)if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') enabledFamilies.push(familyArray[i]);
        return enabledFamilies.join(',');
    }
    function setUpNode(font, family) {
        var parentNode = $b60a95926cba5528$var$createTag('span');
        // Node is invisible to screen readers.
        parentNode.setAttribute('aria-hidden', true);
        parentNode.style.fontFamily = family;
        var node = $b60a95926cba5528$var$createTag('span');
        // Characters that vary significantly among different fonts
        node.innerText = 'giItT1WQy@!-/#';
        // Visible - so we can measure it - but not on the screen
        parentNode.style.position = 'absolute';
        parentNode.style.left = '-10000px';
        parentNode.style.top = '-10000px';
        // Large font size makes even subtle changes obvious
        parentNode.style.fontSize = '300px';
        // Reset any font properties
        parentNode.style.fontVariant = 'normal';
        parentNode.style.fontStyle = 'normal';
        parentNode.style.fontWeight = 'normal';
        parentNode.style.letterSpacing = '0';
        parentNode.appendChild(node);
        document.body.appendChild(parentNode);
        // Remember width with no applied web font
        var width = node.offsetWidth;
        node.style.fontFamily = trimFontOptions(font) + ', ' + family;
        return {
            node: node,
            w: width,
            parent: parentNode
        };
    }
    function checkLoadedFonts() {
        var i;
        var len = this.fonts.length;
        var node;
        var w;
        var loadedCount = len;
        for(i = 0; i < len; i += 1){
            if (this.fonts[i].loaded) loadedCount -= 1;
            else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
            else {
                node = this.fonts[i].monoCase.node;
                w = this.fonts[i].monoCase.w;
                if (node.offsetWidth !== w) {
                    loadedCount -= 1;
                    this.fonts[i].loaded = true;
                } else {
                    node = this.fonts[i].sansCase.node;
                    w = this.fonts[i].sansCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    }
                }
                if (this.fonts[i].loaded) {
                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                }
            }
        }
        if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
        else setTimeout(this.setIsLoadedBinded, 10);
    }
    function createHelper(fontData, def) {
        var engine = document.body && def ? 'svg' : 'canvas';
        var helper;
        var fontProps = $b60a95926cba5528$var$getFontProperties(fontData);
        if (engine === 'svg') {
            var tHelper = $b60a95926cba5528$var$createNS('text');
            tHelper.style.fontSize = '100px';
            // tHelper.style.fontFamily = fontData.fFamily;
            tHelper.setAttribute('font-family', fontData.fFamily);
            tHelper.setAttribute('font-style', fontProps.style);
            tHelper.setAttribute('font-weight', fontProps.weight);
            tHelper.textContent = '1';
            if (fontData.fClass) {
                tHelper.style.fontFamily = 'inherit';
                tHelper.setAttribute('class', fontData.fClass);
            } else tHelper.style.fontFamily = fontData.fFamily;
            def.appendChild(tHelper);
            helper = tHelper;
        } else {
            var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
            tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
            helper = tCanvasHelper;
        }
        function measure(text) {
            if (engine === 'svg') {
                helper.textContent = text;
                return helper.getComputedTextLength();
            }
            return helper.measureText(text).width;
        }
        return {
            measureText: measure
        };
    }
    function addFonts(fontData, defs) {
        if (!fontData) {
            this.isLoaded = true;
            return;
        }
        if (this.chars) {
            this.isLoaded = true;
            this.fonts = fontData.list;
            return;
        }
        if (!document.body) {
            this.isLoaded = true;
            fontData.list.forEach((data)=>{
                data.helper = createHelper(data);
                data.cache = {};
            });
            this.fonts = fontData.list;
            return;
        }
        var fontArr = fontData.list;
        var i;
        var len = fontArr.length;
        var _pendingFonts = len;
        for(i = 0; i < len; i += 1){
            var shouldLoadFont = true;
            var loadedSelector;
            var j;
            fontArr[i].loaded = false;
            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
            if (!fontArr[i].fPath) {
                fontArr[i].loaded = true;
                _pendingFonts -= 1;
            } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
                loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                if (loadedSelector.length > 0) shouldLoadFont = false;
                if (shouldLoadFont) {
                    var s = $b60a95926cba5528$var$createTag('style');
                    s.setAttribute('f-forigin', fontArr[i].fOrigin);
                    s.setAttribute('f-origin', fontArr[i].origin);
                    s.setAttribute('f-family', fontArr[i].fFamily);
                    s.type = 'text/css';
                    s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                    defs.appendChild(s);
                }
            } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
                loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                shouldLoadFont = false;
                if (shouldLoadFont) {
                    var l = $b60a95926cba5528$var$createTag('link');
                    l.setAttribute('f-forigin', fontArr[i].fOrigin);
                    l.setAttribute('f-origin', fontArr[i].origin);
                    l.type = 'text/css';
                    l.rel = 'stylesheet';
                    l.href = fontArr[i].fPath;
                    document.body.appendChild(l);
                }
            } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
                loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                shouldLoadFont = false;
                if (shouldLoadFont) {
                    var sc = $b60a95926cba5528$var$createTag('link');
                    sc.setAttribute('f-forigin', fontArr[i].fOrigin);
                    sc.setAttribute('f-origin', fontArr[i].origin);
                    sc.setAttribute('rel', 'stylesheet');
                    sc.setAttribute('href', fontArr[i].fPath);
                    defs.appendChild(sc);
                }
            }
            fontArr[i].helper = createHelper(fontArr[i], defs);
            fontArr[i].cache = {};
            this.fonts.push(fontArr[i]);
        }
        if (_pendingFonts === 0) this.isLoaded = true;
        else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
        // Adding this timeout seems to fix it
        setTimeout(this.checkLoadedFonts.bind(this), 100);
    }
    function addChars(chars) {
        if (!chars) return;
        if (!this.chars) this.chars = [];
        var i;
        var len = chars.length;
        var j;
        var jLen = this.chars.length;
        var found;
        for(i = 0; i < len; i += 1){
            j = 0;
            found = false;
            while(j < jLen){
                if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                j += 1;
            }
            if (!found) {
                this.chars.push(chars[i]);
                jLen += 1;
            }
        }
    }
    function getCharData(char, style, font) {
        var i = 0;
        var len = this.chars.length;
        while(i < len){
            if (this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
            i += 1;
        }
        if ((typeof char === 'string' && char.charCodeAt(0) !== 13 || !char) && console && console.warn // eslint-disable-line no-console
         && !this._warned) {
            this._warned = true;
            console.warn('Missing character from exported characters list: ', char, style, font); // eslint-disable-line no-console
        }
        return emptyChar;
    }
    function measureText(char, fontName, size) {
        var fontData = this.getFontByName(fontName);
        // Using the char instead of char.charCodeAt(0)
        // to avoid collisions between equal chars
        var index = char;
        if (!fontData.cache[index]) {
            var tHelper = fontData.helper;
            if (char === ' ') {
                var doubleSize = tHelper.measureText('|' + char + '|');
                var singleSize = tHelper.measureText('||');
                fontData.cache[index] = (doubleSize - singleSize) / 100;
            } else fontData.cache[index] = tHelper.measureText(char) / 100;
        }
        return fontData.cache[index] * size;
    }
    function getFontByName(name) {
        var i = 0;
        var len = this.fonts.length;
        while(i < len){
            if (this.fonts[i].fName === name) return this.fonts[i];
            i += 1;
        }
        return this.fonts[0];
    }
    function getCodePoint(string) {
        var codePoint = 0;
        var first = string.charCodeAt(0);
        if (first >= 0xD800 && first <= 0xDBFF) {
            var second = string.charCodeAt(1);
            if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
        }
        return codePoint;
    }
    // Skin tone modifiers
    function isModifier(firstCharCode, secondCharCode) {
        var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
        return surrogateModifiers.indexOf(sum) !== -1;
    }
    function isZeroWidthJoiner(charCode) {
        return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
    }
    // This codepoint may change the appearance of the preceding character.
    // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
    // as a colorful image as compared to a monochrome text variant.
    function isVariationSelector(charCode) {
        return charCode === VARIATION_SELECTOR_16_CODE_POINT;
    }
    // The regional indicator symbols are a set of 26 alphabetic Unicode
    /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
    // two-letter country codes in a way that allows optional special treatment.
    function isRegionalCode(string) {
        var codePoint = getCodePoint(string);
        if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
        return false;
    }
    // Some Emoji implementations represent combinations of
    // two “regional indicator” letters as a single flag symbol.
    function isFlagEmoji(string) {
        return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
    }
    function isCombinedCharacter(char) {
        return combinedCharacters.indexOf(char) !== -1;
    }
    // Regional flags start with a BLACK_FLAG_CODE_POINT
    // folowed by 5 chars in the TAG range
    // and end with a CANCEL_TAG_CODE_POINT
    function isRegionalFlag(text, index) {
        var codePoint = getCodePoint(text.substr(index, 2));
        if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
        var count = 0;
        index += 2;
        while(count < 5){
            codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
            count += 1;
            index += 2;
        }
        return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
    }
    function setIsLoaded() {
        this.isLoaded = true;
    }
    var Font = function() {
        this.fonts = [];
        this.chars = null;
        this.typekitLoaded = 0;
        this.isLoaded = false;
        this._warned = false;
        this.initTime = Date.now();
        this.setIsLoadedBinded = this.setIsLoaded.bind(this);
        this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
    };
    Font.isModifier = isModifier;
    Font.isZeroWidthJoiner = isZeroWidthJoiner;
    Font.isFlagEmoji = isFlagEmoji;
    Font.isRegionalCode = isRegionalCode;
    Font.isCombinedCharacter = isCombinedCharacter;
    Font.isRegionalFlag = isRegionalFlag;
    Font.isVariationSelector = isVariationSelector;
    Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
    var fontPrototype = {
        addChars: addChars,
        addFonts: addFonts,
        getCharData: getCharData,
        getFontByName: getFontByName,
        measureText: measureText,
        checkLoadedFonts: checkLoadedFonts,
        setIsLoaded: setIsLoaded
    };
    Font.prototype = fontPrototype;
    return Font;
}();
function $b60a95926cba5528$var$SlotManager(animationData) {
    this.animationData = animationData;
}
$b60a95926cba5528$var$SlotManager.prototype.getProp = function(data) {
    if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
    return data;
};
function $b60a95926cba5528$var$slotFactory(animationData) {
    return new $b60a95926cba5528$var$SlotManager(animationData);
}
function $b60a95926cba5528$var$RenderableElement() {}
$b60a95926cba5528$var$RenderableElement.prototype = {
    initRenderable: function() {
        // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
        this.isInRange = false;
        // layer's display state
        this.hidden = false;
        // If layer's transparency equals 0, it can be hidden
        this.isTransparent = false;
        // list of animated components
        this.renderableComponents = [];
    },
    addRenderableComponent: function(component) {
        if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
    },
    removeRenderableComponent: function(component) {
        if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
    },
    prepareRenderableFrame: function(num) {
        this.checkLayerLimits(num);
    },
    checkTransparency: function() {
        if (this.finalTransform.mProp.o.v <= 0) {
            if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                this.isTransparent = true;
                this.hide();
            }
        } else if (this.isTransparent) {
            this.isTransparent = false;
            this.show();
        }
    },
    /**
     * @function
     * Initializes frame related properties.
     *
     * @param {number} num
     * current frame number in Layer's time
     *
     */ checkLayerLimits: function(num) {
        if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
            if (this.isInRange !== true) {
                this.globalData._mdf = true;
                this._mdf = true;
                this.isInRange = true;
                this.show();
            }
        } else if (this.isInRange !== false) {
            this.globalData._mdf = true;
            this.isInRange = false;
            this.hide();
        }
    },
    renderRenderable: function() {
        var i;
        var len = this.renderableComponents.length;
        for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
    /* this.maskManager.renderFrame(this.finalTransform.mat);
        this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
    sourceRectAtTime: function() {
        return {
            top: 0,
            left: 0,
            width: 100,
            height: 100
        };
    },
    getLayerSize: function() {
        if (this.data.ty === 5) return {
            w: this.data.textData.width,
            h: this.data.textData.height
        };
        return {
            w: this.data.width,
            h: this.data.height
        };
    }
};
const $b60a95926cba5528$var$getBlendMode = function() {
    var blendModeEnums = {
        0: 'source-over',
        1: 'multiply',
        2: 'screen',
        3: 'overlay',
        4: 'darken',
        5: 'lighten',
        6: 'color-dodge',
        7: 'color-burn',
        8: 'hard-light',
        9: 'soft-light',
        10: 'difference',
        11: 'exclusion',
        12: 'hue',
        13: 'saturation',
        14: 'color',
        15: 'luminosity'
    };
    return function(mode) {
        return blendModeEnums[mode] || '';
    };
}();
function $b60a95926cba5528$var$SliderEffect(data, elem, container) {
    this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function $b60a95926cba5528$var$AngleEffect(data, elem, container) {
    this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function $b60a95926cba5528$var$ColorEffect(data, elem, container) {
    this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.v, 1, 0, container);
}
function $b60a95926cba5528$var$PointEffect(data, elem, container) {
    this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.v, 1, 0, container);
}
function $b60a95926cba5528$var$LayerIndexEffect(data, elem, container) {
    this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function $b60a95926cba5528$var$MaskIndexEffect(data, elem, container) {
    this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function $b60a95926cba5528$var$CheckboxEffect(data, elem, container) {
    this.p = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.v, 0, 0, container);
}
function $b60a95926cba5528$var$NoValueEffect() {
    this.p = {};
}
function $b60a95926cba5528$var$EffectsManager(data, element) {
    var effects = data.ef || [];
    this.effectElements = [];
    var i;
    var len = effects.length;
    var effectItem;
    for(i = 0; i < len; i += 1){
        effectItem = new $b60a95926cba5528$var$GroupEffect(effects[i], element);
        this.effectElements.push(effectItem);
    }
}
function $b60a95926cba5528$var$GroupEffect(data, element) {
    this.init(data, element);
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$DynamicPropertyContainer
], $b60a95926cba5528$var$GroupEffect);
$b60a95926cba5528$var$GroupEffect.prototype.getValue = $b60a95926cba5528$var$GroupEffect.prototype.iterateDynamicProperties;
$b60a95926cba5528$var$GroupEffect.prototype.init = function(data, element) {
    this.data = data;
    this.effectElements = [];
    this.initDynamicPropertyContainer(element);
    var i;
    var len = this.data.ef.length;
    var eff;
    var effects = this.data.ef;
    for(i = 0; i < len; i += 1){
        eff = null;
        switch(effects[i].ty){
            case 0:
                eff = new $b60a95926cba5528$var$SliderEffect(effects[i], element, this);
                break;
            case 1:
                eff = new $b60a95926cba5528$var$AngleEffect(effects[i], element, this);
                break;
            case 2:
                eff = new $b60a95926cba5528$var$ColorEffect(effects[i], element, this);
                break;
            case 3:
                eff = new $b60a95926cba5528$var$PointEffect(effects[i], element, this);
                break;
            case 4:
            case 7:
                eff = new $b60a95926cba5528$var$CheckboxEffect(effects[i], element, this);
                break;
            case 10:
                eff = new $b60a95926cba5528$var$LayerIndexEffect(effects[i], element, this);
                break;
            case 11:
                eff = new $b60a95926cba5528$var$MaskIndexEffect(effects[i], element, this);
                break;
            case 5:
                eff = new $b60a95926cba5528$var$EffectsManager(effects[i], element, this);
                break;
            // case 6:
            default:
                eff = new $b60a95926cba5528$var$NoValueEffect(effects[i], element, this);
                break;
        }
        if (eff) this.effectElements.push(eff);
    }
};
function $b60a95926cba5528$var$BaseElement() {}
$b60a95926cba5528$var$BaseElement.prototype = {
    checkMasks: function() {
        if (!this.data.hasMask) return false;
        var i = 0;
        var len = this.data.masksProperties.length;
        while(i < len){
            if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) return true;
            i += 1;
        }
        return false;
    },
    initExpressions: function() {
        const expressionsInterfaces = $b60a95926cba5528$var$getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        const LayerExpressionInterface = expressionsInterfaces('layer');
        const EffectsExpressionInterface = expressionsInterfaces('effects');
        const ShapeExpressionInterface = expressionsInterfaces('shape');
        const TextExpressionInterface = expressionsInterfaces('text');
        const CompExpressionInterface = expressionsInterfaces('comp');
        this.layerInterface = LayerExpressionInterface(this);
        if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
        var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
        this.layerInterface.registerEffectsInterface(effectsInterface);
        if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
        else if (this.data.ty === 4) {
            this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
            this.layerInterface.content = this.layerInterface.shapeInterface;
        } else if (this.data.ty === 5) {
            this.layerInterface.textInterface = TextExpressionInterface(this);
            this.layerInterface.text = this.layerInterface.textInterface;
        }
    },
    setBlendMode: function() {
        var blendModeValue = $b60a95926cba5528$var$getBlendMode(this.data.bm);
        var elem = this.baseElement || this.layerElement;
        elem.style['mix-blend-mode'] = blendModeValue;
    },
    initBaseData: function(data, globalData, comp) {
        this.globalData = globalData;
        this.comp = comp;
        this.data = data;
        this.layerId = $b60a95926cba5528$var$createElementID();
        // Stretch factor for old animations missing this property.
        if (!this.data.sr) this.data.sr = 1;
        // effects manager
        this.effectsManager = new $b60a95926cba5528$var$EffectsManager(this.data, this, this.dynamicProperties);
    },
    getType: function() {
        return this.type;
    },
    sourceRectAtTime: function() {}
};
/**
 * @file
 * Handles element's layer frame update.
 * Checks layer in point and out point
 *
 */ function $b60a95926cba5528$var$FrameElement() {}
$b60a95926cba5528$var$FrameElement.prototype = {
    /**
     * @function
     * Initializes frame related properties.
     *
     */ initFrame: function() {
        // set to true when inpoint is rendered
        this._isFirstFrame = false;
        // list of animated properties
        this.dynamicProperties = [];
        // If layer has been modified in current tick this will be true
        this._mdf = false;
    },
    /**
     * @function
     * Calculates all dynamic values
     *
     * @param {number} num
     * current frame number in Layer's time
     * @param {boolean} isVisible
     * if layers is currently in range
     *
     */ prepareProperties: function(num, isVisible) {
        var i;
        var len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
            this.dynamicProperties[i].getValue();
            if (this.dynamicProperties[i]._mdf) {
                this.globalData._mdf = true;
                this._mdf = true;
            }
        }
    },
    addDynamicProperty: function(prop) {
        if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
    }
};
function $b60a95926cba5528$var$FootageElement(data, globalData, comp) {
    this.initFrame();
    this.initRenderable();
    this.assetData = globalData.getAssetData(data.refId);
    this.footageData = globalData.imageLoader.getAsset(this.assetData);
    this.initBaseData(data, globalData, comp);
}
$b60a95926cba5528$var$FootageElement.prototype.prepareFrame = function() {};
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$RenderableElement,
    $b60a95926cba5528$var$BaseElement,
    $b60a95926cba5528$var$FrameElement
], $b60a95926cba5528$var$FootageElement);
$b60a95926cba5528$var$FootageElement.prototype.getBaseElement = function() {
    return null;
};
$b60a95926cba5528$var$FootageElement.prototype.renderFrame = function() {};
$b60a95926cba5528$var$FootageElement.prototype.destroy = function() {};
$b60a95926cba5528$var$FootageElement.prototype.initExpressions = function() {
    const expressionsInterfaces = $b60a95926cba5528$var$getExpressionInterfaces();
    if (!expressionsInterfaces) return;
    const FootageInterface = expressionsInterfaces('footage');
    this.layerInterface = FootageInterface(this);
};
$b60a95926cba5528$var$FootageElement.prototype.getFootageData = function() {
    return this.footageData;
};
function $b60a95926cba5528$var$AudioElement(data, globalData, comp) {
    this.initFrame();
    this.initRenderable();
    this.assetData = globalData.getAssetData(data.refId);
    this.initBaseData(data, globalData, comp);
    this._isPlaying = false;
    this._canPlay = false;
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.audio = this.globalData.audioController.createAudio(assetPath);
    this._currentTime = 0;
    this.globalData.audioController.addAudio(this);
    this._volumeMultiplier = 1;
    this._volume = 1;
    this._previousVolume = null;
    this.tm = data.tm ? $b60a95926cba5528$var$PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
        _placeholder: true
    };
    this.lv = $b60a95926cba5528$var$PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
        k: [
            100
        ]
    }, 1, 0.01, this);
}
$b60a95926cba5528$var$AudioElement.prototype.prepareFrame = function(num) {
    this.prepareRenderableFrame(num, true);
    this.prepareProperties(num, true);
    if (!this.tm._placeholder) {
        var timeRemapped = this.tm.v;
        this._currentTime = timeRemapped;
    } else this._currentTime = num / this.data.sr;
    this._volume = this.lv.v[0];
    var totalVolume = this._volume * this._volumeMultiplier;
    if (this._previousVolume !== totalVolume) {
        this._previousVolume = totalVolume;
        this.audio.volume(totalVolume);
    }
};
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$RenderableElement,
    $b60a95926cba5528$var$BaseElement,
    $b60a95926cba5528$var$FrameElement
], $b60a95926cba5528$var$AudioElement);
$b60a95926cba5528$var$AudioElement.prototype.renderFrame = function() {
    if (this.isInRange && this._canPlay) {
        if (!this._isPlaying) {
            this.audio.play();
            this.audio.seek(this._currentTime / this.globalData.frameRate);
            this._isPlaying = true;
        } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
    }
};
$b60a95926cba5528$var$AudioElement.prototype.show = function() {
// this.audio.play()
};
$b60a95926cba5528$var$AudioElement.prototype.hide = function() {
    this.audio.pause();
    this._isPlaying = false;
};
$b60a95926cba5528$var$AudioElement.prototype.pause = function() {
    this.audio.pause();
    this._isPlaying = false;
    this._canPlay = false;
};
$b60a95926cba5528$var$AudioElement.prototype.resume = function() {
    this._canPlay = true;
};
$b60a95926cba5528$var$AudioElement.prototype.setRate = function(rateValue) {
    this.audio.rate(rateValue);
};
$b60a95926cba5528$var$AudioElement.prototype.volume = function(volumeValue) {
    this._volumeMultiplier = volumeValue;
    this._previousVolume = volumeValue * this._volume;
    this.audio.volume(this._previousVolume);
};
$b60a95926cba5528$var$AudioElement.prototype.getBaseElement = function() {
    return null;
};
$b60a95926cba5528$var$AudioElement.prototype.destroy = function() {};
$b60a95926cba5528$var$AudioElement.prototype.sourceRectAtTime = function() {};
$b60a95926cba5528$var$AudioElement.prototype.initExpressions = function() {};
function $b60a95926cba5528$var$BaseRenderer() {}
$b60a95926cba5528$var$BaseRenderer.prototype.checkLayers = function(num) {
    var i;
    var len = this.layers.length;
    var data;
    this.completeLayers = true;
    for(i = len - 1; i >= 0; i -= 1){
        if (!this.elements[i]) {
            data = this.layers[i];
            if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
        }
        this.completeLayers = this.elements[i] ? this.completeLayers : false;
    }
    this.checkPendingElements();
};
$b60a95926cba5528$var$BaseRenderer.prototype.createItem = function(layer) {
    switch(layer.ty){
        case 2:
            return this.createImage(layer);
        case 0:
            return this.createComp(layer);
        case 1:
            return this.createSolid(layer);
        case 3:
            return this.createNull(layer);
        case 4:
            return this.createShape(layer);
        case 5:
            return this.createText(layer);
        case 6:
            return this.createAudio(layer);
        case 13:
            return this.createCamera(layer);
        case 15:
            return this.createFootage(layer);
        default:
            return this.createNull(layer);
    }
};
$b60a95926cba5528$var$BaseRenderer.prototype.createCamera = function() {
    throw new Error('You\'re using a 3d camera. Try the html renderer.');
};
$b60a95926cba5528$var$BaseRenderer.prototype.createAudio = function(data) {
    return new $b60a95926cba5528$var$AudioElement(data, this.globalData, this);
};
$b60a95926cba5528$var$BaseRenderer.prototype.createFootage = function(data) {
    return new $b60a95926cba5528$var$FootageElement(data, this.globalData, this);
};
$b60a95926cba5528$var$BaseRenderer.prototype.buildAllItems = function() {
    var i;
    var len = this.layers.length;
    for(i = 0; i < len; i += 1)this.buildItem(i);
    this.checkPendingElements();
};
$b60a95926cba5528$var$BaseRenderer.prototype.includeLayers = function(newLayers) {
    this.completeLayers = false;
    var i;
    var len = newLayers.length;
    var j;
    var jLen = this.layers.length;
    for(i = 0; i < len; i += 1){
        j = 0;
        while(j < jLen){
            if (this.layers[j].id === newLayers[i].id) {
                this.layers[j] = newLayers[i];
                break;
            }
            j += 1;
        }
    }
};
$b60a95926cba5528$var$BaseRenderer.prototype.setProjectInterface = function(pInterface) {
    this.globalData.projectInterface = pInterface;
};
$b60a95926cba5528$var$BaseRenderer.prototype.initItems = function() {
    if (!this.globalData.progressiveLoad) this.buildAllItems();
};
$b60a95926cba5528$var$BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
    var elements = this.elements;
    var layers = this.layers;
    var i = 0;
    var len = layers.length;
    while(i < len){
        if (layers[i].ind == parentName) {
            if (!elements[i] || elements[i] === true) {
                this.buildItem(i);
                this.addPendingElement(element);
            } else {
                hierarchy.push(elements[i]);
                elements[i].setAsParent();
                if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                else element.setHierarchy(hierarchy);
            }
        }
        i += 1;
    }
};
$b60a95926cba5528$var$BaseRenderer.prototype.addPendingElement = function(element) {
    this.pendingElements.push(element);
};
$b60a95926cba5528$var$BaseRenderer.prototype.searchExtraCompositions = function(assets) {
    var i;
    var len = assets.length;
    for(i = 0; i < len; i += 1)if (assets[i].xt) {
        var comp = this.createComp(assets[i]);
        comp.initExpressions();
        this.globalData.projectInterface.registerComposition(comp);
    }
};
$b60a95926cba5528$var$BaseRenderer.prototype.getElementById = function(ind) {
    var i;
    var len = this.elements.length;
    for(i = 0; i < len; i += 1){
        if (this.elements[i].data.ind === ind) return this.elements[i];
    }
    return null;
};
$b60a95926cba5528$var$BaseRenderer.prototype.getElementByPath = function(path) {
    var pathValue = path.shift();
    var element;
    if (typeof pathValue === 'number') element = this.elements[pathValue];
    else {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
            element = this.elements[i];
            break;
        }
    }
    if (path.length === 0) return element;
    return element.getElementByPath(path);
};
$b60a95926cba5528$var$BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
    this.globalData.fontManager = new $b60a95926cba5528$var$FontManager();
    this.globalData.slotManager = $b60a95926cba5528$var$slotFactory(animData);
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.imageLoader = this.animationItem.imagePreloader;
    this.globalData.audioController = this.animationItem.audioController;
    this.globalData.frameId = 0;
    this.globalData.frameRate = animData.fr;
    this.globalData.nm = animData.nm;
    this.globalData.compSize = {
        w: animData.w,
        h: animData.h
    };
};
var $b60a95926cba5528$var$effectTypes = {
    TRANSFORM_EFFECT: 'transformEFfect'
};
function $b60a95926cba5528$var$TransformElement() {}
$b60a95926cba5528$var$TransformElement.prototype = {
    initTransform: function() {
        var mat = new $b60a95926cba5528$var$Matrix();
        this.finalTransform = {
            mProp: this.data.ks ? $b60a95926cba5528$var$TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                o: 0
            },
            _matMdf: false,
            _localMatMdf: false,
            _opMdf: false,
            mat: mat,
            localMat: mat,
            localOpacity: 1
        };
        if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
        // TODO: check TYPE 11: Guided elements
        this.data.ty;
    },
    renderTransform: function() {
        this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
        this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
        if (this.hierarchy) {
            var mat;
            var finalMat = this.finalTransform.mat;
            var i = 0;
            var len = this.hierarchy.length;
            // Checking if any of the transformation matrices in the hierarchy chain has changed.
            if (!this.finalTransform._matMdf) while(i < len){
                if (this.hierarchy[i].finalTransform.mProp._mdf) {
                    this.finalTransform._matMdf = true;
                    break;
                }
                i += 1;
            }
            if (this.finalTransform._matMdf) {
                mat = this.finalTransform.mProp.v.props;
                finalMat.cloneFromProps(mat);
                for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
            }
        }
        if (!this.localTransforms || this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
        if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
    },
    renderLocalTransform: function() {
        if (this.localTransforms) {
            var i = 0;
            var len = this.localTransforms.length;
            this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                    this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                    this.finalTransform._opMdf = true;
                }
                i += 1;
            }
            if (this.finalTransform._localMatMdf) {
                var localMat = this.finalTransform.localMat;
                this.localTransforms[0].matrix.clone(localMat);
                for(i = 1; i < len; i += 1){
                    var lmat = this.localTransforms[i].matrix;
                    localMat.multiply(lmat);
                }
                localMat.multiply(this.finalTransform.mat);
            }
            if (this.finalTransform._opMdf) {
                var localOp = this.finalTransform.localOpacity;
                for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                this.finalTransform.localOpacity = localOp;
            }
        }
    },
    searchEffectTransforms: function() {
        if (this.renderableEffectsManager) {
            var transformEffects = this.renderableEffectsManager.getEffects($b60a95926cba5528$var$effectTypes.TRANSFORM_EFFECT);
            if (transformEffects.length) {
                this.localTransforms = [];
                this.finalTransform.localMat = new $b60a95926cba5528$var$Matrix();
                var i = 0;
                var len = transformEffects.length;
                for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
            }
        }
    },
    globalToLocal: function(pt) {
        var transforms = [];
        transforms.push(this.finalTransform);
        var flag = true;
        var comp = this.comp;
        while(flag)if (comp.finalTransform) {
            if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
            comp = comp.comp;
        } else flag = false;
        var i;
        var len = transforms.length;
        var ptNew;
        for(i = 0; i < len; i += 1){
            ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
            // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
            pt = [
                pt[0] - ptNew[0],
                pt[1] - ptNew[1],
                0
            ];
        }
        return pt;
    },
    mHelper: new $b60a95926cba5528$var$Matrix()
};
function $b60a95926cba5528$var$MaskElement(data, element, globalData) {
    this.data = data;
    this.element = element;
    this.globalData = globalData;
    this.storedData = [];
    this.masksProperties = this.data.masksProperties || [];
    this.maskElement = null;
    var defs = this.globalData.defs;
    var i;
    var len = this.masksProperties ? this.masksProperties.length : 0;
    this.viewData = $b60a95926cba5528$var$createSizedArray(len);
    this.solidPath = '';
    var path;
    var properties = this.masksProperties;
    var count = 0;
    var currentMasks = [];
    var j;
    var jLen;
    var layerId = $b60a95926cba5528$var$createElementID();
    var rect;
    var expansor;
    var feMorph;
    var x;
    var maskType = 'clipPath';
    var maskRef = 'clip-path';
    for(i = 0; i < len; i += 1){
        if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
            maskType = 'mask';
            maskRef = 'mask';
        }
        if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
            rect = $b60a95926cba5528$var$createNS('rect');
            rect.setAttribute('fill', '#ffffff');
            rect.setAttribute('width', this.element.comp.data.w || 0);
            rect.setAttribute('height', this.element.comp.data.h || 0);
            currentMasks.push(rect);
        } else rect = null;
        path = $b60a95926cba5528$var$createNS('path');
        if (properties[i].mode === 'n') {
            // TODO move this to a factory or to a constructor
            this.viewData[i] = {
                op: $b60a95926cba5528$var$PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                prop: $b60a95926cba5528$var$ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                elem: path,
                lastPath: ''
            };
            defs.appendChild(path);
        } else {
            count += 1;
            path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
            path.setAttribute('clip-rule', 'nonzero');
            var filterID;
            if (properties[i].x.k !== 0) {
                maskType = 'mask';
                maskRef = 'mask';
                x = $b60a95926cba5528$var$PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                filterID = $b60a95926cba5528$var$createElementID();
                expansor = $b60a95926cba5528$var$createNS('filter');
                expansor.setAttribute('id', filterID);
                feMorph = $b60a95926cba5528$var$createNS('feMorphology');
                feMorph.setAttribute('operator', 'erode');
                feMorph.setAttribute('in', 'SourceGraphic');
                feMorph.setAttribute('radius', '0');
                expansor.appendChild(feMorph);
                defs.appendChild(expansor);
                path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
            } else {
                feMorph = null;
                x = null;
            }
            // TODO move this to a factory or to a constructor
            this.storedData[i] = {
                elem: path,
                x: x,
                expan: feMorph,
                lastPath: '',
                lastOperator: '',
                filterId: filterID,
                lastRadius: 0
            };
            if (properties[i].mode === 'i') {
                jLen = currentMasks.length;
                var g = $b60a95926cba5528$var$createNS('g');
                for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                var mask = $b60a95926cba5528$var$createNS('mask');
                mask.setAttribute('mask-type', 'alpha');
                mask.setAttribute('id', layerId + '_' + count);
                mask.appendChild(path);
                defs.appendChild(mask);
                g.setAttribute('mask', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + layerId + '_' + count + ')');
                currentMasks.length = 0;
                currentMasks.push(g);
            } else currentMasks.push(path);
            if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
            // TODO move this to a factory or to a constructor
            this.viewData[i] = {
                elem: path,
                lastPath: '',
                op: $b60a95926cba5528$var$PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                prop: $b60a95926cba5528$var$ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                invRect: rect
            };
            if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
        }
    }
    this.maskElement = $b60a95926cba5528$var$createNS(maskType);
    len = currentMasks.length;
    for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
    if (count > 0) {
        this.maskElement.setAttribute('id', layerId);
        this.element.maskedElement.setAttribute(maskRef, 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + layerId + ')');
        defs.appendChild(this.maskElement);
    }
    if (this.viewData.length) this.element.addRenderableComponent(this);
}
$b60a95926cba5528$var$MaskElement.prototype.getMaskProperty = function(pos) {
    return this.viewData[pos].prop;
};
$b60a95926cba5528$var$MaskElement.prototype.renderFrame = function(isFirstFrame) {
    var finalMat = this.element.finalTransform.mat;
    var i;
    var len = this.masksProperties.length;
    for(i = 0; i < len; i += 1){
        if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
        if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
        if (this.masksProperties[i].mode !== 'n') {
            if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
            if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                var feMorph = this.storedData[i].expan;
                if (this.storedData[i].x.v < 0) {
                    if (this.storedData[i].lastOperator !== 'erode') {
                        this.storedData[i].lastOperator = 'erode';
                        this.storedData[i].elem.setAttribute('filter', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + this.storedData[i].filterId + ')');
                    }
                    feMorph.setAttribute('radius', -this.storedData[i].x.v);
                } else {
                    if (this.storedData[i].lastOperator !== 'dilate') {
                        this.storedData[i].lastOperator = 'dilate';
                        this.storedData[i].elem.setAttribute('filter', null);
                    }
                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
                }
            }
        }
    }
};
$b60a95926cba5528$var$MaskElement.prototype.getMaskelement = function() {
    return this.maskElement;
};
$b60a95926cba5528$var$MaskElement.prototype.createLayerSolidPath = function() {
    var path = 'M0,0 ';
    path += ' h' + this.globalData.compSize.w;
    path += ' v' + this.globalData.compSize.h;
    path += ' h-' + this.globalData.compSize.w;
    path += ' v-' + this.globalData.compSize.h + ' ';
    return path;
};
$b60a95926cba5528$var$MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
    var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
    var i;
    var len;
    len = pathNodes._length;
    for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
    pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
    // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
    if (pathNodes.c && len > 1) pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
    // pathNodes.__renderedString = pathString;
    if (viewData.lastPath !== pathString) {
        var pathShapeValue = '';
        if (viewData.elem) {
            if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
            viewData.elem.setAttribute('d', pathShapeValue);
        }
        viewData.lastPath = pathString;
    }
};
$b60a95926cba5528$var$MaskElement.prototype.destroy = function() {
    this.element = null;
    this.globalData = null;
    this.maskElement = null;
    this.data = null;
    this.masksProperties = null;
};
const $b60a95926cba5528$var$filtersFactory = function() {
    var ob = {};
    ob.createFilter = createFilter;
    ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
    function createFilter(filId, skipCoordinates) {
        var fil = $b60a95926cba5528$var$createNS('filter');
        fil.setAttribute('id', filId);
        if (skipCoordinates !== true) {
            fil.setAttribute('filterUnits', 'objectBoundingBox');
            fil.setAttribute('x', '0%');
            fil.setAttribute('y', '0%');
            fil.setAttribute('width', '100%');
            fil.setAttribute('height', '100%');
        }
        return fil;
    }
    function createAlphaToLuminanceFilter() {
        var feColorMatrix = $b60a95926cba5528$var$createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
        return feColorMatrix;
    }
    return ob;
}();
const $b60a95926cba5528$var$featureSupport = function() {
    var ob = {
        maskType: true,
        svgLumaHidden: true,
        offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
    };
    if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
    if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
    return ob;
}();
var $b60a95926cba5528$var$registeredEffects = {};
var $b60a95926cba5528$var$idPrefix = 'filter_result_';
function $b60a95926cba5528$var$SVGEffects(elem) {
    var i;
    var source = 'SourceGraphic';
    var len = elem.data.ef ? elem.data.ef.length : 0;
    var filId = $b60a95926cba5528$var$createElementID();
    var fil = $b60a95926cba5528$var$filtersFactory.createFilter(filId, true);
    var count = 0;
    this.filters = [];
    var filterManager;
    for(i = 0; i < len; i += 1){
        filterManager = null;
        var type = elem.data.ef[i].ty;
        if ($b60a95926cba5528$var$registeredEffects[type]) {
            var Effect = $b60a95926cba5528$var$registeredEffects[type].effect;
            filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, $b60a95926cba5528$var$idPrefix + count, source);
            source = $b60a95926cba5528$var$idPrefix + count;
            if ($b60a95926cba5528$var$registeredEffects[type].countsAsEffect) count += 1;
        }
        if (filterManager) this.filters.push(filterManager);
    }
    if (count) {
        elem.globalData.defs.appendChild(fil);
        elem.layerElement.setAttribute('filter', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + filId + ')');
    }
    if (this.filters.length) elem.addRenderableComponent(this);
}
$b60a95926cba5528$var$SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
    var i;
    var len = this.filters.length;
    for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
};
$b60a95926cba5528$var$SVGEffects.prototype.getEffects = function(type) {
    var i;
    var len = this.filters.length;
    var effects = [];
    for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
    return effects;
};
function $b60a95926cba5528$var$registerEffect(id, effect, countsAsEffect) {
    $b60a95926cba5528$var$registeredEffects[id] = {
        effect: effect,
        countsAsEffect: countsAsEffect
    };
}
function $b60a95926cba5528$var$SVGBaseElement() {}
$b60a95926cba5528$var$SVGBaseElement.prototype = {
    initRendererElement: function() {
        this.layerElement = $b60a95926cba5528$var$createNS('g');
    },
    createContainerElements: function() {
        this.matteElement = $b60a95926cba5528$var$createNS('g');
        this.transformedElement = this.layerElement;
        this.maskedElement = this.layerElement;
        this._sizeChanged = false;
        var layerElementParent = null;
        // If this layer acts as a mask for the following layer
        if (this.data.td) {
            this.matteMasks = {};
            var gg = $b60a95926cba5528$var$createNS('g');
            gg.setAttribute('id', this.layerId);
            gg.appendChild(this.layerElement);
            layerElementParent = gg;
            this.globalData.defs.appendChild(gg);
        } else if (this.data.tt) {
            this.matteElement.appendChild(this.layerElement);
            layerElementParent = this.matteElement;
            this.baseElement = this.matteElement;
        } else this.baseElement = this.layerElement;
        if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
        if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
        // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
        if (this.data.ty === 0 && !this.data.hd) {
            var cp = $b60a95926cba5528$var$createNS('clipPath');
            var pt = $b60a95926cba5528$var$createNS('path');
            pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
            var clipId = $b60a95926cba5528$var$createElementID();
            cp.setAttribute('id', clipId);
            cp.appendChild(pt);
            this.globalData.defs.appendChild(cp);
            if (this.checkMasks()) {
                var cpGroup = $b60a95926cba5528$var$createNS('g');
                cpGroup.setAttribute('clip-path', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + clipId + ')');
                cpGroup.appendChild(this.layerElement);
                this.transformedElement = cpGroup;
                if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                else this.baseElement = this.transformedElement;
            } else this.layerElement.setAttribute('clip-path', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + clipId + ')');
        }
        if (this.data.bm !== 0) this.setBlendMode();
    },
    renderElement: function() {
        if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
        if (this.finalTransform._opMdf) this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
    },
    destroyBaseElement: function() {
        this.layerElement = null;
        this.matteElement = null;
        this.maskManager.destroy();
    },
    getBaseElement: function() {
        if (this.data.hd) return null;
        return this.baseElement;
    },
    createRenderableComponents: function() {
        this.maskManager = new $b60a95926cba5528$var$MaskElement(this.data, this, this.globalData);
        this.renderableEffectsManager = new $b60a95926cba5528$var$SVGEffects(this);
        this.searchEffectTransforms();
    },
    getMatte: function(matteType) {
        // This should not be a common case. But for backward compatibility, we'll create the matte object.
        // It solves animations that have two consecutive layers marked as matte masks.
        // Which is an undefined behavior in AE.
        if (!this.matteMasks) this.matteMasks = {};
        if (!this.matteMasks[matteType]) {
            var id = this.layerId + '_' + matteType;
            var filId;
            var fil;
            var useElement;
            var gg;
            if (matteType === 1 || matteType === 3) {
                var masker = $b60a95926cba5528$var$createNS('mask');
                masker.setAttribute('id', id);
                masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
                useElement = $b60a95926cba5528$var$createNS('use');
                useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                masker.appendChild(useElement);
                this.globalData.defs.appendChild(masker);
                if (!$b60a95926cba5528$var$featureSupport.maskType && matteType === 1) {
                    masker.setAttribute('mask-type', 'luminance');
                    filId = $b60a95926cba5528$var$createElementID();
                    fil = $b60a95926cba5528$var$filtersFactory.createFilter(filId);
                    this.globalData.defs.appendChild(fil);
                    fil.appendChild($b60a95926cba5528$var$filtersFactory.createAlphaToLuminanceFilter());
                    gg = $b60a95926cba5528$var$createNS('g');
                    gg.appendChild(useElement);
                    masker.appendChild(gg);
                    gg.setAttribute('filter', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + filId + ')');
                }
            } else if (matteType === 2) {
                var maskGroup = $b60a95926cba5528$var$createNS('mask');
                maskGroup.setAttribute('id', id);
                maskGroup.setAttribute('mask-type', 'alpha');
                var maskGrouper = $b60a95926cba5528$var$createNS('g');
                maskGroup.appendChild(maskGrouper);
                filId = $b60a95926cba5528$var$createElementID();
                fil = $b60a95926cba5528$var$filtersFactory.createFilter(filId);
                /// /
                var feCTr = $b60a95926cba5528$var$createNS('feComponentTransfer');
                feCTr.setAttribute('in', 'SourceGraphic');
                fil.appendChild(feCTr);
                var feFunc = $b60a95926cba5528$var$createNS('feFuncA');
                feFunc.setAttribute('type', 'table');
                feFunc.setAttribute('tableValues', '1.0 0.0');
                feCTr.appendChild(feFunc);
                /// /
                this.globalData.defs.appendChild(fil);
                var alphaRect = $b60a95926cba5528$var$createNS('rect');
                alphaRect.setAttribute('width', this.comp.data.w);
                alphaRect.setAttribute('height', this.comp.data.h);
                alphaRect.setAttribute('x', '0');
                alphaRect.setAttribute('y', '0');
                alphaRect.setAttribute('fill', '#ffffff');
                alphaRect.setAttribute('opacity', '0');
                maskGrouper.setAttribute('filter', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + filId + ')');
                maskGrouper.appendChild(alphaRect);
                useElement = $b60a95926cba5528$var$createNS('use');
                useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                maskGrouper.appendChild(useElement);
                if (!$b60a95926cba5528$var$featureSupport.maskType) {
                    maskGroup.setAttribute('mask-type', 'luminance');
                    fil.appendChild($b60a95926cba5528$var$filtersFactory.createAlphaToLuminanceFilter());
                    gg = $b60a95926cba5528$var$createNS('g');
                    maskGrouper.appendChild(alphaRect);
                    gg.appendChild(this.layerElement);
                    maskGrouper.appendChild(gg);
                }
                this.globalData.defs.appendChild(maskGroup);
            }
            this.matteMasks[matteType] = id;
        }
        return this.matteMasks[matteType];
    },
    setMatte: function(id) {
        if (!this.matteElement) return;
        this.matteElement.setAttribute('mask', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + id + ')');
    }
};
/**
 * @file
 * Handles AE's layer parenting property.
 *
 */ function $b60a95926cba5528$var$HierarchyElement() {}
$b60a95926cba5528$var$HierarchyElement.prototype = {
    /**
     * @function
     * Initializes hierarchy properties
     *
     */ initHierarchy: function() {
        // element's parent list
        this.hierarchy = [];
        // if element is parent of another layer _isParent will be true
        this._isParent = false;
        this.checkParenting();
    },
    /**
     * @function
     * Sets layer's hierarchy.
     * @param {array} hierarch
     * layer's parent list
     *
     */ setHierarchy: function(hierarchy) {
        this.hierarchy = hierarchy;
    },
    /**
     * @function
     * Sets layer as parent.
     *
     */ setAsParent: function() {
        this._isParent = true;
    },
    /**
     * @function
     * Searches layer's parenting chain
     *
     */ checkParenting: function() {
        if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
    }
};
function $b60a95926cba5528$var$RenderableDOMElement() {}
(function() {
    var _prototype = {
        initElement: function(data, globalData, comp) {
            this.initFrame();
            this.initBaseData(data, globalData, comp);
            this.initTransform(data, globalData, comp);
            this.initHierarchy();
            this.initRenderable();
            this.initRendererElement();
            this.createContainerElements();
            this.createRenderableComponents();
            this.createContent();
            this.hide();
        },
        hide: function() {
            // console.log('HIDE', this);
            if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                var elem = this.baseElement || this.layerElement;
                elem.style.display = 'none';
                this.hidden = true;
            }
        },
        show: function() {
            // console.log('SHOW', this);
            if (this.isInRange && !this.isTransparent) {
                if (!this.data.hd) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = 'block';
                }
                this.hidden = false;
                this._isFirstFrame = true;
            }
        },
        renderFrame: function() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        renderInnerContent: function() {},
        prepareFrame: function(num) {
            this._mdf = false;
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
            this.checkTransparency();
        },
        destroy: function() {
            this.innerElem = null;
            this.destroyBaseElement();
        }
    };
    $b60a95926cba5528$var$extendPrototype([
        $b60a95926cba5528$var$RenderableElement,
        $b60a95926cba5528$var$createProxyFunction(_prototype)
    ], $b60a95926cba5528$var$RenderableDOMElement);
})();
function $b60a95926cba5528$var$IImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);
    if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
    this.initElement(data, globalData, comp);
    this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
    };
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$BaseElement,
    $b60a95926cba5528$var$TransformElement,
    $b60a95926cba5528$var$SVGBaseElement,
    $b60a95926cba5528$var$HierarchyElement,
    $b60a95926cba5528$var$FrameElement,
    $b60a95926cba5528$var$RenderableDOMElement
], $b60a95926cba5528$var$IImageElement);
$b60a95926cba5528$var$IImageElement.prototype.createContent = function() {
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.innerElem = $b60a95926cba5528$var$createNS('image');
    this.innerElem.setAttribute('width', this.assetData.w + 'px');
    this.innerElem.setAttribute('height', this.assetData.h + 'px');
    this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
    this.layerElement.appendChild(this.innerElem);
};
$b60a95926cba5528$var$IImageElement.prototype.sourceRectAtTime = function() {
    return this.sourceRect;
};
function $b60a95926cba5528$var$ProcessedElement(element, position) {
    this.elem = element;
    this.pos = position;
}
function $b60a95926cba5528$var$IShapeElement() {}
$b60a95926cba5528$var$IShapeElement.prototype = {
    addShapeToModifiers: function(data) {
        var i;
        var len = this.shapeModifiers.length;
        for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
    },
    isShapeInAnimatedModifiers: function(data) {
        var i = 0;
        var len = this.shapeModifiers.length;
        while(i < len){
            if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
        }
        return false;
    },
    renderModifiers: function() {
        if (!this.shapeModifiers.length) return;
        var i;
        var len = this.shapes.length;
        for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
        len = this.shapeModifiers.length;
        var shouldBreakProcess;
        for(i = len - 1; i >= 0; i -= 1){
            shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame);
            // workaround to fix cases where a repeater resets the shape so the following processes get called twice
            // TODO: find a better solution for this
            if (shouldBreakProcess) break;
        }
    },
    searchProcessedElement: function(elem) {
        var elements = this.processedElements;
        var i = 0;
        var len = elements.length;
        while(i < len){
            if (elements[i].elem === elem) return elements[i].pos;
            i += 1;
        }
        return 0;
    },
    addProcessedElement: function(elem, pos) {
        var elements = this.processedElements;
        var i = elements.length;
        while(i){
            i -= 1;
            if (elements[i].elem === elem) {
                elements[i].pos = pos;
                return;
            }
        }
        elements.push(new $b60a95926cba5528$var$ProcessedElement(elem, pos));
    },
    prepareFrame: function(num) {
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    }
};
const $b60a95926cba5528$var$lineCapEnum = {
    1: 'butt',
    2: 'round',
    3: 'square'
};
const $b60a95926cba5528$var$lineJoinEnum = {
    1: 'miter',
    2: 'round',
    3: 'bevel'
};
function $b60a95926cba5528$var$SVGShapeData(transformers, level, shape) {
    this.caches = [];
    this.styles = [];
    this.transformers = transformers;
    this.lStr = '';
    this.sh = shape;
    this.lvl = level;
    // TODO find if there are some cases where _isAnimated can be false.
    // For now, since shapes add up with other shapes. They have to be calculated every time.
    // One way of finding out is checking if all styles associated to this shape depend only of this shape
    this._isAnimated = !!shape.k;
    // TODO: commenting this for now since all shapes are animated
    var i = 0;
    var len = transformers.length;
    while(i < len){
        if (transformers[i].mProps.dynamicProperties.length) {
            this._isAnimated = true;
            break;
        }
        i += 1;
    }
}
$b60a95926cba5528$var$SVGShapeData.prototype.setAsAnimated = function() {
    this._isAnimated = true;
};
function $b60a95926cba5528$var$SVGStyleData(data, level) {
    this.data = data;
    this.type = data.ty;
    this.d = '';
    this.lvl = level;
    this._mdf = false;
    this.closed = data.hd === true;
    this.pElem = $b60a95926cba5528$var$createNS('path');
    this.msElem = null;
}
$b60a95926cba5528$var$SVGStyleData.prototype.reset = function() {
    this.d = '';
    this._mdf = false;
};
function $b60a95926cba5528$var$DashProperty(elem, data, renderer, container) {
    this.elem = elem;
    this.frameId = -1;
    this.dataProps = $b60a95926cba5528$var$createSizedArray(data.length);
    this.renderer = renderer;
    this.k = false;
    this.dashStr = '';
    this.dashArray = $b60a95926cba5528$var$createTypedArray('float32', data.length ? data.length - 1 : 0);
    this.dashoffset = $b60a95926cba5528$var$createTypedArray('float32', 1);
    this.initDynamicPropertyContainer(container);
    var i;
    var len = data.length || 0;
    var prop;
    for(i = 0; i < len; i += 1){
        prop = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
        this.k = prop.k || this.k;
        this.dataProps[i] = {
            n: data[i].n,
            p: prop
        };
    }
    if (!this.k) this.getValue(true);
    this._isAnimated = this.k;
}
$b60a95926cba5528$var$DashProperty.prototype.getValue = function(forceRender) {
    if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
    this.frameId = this.elem.globalData.frameId;
    this.iterateDynamicProperties();
    this._mdf = this._mdf || forceRender;
    if (this._mdf) {
        var i = 0;
        var len = this.dataProps.length;
        if (this.renderer === 'svg') this.dashStr = '';
        for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== 'o') {
            if (this.renderer === 'svg') this.dashStr += ' ' + this.dataProps[i].p.v;
            else this.dashArray[i] = this.dataProps[i].p.v;
        } else this.dashoffset[0] = this.dataProps[i].p.v;
    }
};
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$DynamicPropertyContainer
], $b60a95926cba5528$var$DashProperty);
function $b60a95926cba5528$var$SVGStrokeStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.o = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.w = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.w, 0, null, this);
    this.d = new $b60a95926cba5528$var$DashProperty(elem, data.d || {}, 'svg', this);
    this.c = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.c, 1, 255, this);
    this.style = styleOb;
    this._isAnimated = !!this._isAnimated;
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$DynamicPropertyContainer
], $b60a95926cba5528$var$SVGStrokeStyleData);
function $b60a95926cba5528$var$SVGFillStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.o = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.c = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.c, 1, 255, this);
    this.style = styleOb;
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$DynamicPropertyContainer
], $b60a95926cba5528$var$SVGFillStyleData);
function $b60a95926cba5528$var$SVGNoStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.style = styleOb;
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$DynamicPropertyContainer
], $b60a95926cba5528$var$SVGNoStyleData);
function $b60a95926cba5528$var$GradientProperty(elem, data, container) {
    this.data = data;
    this.c = $b60a95926cba5528$var$createTypedArray('uint8c', data.p * 4);
    var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
    this.o = $b60a95926cba5528$var$createTypedArray('float32', cLength);
    this._cmdf = false;
    this._omdf = false;
    this._collapsable = this.checkCollapsable();
    this._hasOpacity = cLength;
    this.initDynamicPropertyContainer(container);
    this.prop = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.k, 1, null, this);
    this.k = this.prop.k;
    this.getValue(true);
}
$b60a95926cba5528$var$GradientProperty.prototype.comparePoints = function(values, points) {
    var i = 0;
    var len = this.o.length / 2;
    var diff;
    while(i < len){
        diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
        if (diff > 0.01) return false;
        i += 1;
    }
    return true;
};
$b60a95926cba5528$var$GradientProperty.prototype.checkCollapsable = function() {
    if (this.o.length / 2 !== this.c.length / 4) return false;
    if (this.data.k.k[0].s) {
        var i = 0;
        var len = this.data.k.k.length;
        while(i < len){
            if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
            i += 1;
        }
    } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
    return true;
};
$b60a95926cba5528$var$GradientProperty.prototype.getValue = function(forceRender) {
    this.prop.getValue();
    this._mdf = false;
    this._cmdf = false;
    this._omdf = false;
    if (this.prop._mdf || forceRender) {
        var i;
        var len = this.data.p * 4;
        var mult;
        var val;
        for(i = 0; i < len; i += 1){
            mult = i % 4 === 0 ? 100 : 255;
            val = Math.round(this.prop.v[i] * mult);
            if (this.c[i] !== val) {
                this.c[i] = val;
                this._cmdf = !forceRender;
            }
        }
        if (this.o.length) {
            len = this.prop.v.length;
            for(i = this.data.p * 4; i < len; i += 1){
                mult = i % 2 === 0 ? 100 : 1;
                val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                if (this.o[i - this.data.p * 4] !== val) {
                    this.o[i - this.data.p * 4] = val;
                    this._omdf = !forceRender;
                }
            }
        }
        this._mdf = !forceRender;
    }
};
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$DynamicPropertyContainer
], $b60a95926cba5528$var$GradientProperty);
function $b60a95926cba5528$var$SVGGradientFillStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.initGradientData(elem, data, styleOb);
}
$b60a95926cba5528$var$SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
    this.o = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.s = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.s, 1, null, this);
    this.e = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.e, 1, null, this);
    this.h = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.h || {
        k: 0
    }, 0, 0.01, this);
    this.a = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.a || {
        k: 0
    }, 0, $b60a95926cba5528$var$degToRads, this);
    this.g = new $b60a95926cba5528$var$GradientProperty(elem, data.g, this);
    this.style = styleOb;
    this.stops = [];
    this.setGradientData(styleOb.pElem, data);
    this.setGradientOpacity(data, styleOb);
    this._isAnimated = !!this._isAnimated;
};
$b60a95926cba5528$var$SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
    var gradientId = $b60a95926cba5528$var$createElementID();
    var gfill = $b60a95926cba5528$var$createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
    gfill.setAttribute('id', gradientId);
    gfill.setAttribute('spreadMethod', 'pad');
    gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
    var stops = [];
    var stop;
    var j;
    var jLen;
    jLen = data.g.p * 4;
    for(j = 0; j < jLen; j += 4){
        stop = $b60a95926cba5528$var$createNS('stop');
        gfill.appendChild(stop);
        stops.push(stop);
    }
    pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + gradientId + ')');
    this.gf = gfill;
    this.cst = stops;
};
$b60a95926cba5528$var$SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
    if (this.g._hasOpacity && !this.g._collapsable) {
        var stop;
        var j;
        var jLen;
        var mask = $b60a95926cba5528$var$createNS('mask');
        var maskElement = $b60a95926cba5528$var$createNS('path');
        mask.appendChild(maskElement);
        var opacityId = $b60a95926cba5528$var$createElementID();
        var maskId = $b60a95926cba5528$var$createElementID();
        mask.setAttribute('id', maskId);
        var opFill = $b60a95926cba5528$var$createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
        opFill.setAttribute('id', opacityId);
        opFill.setAttribute('spreadMethod', 'pad');
        opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
        jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
        var stops = this.stops;
        for(j = data.g.p * 4; j < jLen; j += 2){
            stop = $b60a95926cba5528$var$createNS('stop');
            stop.setAttribute('stop-color', 'rgb(255,255,255)');
            opFill.appendChild(stop);
            stops.push(stop);
        }
        maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + opacityId + ')');
        if (data.ty === 'gs') {
            maskElement.setAttribute('stroke-linecap', $b60a95926cba5528$var$lineCapEnum[data.lc || 2]);
            maskElement.setAttribute('stroke-linejoin', $b60a95926cba5528$var$lineJoinEnum[data.lj || 2]);
            if (data.lj === 1) maskElement.setAttribute('stroke-miterlimit', data.ml);
        }
        this.of = opFill;
        this.ms = mask;
        this.ost = stops;
        this.maskId = maskId;
        styleOb.msElem = maskElement;
    }
};
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$DynamicPropertyContainer
], $b60a95926cba5528$var$SVGGradientFillStyleData);
function $b60a95926cba5528$var$SVGGradientStrokeStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.w = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.w, 0, null, this);
    this.d = new $b60a95926cba5528$var$DashProperty(elem, data.d || {}, 'svg', this);
    this.initGradientData(elem, data, styleOb);
    this._isAnimated = !!this._isAnimated;
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$SVGGradientFillStyleData,
    $b60a95926cba5528$var$DynamicPropertyContainer
], $b60a95926cba5528$var$SVGGradientStrokeStyleData);
function $b60a95926cba5528$var$ShapeGroupData() {
    this.it = [];
    this.prevViewData = [];
    this.gr = $b60a95926cba5528$var$createNS('g');
}
function $b60a95926cba5528$var$SVGTransformData(mProps, op, container) {
    this.transform = {
        mProps: mProps,
        op: op,
        container: container
    };
    this.elements = [];
    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
}
const $b60a95926cba5528$var$buildShapeString = function(pathNodes, length, closed, mat) {
    if (length === 0) return '';
    var _o = pathNodes.o;
    var _i = pathNodes.i;
    var _v = pathNodes.v;
    var i;
    var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
    for(i = 1; i < length; i += 1)shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
    if (closed && length) {
        shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        shapeString += 'z';
    }
    return shapeString;
};
const $b60a95926cba5528$var$SVGElementsRenderer = function() {
    var _identityMatrix = new $b60a95926cba5528$var$Matrix();
    var _matrixHelper = new $b60a95926cba5528$var$Matrix();
    var ob = {
        createRenderFunction: createRenderFunction
    };
    function createRenderFunction(data) {
        switch(data.ty){
            case 'fl':
                return renderFill;
            case 'gf':
                return renderGradient;
            case 'gs':
                return renderGradientStroke;
            case 'st':
                return renderStroke;
            case 'sh':
            case 'el':
            case 'rc':
            case 'sr':
                return renderPath;
            case 'tr':
                return renderContentTransform;
            case 'no':
                return renderNoop;
            default:
                return null;
        }
    }
    function renderContentTransform(styleData, itemData, isFirstFrame) {
        if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
        if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
    }
    function renderNoop() {}
    function renderPath(styleData, itemData, isFirstFrame) {
        var j;
        var jLen;
        var pathStringTransformed;
        var redraw;
        var pathNodes;
        var l;
        var lLen = itemData.styles.length;
        var lvl = itemData.lvl;
        var paths;
        var mat;
        var iterations;
        var k;
        for(l = 0; l < lLen; l += 1){
            redraw = itemData.sh._mdf || isFirstFrame;
            if (itemData.styles[l].lvl < lvl) {
                mat = _matrixHelper.reset();
                iterations = lvl - itemData.styles[l].lvl;
                k = itemData.transformers.length - 1;
                while(!redraw && iterations > 0){
                    redraw = itemData.transformers[k].mProps._mdf || redraw;
                    iterations -= 1;
                    k -= 1;
                }
                if (redraw) {
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(iterations > 0){
                        mat.multiply(itemData.transformers[k].mProps.v);
                        iterations -= 1;
                        k -= 1;
                    }
                }
            } else mat = _identityMatrix;
            paths = itemData.sh.paths;
            jLen = paths._length;
            if (redraw) {
                pathStringTransformed = '';
                for(j = 0; j < jLen; j += 1){
                    pathNodes = paths.shapes[j];
                    if (pathNodes && pathNodes._length) pathStringTransformed += $b60a95926cba5528$var$buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                }
                itemData.caches[l] = pathStringTransformed;
            } else pathStringTransformed = itemData.caches[l];
            itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
            itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
        }
    }
    function renderFill(styleData, itemData, isFirstFrame) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill', 'rgb(' + $b60a95926cba5528$var$bmFloor(itemData.c.v[0]) + ',' + $b60a95926cba5528$var$bmFloor(itemData.c.v[1]) + ',' + $b60a95926cba5528$var$bmFloor(itemData.c.v[2]) + ')');
        if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
    }
    function renderGradientStroke(styleData, itemData, isFirstFrame) {
        renderGradient(styleData, itemData, isFirstFrame);
        renderStroke(styleData, itemData, isFirstFrame);
    }
    function renderGradient(styleData, itemData, isFirstFrame) {
        var gfill = itemData.gf;
        var hasOpacity = itemData.g._hasOpacity;
        var pt1 = itemData.s.v;
        var pt2 = itemData.e.v;
        if (itemData.o._mdf || isFirstFrame) {
            var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
            itemData.style.pElem.setAttribute(attr, itemData.o.v);
        }
        if (itemData.s._mdf || isFirstFrame) {
            var attr1 = styleData.t === 1 ? 'x1' : 'cx';
            var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
            gfill.setAttribute(attr1, pt1[0]);
            gfill.setAttribute(attr2, pt1[1]);
            if (hasOpacity && !itemData.g._collapsable) {
                itemData.of.setAttribute(attr1, pt1[0]);
                itemData.of.setAttribute(attr2, pt1[1]);
            }
        }
        var stops;
        var i;
        var len;
        var stop;
        if (itemData.g._cmdf || isFirstFrame) {
            stops = itemData.cst;
            var cValues = itemData.g.c;
            len = stops.length;
            for(i = 0; i < len; i += 1){
                stop = stops[i];
                stop.setAttribute('offset', cValues[i * 4] + '%');
                stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
            }
        }
        if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
            var oValues = itemData.g.o;
            if (itemData.g._collapsable) stops = itemData.cst;
            else stops = itemData.ost;
            len = stops.length;
            for(i = 0; i < len; i += 1){
                stop = stops[i];
                if (!itemData.g._collapsable) stop.setAttribute('offset', oValues[i * 2] + '%');
                stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
            }
        }
        if (styleData.t === 1) {
            if (itemData.e._mdf || isFirstFrame) {
                gfill.setAttribute('x2', pt2[0]);
                gfill.setAttribute('y2', pt2[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute('x2', pt2[0]);
                    itemData.of.setAttribute('y2', pt2[1]);
                }
            }
        } else {
            var rad;
            if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                gfill.setAttribute('r', rad);
                if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute('r', rad);
            }
            if (itemData.s._mdf || itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                var percent = itemData.h.v;
                if (percent >= 1) percent = 0.99;
                else if (percent <= -1) percent = -0.99;
                var dist = rad * percent;
                var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                gfill.setAttribute('fx', x);
                gfill.setAttribute('fy', y);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute('fx', x);
                    itemData.of.setAttribute('fy', y);
                }
            }
        // gfill.setAttribute('fy','200');
        }
    }
    function renderStroke(styleData, itemData, isFirstFrame) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || isFirstFrame) && d.dashStr) {
            styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
            styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
        }
        if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute('stroke', 'rgb(' + $b60a95926cba5528$var$bmFloor(itemData.c.v[0]) + ',' + $b60a95926cba5528$var$bmFloor(itemData.c.v[1]) + ',' + $b60a95926cba5528$var$bmFloor(itemData.c.v[2]) + ')');
        if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
        if (itemData.w._mdf || isFirstFrame) {
            styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
            if (styleElem.msElem) styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
        }
    }
    return ob;
}();
function $b60a95926cba5528$var$SVGShapeElement(data, globalData, comp) {
    // List of drawable elements
    this.shapes = [];
    // Full shape data
    this.shapesData = data.shapes;
    // List of styles that will be applied to shapes
    this.stylesList = [];
    // List of modifiers that will be applied to shapes
    this.shapeModifiers = [];
    // List of items in shape tree
    this.itemsData = [];
    // List of items in previous shape tree
    this.processedElements = [];
    // List of animated components
    this.animatedContents = [];
    this.initElement(data, globalData, comp);
    // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    // List of elements that have been created
    this.prevViewData = [];
// Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$BaseElement,
    $b60a95926cba5528$var$TransformElement,
    $b60a95926cba5528$var$SVGBaseElement,
    $b60a95926cba5528$var$IShapeElement,
    $b60a95926cba5528$var$HierarchyElement,
    $b60a95926cba5528$var$FrameElement,
    $b60a95926cba5528$var$RenderableDOMElement
], $b60a95926cba5528$var$SVGShapeElement);
$b60a95926cba5528$var$SVGShapeElement.prototype.initSecondaryElement = function() {};
$b60a95926cba5528$var$SVGShapeElement.prototype.identityMatrix = new $b60a95926cba5528$var$Matrix();
$b60a95926cba5528$var$SVGShapeElement.prototype.buildExpressionInterface = function() {};
$b60a95926cba5528$var$SVGShapeElement.prototype.createContent = function() {
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
    this.filterUniqueShapes();
};
/*
This method searches for multiple shapes that affect a single element and one of them is animated
*/ $b60a95926cba5528$var$SVGShapeElement.prototype.filterUniqueShapes = function() {
    var i;
    var len = this.shapes.length;
    var shape;
    var j;
    var jLen = this.stylesList.length;
    var style;
    var tempShapes = [];
    var areAnimated = false;
    for(j = 0; j < jLen; j += 1){
        style = this.stylesList[j];
        areAnimated = false;
        tempShapes.length = 0;
        for(i = 0; i < len; i += 1){
            shape = this.shapes[i];
            if (shape.styles.indexOf(style) !== -1) {
                tempShapes.push(shape);
                areAnimated = shape._isAnimated || areAnimated;
            }
        }
        if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
    }
};
$b60a95926cba5528$var$SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
    var i;
    var len = shapes.length;
    for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
};
$b60a95926cba5528$var$SVGShapeElement.prototype.createStyleElement = function(data, level) {
    // TODO: prevent drawing of hidden styles
    var elementData;
    var styleOb = new $b60a95926cba5528$var$SVGStyleData(data, level);
    var pathElement = styleOb.pElem;
    if (data.ty === 'st') elementData = new $b60a95926cba5528$var$SVGStrokeStyleData(this, data, styleOb);
    else if (data.ty === 'fl') elementData = new $b60a95926cba5528$var$SVGFillStyleData(this, data, styleOb);
    else if (data.ty === 'gf' || data.ty === 'gs') {
        var GradientConstructor = data.ty === 'gf' ? $b60a95926cba5528$var$SVGGradientFillStyleData : $b60a95926cba5528$var$SVGGradientStrokeStyleData;
        elementData = new GradientConstructor(this, data, styleOb);
        this.globalData.defs.appendChild(elementData.gf);
        if (elementData.maskId) {
            this.globalData.defs.appendChild(elementData.ms);
            this.globalData.defs.appendChild(elementData.of);
            pathElement.setAttribute('mask', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + elementData.maskId + ')');
        }
    } else if (data.ty === 'no') elementData = new $b60a95926cba5528$var$SVGNoStyleData(this, data, styleOb);
    if (data.ty === 'st' || data.ty === 'gs') {
        pathElement.setAttribute('stroke-linecap', $b60a95926cba5528$var$lineCapEnum[data.lc || 2]);
        pathElement.setAttribute('stroke-linejoin', $b60a95926cba5528$var$lineJoinEnum[data.lj || 2]);
        pathElement.setAttribute('fill-opacity', '0');
        if (data.lj === 1) pathElement.setAttribute('stroke-miterlimit', data.ml);
    }
    if (data.r === 2) pathElement.setAttribute('fill-rule', 'evenodd');
    if (data.ln) pathElement.setAttribute('id', data.ln);
    if (data.cl) pathElement.setAttribute('class', data.cl);
    if (data.bm) pathElement.style['mix-blend-mode'] = $b60a95926cba5528$var$getBlendMode(data.bm);
    this.stylesList.push(styleOb);
    this.addToAnimatedContents(data, elementData);
    return elementData;
};
$b60a95926cba5528$var$SVGShapeElement.prototype.createGroupElement = function(data) {
    var elementData = new $b60a95926cba5528$var$ShapeGroupData();
    if (data.ln) elementData.gr.setAttribute('id', data.ln);
    if (data.cl) elementData.gr.setAttribute('class', data.cl);
    if (data.bm) elementData.gr.style['mix-blend-mode'] = $b60a95926cba5528$var$getBlendMode(data.bm);
    return elementData;
};
$b60a95926cba5528$var$SVGShapeElement.prototype.createTransformElement = function(data, container) {
    var transformProperty = $b60a95926cba5528$var$TransformPropertyFactory.getTransformProperty(this, data, this);
    var elementData = new $b60a95926cba5528$var$SVGTransformData(transformProperty, transformProperty.o, container);
    this.addToAnimatedContents(data, elementData);
    return elementData;
};
$b60a95926cba5528$var$SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
    var ty = 4;
    if (data.ty === 'rc') ty = 5;
    else if (data.ty === 'el') ty = 6;
    else if (data.ty === 'sr') ty = 7;
    var shapeProperty = $b60a95926cba5528$var$ShapePropertyFactory.getShapeProp(this, data, ty, this);
    var elementData = new $b60a95926cba5528$var$SVGShapeData(ownTransformers, level, shapeProperty);
    this.shapes.push(elementData);
    this.addShapeToModifiers(elementData);
    this.addToAnimatedContents(data, elementData);
    return elementData;
};
$b60a95926cba5528$var$SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
    var i = 0;
    var len = this.animatedContents.length;
    while(i < len){
        if (this.animatedContents[i].element === element) return;
        i += 1;
    }
    this.animatedContents.push({
        fn: $b60a95926cba5528$var$SVGElementsRenderer.createRenderFunction(data),
        element: element,
        data: data
    });
};
$b60a95926cba5528$var$SVGShapeElement.prototype.setElementStyles = function(elementData) {
    var arr = elementData.styles;
    var j;
    var jLen = this.stylesList.length;
    for(j = 0; j < jLen; j += 1)if (arr.indexOf(this.stylesList[j]) === -1 && !this.stylesList[j].closed) arr.push(this.stylesList[j]);
};
$b60a95926cba5528$var$SVGShapeElement.prototype.reloadShapes = function() {
    this._isFirstFrame = true;
    var i;
    var len = this.itemsData.length;
    for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
    this.filterUniqueShapes();
    len = this.dynamicProperties.length;
    for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
    this.renderModifiers();
};
$b60a95926cba5528$var$SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
    var ownTransformers = [].concat(transformers);
    var i;
    var len = arr.length - 1;
    var j;
    var jLen;
    var ownStyles = [];
    var ownModifiers = [];
    var currentTransform;
    var modifier;
    var processedPos;
    for(i = len; i >= 0; i -= 1){
        processedPos = this.searchProcessedElement(arr[i]);
        if (!processedPos) arr[i]._render = render;
        else itemsData[i] = prevViewData[processedPos - 1];
        if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
            if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
            else itemsData[i].style.closed = arr[i].hd;
            if (arr[i]._render) {
                if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
            }
            ownStyles.push(itemsData[i].style);
        } else if (arr[i].ty === 'gr') {
            if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
            else {
                jLen = itemsData[i].it.length;
                for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
            }
            this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
            if (arr[i]._render) {
                if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
            }
        } else if (arr[i].ty === 'tr') {
            if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
            currentTransform = itemsData[i].transform;
            ownTransformers.push(currentTransform);
        } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
            if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
            this.setElementStyles(itemsData[i]);
        } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
            if (!processedPos) {
                modifier = $b60a95926cba5528$var$ShapeModifiers.getModifier(arr[i].ty);
                modifier.init(this, arr[i]);
                itemsData[i] = modifier;
                this.shapeModifiers.push(modifier);
            } else {
                modifier = itemsData[i];
                modifier.closed = false;
            }
            ownModifiers.push(modifier);
        } else if (arr[i].ty === 'rp') {
            if (!processedPos) {
                modifier = $b60a95926cba5528$var$ShapeModifiers.getModifier(arr[i].ty);
                itemsData[i] = modifier;
                modifier.init(this, arr, i, itemsData);
                this.shapeModifiers.push(modifier);
                render = false;
            } else {
                modifier = itemsData[i];
                modifier.closed = true;
            }
            ownModifiers.push(modifier);
        }
        this.addProcessedElement(arr[i], i + 1);
    }
    len = ownStyles.length;
    for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
    len = ownModifiers.length;
    for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
};
$b60a95926cba5528$var$SVGShapeElement.prototype.renderInnerContent = function() {
    this.renderModifiers();
    var i;
    var len = this.stylesList.length;
    for(i = 0; i < len; i += 1)this.stylesList[i].reset();
    this.renderShape();
    for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
        if (this.stylesList[i].msElem) {
            this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
            // Adding M0 0 fixes same mask bug on all browsers
            this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
        }
        this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
    }
};
$b60a95926cba5528$var$SVGShapeElement.prototype.renderShape = function() {
    var i;
    var len = this.animatedContents.length;
    var animatedContent;
    for(i = 0; i < len; i += 1){
        animatedContent = this.animatedContents[i];
        if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
    }
};
$b60a95926cba5528$var$SVGShapeElement.prototype.destroy = function() {
    this.destroyBaseElement();
    this.shapesData = null;
    this.itemsData = null;
};
function $b60a95926cba5528$var$LetterProps(o, sw, sc, fc, m, p) {
    this.o = o;
    this.sw = sw;
    this.sc = sc;
    this.fc = fc;
    this.m = m;
    this.p = p;
    this._mdf = {
        o: true,
        sw: !!sw,
        sc: !!sc,
        fc: !!fc,
        m: true,
        p: true
    };
}
$b60a95926cba5528$var$LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
    this._mdf.o = false;
    this._mdf.sw = false;
    this._mdf.sc = false;
    this._mdf.fc = false;
    this._mdf.m = false;
    this._mdf.p = false;
    var updated = false;
    if (this.o !== o) {
        this.o = o;
        this._mdf.o = true;
        updated = true;
    }
    if (this.sw !== sw) {
        this.sw = sw;
        this._mdf.sw = true;
        updated = true;
    }
    if (this.sc !== sc) {
        this.sc = sc;
        this._mdf.sc = true;
        updated = true;
    }
    if (this.fc !== fc) {
        this.fc = fc;
        this._mdf.fc = true;
        updated = true;
    }
    if (this.m !== m) {
        this.m = m;
        this._mdf.m = true;
        updated = true;
    }
    if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
        this.p = p;
        this._mdf.p = true;
        updated = true;
    }
    return updated;
};
function $b60a95926cba5528$var$TextProperty(elem, data) {
    this._frameId = $b60a95926cba5528$var$initialDefaultFrame;
    this.pv = '';
    this.v = '';
    this.kf = false;
    this._isFirstFrame = true;
    this._mdf = false;
    if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
    this.data = data;
    this.elem = elem;
    this.comp = this.elem.comp;
    this.keysIndex = 0;
    this.canResize = false;
    this.minimumFontSize = 1;
    this.effectsSequence = [];
    this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: '',
        fStyle: '',
        fWeight: '',
        fc: '',
        j: '',
        justifyOffset: '',
        l: [],
        lh: 0,
        lineWidths: [],
        ls: '',
        of: '',
        s: '',
        sc: '',
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: false,
        strokeColorAnim: false,
        strokeWidthAnim: false,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: false
    };
    this.copyData(this.currentData, this.data.d.k[0].s);
    if (!this.searchProperty()) this.completeTextData(this.currentData);
}
$b60a95926cba5528$var$TextProperty.prototype.defaultBoxWidth = [
    0,
    0
];
$b60a95926cba5528$var$TextProperty.prototype.copyData = function(obj, data) {
    for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
    return obj;
};
$b60a95926cba5528$var$TextProperty.prototype.setCurrentData = function(data) {
    if (!data.__complete) this.completeTextData(data);
    this.currentData = data;
    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
    this._mdf = true;
};
$b60a95926cba5528$var$TextProperty.prototype.searchProperty = function() {
    return this.searchKeyframes();
};
$b60a95926cba5528$var$TextProperty.prototype.searchKeyframes = function() {
    this.kf = this.data.d.k.length > 1;
    if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
    return this.kf;
};
$b60a95926cba5528$var$TextProperty.prototype.addEffect = function(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.elem.addDynamicProperty(this);
};
$b60a95926cba5528$var$TextProperty.prototype.getValue = function(_finalValue) {
    if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
    var currentValue = this.currentData;
    var currentIndex = this.keysIndex;
    if (this.lock) {
        this.setCurrentData(this.currentData);
        return;
    }
    this.lock = true;
    this._mdf = false;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
    for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
    if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
    else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
    if (currentValue !== finalValue) this.setCurrentData(finalValue);
    this.v = this.currentData;
    this.pv = this.v;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
};
$b60a95926cba5528$var$TextProperty.prototype.getKeyframeValue = function() {
    var textKeys = this.data.d.k;
    var frameNum = this.elem.comp.renderedFrame;
    var i = 0;
    var len = textKeys.length;
    while(i <= len - 1){
        if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
        i += 1;
    }
    if (this.keysIndex !== i) this.keysIndex = i;
    return this.data.d.k[this.keysIndex].s;
};
$b60a95926cba5528$var$TextProperty.prototype.buildFinalText = function(text) {
    var charactersArray = [];
    var i = 0;
    var len = text.length;
    var charCode;
    var secondCharCode;
    var shouldCombine = false;
    var shouldCombineNext = false;
    var currentChars = '';
    while(i < len){
        shouldCombine = shouldCombineNext;
        shouldCombineNext = false;
        charCode = text.charCodeAt(i);
        currentChars = text.charAt(i);
        if ($b60a95926cba5528$var$FontManager.isCombinedCharacter(charCode)) shouldCombine = true;
        else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
            if ($b60a95926cba5528$var$FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
            else {
                secondCharCode = text.charCodeAt(i + 1);
                // It's a surrogate pair (this is the Low surrogate)
                if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                    if ($b60a95926cba5528$var$FontManager.isModifier(charCode, secondCharCode)) {
                        currentChars = text.substr(i, 2);
                        shouldCombine = true;
                    } else if ($b60a95926cba5528$var$FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                    else currentChars = text.substr(i, 2);
                }
            }
        } else if (charCode > 0xDBFF) {
            secondCharCode = text.charCodeAt(i + 1);
            if ($b60a95926cba5528$var$FontManager.isVariationSelector(charCode)) shouldCombine = true;
        } else if ($b60a95926cba5528$var$FontManager.isZeroWidthJoiner(charCode)) {
            shouldCombine = true;
            shouldCombineNext = true;
        }
        if (shouldCombine) {
            charactersArray[charactersArray.length - 1] += currentChars;
            shouldCombine = false;
        } else charactersArray.push(currentChars);
        i += currentChars.length;
    }
    return charactersArray;
};
$b60a95926cba5528$var$TextProperty.prototype.completeTextData = function(documentData) {
    documentData.__complete = true;
    var fontManager = this.elem.globalData.fontManager;
    var data = this.data;
    var letters = [];
    var i;
    var len;
    var newLineFlag;
    var index = 0;
    var val;
    var anchorGrouping = data.m.g;
    var currentSize = 0;
    var currentPos = 0;
    var currentLine = 0;
    var lineWidths = [];
    var lineWidth = 0;
    var maxLineWidth = 0;
    var j;
    var jLen;
    var fontData = fontManager.getFontByName(documentData.f);
    var charData;
    var cLength = 0;
    var fontProps = $b60a95926cba5528$var$getFontProperties(fontData);
    documentData.fWeight = fontProps.weight;
    documentData.fStyle = fontProps.style;
    documentData.finalSize = documentData.s;
    documentData.finalText = this.buildFinalText(documentData.t);
    len = documentData.finalText.length;
    documentData.finalLineHeight = documentData.lh;
    var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
    var charCode;
    if (documentData.sz) {
        var flag = true;
        var boxWidth = documentData.sz[0];
        var boxHeight = documentData.sz[1];
        var currentHeight;
        var finalText;
        while(flag){
            finalText = this.buildFinalText(documentData.t);
            currentHeight = 0;
            lineWidth = 0;
            len = finalText.length;
            trackingOffset = documentData.tr / 1000 * documentData.finalSize;
            var lastSpaceIndex = -1;
            for(i = 0; i < len; i += 1){
                charCode = finalText[i].charCodeAt(0);
                newLineFlag = false;
                if (finalText[i] === ' ') lastSpaceIndex = i;
                else if (charCode === 13 || charCode === 3) {
                    lineWidth = 0;
                    newLineFlag = true;
                    currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                }
                if (fontManager.chars) {
                    charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                    cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
                    if (lastSpaceIndex === -1) len += 1;
                    else i = lastSpaceIndex;
                    currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r');
                    // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                    lastSpaceIndex = -1;
                    lineWidth = 0;
                } else {
                    lineWidth += cLength;
                    lineWidth += trackingOffset;
                }
            }
            currentHeight += fontData.ascent * documentData.finalSize / 100;
            if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                documentData.finalSize -= 1;
                documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
            } else {
                documentData.finalText = finalText;
                len = documentData.finalText.length;
                flag = false;
            }
        }
    }
    lineWidth = -trackingOffset;
    cLength = 0;
    var uncollapsedSpaces = 0;
    var currentChar;
    for(i = 0; i < len; i += 1){
        newLineFlag = false;
        currentChar = documentData.finalText[i];
        charCode = currentChar.charCodeAt(0);
        if (charCode === 13 || charCode === 3) {
            uncollapsedSpaces = 0;
            lineWidths.push(lineWidth);
            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
            lineWidth = -2 * trackingOffset;
            val = '';
            newLineFlag = true;
            currentLine += 1;
        } else val = currentChar;
        if (fontManager.chars) {
            charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
            cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
        } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
        // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
        cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
        //
        if (currentChar === ' ') uncollapsedSpaces += cLength + trackingOffset;
        else {
            lineWidth += cLength + trackingOffset + uncollapsedSpaces;
            uncollapsedSpaces = 0;
        }
        letters.push({
            l: cLength,
            an: cLength,
            add: currentSize,
            n: newLineFlag,
            anIndexes: [],
            val: val,
            line: currentLine,
            animatorJustifyOffset: 0
        });
        if (anchorGrouping == 2) {
            currentSize += cLength;
            if (val === '' || val === ' ' || i === len - 1) {
                if (val === '' || val === ' ') currentSize -= cLength;
                while(currentPos <= i){
                    letters[currentPos].an = currentSize;
                    letters[currentPos].ind = index;
                    letters[currentPos].extra = cLength;
                    currentPos += 1;
                }
                index += 1;
                currentSize = 0;
            }
        } else if (anchorGrouping == 3) {
            currentSize += cLength;
            if (val === '' || i === len - 1) {
                if (val === '') currentSize -= cLength;
                while(currentPos <= i){
                    letters[currentPos].an = currentSize;
                    letters[currentPos].ind = index;
                    letters[currentPos].extra = cLength;
                    currentPos += 1;
                }
                currentSize = 0;
                index += 1;
            }
        } else {
            letters[index].ind = index;
            letters[index].extra = 0;
            index += 1;
        }
    }
    documentData.l = letters;
    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
    lineWidths.push(lineWidth);
    if (documentData.sz) {
        documentData.boxWidth = documentData.sz[0];
        documentData.justifyOffset = 0;
    } else {
        documentData.boxWidth = maxLineWidth;
        switch(documentData.j){
            case 1:
                documentData.justifyOffset = -documentData.boxWidth;
                break;
            case 2:
                documentData.justifyOffset = -documentData.boxWidth / 2;
                break;
            default:
                documentData.justifyOffset = 0;
        }
    }
    documentData.lineWidths = lineWidths;
    var animators = data.a;
    var animatorData;
    var letterData;
    jLen = animators.length;
    var based;
    var ind;
    var indexes = [];
    for(j = 0; j < jLen; j += 1){
        animatorData = animators[j];
        if (animatorData.a.sc) documentData.strokeColorAnim = true;
        if (animatorData.a.sw) documentData.strokeWidthAnim = true;
        if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
        ind = 0;
        based = animatorData.s.b;
        for(i = 0; i < len; i += 1){
            letterData = letters[i];
            letterData.anIndexes[j] = ind;
            if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                if (animatorData.s.rn === 1) indexes.push(ind);
                ind += 1;
            }
        }
        data.a[j].s.totalChars = ind;
        var currentInd = -1;
        var newInd;
        if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
            letterData = letters[i];
            if (currentInd != letterData.anIndexes[j]) {
                currentInd = letterData.anIndexes[j];
                newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
            }
            letterData.anIndexes[j] = newInd;
        }
    }
    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
    documentData.ls = documentData.ls || 0;
    documentData.ascent = fontData.ascent * documentData.finalSize / 100;
};
$b60a95926cba5528$var$TextProperty.prototype.updateDocumentData = function(newData, index) {
    index = index === undefined ? this.keysIndex : index;
    var dData = this.copyData({}, this.data.d.k[index].s);
    dData = this.copyData(dData, newData);
    this.data.d.k[index].s = dData;
    this.recalculate(index);
    this.setCurrentData(dData);
    this.elem.addDynamicProperty(this);
};
$b60a95926cba5528$var$TextProperty.prototype.recalculate = function(index) {
    var dData = this.data.d.k[index].s;
    dData.__complete = false;
    this.keysIndex = 0;
    this._isFirstFrame = true;
    this.getValue(dData);
};
$b60a95926cba5528$var$TextProperty.prototype.canResizeFont = function(_canResize) {
    this.canResize = _canResize;
    this.recalculate(this.keysIndex);
    this.elem.addDynamicProperty(this);
};
$b60a95926cba5528$var$TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
    this.minimumFontSize = Math.floor(_fontValue) || 1;
    this.recalculate(this.keysIndex);
    this.elem.addDynamicProperty(this);
};
const $b60a95926cba5528$var$TextSelectorProp = function() {
    var max = Math.max;
    var min = Math.min;
    var floor = Math.floor;
    function TextSelectorPropFactory(elem, data) {
        this._currentTextLength = -1;
        this.k = false;
        this.data = data;
        this.elem = elem;
        this.comp = elem.comp;
        this.finalS = 0;
        this.finalE = 0;
        this.initDynamicPropertyContainer(elem);
        this.s = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.s || {
            k: 0
        }, 0, 0, this);
        if ('e' in data) this.e = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.e, 0, 0, this);
        else this.e = {
            v: 100
        };
        this.o = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.o || {
            k: 0
        }, 0, 0, this);
        this.xe = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.xe || {
            k: 0
        }, 0, 0, this);
        this.ne = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.ne || {
            k: 0
        }, 0, 0, this);
        this.sm = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.sm || {
            k: 100
        }, 0, 0, this);
        this.a = $b60a95926cba5528$var$PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
        if (!this.dynamicProperties.length) this.getValue();
    }
    TextSelectorPropFactory.prototype = {
        getMult: function(ind) {
            if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
            var x1 = 0;
            var y1 = 0;
            var x2 = 1;
            var y2 = 1;
            if (this.ne.v > 0) x1 = this.ne.v / 100.0;
            else y1 = -this.ne.v / 100.0;
            if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
            else y2 = 1.0 + this.xe.v / 100.0;
            var easer = $b60a95926cba5528$var$BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
            var mult = 0;
            var s = this.finalS;
            var e = this.finalE;
            var type = this.data.sh;
            if (type === 2) {
                if (e === s) mult = ind >= e ? 1 : 0;
                else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                mult = easer(mult);
            } else if (type === 3) {
                if (e === s) mult = ind >= e ? 0 : 1;
                else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                mult = easer(mult);
            } else if (type === 4) {
                if (e === s) mult = 0;
                else {
                    mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    if (mult < 0.5) mult *= 2;
                    else mult = 1 - 2 * (mult - 0.5);
                }
                mult = easer(mult);
            } else if (type === 5) {
                if (e === s) mult = 0;
                else {
                    var tot = e - s;
                    /* ind += 0.5;
                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                    var x = -tot / 2 + ind;
                    var a = tot / 2;
                    mult = Math.sqrt(1 - x * x / (a * a));
                }
                mult = easer(mult);
            } else if (type === 6) {
                if (e === s) mult = 0;
                else {
                    ind = min(max(0, ind + 0.5 - s), e - s);
                    mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                }
                mult = easer(mult);
            } else {
                if (ind >= floor(s)) {
                    if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                    else mult = max(0, min(e - ind, 1));
                }
                mult = easer(mult);
            }
            // Smoothness implementation.
            // The smoothness represents a reduced range of the original [0; 1] range.
            // if smoothness is 25%, the new range will be [0.375; 0.625]
            // Steps are:
            // - find the lower value of the new range (threshold)
            // - if multiplier is smaller than that value, floor it to 0
            // - if it is larger,
            //     - subtract the threshold
            //     - divide it by the smoothness (this will return the range to [0; 1])
            // Note: If it doesn't work on some scenarios, consider applying it before the easer.
            if (this.sm.v !== 100) {
                var smoothness = this.sm.v * 0.01;
                if (smoothness === 0) smoothness = 0.00000001;
                var threshold = 0.5 - smoothness * 0.5;
                if (mult < threshold) mult = 0;
                else {
                    mult = (mult - threshold) / smoothness;
                    if (mult > 1) mult = 1;
                }
            }
            return mult * this.a.v;
        },
        getValue: function(newCharsFlag) {
            this.iterateDynamicProperties();
            this._mdf = newCharsFlag || this._mdf;
            this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
            if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
            var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
            var o = this.o.v / divisor;
            var s = this.s.v / divisor + o;
            var e = this.e.v / divisor + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            this.finalS = s;
            this.finalE = e;
        }
    };
    $b60a95926cba5528$var$extendPrototype([
        $b60a95926cba5528$var$DynamicPropertyContainer
    ], TextSelectorPropFactory);
    function getTextSelectorProp(elem, data, arr) {
        return new TextSelectorPropFactory(elem, data, arr);
    }
    return {
        getTextSelectorProp: getTextSelectorProp
    };
}();
function $b60a95926cba5528$var$TextAnimatorDataProperty(elem, animatorProps, container) {
    var defaultData = {
        propType: false
    };
    var getProp = $b60a95926cba5528$var$PropertyFactory.getProp;
    var textAnimatorAnimatables = animatorProps.a;
    this.a = {
        r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, $b60a95926cba5528$var$degToRads, container) : defaultData,
        rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, $b60a95926cba5528$var$degToRads, container) : defaultData,
        ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, $b60a95926cba5528$var$degToRads, container) : defaultData,
        sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, $b60a95926cba5528$var$degToRads, container) : defaultData,
        sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, $b60a95926cba5528$var$degToRads, container) : defaultData,
        s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
        a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
        o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
        p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
        sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
        sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
        fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
        fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
        fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
        fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
        t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
    };
    this.s = $b60a95926cba5528$var$TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
    this.s.t = animatorProps.s.t;
}
function $b60a95926cba5528$var$TextAnimatorProperty(textData, renderType, elem) {
    this._isFirstFrame = true;
    this._hasMaskedPath = false;
    this._frameId = -1;
    this._textData = textData;
    this._renderType = renderType;
    this._elem = elem;
    this._animatorsData = $b60a95926cba5528$var$createSizedArray(this._textData.a.length);
    this._pathData = {};
    this._moreOptions = {
        alignment: {}
    };
    this.renderedLetters = [];
    this.lettersChangedFlag = false;
    this.initDynamicPropertyContainer(elem);
}
$b60a95926cba5528$var$TextAnimatorProperty.prototype.searchProperties = function() {
    var i;
    var len = this._textData.a.length;
    var animatorProps;
    var getProp = $b60a95926cba5528$var$PropertyFactory.getProp;
    for(i = 0; i < len; i += 1){
        animatorProps = this._textData.a[i];
        this._animatorsData[i] = new $b60a95926cba5528$var$TextAnimatorDataProperty(this._elem, animatorProps, this);
    }
    if (this._textData.p && 'm' in this._textData.p) {
        this._pathData = {
            a: getProp(this._elem, this._textData.p.a, 0, 0, this),
            f: getProp(this._elem, this._textData.p.f, 0, 0, this),
            l: getProp(this._elem, this._textData.p.l, 0, 0, this),
            r: getProp(this._elem, this._textData.p.r, 0, 0, this),
            p: getProp(this._elem, this._textData.p.p, 0, 0, this),
            m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
        };
        this._hasMaskedPath = true;
    } else this._hasMaskedPath = false;
    this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
};
$b60a95926cba5528$var$TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
    this.lettersChangedFlag = lettersChangedFlag;
    if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
    this._isFirstFrame = false;
    var alignment = this._moreOptions.alignment.v;
    var animators = this._animatorsData;
    var textData = this._textData;
    var matrixHelper = this.mHelper;
    var renderType = this._renderType;
    var renderedLettersCount = this.renderedLetters.length;
    var xPos;
    var yPos;
    var i;
    var len;
    var letters = documentData.l;
    var pathInfo;
    var currentLength;
    var currentPoint;
    var segmentLength;
    var flag;
    var pointInd;
    var segmentInd;
    var prevPoint;
    var points;
    var segments;
    var partialLength;
    var totalLength;
    var perc;
    var tanAngle;
    var mask;
    if (this._hasMaskedPath) {
        mask = this._pathData.m;
        if (!this._pathData.n || this._pathData._mdf) {
            var paths = mask.v;
            if (this._pathData.r.v) paths = paths.reverse();
            // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
            pathInfo = {
                tLength: 0,
                segments: []
            };
            len = paths._length - 1;
            var bezierData;
            totalLength = 0;
            for(i = 0; i < len; i += 1){
                bezierData = $b60a95926cba5528$var$bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                    paths.o[i][0] - paths.v[i][0],
                    paths.o[i][1] - paths.v[i][1]
                ], [
                    paths.i[i + 1][0] - paths.v[i + 1][0],
                    paths.i[i + 1][1] - paths.v[i + 1][1]
                ]);
                pathInfo.tLength += bezierData.segmentLength;
                pathInfo.segments.push(bezierData);
                totalLength += bezierData.segmentLength;
            }
            i = len;
            if (mask.v.c) {
                bezierData = $b60a95926cba5528$var$bez.buildBezierData(paths.v[i], paths.v[0], [
                    paths.o[i][0] - paths.v[i][0],
                    paths.o[i][1] - paths.v[i][1]
                ], [
                    paths.i[0][0] - paths.v[0][0],
                    paths.i[0][1] - paths.v[0][1]
                ]);
                pathInfo.tLength += bezierData.segmentLength;
                pathInfo.segments.push(bezierData);
                totalLength += bezierData.segmentLength;
            }
            this._pathData.pi = pathInfo;
        }
        pathInfo = this._pathData.pi;
        currentLength = this._pathData.f.v;
        segmentInd = 0;
        pointInd = 1;
        segmentLength = 0;
        flag = true;
        segments = pathInfo.segments;
        if (currentLength < 0 && mask.v.c) {
            if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
            segmentInd = segments.length - 1;
            points = segments[segmentInd].points;
            pointInd = points.length - 1;
            while(currentLength < 0){
                currentLength += points[pointInd].partialLength;
                pointInd -= 1;
                if (pointInd < 0) {
                    segmentInd -= 1;
                    points = segments[segmentInd].points;
                    pointInd = points.length - 1;
                }
            }
        }
        points = segments[segmentInd].points;
        prevPoint = points[pointInd - 1];
        currentPoint = points[pointInd];
        partialLength = currentPoint.partialLength;
    }
    len = letters.length;
    xPos = 0;
    yPos = 0;
    var yOff = documentData.finalSize * 1.2 * 0.714;
    var firstLine = true;
    var animatorProps;
    var animatorSelector;
    var j;
    var jLen;
    var letterValue;
    jLen = animators.length;
    var mult;
    var ind = -1;
    var offf;
    var xPathPos;
    var yPathPos;
    var initPathPos = currentLength;
    var initSegmentInd = segmentInd;
    var initPointInd = pointInd;
    var currentLine = -1;
    var elemOpacity;
    var sc;
    var sw;
    var fc;
    var k;
    var letterSw;
    var letterSc;
    var letterFc;
    var letterM = '';
    var letterP = this.defaultPropsArray;
    var letterO;
    //
    if (documentData.j === 2 || documentData.j === 1) {
        var animatorJustifyOffset = 0;
        var animatorFirstCharOffset = 0;
        var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
        var lastIndex = 0;
        var isNewLine = true;
        for(i = 0; i < len; i += 1)if (letters[i].n) {
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
            animatorJustifyOffset = 0;
            isNewLine = true;
        } else {
            for(j = 0; j < jLen; j += 1){
                animatorProps = animators[j].a;
                if (animatorProps.t.propType) {
                    if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                    else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                }
            }
            isNewLine = false;
        }
        if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
        while(lastIndex < i){
            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
            lastIndex += 1;
        }
    }
    //
    for(i = 0; i < len; i += 1){
        matrixHelper.reset();
        elemOpacity = 1;
        if (letters[i].n) {
            xPos = 0;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            currentLength = initPathPos;
            firstLine = false;
            if (this._hasMaskedPath) {
                segmentInd = initSegmentInd;
                pointInd = initPointInd;
                points = segments[segmentInd].points;
                prevPoint = points[pointInd - 1];
                currentPoint = points[pointInd];
                partialLength = currentPoint.partialLength;
                segmentLength = 0;
            }
            letterM = '';
            letterFc = '';
            letterSw = '';
            letterO = '';
            letterP = this.defaultPropsArray;
        } else {
            if (this._hasMaskedPath) {
                if (currentLine !== letters[i].line) {
                    switch(documentData.j){
                        case 1:
                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
                            break;
                        case 2:
                            currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                            break;
                        default:
                            break;
                    }
                    currentLine = letters[i].line;
                }
                if (ind !== letters[i].ind) {
                    if (letters[ind]) currentLength += letters[ind].extra;
                    currentLength += letters[i].an / 2;
                    ind = letters[i].ind;
                }
                currentLength += alignment[0] * letters[i].an * 0.005;
                var animatorOffset = 0;
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                        else animatorOffset += animatorProps.p.v[0] * mult;
                    }
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                        else animatorOffset += animatorProps.a.v[0] * mult;
                    }
                }
                flag = true;
                // Force alignment only works with a single line for now
                if (this._pathData.a.v) {
                    currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                    currentLength += this._pathData.f.v;
                }
                while(flag){
                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                        matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                        flag = false;
                    } else if (points) {
                        segmentLength += currentPoint.partialLength;
                        pointInd += 1;
                        if (pointInd >= points.length) {
                            pointInd = 0;
                            segmentInd += 1;
                            if (!segments[segmentInd]) {
                                if (mask.v.c) {
                                    pointInd = 0;
                                    segmentInd = 0;
                                    points = segments[segmentInd].points;
                                } else {
                                    segmentLength -= currentPoint.partialLength;
                                    points = null;
                                }
                            } else points = segments[segmentInd].points;
                        }
                        if (points) {
                            prevPoint = currentPoint;
                            currentPoint = points[pointInd];
                            partialLength = currentPoint.partialLength;
                        }
                    }
                }
                offf = letters[i].an / 2 - letters[i].add;
                matrixHelper.translate(-offf, 0, 0);
            } else {
                offf = letters[i].an / 2 - letters[i].add;
                matrixHelper.translate(-offf, 0, 0);
                // Grouping alignment
                matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
            }
            for(j = 0; j < jLen; j += 1){
                animatorProps = animators[j].a;
                if (animatorProps.t.propType) {
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                    if (xPos !== 0 || documentData.j !== 0) {
                        if (this._hasMaskedPath) {
                            if (mult.length) currentLength += animatorProps.t.v * mult[0];
                            else currentLength += animatorProps.t.v * mult;
                        } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                        else xPos += animatorProps.t.v * mult;
                    }
                }
            }
            if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
            if (documentData.strokeColorAnim) {
                if (documentData.sc) sc = [
                    documentData.sc[0],
                    documentData.sc[1],
                    documentData.sc[2]
                ];
                else sc = [
                    0,
                    0,
                    0
                ];
            }
            if (documentData.fillColorAnim && documentData.fc) fc = [
                documentData.fc[0],
                documentData.fc[1],
                documentData.fc[2]
            ];
            for(j = 0; j < jLen; j += 1){
                animatorProps = animators[j].a;
                if (animatorProps.a.propType) {
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                    else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                }
            }
            for(j = 0; j < jLen; j += 1){
                animatorProps = animators[j].a;
                if (animatorProps.s.propType) {
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                    else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                }
            }
            for(j = 0; j < jLen; j += 1){
                animatorProps = animators[j].a;
                animatorSelector = animators[j].s;
                mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                if (animatorProps.sk.propType) {
                    if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                    else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                }
                if (animatorProps.r.propType) {
                    if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                    else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                }
                if (animatorProps.ry.propType) {
                    if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                    else matrixHelper.rotateY(animatorProps.ry.v * mult);
                }
                if (animatorProps.rx.propType) {
                    if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                    else matrixHelper.rotateX(animatorProps.rx.v * mult);
                }
                if (animatorProps.o.propType) {
                    if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                    else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                }
                if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                    if (mult.length) sw += animatorProps.sw.v * mult[0];
                    else sw += animatorProps.sw.v * mult;
                }
                if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                    for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                    else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                }
                if (documentData.fillColorAnim && documentData.fc) {
                    if (animatorProps.fc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                        else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                    }
                    if (animatorProps.fh.propType) {
                        if (mult.length) fc = $b60a95926cba5528$var$addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                        else fc = $b60a95926cba5528$var$addHueToRGB(fc, animatorProps.fh.v * mult);
                    }
                    if (animatorProps.fs.propType) {
                        if (mult.length) fc = $b60a95926cba5528$var$addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                        else fc = $b60a95926cba5528$var$addSaturationToRGB(fc, animatorProps.fs.v * mult);
                    }
                    if (animatorProps.fb.propType) {
                        if (mult.length) fc = $b60a95926cba5528$var$addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                        else fc = $b60a95926cba5528$var$addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                    }
                }
            }
            for(j = 0; j < jLen; j += 1){
                animatorProps = animators[j].a;
                if (animatorProps.p.propType) {
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (this._hasMaskedPath) {
                        if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                        else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                    else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                }
            }
            if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
            if (documentData.strokeColorAnim) letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
            if (documentData.fillColorAnim && documentData.fc) letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
            if (this._hasMaskedPath) {
                matrixHelper.translate(0, -documentData.ls);
                matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                if (this._pathData.p.v) {
                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
                    if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                    matrixHelper.rotate(-rot * Math.PI / 180);
                }
                matrixHelper.translate(xPathPos, yPathPos, 0);
                currentLength -= alignment[0] * letters[i].an * 0.005;
                if (letters[i + 1] && ind !== letters[i + 1].ind) {
                    currentLength += letters[i].an / 2;
                    currentLength += documentData.tr * 0.001 * documentData.finalSize;
                }
            } else {
                matrixHelper.translate(xPos, yPos, 0);
                if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                switch(documentData.j){
                    case 1:
                        matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                        break;
                    case 2:
                        matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                        break;
                    default:
                        break;
                }
                matrixHelper.translate(0, -documentData.ls);
                matrixHelper.translate(offf, 0, 0);
                matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
            }
            if (renderType === 'html') letterM = matrixHelper.toCSS();
            else if (renderType === 'svg') letterM = matrixHelper.to2dCSS();
            else letterP = [
                matrixHelper.props[0],
                matrixHelper.props[1],
                matrixHelper.props[2],
                matrixHelper.props[3],
                matrixHelper.props[4],
                matrixHelper.props[5],
                matrixHelper.props[6],
                matrixHelper.props[7],
                matrixHelper.props[8],
                matrixHelper.props[9],
                matrixHelper.props[10],
                matrixHelper.props[11],
                matrixHelper.props[12],
                matrixHelper.props[13],
                matrixHelper.props[14],
                matrixHelper.props[15]
            ];
            letterO = elemOpacity;
        }
        if (renderedLettersCount <= i) {
            letterValue = new $b60a95926cba5528$var$LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
            this.renderedLetters.push(letterValue);
            renderedLettersCount += 1;
            this.lettersChangedFlag = true;
        } else {
            letterValue = this.renderedLetters[i];
            this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
        }
    }
};
$b60a95926cba5528$var$TextAnimatorProperty.prototype.getValue = function() {
    if (this._elem.globalData.frameId === this._frameId) return;
    this._frameId = this._elem.globalData.frameId;
    this.iterateDynamicProperties();
};
$b60a95926cba5528$var$TextAnimatorProperty.prototype.mHelper = new $b60a95926cba5528$var$Matrix();
$b60a95926cba5528$var$TextAnimatorProperty.prototype.defaultPropsArray = [];
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$DynamicPropertyContainer
], $b60a95926cba5528$var$TextAnimatorProperty);
function $b60a95926cba5528$var$ITextElement() {}
$b60a95926cba5528$var$ITextElement.prototype.initElement = function(data, globalData, comp) {
    this.lettersChangedFlag = true;
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.textProperty = new $b60a95926cba5528$var$TextProperty(this, data.t, this.dynamicProperties);
    this.textAnimator = new $b60a95926cba5528$var$TextAnimatorProperty(data.t, this.renderType, this);
    this.initTransform(data, globalData, comp);
    this.initHierarchy();
    this.initRenderable();
    this.initRendererElement();
    this.createContainerElements();
    this.createRenderableComponents();
    this.createContent();
    this.hide();
    this.textAnimator.searchProperties(this.dynamicProperties);
};
$b60a95926cba5528$var$ITextElement.prototype.prepareFrame = function(num) {
    this._mdf = false;
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);
};
$b60a95926cba5528$var$ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
    var j;
    var jLen = shapes.length;
    var pathNodes;
    var shapeStr = '';
    for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
        pathNodes = shapes[j].ks.k;
        shapeStr += $b60a95926cba5528$var$buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
    }
    return shapeStr;
};
$b60a95926cba5528$var$ITextElement.prototype.updateDocumentData = function(newData, index) {
    this.textProperty.updateDocumentData(newData, index);
};
$b60a95926cba5528$var$ITextElement.prototype.canResizeFont = function(_canResize) {
    this.textProperty.canResizeFont(_canResize);
};
$b60a95926cba5528$var$ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
    this.textProperty.setMinimumFontSize(_fontSize);
};
$b60a95926cba5528$var$ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
    if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
    matrixHelper.translate(0, -documentData.ls, 0);
    switch(documentData.j){
        case 1:
            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
            break;
        case 2:
            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
            break;
        default:
            break;
    }
    matrixHelper.translate(xPos, yPos, 0);
};
$b60a95926cba5528$var$ITextElement.prototype.buildColor = function(colorData) {
    return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
};
$b60a95926cba5528$var$ITextElement.prototype.emptyProp = new $b60a95926cba5528$var$LetterProps();
$b60a95926cba5528$var$ITextElement.prototype.destroy = function() {};
$b60a95926cba5528$var$ITextElement.prototype.validateText = function() {
    if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
        this.buildNewText();
        this.textProperty._isFirstFrame = false;
        this.textProperty._mdf = false;
    }
};
var $b60a95926cba5528$var$emptyShapeData = {
    shapes: []
};
function $b60a95926cba5528$var$SVGTextLottieElement(data, globalData, comp) {
    this.textSpans = [];
    this.renderType = 'svg';
    this.initElement(data, globalData, comp);
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$BaseElement,
    $b60a95926cba5528$var$TransformElement,
    $b60a95926cba5528$var$SVGBaseElement,
    $b60a95926cba5528$var$HierarchyElement,
    $b60a95926cba5528$var$FrameElement,
    $b60a95926cba5528$var$RenderableDOMElement,
    $b60a95926cba5528$var$ITextElement
], $b60a95926cba5528$var$SVGTextLottieElement);
$b60a95926cba5528$var$SVGTextLottieElement.prototype.createContent = function() {
    if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = $b60a95926cba5528$var$createNS('text');
};
$b60a95926cba5528$var$SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
    var i = 0;
    var len = textArray.length;
    var textContents = [];
    var currentTextContent = '';
    while(i < len){
        if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
            textContents.push(currentTextContent);
            currentTextContent = '';
        } else currentTextContent += textArray[i];
        i += 1;
    }
    textContents.push(currentTextContent);
    return textContents;
};
$b60a95926cba5528$var$SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
    // data should probably be cloned to apply scale separately to each instance of a text on different layers
    // but since text internal content gets only rendered once and then it's never rerendered,
    // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
    // Avoiding cloning is preferred since cloning each character shape data is expensive
    if (data.shapes && data.shapes.length) {
        var shape = data.shapes[0];
        if (shape.it) {
            var shapeItem = shape.it[shape.it.length - 1];
            if (shapeItem.s) {
                shapeItem.s.k[0] = scale;
                shapeItem.s.k[1] = scale;
            }
        }
    }
    return data;
};
$b60a95926cba5528$var$SVGTextLottieElement.prototype.buildNewText = function() {
    this.addDynamicProperty(this);
    var i;
    var len;
    var documentData = this.textProperty.currentData;
    this.renderedLetters = $b60a95926cba5528$var$createSizedArray(documentData ? documentData.l.length : 0);
    if (documentData.fc) this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
    else this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
    if (documentData.sc) {
        this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
        this.layerElement.setAttribute('stroke-width', documentData.sw);
    }
    this.layerElement.setAttribute('font-size', documentData.finalSize);
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    if (fontData.fClass) this.layerElement.setAttribute('class', fontData.fClass);
    else {
        this.layerElement.setAttribute('font-family', fontData.fFamily);
        var fWeight = documentData.fWeight;
        var fStyle = documentData.fStyle;
        this.layerElement.setAttribute('font-style', fStyle);
        this.layerElement.setAttribute('font-weight', fWeight);
    }
    this.layerElement.setAttribute('aria-label', documentData.t);
    var letters = documentData.l || [];
    var usesGlyphs = !!this.globalData.fontManager.chars;
    len = letters.length;
    var tSpan;
    var matrixHelper = this.mHelper;
    var shapeStr = '';
    var singleShape = this.data.singleShape;
    var xPos = 0;
    var yPos = 0;
    var firstLine = true;
    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
    if (singleShape && !usesGlyphs && !documentData.sz) {
        var tElement = this.textContainer;
        var justify = 'start';
        switch(documentData.j){
            case 1:
                justify = 'end';
                break;
            case 2:
                justify = 'middle';
                break;
            default:
                justify = 'start';
                break;
        }
        tElement.setAttribute('text-anchor', justify);
        tElement.setAttribute('letter-spacing', trackingOffset);
        var textContent = this.buildTextContents(documentData.finalText);
        len = textContent.length;
        yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
        for(i = 0; i < len; i += 1){
            tSpan = this.textSpans[i].span || $b60a95926cba5528$var$createNS('tspan');
            tSpan.textContent = textContent[i];
            tSpan.setAttribute('x', 0);
            tSpan.setAttribute('y', yPos);
            tSpan.style.display = 'inherit';
            tElement.appendChild(tSpan);
            if (!this.textSpans[i]) this.textSpans[i] = {
                span: null,
                glyph: null
            };
            this.textSpans[i].span = tSpan;
            yPos += documentData.finalLineHeight;
        }
        this.layerElement.appendChild(tElement);
    } else {
        var cachedSpansLength = this.textSpans.length;
        var charData;
        for(i = 0; i < len; i += 1){
            if (!this.textSpans[i]) this.textSpans[i] = {
                span: null,
                childSpan: null,
                glyph: null
            };
            if (!usesGlyphs || !singleShape || i === 0) {
                tSpan = cachedSpansLength > i ? this.textSpans[i].span : $b60a95926cba5528$var$createNS(usesGlyphs ? 'g' : 'text');
                if (cachedSpansLength <= i) {
                    tSpan.setAttribute('stroke-linecap', 'butt');
                    tSpan.setAttribute('stroke-linejoin', 'round');
                    tSpan.setAttribute('stroke-miterlimit', '4');
                    this.textSpans[i].span = tSpan;
                    if (usesGlyphs) {
                        var childSpan = $b60a95926cba5528$var$createNS('g');
                        tSpan.appendChild(childSpan);
                        this.textSpans[i].childSpan = childSpan;
                    }
                    this.textSpans[i].span = tSpan;
                    this.layerElement.appendChild(tSpan);
                }
                tSpan.style.display = 'inherit';
            }
            matrixHelper.reset();
            if (singleShape) {
                if (letters[i].n) {
                    xPos = -trackingOffset;
                    yPos += documentData.yOffset;
                    yPos += firstLine ? 1 : 0;
                    firstLine = false;
                }
                this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                xPos += letters[i].l || 0;
                // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                xPos += trackingOffset;
            }
            if (usesGlyphs) {
                charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                var glyphElement;
                // t === 1 means the character has been replaced with an animated shaped
                if (charData.t === 1) glyphElement = new $b60a95926cba5528$var$SVGCompElement(charData.data, this.globalData, this);
                else {
                    var data = $b60a95926cba5528$var$emptyShapeData;
                    if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                    glyphElement = new $b60a95926cba5528$var$SVGShapeElement(data, this.globalData, this);
                }
                if (this.textSpans[i].glyph) {
                    var glyph = this.textSpans[i].glyph;
                    this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                    glyph.destroy();
                }
                this.textSpans[i].glyph = glyphElement;
                glyphElement._debug = true;
                glyphElement.prepareFrame(0);
                glyphElement.renderFrame();
                this.textSpans[i].childSpan.appendChild(glyphElement.layerElement);
                // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                // this might have issues with strokes and might need a different solution
                if (charData.t === 1) this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
            } else {
                if (singleShape) tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
            }
        //
        }
        if (singleShape && tSpan) tSpan.setAttribute('d', shapeStr);
    }
    while(i < this.textSpans.length){
        this.textSpans[i].span.style.display = 'none';
        i += 1;
    }
    this._sizeChanged = true;
};
$b60a95926cba5528$var$SVGTextLottieElement.prototype.sourceRectAtTime = function() {
    this.prepareFrame(this.comp.renderedFrame - this.data.st);
    this.renderInnerContent();
    if (this._sizeChanged) {
        this._sizeChanged = false;
        var textBox = this.layerElement.getBBox();
        this.bbox = {
            top: textBox.y,
            left: textBox.x,
            width: textBox.width,
            height: textBox.height
        };
    }
    return this.bbox;
};
$b60a95926cba5528$var$SVGTextLottieElement.prototype.getValue = function() {
    var i;
    var len = this.textSpans.length;
    var glyphElement;
    this.renderedFrame = this.comp.renderedFrame;
    for(i = 0; i < len; i += 1){
        glyphElement = this.textSpans[i].glyph;
        if (glyphElement) {
            glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
            if (glyphElement._mdf) this._mdf = true;
        }
    }
};
$b60a95926cba5528$var$SVGTextLottieElement.prototype.renderInnerContent = function() {
    this.validateText();
    if (!this.data.singleShape || this._mdf) {
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
            this._sizeChanged = true;
            var i;
            var len;
            var renderedLetters = this.textAnimator.renderedLetters;
            var letters = this.textProperty.currentData.l;
            len = letters.length;
            var renderedLetter;
            var textSpan;
            var glyphElement;
            for(i = 0; i < len; i += 1)if (!letters[i].n) {
                renderedLetter = renderedLetters[i];
                textSpan = this.textSpans[i].span;
                glyphElement = this.textSpans[i].glyph;
                if (glyphElement) glyphElement.renderFrame();
                if (renderedLetter._mdf.m) textSpan.setAttribute('transform', renderedLetter.m);
                if (renderedLetter._mdf.o) textSpan.setAttribute('opacity', renderedLetter.o);
                if (renderedLetter._mdf.sw) textSpan.setAttribute('stroke-width', renderedLetter.sw);
                if (renderedLetter._mdf.sc) textSpan.setAttribute('stroke', renderedLetter.sc);
                if (renderedLetter._mdf.fc) textSpan.setAttribute('fill', renderedLetter.fc);
            }
        }
    }
};
function $b60a95926cba5528$var$ISolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$IImageElement
], $b60a95926cba5528$var$ISolidElement);
$b60a95926cba5528$var$ISolidElement.prototype.createContent = function() {
    var rect = $b60a95926cba5528$var$createNS('rect');
    /// /rect.style.width = this.data.sw;
    /// /rect.style.height = this.data.sh;
    /// /rect.style.fill = this.data.sc;
    rect.setAttribute('width', this.data.sw);
    rect.setAttribute('height', this.data.sh);
    rect.setAttribute('fill', this.data.sc);
    this.layerElement.appendChild(rect);
};
function $b60a95926cba5528$var$NullElement(data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initFrame();
    this.initTransform(data, globalData, comp);
    this.initHierarchy();
}
$b60a95926cba5528$var$NullElement.prototype.prepareFrame = function(num) {
    this.prepareProperties(num, true);
};
$b60a95926cba5528$var$NullElement.prototype.renderFrame = function() {};
$b60a95926cba5528$var$NullElement.prototype.getBaseElement = function() {
    return null;
};
$b60a95926cba5528$var$NullElement.prototype.destroy = function() {};
$b60a95926cba5528$var$NullElement.prototype.sourceRectAtTime = function() {};
$b60a95926cba5528$var$NullElement.prototype.hide = function() {};
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$BaseElement,
    $b60a95926cba5528$var$TransformElement,
    $b60a95926cba5528$var$HierarchyElement,
    $b60a95926cba5528$var$FrameElement
], $b60a95926cba5528$var$NullElement);
function $b60a95926cba5528$var$SVGRendererBase() {}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$BaseRenderer
], $b60a95926cba5528$var$SVGRendererBase);
$b60a95926cba5528$var$SVGRendererBase.prototype.createNull = function(data) {
    return new $b60a95926cba5528$var$NullElement(data, this.globalData, this);
};
$b60a95926cba5528$var$SVGRendererBase.prototype.createShape = function(data) {
    return new $b60a95926cba5528$var$SVGShapeElement(data, this.globalData, this);
};
$b60a95926cba5528$var$SVGRendererBase.prototype.createText = function(data) {
    return new $b60a95926cba5528$var$SVGTextLottieElement(data, this.globalData, this);
};
$b60a95926cba5528$var$SVGRendererBase.prototype.createImage = function(data) {
    return new $b60a95926cba5528$var$IImageElement(data, this.globalData, this);
};
$b60a95926cba5528$var$SVGRendererBase.prototype.createSolid = function(data) {
    return new $b60a95926cba5528$var$ISolidElement(data, this.globalData, this);
};
$b60a95926cba5528$var$SVGRendererBase.prototype.configAnimation = function(animData) {
    this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
    else this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
    if (!this.renderConfig.viewBoxOnly) {
        this.svgElement.setAttribute('width', animData.w);
        this.svgElement.setAttribute('height', animData.h);
        this.svgElement.style.width = '100%';
        this.svgElement.style.height = '100%';
        this.svgElement.style.transform = 'translate3d(0,0,0)';
        this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
    }
    if (this.renderConfig.width) this.svgElement.setAttribute('width', this.renderConfig.width);
    if (this.renderConfig.height) this.svgElement.setAttribute('height', this.renderConfig.height);
    if (this.renderConfig.className) this.svgElement.setAttribute('class', this.renderConfig.className);
    if (this.renderConfig.id) this.svgElement.setAttribute('id', this.renderConfig.id);
    if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
    this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio);
    // this.layerElement.style.transform = 'translate3d(0,0,0)';
    // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
    this.animationItem.wrapper.appendChild(this.svgElement);
    // Mask animation
    var defs = this.globalData.defs;
    this.setupGlobalData(animData, defs);
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.data = animData;
    var maskElement = $b60a95926cba5528$var$createNS('clipPath');
    var rect = $b60a95926cba5528$var$createNS('rect');
    rect.setAttribute('width', animData.w);
    rect.setAttribute('height', animData.h);
    rect.setAttribute('x', 0);
    rect.setAttribute('y', 0);
    var maskId = $b60a95926cba5528$var$createElementID();
    maskElement.setAttribute('id', maskId);
    maskElement.appendChild(rect);
    this.layerElement.setAttribute('clip-path', 'url(' + $b60a95926cba5528$var$getLocationHref() + '#' + maskId + ')');
    defs.appendChild(maskElement);
    this.layers = animData.layers;
    this.elements = $b60a95926cba5528$var$createSizedArray(animData.layers.length);
};
$b60a95926cba5528$var$SVGRendererBase.prototype.destroy = function() {
    if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
    this.layerElement = null;
    this.globalData.defs = null;
    var i;
    var len = this.layers ? this.layers.length : 0;
    for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
};
$b60a95926cba5528$var$SVGRendererBase.prototype.updateContainerSize = function() {};
$b60a95926cba5528$var$SVGRendererBase.prototype.findIndexByInd = function(ind) {
    var i = 0;
    var len = this.layers.length;
    for(i = 0; i < len; i += 1){
        if (this.layers[i].ind === ind) return i;
    }
    return -1;
};
$b60a95926cba5528$var$SVGRendererBase.prototype.buildItem = function(pos) {
    var elements = this.elements;
    if (elements[pos] || this.layers[pos].ty === 99) return;
    elements[pos] = true;
    var element = this.createItem(this.layers[pos]);
    elements[pos] = element;
    if ($b60a95926cba5528$var$getExpressionsPlugin()) {
        if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
        element.initExpressions();
    }
    this.appendElementInPos(element, pos);
    if (this.layers[pos].tt) {
        var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
        if (elementIndex === -1) return;
        if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
            this.buildItem(elementIndex);
            this.addPendingElement(element);
        } else {
            var matteElement = elements[elementIndex];
            var matteMask = matteElement.getMatte(this.layers[pos].tt);
            element.setMatte(matteMask);
        }
    }
};
$b60a95926cba5528$var$SVGRendererBase.prototype.checkPendingElements = function() {
    while(this.pendingElements.length){
        var element = this.pendingElements.pop();
        element.checkParenting();
        if (element.data.tt) {
            var i = 0;
            var len = this.elements.length;
            while(i < len){
                if (this.elements[i] === element) {
                    var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                    var matteElement = this.elements[elementIndex];
                    var matteMask = matteElement.getMatte(this.layers[i].tt);
                    element.setMatte(matteMask);
                    break;
                }
                i += 1;
            }
        }
    }
};
$b60a95926cba5528$var$SVGRendererBase.prototype.renderFrame = function(num) {
    if (this.renderedFrame === num || this.destroyed) return;
    if (num === null) num = this.renderedFrame;
    else this.renderedFrame = num;
    // console.log('-------');
    // console.log('FRAME ',num);
    this.globalData.frameNum = num;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    this.globalData._mdf = false;
    var i;
    var len = this.layers.length;
    if (!this.completeLayers) this.checkLayers(num);
    for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
    if (this.globalData._mdf) {
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    }
};
$b60a95926cba5528$var$SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
    var newElement = element.getBaseElement();
    if (!newElement) return;
    var i = 0;
    var nextElement;
    while(i < pos){
        if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
        i += 1;
    }
    if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
    else this.layerElement.appendChild(newElement);
};
$b60a95926cba5528$var$SVGRendererBase.prototype.hide = function() {
    this.layerElement.style.display = 'none';
};
$b60a95926cba5528$var$SVGRendererBase.prototype.show = function() {
    this.layerElement.style.display = 'block';
};
function $b60a95926cba5528$var$ICompElement() {}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$BaseElement,
    $b60a95926cba5528$var$TransformElement,
    $b60a95926cba5528$var$HierarchyElement,
    $b60a95926cba5528$var$FrameElement,
    $b60a95926cba5528$var$RenderableDOMElement
], $b60a95926cba5528$var$ICompElement);
$b60a95926cba5528$var$ICompElement.prototype.initElement = function(data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initTransform(data, globalData, comp);
    this.initRenderable();
    this.initHierarchy();
    this.initRendererElement();
    this.createContainerElements();
    this.createRenderableComponents();
    if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
    this.hide();
};
/* ICompElement.prototype.hide = function(){
    if(!this.hidden){
        this.hideElement();
        var i,len = this.elements.length;
        for( i = 0; i < len; i+=1 ){
            if(this.elements[i]){
                this.elements[i].hide();
            }
        }
    }
}; */ $b60a95926cba5528$var$ICompElement.prototype.prepareFrame = function(num) {
    this._mdf = false;
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);
    if (!this.isInRange && !this.data.xt) return;
    if (!this.tm._placeholder) {
        var timeRemapped = this.tm.v;
        if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
        this.renderedFrame = timeRemapped;
    } else this.renderedFrame = num / this.data.sr;
    var i;
    var len = this.elements.length;
    if (!this.completeLayers) this.checkLayers(this.renderedFrame);
    // This iteration needs to be backwards because of how expressions connect between each other
    for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
        if (this.elements[i]._mdf) this._mdf = true;
    }
};
$b60a95926cba5528$var$ICompElement.prototype.renderInnerContent = function() {
    var i;
    var len = this.layers.length;
    for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
};
$b60a95926cba5528$var$ICompElement.prototype.setElements = function(elems) {
    this.elements = elems;
};
$b60a95926cba5528$var$ICompElement.prototype.getElements = function() {
    return this.elements;
};
$b60a95926cba5528$var$ICompElement.prototype.destroyElements = function() {
    var i;
    var len = this.layers.length;
    for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
};
$b60a95926cba5528$var$ICompElement.prototype.destroy = function() {
    this.destroyElements();
    this.destroyBaseElement();
};
function $b60a95926cba5528$var$SVGCompElement(data, globalData, comp) {
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? $b60a95926cba5528$var$createSizedArray(this.layers.length) : [];
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? $b60a95926cba5528$var$PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
        _placeholder: true
    };
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$SVGRendererBase,
    $b60a95926cba5528$var$ICompElement,
    $b60a95926cba5528$var$SVGBaseElement
], $b60a95926cba5528$var$SVGCompElement);
$b60a95926cba5528$var$SVGCompElement.prototype.createComp = function(data) {
    return new $b60a95926cba5528$var$SVGCompElement(data, this.globalData, this);
};
function $b60a95926cba5528$var$SVGRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.svgElement = $b60a95926cba5528$var$createNS('svg');
    var ariaLabel = '';
    if (config && config.title) {
        var titleElement = $b60a95926cba5528$var$createNS('title');
        var titleId = $b60a95926cba5528$var$createElementID();
        titleElement.setAttribute('id', titleId);
        titleElement.textContent = config.title;
        this.svgElement.appendChild(titleElement);
        ariaLabel += titleId;
    }
    if (config && config.description) {
        var descElement = $b60a95926cba5528$var$createNS('desc');
        var descId = $b60a95926cba5528$var$createElementID();
        descElement.setAttribute('id', descId);
        descElement.textContent = config.description;
        this.svgElement.appendChild(descElement);
        ariaLabel += ' ' + descId;
    }
    if (ariaLabel) this.svgElement.setAttribute('aria-labelledby', ariaLabel);
    var defs = $b60a95926cba5528$var$createNS('defs');
    this.svgElement.appendChild(defs);
    var maskElement = $b60a95926cba5528$var$createNS('g');
    this.svgElement.appendChild(maskElement);
    this.layerElement = maskElement;
    this.renderConfig = {
        preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
        imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
        contentVisibility: config && config.contentVisibility || 'visible',
        progressiveLoad: config && config.progressiveLoad || false,
        hideOnTransparent: !(config && config.hideOnTransparent === false),
        viewBoxOnly: config && config.viewBoxOnly || false,
        viewBoxSize: config && config.viewBoxSize || false,
        className: config && config.className || '',
        id: config && config.id || '',
        focusable: config && config.focusable,
        filterSize: {
            width: config && config.filterSize && config.filterSize.width || '100%',
            height: config && config.filterSize && config.filterSize.height || '100%',
            x: config && config.filterSize && config.filterSize.x || '0%',
            y: config && config.filterSize && config.filterSize.y || '0%'
        },
        width: config && config.width,
        height: config && config.height,
        runExpressions: !config || config.runExpressions === undefined || config.runExpressions
    };
    this.globalData = {
        _mdf: false,
        frameNum: -1,
        defs: defs,
        renderConfig: this.renderConfig
    };
    this.elements = [];
    this.pendingElements = [];
    this.destroyed = false;
    this.rendererType = 'svg';
}
$b60a95926cba5528$var$extendPrototype([
    $b60a95926cba5528$var$SVGRendererBase
], $b60a95926cba5528$var$SVGRenderer);
$b60a95926cba5528$var$SVGRenderer.prototype.createComp = function(data) {
    return new $b60a95926cba5528$var$SVGCompElement(data, this.globalData, this);
};
// Registering renderers
$b60a95926cba5528$var$registerRenderer('svg', $b60a95926cba5528$var$SVGRenderer);
// Registering shape modifiers
$b60a95926cba5528$var$ShapeModifiers.registerModifier('tm', $b60a95926cba5528$var$TrimModifier);
$b60a95926cba5528$var$ShapeModifiers.registerModifier('pb', $b60a95926cba5528$var$PuckerAndBloatModifier);
$b60a95926cba5528$var$ShapeModifiers.registerModifier('rp', $b60a95926cba5528$var$RepeaterModifier);
$b60a95926cba5528$var$ShapeModifiers.registerModifier('rd', $b60a95926cba5528$var$RoundCornersModifier);
$b60a95926cba5528$var$ShapeModifiers.registerModifier('zz', $b60a95926cba5528$var$ZigZagModifier);
$b60a95926cba5528$var$ShapeModifiers.registerModifier('op', $b60a95926cba5528$var$OffsetPathModifier);


parcelRequire("kOgzt");
var $jWfAU = parcelRequire("jWfAU");
var $h30hJ = parcelRequire("h30hJ");
const $4fe25c8580dc125b$var$loadingClass = 'btn--loading';
const $4fe25c8580dc125b$export$25f61c8c0582d1e = (button, activate = true)=>{
    button && button.classList.toggle($4fe25c8580dc125b$var$loadingClass, activate);
};



var $613bB = parcelRequire("613bB");

var $kgd8P = parcelRequire("kgd8P");
parcelRequire("kOgzt");
var $77crt = parcelRequire("77crt");
var $ceOOn = parcelRequire("ceOOn");
const $d1759b78371fa58a$export$783252675966cc2d = (form)=>{
    const hubSpotFields = form.querySelectorAll('[data-hstype]');
    const fields = [], legalConsentOptions = {}, communications = [];
    let ipAddress = '', goToWebinarWebinarKey = '', consent_element;
    hubSpotFields.forEach((elm)=>{
        switch(elm.dataset.hstype){
            case 'field':
                if ([
                    'checkbox',
                    'radio'
                ].includes(elm.type)) {
                    if (elm.checked) fields.push({
                        objectTypeId: elm.dataset.hstypeid,
                        name: elm.name,
                        value: elm.value
                    });
                } else if (elm.value !== '') fields.push({
                    objectTypeId: elm.dataset.hstypeid,
                    name: elm.name,
                    value: elm.value
                });
                break;
            case 'communicationCheckbox':
                communications.push({
                    value: elm.checked,
                    subscriptionTypeId: elm.name,
                    text: (0, $77crt.b64_decode)(elm.dataset.hscomtext)
                });
                break;
            case 'consent':
                consent_element = elm;
                break;
            case 'goToWebinarWebinarKey':
                goToWebinarWebinarKey = elm.value;
                break;
            case 'userOrigin':
                ipAddress = (0, $77crt.b64_decode)(elm.value);
                break;
        }
    });
    /**
	 * Build the legalConsentOptions object according to the API docs
	 *
	 * @link https://legacydocs.hubspot.com/docs/methods/forms/submit_form (Section: "Legal consent options")
	 */ switch(form.dataset.legalConsentType){
        case 'none':
            break;
        case 'legitimate_interest':
            {
                const legitimateInterestOptions = {
                    value: true,
                    legalBasis: consent_element.dataset.legalBasis,
                    text: (0, $77crt.b64_decode)(consent_element.dataset.text)
                };
                const subscriptionTypeIds = consent_element.dataset.subscriptionTypeId.split(',').map(Number);
                if (subscriptionTypeIds.length === 1) legitimateInterestOptions.subscriptionTypeId = subscriptionTypeIds[0];
                else if (subscriptionTypeIds.length > 1) legitimateInterestOptions.subscriptionTypeIds = subscriptionTypeIds;
                legalConsentOptions.legitimateInterest = legitimateInterestOptions;
                break;
            }
        case 'implicit_consent_to_process':
        case 'explicit_consent_to_process':
            legalConsentOptions.consent = {
                consentToProcess: true,
                text: (0, $77crt.b64_decode)(consent_element.dataset.text),
                communications: communications
            };
            break;
    }
    return $d1759b78371fa58a$var$hsBodyLoad(fields, legalConsentOptions, ipAddress, goToWebinarWebinarKey);
};
/**
 * Build the object with all data that is sent to HubSpot
 *
 * @link https://legacydocs.hubspot.com/docs/methods/forms/submit_form
 */ const $d1759b78371fa58a$var$hsBodyLoad = (fields, legalConsentOptions, ipAddress = '', goToWebinarWebinarKey = '')=>{
    const cookies = (0, $ceOOn.getAllCookies)();
    const contextOptions = {
        pageUri: document.URL,
        pageName: document.title
    };
    'hubspotutk' in cookies && (contextOptions.hutk = cookies['hubspotutk']);
    ipAddress && (contextOptions.ipAddress = ipAddress);
    goToWebinarWebinarKey && (contextOptions.goToWebinarWebinarKey = goToWebinarWebinarKey);
    return {
        submittedAt: Date.now(),
        fields: fields,
        context: contextOptions,
        legalConsentOptions: legalConsentOptions
    };
};


const $48d304f3f066f0c8$var$logErrorMessage = (message = '')=>{
    console.error('An error occurred while sending the form data to HubSpot.', message);
};
const $48d304f3f066f0c8$export$8027ecf5a33730c9 = async (form, event)=>{
    if (!(0, $kgd8P.validateForm)(form)) {
        // Stop propagation if the form is not valid
        // * This way Google Tag Manager's listener won't receive the bubbling submit event
        event.stopPropagation();
        return;
    }
    const submitBtn = form.querySelector('[type="submit"]');
    // Lock form and show feedback
    (0, $kgd8P.lockForm)(form);
    (0, $4fe25c8580dc125b$export$25f61c8c0582d1e)(submitBtn);
    try {
        const result = await fetch(`${mpHubSpotAjax.url}?action=${mpHubSpotAjax.action}`, {
            method: 'POST',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                hs_route: form.action,
                hs_data: JSON.stringify((0, $d1759b78371fa58a$export$783252675966cc2d)(form))
            })
        });
        const response = await result.json();
        (0, $kgd8P.unlockForm)(form);
        (0, $4fe25c8580dc125b$export$25f61c8c0582d1e)(submitBtn, false);
        if (!response.success || response.data.responseCode !== 200) throw new Error(response.data.responseBody);
        const hubSpotResponse = response.data.responseBody;
        if (hubSpotResponse.errors) hubSpotResponse.errors.forEach((err)=>{
            $48d304f3f066f0c8$var$logErrorMessage(`(${err.errorType}) ${err.message}`);
            switch(err.errorType){
                case 'BLOCKED_EMAIL':
                    {
                        const emailField = form.querySelector('.form-field[data-field-type="email"]');
                        emailField && (0, $613bB.markFieldError)(emailField, 'blocked-email');
                        break;
                    }
            }
        });
        else {
            (0, $kgd8P.resetForm)(form);
            (0, $h30hJ.slideUp)(form);
            if (hubSpotResponse.inlineMessage) {
                // * Option 1: Show a success message
                const container = form.closest('.hs_form');
                const submitMsg = document.createElement('div');
                const icon = document.createElement('div');
                const message = document.createElement('div');
                icon.className = 'submit__logo';
                message.className = 'submit__text';
                message.insertAdjacentHTML('beforeend', hubSpotResponse.inlineMessage);
                submitMsg.className = 'hs_form__submit-msg gradient';
                submitMsg.appendChild(icon);
                submitMsg.appendChild(message);
                container.prepend(submitMsg);
                // Scroll up
                (0, $jWfAU.scrollToElement)('.hs_form__submit-msg');
                // Init animation after 1s due to scroll up duration
                setTimeout(()=>{
                    $48d304f3f066f0c8$var$initSubmitMsgLogoAnimation(icon);
                }, 500);
            } else if (hubSpotResponse.redirectUri) // * Option 2: Redirect to another URL
            location.assign(hubSpotResponse.redirectUri);
        }
    } catch (error) {
        (0, $kgd8P.unlockForm)(form);
        (0, $4fe25c8580dc125b$export$25f61c8c0582d1e)(submitBtn, false);
        $48d304f3f066f0c8$var$logErrorMessage(error);
    }
};
const $48d304f3f066f0c8$var$initSubmitMsgLogoAnimation = (container)=>{
    (0, $b60a95926cba5528$export$2e2bcd8739ae039).loadAnimation({
        container: container,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: {
            v: '5.9.0',
            fr: 29.9700012207031,
            ip: 0,
            op: 18.000000733155,
            w: 22,
            h: 21,
            nm: 'check-turq',
            ddd: 0,
            assets: [],
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'Shape Layer 1',
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                11.384,
                                10.95,
                                0
                            ],
                            ix: 2,
                            l: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                -11.616,
                                37.95,
                                0
                            ],
                            ix: 1,
                            l: 2
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6,
                            l: 2
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -18.182,
                                                    37.933
                                                ],
                                                [
                                                    -13.5,
                                                    42.5
                                                ],
                                                [
                                                    -5.05,
                                                    33.4
                                                ]
                                            ],
                                            c: false
                                        },
                                        ix: 2
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false
                                },
                                {
                                    ty: 'st',
                                    c: {
                                        a: 0,
                                        k: [
                                            0,
                                            0.772549019608,
                                            0.705882352941,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 2,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 1,
                                    ml: 4,
                                    bm: 0,
                                    nm: 'Stroke 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false
                                },
                                {
                                    ty: 'tr',
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: 'Transform'
                                }
                            ],
                            nm: 'Shape 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false
                        },
                        {
                            ty: 'tm',
                            s: {
                                a: 0,
                                k: 0,
                                ix: 1
                            },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.705
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.883
                                            ],
                                            y: [
                                                0
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            0
                                        ]
                                    },
                                    {
                                        t: 18.000000733155,
                                        s: [
                                            100
                                        ]
                                    }
                                ],
                                ix: 2
                            },
                            o: {
                                a: 0,
                                k: 0,
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: 'Trim Paths 1',
                            mn: 'ADBE Vector Filter - Trim',
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 18.000000733155,
                    st: 0,
                    bm: 0
                }
            ],
            markers: []
        }
    });
};


(0, $a3TA1.elementReady)('.hs_form form').then((form)=>{
    if (form instanceof NodeList) form.forEach((f)=>{
        $6f53720de4daa8ca$var$init(f);
    });
    else $6f53720de4daa8ca$var$init(form);
});
const $6f53720de4daa8ca$var$init = (form)=>{
    const cookies = (0, $ceOOn.getAllCookies)();
    const gaField = form.querySelector('input[name="ga_client_id"]');
    if (gaField && cookies['_ga']) gaField.value = cookies['_ga'];
    form.addEventListener('submit', (event)=>{
        // Prevent default event (redirect to action)
        event.preventDefault();
        // Run submit action
        (0, $48d304f3f066f0c8$export$8027ecf5a33730c9)(form, event);
    });
};

})();
//# sourceMappingURL=hubspot.min.js.map
